var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 993.79 722.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-1068,.cls-1070,.cls-11,.cls-120,.cls-121,.cls-15,.cls-17,.cls-171,.cls-174,.cls-181,.cls-183,.cls-190,.cls-20,.cls-232,.cls-239,.cls-32,.cls-425,.cls-427,.cls-462,.cls-608,.cls-610,.cls-624,.cls-631,.cls-685,.cls-787,.cls-886,.cls-97,.cls-985,.cls-99{mix-blend-mode:multiply;}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-18);}.cls-20{fill:url(#linear-gradient-19);}.cls-21{fill:url(#linear-gradient-20);}.cls-22{fill:url(#linear-gradient-21);}.cls-23{fill:url(#linear-gradient-22);}.cls-24{fill:url(#linear-gradient-23);}.cls-25{fill:url(#linear-gradient-24);}.cls-26{fill:url(#linear-gradient-25);}.cls-27{fill:url(#linear-gradient-26);}.cls-28{fill:#e8918a;}.cls-29{fill:#d8746f;}.cls-30{fill:#f6a59a;}.cls-31{fill:url(#linear-gradient-27);}.cls-32{fill:url(#linear-gradient-28);}.cls-33{fill:url(#linear-gradient-29);}.cls-34{fill:url(#linear-gradient-30);}.cls-35{fill:url(#linear-gradient-31);}.cls-36{fill:url(#linear-gradient-32);}.cls-37{fill:url(#linear-gradient-33);}.cls-38{fill:url(#linear-gradient-34);}.cls-39{fill:url(#linear-gradient-35);}.cls-40{fill:url(#linear-gradient-36);}.cls-41{fill:url(#linear-gradient-37);}.cls-42{fill:url(#linear-gradient-38);}.cls-43{fill:url(#linear-gradient-39);}.cls-44{fill:url(#linear-gradient-40);}.cls-45{fill:url(#linear-gradient-41);}.cls-46{fill:url(#linear-gradient-42);}.cls-47{fill:url(#linear-gradient-43);}.cls-48{fill:url(#linear-gradient-44);}.cls-49{fill:url(#linear-gradient-45);}.cls-50{fill:url(#linear-gradient-46);}.cls-51{fill:url(#linear-gradient-47);}.cls-52{fill:url(#linear-gradient-48);}.cls-53{fill:url(#linear-gradient-49);}.cls-54{fill:url(#linear-gradient-50);}.cls-55{fill:url(#linear-gradient-51);}.cls-56{fill:url(#linear-gradient-52);}.cls-57{fill:url(#linear-gradient-53);}.cls-58{fill:url(#linear-gradient-54);}.cls-59{fill:url(#linear-gradient-55);}.cls-60{fill:url(#linear-gradient-56);}.cls-61{fill:url(#linear-gradient-57);}.cls-62{fill:url(#linear-gradient-58);}.cls-63{fill:url(#linear-gradient-59);}.cls-64{fill:url(#linear-gradient-60);}.cls-65{fill:url(#linear-gradient-61);}.cls-66{fill:url(#linear-gradient-62);}.cls-67{fill:url(#linear-gradient-63);}.cls-68{fill:url(#linear-gradient-64);}.cls-69{fill:url(#linear-gradient-65);}.cls-70{fill:url(#linear-gradient-66);}.cls-71{fill:url(#linear-gradient-67);}.cls-72{fill:url(#linear-gradient-68);}.cls-73{fill:url(#linear-gradient-69);}.cls-74{fill:url(#linear-gradient-70);}.cls-75{fill:url(#linear-gradient-71);}.cls-76{fill:url(#linear-gradient-72);}.cls-77{fill:url(#linear-gradient-73);}.cls-78{fill:url(#linear-gradient-74);}.cls-79{fill:url(#linear-gradient-75);}.cls-80{fill:url(#linear-gradient-76);}.cls-81{fill:url(#linear-gradient-77);}.cls-82{fill:url(#linear-gradient-78);}.cls-83{fill:url(#linear-gradient-79);}.cls-84{fill:url(#linear-gradient-80);}.cls-85{fill:url(#linear-gradient-81);}.cls-86{fill:url(#linear-gradient-82);}.cls-87{fill:url(#linear-gradient-83);}.cls-88{fill:url(#linear-gradient-84);}.cls-89{fill:#f9f6e7;}.cls-90{fill:url(#linear-gradient-85);}.cls-91{fill:url(#linear-gradient-86);}.cls-92{fill:url(#linear-gradient-87);}.cls-93{fill:url(#linear-gradient-88);}.cls-94{fill:url(#linear-gradient-89);}.cls-95{fill:url(#linear-gradient-90);}.cls-96{fill:url(#linear-gradient-91);}.cls-97{fill:url(#linear-gradient-92);}.cls-98{fill:url(#linear-gradient-93);}.cls-99{fill:url(#linear-gradient-94);}.cls-100{fill:#e08080;}.cls-101{fill:url(#linear-gradient-95);}.cls-102{fill:url(#linear-gradient-96);}.cls-103{fill:url(#linear-gradient-97);}.cls-104{fill:url(#linear-gradient-98);}.cls-105{fill:url(#linear-gradient-99);}.cls-106{fill:#fff;}.cls-107{fill:url(#linear-gradient-100);}.cls-108{fill:url(#linear-gradient-101);}.cls-109{fill:url(#linear-gradient-102);}.cls-110{fill:url(#linear-gradient-103);}.cls-111{fill:url(#linear-gradient-104);}.cls-112{fill:url(#linear-gradient-105);}.cls-113{fill:url(#linear-gradient-106);}.cls-114{fill:url(#linear-gradient-107);}.cls-115{fill:#605972;}.cls-116{fill:#474056;}.cls-117{fill:url(#linear-gradient-108);}.cls-118{fill:#f5a499;}.cls-119{fill:#231f20;}.cls-120{fill:url(#linear-gradient-109);}.cls-121{fill:url(#linear-gradient-110);}.cls-122{fill:url(#linear-gradient-111);}.cls-123{fill:url(#linear-gradient-112);}.cls-124{fill:url(#linear-gradient-113);}.cls-125{fill:url(#linear-gradient-114);}.cls-126{fill:url(#linear-gradient-115);}.cls-127{fill:#dc6626;}.cls-128{fill:url(#linear-gradient-116);}.cls-129{fill:url(#linear-gradient-117);}.cls-130{fill:url(#linear-gradient-118);}.cls-131{fill:url(#linear-gradient-119);}.cls-132{fill:url(#linear-gradient-120);}.cls-133{fill:url(#linear-gradient-121);}.cls-134{fill:url(#linear-gradient-122);}.cls-135{fill:url(#linear-gradient-123);}.cls-136{fill:url(#linear-gradient-124);}.cls-137{fill:url(#linear-gradient-125);}.cls-138{fill:url(#linear-gradient-126);}.cls-139{fill:url(#linear-gradient-127);}.cls-140{fill:url(#linear-gradient-128);}.cls-141{fill:url(#linear-gradient-129);}.cls-142{fill:url(#linear-gradient-130);}.cls-143{fill:url(#linear-gradient-131);}.cls-144{fill:url(#linear-gradient-132);}.cls-145{fill:url(#linear-gradient-133);}.cls-146{fill:url(#linear-gradient-134);}.cls-147{fill:url(#linear-gradient-135);}.cls-148{fill:url(#linear-gradient-136);}.cls-149{fill:url(#linear-gradient-137);}.cls-150{fill:url(#linear-gradient-138);}.cls-151{fill:url(#linear-gradient-139);}.cls-152{fill:url(#linear-gradient-140);}.cls-153{fill:url(#linear-gradient-141);}.cls-154{fill:url(#linear-gradient-142);}.cls-155{fill:url(#linear-gradient-143);}.cls-156{fill:url(#linear-gradient-144);}.cls-157{fill:url(#linear-gradient-145);}.cls-158{fill:url(#linear-gradient-146);}.cls-159{fill:url(#linear-gradient-147);}.cls-160{fill:url(#linear-gradient-148);}.cls-161{fill:url(#linear-gradient-149);}.cls-162{fill:url(#linear-gradient-150);}.cls-163{fill:url(#linear-gradient-151);}.cls-164{fill:url(#linear-gradient-152);}.cls-165{fill:url(#linear-gradient-153);}.cls-166{fill:url(#linear-gradient-154);}.cls-167{fill:url(#linear-gradient-155);}.cls-168{fill:url(#linear-gradient-156);}.cls-169{fill:url(#linear-gradient-157);}.cls-170{fill:url(#linear-gradient-158);}.cls-171{fill:url(#linear-gradient-159);}.cls-172{fill:url(#linear-gradient-160);}.cls-173{fill:url(#linear-gradient-161);}.cls-174{fill:url(#linear-gradient-162);}.cls-175{fill:url(#linear-gradient-163);}.cls-176{fill:url(#linear-gradient-164);}.cls-177{fill:url(#linear-gradient-165);}.cls-178{fill:url(#linear-gradient-166);}.cls-179{fill:url(#linear-gradient-167);}.cls-180{fill:url(#linear-gradient-168);}.cls-181{fill:url(#linear-gradient-169);}.cls-182{fill:url(#linear-gradient-170);}.cls-183{fill:url(#linear-gradient-171);}.cls-184{fill:url(#linear-gradient-172);}.cls-185{fill:url(#linear-gradient-173);}.cls-186{fill:url(#linear-gradient-174);}.cls-187{fill:url(#linear-gradient-175);}.cls-188{fill:url(#linear-gradient-176);}.cls-189{fill:url(#linear-gradient-177);}.cls-190{fill:url(#linear-gradient-178);}.cls-191{fill:url(#linear-gradient-179);}.cls-192{fill:url(#linear-gradient-180);}.cls-193{fill:url(#linear-gradient-181);}.cls-194{fill:url(#linear-gradient-182);}.cls-195{fill:url(#linear-gradient-183);}.cls-196{fill:url(#linear-gradient-184);}.cls-197{fill:url(#linear-gradient-185);}.cls-198{fill:url(#linear-gradient-186);}.cls-199{fill:url(#linear-gradient-187);}.cls-200{fill:url(#linear-gradient-188);}.cls-201{fill:url(#linear-gradient-189);}.cls-202{fill:url(#linear-gradient-190);}.cls-203{fill:url(#linear-gradient-191);}.cls-204{fill:url(#linear-gradient-192);}.cls-205{fill:url(#linear-gradient-193);}.cls-206{fill:url(#linear-gradient-194);}.cls-207{fill:url(#linear-gradient-195);}.cls-208{fill:url(#linear-gradient-196);}.cls-209{fill:url(#linear-gradient-197);}.cls-210{fill:url(#linear-gradient-198);}.cls-211{fill:url(#linear-gradient-199);}.cls-212{fill:url(#linear-gradient-200);}.cls-213{fill:url(#linear-gradient-201);}.cls-214{fill:url(#linear-gradient-202);}.cls-215{fill:url(#linear-gradient-203);}.cls-216{fill:url(#linear-gradient-204);}.cls-217{fill:url(#linear-gradient-205);}.cls-218{fill:url(#linear-gradient-206);}.cls-219{fill:url(#linear-gradient-207);}.cls-220{fill:url(#linear-gradient-208);}.cls-221{fill:url(#linear-gradient-209);}.cls-222{fill:url(#linear-gradient-210);}.cls-223{fill:url(#linear-gradient-211);}.cls-224{fill:url(#linear-gradient-212);}.cls-225{fill:url(#linear-gradient-213);}.cls-226{fill:url(#linear-gradient-214);}.cls-227{fill:url(#linear-gradient-215);}.cls-228{fill:url(#linear-gradient-216);}.cls-229{fill:url(#linear-gradient-217);}.cls-230{fill:url(#linear-gradient-218);}.cls-231{fill:url(#linear-gradient-219);}.cls-232{fill:url(#linear-gradient-220);}.cls-233{fill:url(#linear-gradient-221);}.cls-234{fill:url(#linear-gradient-222);}.cls-235{fill:url(#linear-gradient-223);}.cls-236{fill:url(#linear-gradient-224);}.cls-237{fill:url(#linear-gradient-225);}.cls-238{fill:url(#linear-gradient-226);}.cls-239{fill:url(#linear-gradient-227);}.cls-240{fill:url(#linear-gradient-228);}.cls-241{fill:url(#linear-gradient-229);}.cls-242{fill:url(#linear-gradient-230);}.cls-243{fill:url(#linear-gradient-231);}.cls-244{fill:url(#linear-gradient-232);}.cls-245{fill:url(#linear-gradient-233);}.cls-246{fill:url(#linear-gradient-234);}.cls-247{fill:url(#linear-gradient-235);}.cls-248{fill:url(#linear-gradient-236);}.cls-249{fill:url(#linear-gradient-237);}.cls-250{fill:url(#linear-gradient-238);}.cls-251{fill:url(#linear-gradient-239);}.cls-252{fill:url(#linear-gradient-240);}.cls-253{fill:url(#linear-gradient-241);}.cls-254{fill:url(#linear-gradient-242);}.cls-255{fill:url(#linear-gradient-243);}.cls-256{fill:url(#linear-gradient-244);}.cls-257{fill:url(#linear-gradient-245);}.cls-258{fill:url(#linear-gradient-246);}.cls-259{fill:url(#linear-gradient-247);}.cls-260{fill:url(#linear-gradient-248);}.cls-261{fill:url(#linear-gradient-249);}.cls-262{fill:url(#linear-gradient-250);}.cls-263{fill:url(#linear-gradient-251);}.cls-264{fill:url(#linear-gradient-252);}.cls-265{fill:url(#linear-gradient-253);}.cls-266{fill:url(#linear-gradient-254);}.cls-267{fill:url(#linear-gradient-255);}.cls-268{fill:url(#linear-gradient-256);}.cls-269{fill:url(#linear-gradient-257);}.cls-270{fill:url(#linear-gradient-258);}.cls-271{fill:url(#linear-gradient-259);}.cls-272{fill:url(#linear-gradient-260);}.cls-273{fill:url(#linear-gradient-261);}.cls-274{fill:url(#linear-gradient-262);}.cls-275{fill:url(#linear-gradient-263);}.cls-276{fill:url(#linear-gradient-264);}.cls-277{fill:url(#linear-gradient-265);}.cls-278{fill:url(#linear-gradient-266);}.cls-279{fill:url(#linear-gradient-267);}.cls-280{fill:url(#linear-gradient-268);}.cls-281{fill:url(#linear-gradient-269);}.cls-282{fill:url(#linear-gradient-270);}.cls-283{fill:url(#linear-gradient-271);}.cls-284{fill:url(#linear-gradient-272);}.cls-285{fill:url(#linear-gradient-273);}.cls-286{fill:url(#linear-gradient-274);}.cls-287{fill:url(#linear-gradient-275);}.cls-288{fill:url(#linear-gradient-276);}.cls-289{fill:url(#linear-gradient-277);}.cls-290{fill:url(#linear-gradient-278);}.cls-291{fill:url(#linear-gradient-279);}.cls-292{fill:url(#linear-gradient-280);}.cls-293{fill:url(#linear-gradient-281);}.cls-294{fill:url(#linear-gradient-282);}.cls-295{fill:url(#linear-gradient-283);}.cls-296{fill:url(#linear-gradient-284);}.cls-297{fill:url(#linear-gradient-285);}.cls-298{fill:url(#linear-gradient-286);}.cls-299{fill:url(#linear-gradient-287);}.cls-300{fill:url(#linear-gradient-288);}.cls-301{fill:url(#linear-gradient-289);}.cls-302{fill:url(#linear-gradient-290);}.cls-303{fill:url(#linear-gradient-291);}.cls-304{fill:url(#linear-gradient-292);}.cls-305{fill:url(#linear-gradient-293);}.cls-306{fill:url(#linear-gradient-294);}.cls-307{fill:url(#linear-gradient-295);}.cls-308{fill:url(#linear-gradient-296);}.cls-309{fill:url(#linear-gradient-297);}.cls-310{fill:url(#linear-gradient-298);}.cls-311{fill:url(#linear-gradient-299);}.cls-312{fill:url(#linear-gradient-300);}.cls-313{fill:url(#linear-gradient-301);}.cls-314{fill:url(#linear-gradient-302);}.cls-315{fill:url(#linear-gradient-310);}.cls-316{fill:url(#linear-gradient-315);}.cls-317{fill:url(#linear-gradient-316);}.cls-318{fill:url(#linear-gradient-317);}.cls-319{fill:url(#linear-gradient-318);}.cls-320{fill:url(#linear-gradient-319);}.cls-321{fill:url(#linear-gradient-320);}.cls-322{fill:url(#linear-gradient-321);}.cls-323{fill:url(#linear-gradient-322);}.cls-324{fill:url(#linear-gradient-323);}.cls-325{fill:url(#linear-gradient-324);}.cls-326{fill:url(#linear-gradient-325);}.cls-327{fill:url(#linear-gradient-326);}.cls-328{fill:url(#linear-gradient-327);}.cls-329{fill:url(#linear-gradient-328);}.cls-330{fill:url(#linear-gradient-329);}.cls-331{fill:url(#linear-gradient-330);}.cls-332{fill:url(#linear-gradient-331);}.cls-333{fill:url(#linear-gradient-332);}.cls-334{fill:url(#linear-gradient-333);}.cls-335{fill:url(#linear-gradient-334);}.cls-336{fill:url(#linear-gradient-335);}.cls-337{fill:url(#linear-gradient-336);}.cls-338{fill:url(#linear-gradient-337);}.cls-339{fill:url(#linear-gradient-338);}.cls-340{fill:url(#linear-gradient-339);}.cls-341{fill:url(#linear-gradient-340);}.cls-342{fill:url(#linear-gradient-341);}.cls-343{fill:url(#linear-gradient-342);}.cls-344{fill:url(#linear-gradient-343);}.cls-345{fill:url(#linear-gradient-344);}.cls-346{fill:url(#linear-gradient-346);}.cls-347{fill:url(#linear-gradient-347);}.cls-348{fill:url(#linear-gradient-352);}.cls-349{fill:url(#linear-gradient-357);}.cls-350{fill:url(#linear-gradient-365);}.cls-351{fill:url(#linear-gradient-370);}.cls-352{fill:url(#linear-gradient-371);}.cls-353{fill:url(#linear-gradient-372);}.cls-354{fill:url(#linear-gradient-373);}.cls-355{fill:url(#linear-gradient-374);}.cls-356{fill:url(#linear-gradient-375);}.cls-357{fill:url(#linear-gradient-376);}.cls-358{fill:url(#linear-gradient-377);}.cls-359{fill:url(#linear-gradient-378);}.cls-360{fill:url(#linear-gradient-379);}.cls-361{fill:url(#linear-gradient-380);}.cls-362{fill:url(#linear-gradient-381);}.cls-363{fill:url(#linear-gradient-382);}.cls-364{fill:url(#linear-gradient-383);}.cls-365{fill:url(#linear-gradient-384);}.cls-366{fill:url(#linear-gradient-385);}.cls-367{fill:url(#linear-gradient-386);}.cls-368{fill:url(#linear-gradient-387);}.cls-369{fill:url(#linear-gradient-388);}.cls-370{fill:url(#linear-gradient-389);}.cls-371{fill:url(#linear-gradient-390);}.cls-372{fill:url(#linear-gradient-391);}.cls-373{fill:url(#linear-gradient-392);}.cls-374{fill:url(#linear-gradient-393);}.cls-375{fill:url(#linear-gradient-394);}.cls-376{fill:url(#linear-gradient-395);}.cls-377{fill:url(#linear-gradient-396);}.cls-378{fill:#f7b733;}.cls-379{fill:url(#linear-gradient-397);}.cls-380{fill:url(#linear-gradient-398);}.cls-381{fill:url(#linear-gradient-399);}.cls-382{fill:url(#linear-gradient-400);}.cls-383{fill:url(#linear-gradient-401);}.cls-384{fill:url(#linear-gradient-402);}.cls-385{fill:url(#linear-gradient-403);}.cls-386{fill:url(#linear-gradient-404);}.cls-387{fill:url(#linear-gradient-405);}.cls-388{fill:url(#linear-gradient-406);}.cls-389{fill:url(#linear-gradient-407);}.cls-390{fill:url(#linear-gradient-408);}.cls-391{fill:url(#linear-gradient-409);}.cls-392{fill:url(#linear-gradient-410);}.cls-393{fill:url(#linear-gradient-411);}.cls-394{fill:url(#linear-gradient-412);}.cls-395{fill:url(#linear-gradient-413);}.cls-396{fill:url(#linear-gradient-414);}.cls-397{fill:url(#linear-gradient-415);}.cls-398{fill:url(#linear-gradient-416);}.cls-399{fill:url(#linear-gradient-417);}.cls-400{fill:url(#linear-gradient-418);}.cls-401{fill:url(#linear-gradient-419);}.cls-402{fill:url(#linear-gradient-420);}.cls-403{fill:url(#linear-gradient-421);}.cls-404{fill:url(#linear-gradient-422);}.cls-405{fill:url(#linear-gradient-423);}.cls-406{fill:url(#linear-gradient-424);}.cls-407{fill:url(#linear-gradient-425);}.cls-408{fill:url(#linear-gradient-426);}.cls-409{fill:url(#linear-gradient-427);}.cls-410{fill:url(#linear-gradient-428);}.cls-411{fill:url(#linear-gradient-429);}.cls-412{fill:url(#linear-gradient-430);}.cls-413{fill:url(#linear-gradient-431);}.cls-414{fill:#ffd385;}.cls-415{fill:url(#linear-gradient-432);}.cls-416{fill:url(#linear-gradient-433);}.cls-417{fill:url(#linear-gradient-434);}.cls-418{fill:url(#linear-gradient-435);}.cls-419{fill:url(#linear-gradient-436);}.cls-420{fill:url(#linear-gradient-437);}.cls-421{fill:url(#linear-gradient-438);}.cls-422{fill:url(#linear-gradient-439);}.cls-423{fill:url(#linear-gradient-440);}.cls-424{fill:url(#linear-gradient-441);}.cls-425{fill:url(#linear-gradient-442);}.cls-426{fill:url(#linear-gradient-443);}.cls-427{fill:url(#linear-gradient-444);}.cls-428{fill:url(#linear-gradient-445);}.cls-429{fill:url(#linear-gradient-446);}.cls-430{fill:url(#linear-gradient-447);}.cls-431{fill:url(#linear-gradient-448);}.cls-432{fill:url(#linear-gradient-449);}.cls-433{fill:url(#linear-gradient-450);}.cls-434{fill:url(#linear-gradient-451);}.cls-435{fill:url(#linear-gradient-452);}.cls-436{fill:url(#linear-gradient-453);}.cls-437{fill:url(#linear-gradient-454);}.cls-438{fill:url(#linear-gradient-455);}.cls-439{fill:url(#linear-gradient-456);}.cls-440{fill:url(#linear-gradient-457);}.cls-441{fill:url(#linear-gradient-458);}.cls-442{fill:url(#linear-gradient-459);}.cls-443{fill:url(#linear-gradient-460);}.cls-444{fill:url(#linear-gradient-461);}.cls-445{fill:url(#linear-gradient-462);}.cls-446{fill:url(#linear-gradient-463);}.cls-447{fill:url(#linear-gradient-464);}.cls-448{fill:url(#linear-gradient-465);}.cls-449{fill:url(#linear-gradient-466);}.cls-450{fill:url(#linear-gradient-467);}.cls-451{fill:url(#linear-gradient-468);}.cls-452{fill:url(#linear-gradient-469);}.cls-453{fill:url(#linear-gradient-470);}.cls-454{fill:url(#linear-gradient-471);}.cls-455{fill:url(#linear-gradient-472);}.cls-456{fill:url(#linear-gradient-473);}.cls-457{fill:url(#linear-gradient-474);}.cls-458{fill:url(#linear-gradient-475);}.cls-459{fill:url(#linear-gradient-476);}.cls-460{fill:url(#linear-gradient-477);}.cls-461{fill:url(#linear-gradient-478);}.cls-462{fill:url(#linear-gradient-479);}.cls-463{fill:url(#linear-gradient-480);}.cls-464{fill:url(#linear-gradient-481);}.cls-465{fill:url(#linear-gradient-482);}.cls-466{fill:url(#linear-gradient-483);}.cls-467{fill:url(#linear-gradient-484);}.cls-468{fill:url(#linear-gradient-485);}.cls-469{fill:url(#linear-gradient-486);}.cls-470{fill:url(#linear-gradient-487);}.cls-471{fill:url(#linear-gradient-488);}.cls-472{fill:url(#linear-gradient-489);}.cls-473{fill:url(#linear-gradient-490);}.cls-474{fill:url(#linear-gradient-491);}.cls-475{fill:url(#linear-gradient-492);}.cls-476{fill:url(#linear-gradient-493);}.cls-477{fill:url(#linear-gradient-494);}.cls-478{fill:url(#linear-gradient-495);}.cls-479{fill:url(#linear-gradient-496);}.cls-480{fill:url(#linear-gradient-497);}.cls-481{fill:url(#linear-gradient-498);}.cls-482{fill:url(#linear-gradient-499);}.cls-483{fill:url(#linear-gradient-500);}.cls-484{fill:url(#linear-gradient-501);}.cls-485{fill:url(#linear-gradient-502);}.cls-486{fill:url(#linear-gradient-503);}.cls-487{fill:url(#linear-gradient-504);}.cls-488{fill:url(#linear-gradient-505);}.cls-489{fill:url(#linear-gradient-506);}.cls-490{fill:url(#linear-gradient-507);}.cls-491{fill:url(#linear-gradient-508);}.cls-492{fill:url(#linear-gradient-509);}.cls-493{fill:url(#linear-gradient-510);}.cls-494{fill:url(#linear-gradient-511);}.cls-495{fill:url(#linear-gradient-512);}.cls-496{fill:url(#linear-gradient-513);}.cls-497{fill:url(#linear-gradient-514);}.cls-498{fill:url(#linear-gradient-515);}.cls-499{fill:url(#linear-gradient-516);}.cls-500{fill:url(#linear-gradient-517);}.cls-501{fill:url(#linear-gradient-518);}.cls-502{fill:url(#linear-gradient-519);}.cls-503{fill:url(#linear-gradient-520);}.cls-504{fill:url(#linear-gradient-521);}.cls-505{fill:url(#linear-gradient-522);}.cls-506{fill:url(#linear-gradient-523);}.cls-507{fill:url(#linear-gradient-524);}.cls-508{fill:url(#linear-gradient-525);}.cls-509{fill:url(#linear-gradient-526);}.cls-510{fill:url(#linear-gradient-527);}.cls-511{fill:url(#linear-gradient-528);}.cls-512{fill:url(#linear-gradient-529);}.cls-513{fill:url(#linear-gradient-530);}.cls-514{fill:url(#linear-gradient-531);}.cls-515{fill:url(#linear-gradient-532);}.cls-516{fill:url(#linear-gradient-533);}.cls-517{fill:url(#linear-gradient-534);}.cls-518{fill:url(#linear-gradient-535);}.cls-519{fill:url(#linear-gradient-536);}.cls-520{fill:url(#linear-gradient-537);}.cls-521{fill:url(#linear-gradient-538);}.cls-522{fill:url(#linear-gradient-539);}.cls-523{fill:url(#linear-gradient-540);}.cls-524{fill:url(#linear-gradient-541);}.cls-525{fill:url(#linear-gradient-542);}.cls-526{fill:url(#linear-gradient-543);}.cls-527{fill:url(#linear-gradient-544);}.cls-528{fill:url(#linear-gradient-545);}.cls-529{fill:url(#linear-gradient-546);}.cls-530{fill:url(#linear-gradient-547);}.cls-531{fill:url(#linear-gradient-548);}.cls-532{fill:url(#linear-gradient-549);}.cls-533{fill:url(#linear-gradient-550);}.cls-534{fill:url(#linear-gradient-551);}.cls-535{fill:url(#linear-gradient-552);}.cls-536{fill:url(#linear-gradient-553);}.cls-537{fill:url(#linear-gradient-554);}.cls-538{fill:url(#linear-gradient-555);}.cls-539{fill:url(#linear-gradient-556);}.cls-540{fill:url(#linear-gradient-557);}.cls-541{fill:url(#linear-gradient-558);}.cls-542{fill:url(#linear-gradient-559);}.cls-543{fill:url(#linear-gradient-560);}.cls-544{fill:url(#linear-gradient-561);}.cls-545{fill:url(#linear-gradient-562);}.cls-546{fill:url(#linear-gradient-563);}.cls-547{fill:url(#linear-gradient-564);}.cls-548{fill:url(#linear-gradient-565);}.cls-549{fill:url(#linear-gradient-566);}.cls-550{fill:url(#linear-gradient-567);}.cls-551{fill:url(#linear-gradient-568);}.cls-552{fill:url(#linear-gradient-569);}.cls-553{fill:url(#linear-gradient-570);}.cls-554{fill:url(#linear-gradient-571);}.cls-555{fill:url(#linear-gradient-572);}.cls-556{fill:url(#linear-gradient-573);}.cls-557{fill:url(#linear-gradient-574);}.cls-558{fill:url(#linear-gradient-575);}.cls-559{fill:url(#linear-gradient-576);}.cls-560{fill:url(#linear-gradient-577);}.cls-561{fill:url(#linear-gradient-578);}.cls-562{fill:url(#linear-gradient-579);}.cls-563{fill:url(#linear-gradient-580);}.cls-564{fill:url(#linear-gradient-581);}.cls-565{fill:url(#linear-gradient-582);}.cls-566{fill:url(#linear-gradient-583);}.cls-567{fill:url(#linear-gradient-584);}.cls-568{fill:url(#linear-gradient-585);}.cls-569{fill:url(#linear-gradient-586);}.cls-570{fill:url(#linear-gradient-587);}.cls-571{fill:url(#linear-gradient-588);}.cls-572{fill:url(#linear-gradient-589);}.cls-573{fill:url(#linear-gradient-590);}.cls-574{fill:url(#linear-gradient-591);}.cls-575{fill:url(#linear-gradient-592);}.cls-576{fill:url(#linear-gradient-593);}.cls-577{fill:url(#linear-gradient-594);}.cls-578{fill:url(#linear-gradient-595);}.cls-579{fill:url(#linear-gradient-596);}.cls-580{fill:url(#linear-gradient-597);}.cls-581{fill:url(#linear-gradient-598);}.cls-582{fill:url(#linear-gradient-599);}.cls-583{fill:url(#linear-gradient-600);}.cls-584{fill:url(#linear-gradient-601);}.cls-585{fill:url(#linear-gradient-602);}.cls-586{fill:url(#linear-gradient-603);}.cls-587{fill:url(#linear-gradient-604);}.cls-588{fill:url(#linear-gradient-605);}.cls-589{fill:url(#linear-gradient-606);}.cls-590{fill:url(#linear-gradient-607);}.cls-591{fill:url(#linear-gradient-608);}.cls-592{fill:url(#linear-gradient-609);}.cls-593{fill:url(#linear-gradient-610);}.cls-594{fill:url(#linear-gradient-611);}.cls-595{fill:url(#linear-gradient-612);}.cls-596{fill:url(#linear-gradient-613);}.cls-597{fill:url(#linear-gradient-614);}.cls-598{fill:url(#linear-gradient-615);}.cls-599{fill:url(#linear-gradient-616);}.cls-600{fill:url(#linear-gradient-617);}.cls-601{fill:url(#linear-gradient-618);}.cls-602{fill:url(#linear-gradient-619);}.cls-603{fill:url(#linear-gradient-620);}.cls-604{fill:url(#linear-gradient-621);}.cls-605{fill:url(#linear-gradient-622);}.cls-606{fill:url(#linear-gradient-623);}.cls-607{fill:url(#linear-gradient-624);}.cls-608{fill:url(#linear-gradient-625);}.cls-609{fill:url(#linear-gradient-626);}.cls-610{fill:url(#linear-gradient-627);}.cls-611{fill:url(#linear-gradient-628);}.cls-612{fill:url(#linear-gradient-629);}.cls-613{fill:url(#linear-gradient-630);}.cls-614{fill:url(#linear-gradient-631);}.cls-615{fill:url(#linear-gradient-632);}.cls-616{fill:url(#linear-gradient-633);}.cls-617{fill:url(#linear-gradient-634);}.cls-618{fill:url(#linear-gradient-635);}.cls-619{fill:url(#linear-gradient-636);}.cls-620{fill:url(#linear-gradient-637);}.cls-621{fill:url(#linear-gradient-638);}.cls-622{fill:url(#linear-gradient-639);}.cls-623{fill:url(#linear-gradient-640);}.cls-624{fill:url(#linear-gradient-641);}.cls-625{fill:url(#linear-gradient-642);}.cls-626{fill:url(#linear-gradient-643);}.cls-627{fill:url(#linear-gradient-644);}.cls-628{fill:url(#linear-gradient-645);}.cls-629{fill:url(#linear-gradient-646);}.cls-630{fill:url(#linear-gradient-647);}.cls-631{fill:url(#linear-gradient-648);}.cls-632{fill:url(#linear-gradient-649);}.cls-633{fill:url(#linear-gradient-650);}.cls-634{fill:url(#linear-gradient-651);}.cls-635{fill:url(#linear-gradient-652);}.cls-636{fill:url(#linear-gradient-653);}.cls-637{fill:url(#linear-gradient-654);}.cls-638{fill:url(#linear-gradient-655);}.cls-639{fill:url(#linear-gradient-656);}.cls-640{fill:url(#linear-gradient-657);}.cls-641{fill:url(#linear-gradient-658);}.cls-642{fill:url(#linear-gradient-659);}.cls-643{fill:url(#linear-gradient-660);}.cls-644{fill:url(#linear-gradient-661);}.cls-645{fill:url(#linear-gradient-662);}.cls-646{fill:url(#linear-gradient-663);}.cls-647{fill:url(#linear-gradient-664);}.cls-648{fill:url(#linear-gradient-665);}.cls-649{fill:url(#linear-gradient-666);}.cls-650{fill:url(#linear-gradient-667);}.cls-651{fill:url(#linear-gradient-668);}.cls-652{fill:url(#linear-gradient-669);}.cls-653{fill:url(#linear-gradient-670);}.cls-654{fill:url(#linear-gradient-671);}.cls-655{fill:url(#linear-gradient-672);}.cls-656{fill:url(#linear-gradient-673);}.cls-657{fill:url(#linear-gradient-674);}.cls-658{fill:url(#linear-gradient-675);}.cls-659{fill:url(#linear-gradient-676);}.cls-660{fill:url(#linear-gradient-677);}.cls-661{fill:url(#linear-gradient-678);}.cls-662{fill:url(#linear-gradient-679);}.cls-663{fill:url(#linear-gradient-680);}.cls-664{fill:url(#linear-gradient-681);}.cls-665{fill:url(#linear-gradient-682);}.cls-666{fill:url(#linear-gradient-683);}.cls-667{fill:url(#linear-gradient-684);}.cls-668{fill:url(#linear-gradient-685);}.cls-669{fill:url(#linear-gradient-686);}.cls-670{fill:url(#linear-gradient-687);}.cls-671{fill:url(#linear-gradient-688);}.cls-672{fill:url(#linear-gradient-689);}.cls-673{fill:url(#linear-gradient-690);}.cls-674{fill:url(#linear-gradient-691);}.cls-675{fill:url(#linear-gradient-692);}.cls-676{fill:url(#linear-gradient-693);}.cls-677{fill:url(#linear-gradient-694);}.cls-678{fill:url(#linear-gradient-695);}.cls-679{fill:url(#linear-gradient-696);}.cls-680{fill:url(#linear-gradient-697);}.cls-681{fill:url(#linear-gradient-698);}.cls-682{fill:url(#linear-gradient-699);}.cls-683{fill:url(#linear-gradient-700);}.cls-684{fill:url(#linear-gradient-701);}.cls-685{fill:url(#linear-gradient-702);}.cls-686{fill:url(#linear-gradient-703);}.cls-687{fill:url(#linear-gradient-704);}.cls-688{fill:url(#linear-gradient-705);}.cls-689{fill:url(#linear-gradient-706);}.cls-690{fill:url(#linear-gradient-707);}.cls-691{fill:url(#linear-gradient-708);}.cls-692{fill:url(#linear-gradient-709);}.cls-693{fill:url(#linear-gradient-710);}.cls-694{fill:url(#linear-gradient-711);}.cls-695{fill:url(#linear-gradient-712);}.cls-696{fill:url(#linear-gradient-713);}.cls-697{fill:url(#linear-gradient-714);}.cls-698{fill:url(#linear-gradient-715);}.cls-699{fill:url(#linear-gradient-716);}.cls-700{fill:url(#linear-gradient-717);}.cls-701{fill:url(#linear-gradient-718);}.cls-702{fill:url(#linear-gradient-719);}.cls-703{fill:url(#linear-gradient-720);}.cls-704{fill:url(#linear-gradient-721);}.cls-705{fill:url(#linear-gradient-722);}.cls-706{fill:url(#linear-gradient-723);}.cls-707{fill:url(#linear-gradient-724);}.cls-708{fill:url(#linear-gradient-725);}.cls-709{fill:url(#linear-gradient-726);}.cls-710{fill:url(#linear-gradient-727);}.cls-711{fill:url(#linear-gradient-728);}.cls-712{fill:url(#linear-gradient-729);}.cls-713{fill:url(#linear-gradient-730);}.cls-714{fill:url(#linear-gradient-731);}.cls-715{fill:url(#linear-gradient-732);}.cls-716{fill:url(#linear-gradient-733);}.cls-717{fill:url(#linear-gradient-734);}.cls-718{fill:url(#linear-gradient-735);}.cls-719{fill:url(#linear-gradient-736);}.cls-720{fill:url(#linear-gradient-737);}.cls-721{fill:url(#linear-gradient-738);}.cls-722{fill:url(#linear-gradient-739);}.cls-723{fill:url(#linear-gradient-740);}.cls-724{fill:url(#linear-gradient-741);}.cls-725{fill:#343451;}.cls-726,.cls-764{fill:none;}.cls-726{stroke:#231f20;stroke-miterlimit:10;stroke-width:0.5px;}.cls-727{fill:url(#linear-gradient-742);}.cls-728{fill:url(#linear-gradient-743);}.cls-729{fill:url(#linear-gradient-744);}.cls-730{fill:url(#linear-gradient-745);}.cls-731{fill:url(#linear-gradient-746);}.cls-732{fill:url(#linear-gradient-747);}.cls-733{fill:url(#linear-gradient-748);}.cls-734{fill:url(#linear-gradient-749);}.cls-735{fill:url(#linear-gradient-750);}.cls-736{fill:url(#linear-gradient-751);}.cls-737{fill:url(#linear-gradient-752);}.cls-738{fill:url(#linear-gradient-753);}.cls-739{fill:url(#linear-gradient-754);}.cls-740{fill:url(#linear-gradient-755);}.cls-741{fill:url(#linear-gradient-756);}.cls-742{fill:url(#linear-gradient-757);}.cls-743{fill:url(#linear-gradient-758);}.cls-744{fill:url(#linear-gradient-759);}.cls-745{fill:url(#linear-gradient-760);}.cls-746{fill:url(#linear-gradient-761);}.cls-747{fill:url(#linear-gradient-762);}.cls-748{fill:url(#linear-gradient-763);}.cls-749{fill:url(#linear-gradient-764);}.cls-750{fill:url(#linear-gradient-765);}.cls-751{fill:url(#linear-gradient-766);}.cls-752{fill:url(#linear-gradient-767);}.cls-753{fill:url(#linear-gradient-768);}.cls-754{fill:url(#linear-gradient-769);}.cls-755{fill:url(#linear-gradient-770);}.cls-756{fill:url(#linear-gradient-771);}.cls-757{fill:url(#linear-gradient-772);}.cls-758{fill:url(#linear-gradient-773);}.cls-759{fill:url(#linear-gradient-774);}.cls-760{fill:url(#linear-gradient-775);}.cls-761{fill:url(#linear-gradient-776);}.cls-762{fill:url(#linear-gradient-777);}.cls-763{fill:url(#linear-gradient-778);}.cls-765{fill:url(#linear-gradient-779);}.cls-766{fill:url(#linear-gradient-780);}.cls-767{fill:url(#linear-gradient-781);}.cls-768{fill:url(#linear-gradient-782);}.cls-769{fill:url(#linear-gradient-783);}.cls-770{fill:url(#linear-gradient-784);}.cls-771{fill:url(#linear-gradient-785);}.cls-772{fill:url(#linear-gradient-786);}.cls-773{fill:url(#linear-gradient-787);}.cls-774{fill:url(#linear-gradient-788);}.cls-775{fill:url(#linear-gradient-789);}.cls-776{fill:url(#linear-gradient-790);}.cls-777{fill:url(#linear-gradient-791);}.cls-778{fill:url(#linear-gradient-792);}.cls-779{fill:url(#linear-gradient-793);}.cls-780{fill:url(#linear-gradient-794);}.cls-781{fill:url(#linear-gradient-795);}.cls-782{fill:url(#linear-gradient-796);}.cls-783{fill:url(#linear-gradient-797);}.cls-784{fill:url(#linear-gradient-798);}.cls-785{fill:url(#linear-gradient-799);}.cls-786{fill:url(#linear-gradient-800);}.cls-787{fill:url(#linear-gradient-801);}.cls-788{fill:url(#linear-gradient-802);}.cls-789{fill:url(#linear-gradient-803);}.cls-790{fill:url(#linear-gradient-804);}.cls-791{fill:url(#linear-gradient-805);}.cls-792{fill:url(#linear-gradient-806);}.cls-793{fill:url(#linear-gradient-807);}.cls-794{fill:url(#linear-gradient-808);}.cls-795{fill:url(#linear-gradient-809);}.cls-796{fill:url(#linear-gradient-810);}.cls-797{fill:url(#linear-gradient-811);}.cls-798{fill:url(#linear-gradient-812);}.cls-799{fill:url(#linear-gradient-813);}.cls-800{fill:url(#linear-gradient-814);}.cls-801{fill:url(#linear-gradient-815);}.cls-802{fill:url(#linear-gradient-816);}.cls-803{fill:url(#linear-gradient-817);}.cls-804{fill:url(#linear-gradient-818);}.cls-805{fill:url(#linear-gradient-819);}.cls-806{fill:url(#linear-gradient-820);}.cls-807{fill:url(#linear-gradient-821);}.cls-808{fill:url(#linear-gradient-822);}.cls-809{fill:url(#linear-gradient-823);}.cls-810{fill:url(#linear-gradient-824);}.cls-811{fill:url(#linear-gradient-825);}.cls-812{fill:url(#linear-gradient-826);}.cls-813{fill:url(#linear-gradient-827);}.cls-814{fill:url(#linear-gradient-828);}.cls-815{fill:url(#linear-gradient-829);}.cls-816{fill:url(#linear-gradient-830);}.cls-817{fill:url(#linear-gradient-831);}.cls-818{fill:url(#linear-gradient-832);}.cls-819{fill:url(#linear-gradient-833);}.cls-820{fill:url(#linear-gradient-834);}.cls-821{fill:url(#linear-gradient-835);}.cls-822{fill:url(#linear-gradient-836);}.cls-823{fill:url(#linear-gradient-837);}.cls-824{fill:url(#linear-gradient-838);}.cls-825{fill:url(#linear-gradient-839);}.cls-826{fill:url(#linear-gradient-840);}.cls-827{fill:url(#linear-gradient-841);}.cls-828{fill:url(#linear-gradient-842);}.cls-829{fill:url(#linear-gradient-843);}.cls-830{fill:url(#linear-gradient-844);}.cls-831{fill:url(#linear-gradient-845);}.cls-832{fill:url(#linear-gradient-846);}.cls-833{fill:url(#linear-gradient-847);}.cls-834{fill:url(#linear-gradient-848);}.cls-835{fill:url(#linear-gradient-849);}.cls-836{fill:url(#linear-gradient-850);}.cls-837{fill:url(#linear-gradient-851);}.cls-838{fill:url(#linear-gradient-852);}.cls-839{fill:url(#linear-gradient-853);}.cls-840{fill:url(#linear-gradient-854);}.cls-841{fill:url(#linear-gradient-855);}.cls-842{fill:url(#linear-gradient-856);}.cls-843{fill:url(#linear-gradient-857);}.cls-844{fill:url(#linear-gradient-858);}.cls-845{fill:url(#linear-gradient-859);}.cls-846{fill:url(#linear-gradient-860);}.cls-847{fill:url(#linear-gradient-861);}.cls-848{fill:url(#linear-gradient-862);}.cls-849{fill:url(#linear-gradient-863);}.cls-850{fill:url(#linear-gradient-864);}.cls-851{fill:url(#linear-gradient-865);}.cls-852{fill:url(#linear-gradient-866);}.cls-853{fill:url(#linear-gradient-867);}.cls-854{fill:url(#linear-gradient-868);}.cls-855{fill:url(#linear-gradient-869);}.cls-856{fill:url(#linear-gradient-870);}.cls-857{fill:url(#linear-gradient-871);}.cls-858{fill:url(#linear-gradient-872);}.cls-859{fill:url(#linear-gradient-873);}.cls-860{fill:url(#linear-gradient-874);}.cls-861{fill:url(#linear-gradient-875);}.cls-862{fill:url(#linear-gradient-876);}.cls-863{fill:url(#linear-gradient-877);}.cls-864{fill:url(#linear-gradient-878);}.cls-865{fill:url(#linear-gradient-879);}.cls-866{fill:url(#linear-gradient-880);}.cls-867{fill:url(#linear-gradient-881);}.cls-868{fill:url(#linear-gradient-882);}.cls-869{fill:url(#linear-gradient-883);}.cls-870{fill:url(#linear-gradient-884);}.cls-871{fill:url(#linear-gradient-885);}.cls-872{fill:url(#linear-gradient-886);}.cls-873{fill:url(#linear-gradient-887);}.cls-874{fill:url(#linear-gradient-888);}.cls-875{fill:url(#linear-gradient-889);}.cls-876{fill:url(#linear-gradient-890);}.cls-877{fill:url(#linear-gradient-891);}.cls-878{fill:url(#linear-gradient-892);}.cls-879{fill:url(#linear-gradient-893);}.cls-880{fill:url(#linear-gradient-894);}.cls-881{fill:url(#linear-gradient-895);}.cls-882{fill:url(#linear-gradient-896);}.cls-883{fill:url(#linear-gradient-897);}.cls-884{fill:url(#linear-gradient-898);}.cls-885{fill:url(#linear-gradient-899);}.cls-886{fill:url(#linear-gradient-900);}.cls-887{fill:url(#linear-gradient-901);}.cls-888{fill:url(#linear-gradient-902);}.cls-889{fill:url(#linear-gradient-903);}.cls-890{fill:url(#linear-gradient-904);}.cls-891{fill:url(#linear-gradient-905);}.cls-892{fill:url(#linear-gradient-906);}.cls-893{fill:url(#linear-gradient-907);}.cls-894{fill:url(#linear-gradient-908);}.cls-895{fill:url(#linear-gradient-909);}.cls-896{fill:url(#linear-gradient-910);}.cls-897{fill:url(#linear-gradient-911);}.cls-898{fill:url(#linear-gradient-912);}.cls-899{fill:url(#linear-gradient-913);}.cls-900{fill:url(#linear-gradient-914);}.cls-901{fill:url(#linear-gradient-915);}.cls-902{fill:url(#linear-gradient-916);}.cls-903{fill:url(#linear-gradient-917);}.cls-904{fill:url(#linear-gradient-918);}.cls-905{fill:url(#linear-gradient-919);}.cls-906{fill:url(#linear-gradient-920);}.cls-907{fill:url(#linear-gradient-921);}.cls-908{fill:url(#linear-gradient-922);}.cls-909{fill:url(#linear-gradient-923);}.cls-910{fill:url(#linear-gradient-924);}.cls-911{fill:url(#linear-gradient-925);}.cls-912{fill:url(#linear-gradient-926);}.cls-913{fill:url(#linear-gradient-927);}.cls-914{fill:url(#linear-gradient-928);}.cls-915{fill:url(#linear-gradient-929);}.cls-916{fill:url(#linear-gradient-930);}.cls-917{fill:url(#linear-gradient-931);}.cls-918{fill:url(#linear-gradient-932);}.cls-919{fill:url(#linear-gradient-933);}.cls-920{fill:url(#linear-gradient-934);}.cls-921{fill:url(#linear-gradient-935);}.cls-922{fill:url(#linear-gradient-936);}.cls-923{fill:url(#linear-gradient-937);}.cls-924{fill:url(#linear-gradient-938);}.cls-925{fill:url(#linear-gradient-939);}.cls-926{fill:url(#linear-gradient-940);}.cls-927{fill:url(#linear-gradient-941);}.cls-928{fill:url(#linear-gradient-942);}.cls-929{fill:url(#linear-gradient-943);}.cls-930{fill:url(#linear-gradient-944);}.cls-931{fill:url(#linear-gradient-945);}.cls-932{fill:url(#linear-gradient-946);}.cls-933{fill:url(#linear-gradient-947);}.cls-934{fill:url(#linear-gradient-948);}.cls-935{fill:url(#linear-gradient-949);}.cls-936{fill:url(#linear-gradient-950);}.cls-937{fill:url(#linear-gradient-951);}.cls-938{fill:url(#linear-gradient-952);}.cls-939{fill:url(#linear-gradient-953);}.cls-940{fill:url(#linear-gradient-954);}.cls-941{fill:url(#linear-gradient-955);}.cls-942{fill:url(#linear-gradient-956);}.cls-943{fill:url(#linear-gradient-957);}.cls-944{fill:url(#linear-gradient-958);}.cls-945{fill:url(#linear-gradient-959);}.cls-946{fill:url(#linear-gradient-960);}.cls-947{fill:url(#linear-gradient-961);}.cls-948{fill:url(#linear-gradient-962);}.cls-949{fill:url(#linear-gradient-963);}.cls-950{fill:url(#linear-gradient-964);}.cls-951{fill:url(#linear-gradient-965);}.cls-952{fill:url(#linear-gradient-966);}.cls-953{fill:url(#linear-gradient-967);}.cls-954{fill:url(#linear-gradient-968);}.cls-955{fill:url(#linear-gradient-969);}.cls-956{fill:url(#linear-gradient-970);}.cls-957{fill:url(#linear-gradient-971);}.cls-958{fill:url(#linear-gradient-972);}.cls-959{fill:url(#linear-gradient-973);}.cls-960{fill:url(#linear-gradient-974);}.cls-961{fill:url(#linear-gradient-975);}.cls-962{fill:url(#linear-gradient-976);}.cls-963{fill:url(#linear-gradient-977);}.cls-964{fill:url(#linear-gradient-978);}.cls-965{fill:url(#linear-gradient-979);}.cls-966{fill:url(#linear-gradient-980);}.cls-967{fill:url(#linear-gradient-981);}.cls-968{fill:url(#linear-gradient-982);}.cls-969{fill:url(#linear-gradient-983);}.cls-970{fill:url(#linear-gradient-984);}.cls-971{fill:url(#linear-gradient-985);}.cls-972{fill:url(#linear-gradient-986);}.cls-973{fill:url(#linear-gradient-987);}.cls-974{fill:url(#linear-gradient-988);}.cls-975{fill:url(#linear-gradient-989);}.cls-976{fill:url(#linear-gradient-990);}.cls-977{fill:url(#linear-gradient-991);}.cls-978{fill:url(#linear-gradient-992);}.cls-979{fill:url(#linear-gradient-993);}.cls-980{fill:url(#linear-gradient-994);}.cls-981{fill:url(#linear-gradient-995);}.cls-982{fill:url(#linear-gradient-996);}.cls-983{fill:url(#linear-gradient-997);}.cls-984{fill:url(#linear-gradient-998);}.cls-985{fill:url(#linear-gradient-999);}.cls-986{fill:url(#linear-gradient-1000);}.cls-987{fill:url(#linear-gradient-1001);}.cls-988{fill:url(#linear-gradient-1002);}.cls-989{fill:url(#linear-gradient-1003);}.cls-990{fill:url(#linear-gradient-1004);}.cls-991{fill:url(#linear-gradient-1005);}.cls-992{fill:url(#linear-gradient-1006);}.cls-993{fill:url(#linear-gradient-1007);}.cls-994{fill:url(#linear-gradient-1008);}.cls-995{fill:url(#linear-gradient-1009);}.cls-996{fill:url(#linear-gradient-1010);}.cls-997{fill:url(#linear-gradient-1011);}.cls-998{fill:url(#linear-gradient-1012);}.cls-999{fill:url(#linear-gradient-1013);}.cls-1000{fill:url(#linear-gradient-1014);}.cls-1001{fill:url(#linear-gradient-1015);}.cls-1002{fill:url(#linear-gradient-1016);}.cls-1003{fill:url(#linear-gradient-1017);}.cls-1004{fill:url(#linear-gradient-1018);}.cls-1005{fill:url(#linear-gradient-1019);}.cls-1006{fill:url(#linear-gradient-1020);}.cls-1007{fill:url(#linear-gradient-1021);}.cls-1008{fill:url(#linear-gradient-1022);}.cls-1009{fill:url(#linear-gradient-1023);}.cls-1010{fill:url(#linear-gradient-1024);}.cls-1011{fill:url(#linear-gradient-1025);}.cls-1012{fill:url(#linear-gradient-1026);}.cls-1013{fill:url(#linear-gradient-1027);}.cls-1014{fill:url(#linear-gradient-1028);}.cls-1015{fill:url(#linear-gradient-1029);}.cls-1016{fill:url(#linear-gradient-1030);}.cls-1017{fill:url(#linear-gradient-1031);}.cls-1018{fill:url(#linear-gradient-1032);}.cls-1019{fill:url(#linear-gradient-1033);}.cls-1020{fill:url(#linear-gradient-1034);}.cls-1021{fill:url(#linear-gradient-1035);}.cls-1022{fill:url(#linear-gradient-1036);}.cls-1023{fill:url(#linear-gradient-1037);}.cls-1024{fill:url(#linear-gradient-1038);}.cls-1025{fill:url(#linear-gradient-1039);}.cls-1026{fill:url(#linear-gradient-1040);}.cls-1027{fill:url(#linear-gradient-1041);}.cls-1028{fill:url(#linear-gradient-1042);}.cls-1029{fill:url(#linear-gradient-1043);}.cls-1030{fill:url(#linear-gradient-1044);}.cls-1031{fill:url(#linear-gradient-1045);}.cls-1032{fill:url(#linear-gradient-1046);}.cls-1033{fill:url(#linear-gradient-1047);}.cls-1034{fill:url(#linear-gradient-1048);}.cls-1035{fill:url(#linear-gradient-1049);}.cls-1036{fill:url(#linear-gradient-1050);}.cls-1037{fill:url(#linear-gradient-1051);}.cls-1038{fill:url(#linear-gradient-1052);}.cls-1039{fill:url(#linear-gradient-1053);}.cls-1040{fill:url(#linear-gradient-1054);}.cls-1041{fill:url(#linear-gradient-1055);}.cls-1042{fill:url(#linear-gradient-1056);}.cls-1043{fill:url(#linear-gradient-1057);}.cls-1044{fill:url(#linear-gradient-1058);}.cls-1045{fill:url(#linear-gradient-1059);}.cls-1046{fill:url(#linear-gradient-1060);}.cls-1047{fill:url(#linear-gradient-1061);}.cls-1048{fill:url(#linear-gradient-1062);}.cls-1049{fill:url(#linear-gradient-1063);}.cls-1050{fill:url(#linear-gradient-1064);}.cls-1051{fill:url(#linear-gradient-1065);}.cls-1052{fill:url(#linear-gradient-1066);}.cls-1053{fill:url(#linear-gradient-1067);}.cls-1054{fill:url(#linear-gradient-1068);}.cls-1055{fill:url(#linear-gradient-1069);}.cls-1056{fill:url(#linear-gradient-1070);}.cls-1057{fill:url(#linear-gradient-1071);}.cls-1058{fill:url(#linear-gradient-1072);}.cls-1059{fill:url(#linear-gradient-1073);}.cls-1060{fill:url(#linear-gradient-1074);}.cls-1061{fill:url(#linear-gradient-1075);}.cls-1062{fill:url(#linear-gradient-1076);}.cls-1063{fill:url(#linear-gradient-1077);}.cls-1064{fill:url(#linear-gradient-1078);}.cls-1065{fill:url(#linear-gradient-1079);}.cls-1066{fill:url(#linear-gradient-1080);}.cls-1067{fill:url(#linear-gradient-1081);}.cls-1068{fill:url(#linear-gradient-1082);}.cls-1069{fill:url(#linear-gradient-1083);}.cls-1070{fill:url(#linear-gradient-1084);}.cls-1071{fill:url(#linear-gradient-1085);}.cls-1072{fill:url(#linear-gradient-1086);}.cls-1073{fill:url(#linear-gradient-1087);}.cls-1074{fill:url(#linear-gradient-1088);}.cls-1075{fill:url(#linear-gradient-1089);}.cls-1076{fill:url(#linear-gradient-1090);}.cls-1077{fill:url(#linear-gradient-1091);}.cls-1078{fill:url(#linear-gradient-1092);}.cls-1079{fill:url(#linear-gradient-1093);}.cls-1080{fill:url(#linear-gradient-1094);}.cls-1081{fill:url(#linear-gradient-1095);}.cls-1082{fill:url(#linear-gradient-1096);}.cls-1083{fill:url(#linear-gradient-1097);}.cls-1084{fill:url(#linear-gradient-1098);}.cls-1085{fill:url(#linear-gradient-1099);}.cls-1086{fill:url(#linear-gradient-1100);}.cls-1087{fill:url(#linear-gradient-1101);}.cls-1088{fill:url(#linear-gradient-1102);}.cls-1089{fill:url(#linear-gradient-1103);}.cls-1090{fill:url(#linear-gradient-1104);}.cls-1091{fill:url(#linear-gradient-1105);}.cls-1092{fill:url(#linear-gradient-1106);}.cls-1093{fill:url(#linear-gradient-1107);}.cls-1094{fill:url(#linear-gradient-1108);}.cls-1095{fill:url(#linear-gradient-1109);}.cls-1096{fill:url(#linear-gradient-1110);}.cls-1097{fill:url(#linear-gradient-1111);}.cls-1098{fill:url(#linear-gradient-1112);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 492.79,
    y1: -63.06,
    x2: 492.79,
    y2: -8.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe7ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f39e5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 496.51,
    y1: -63.06,
    x2: 496.51,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 500.43,
    y1: -63.06,
    x2: 500.43,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 503.67,
    y1: -63.06,
    x2: 503.67,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 328.51,
    y1: -63.06,
    x2: 328.51,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 334.08,
    y1: -63.06,
    x2: 334.08,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 339.81,
    y1: -63.06,
    x2: 339.81,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 345.63,
    y1: -63.06,
    x2: 345.63,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 169.16,
    y1: 139.46,
    x2: 169.16,
    y2: 44.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 547.97,
    y1: 72,
    x2: 575.72,
    y2: 104.27,
    gradientTransform: "matrix(-1, 0, 0, 1, 732.15, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5d9de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 580.88,
    y1: 128.91,
    x2: 579.03,
    y2: 181.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 732.15, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 568.68,
    y1: 124.27,
    x2: 566.83,
    y2: 177.11,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 162.27,
    y1: 224.97,
    x2: 162.27,
    y2: -85.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4b6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 540.56,
    y1: 123.62,
    x2: 601.36,
    y2: 135.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 732.15, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c51a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 151.72,
    y1: 224.97,
    x2: 151.72,
    y2: -85.78,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 550.97,
    y1: 136.35,
    x2: 632.27,
    y2: 123.47,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 570.24,
    y1: 68.55,
    x2: 583.16,
    y2: 68.55,
    gradientTransform: "matrix(-0.53, -0.85, -0.85, 0.53, 521.01, 519.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 156.38,
    y1: 132.54,
    x2: 156.38,
    y2: 64.63,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 574.01,
    y1: 57.61,
    x2: 576.94,
    y2: 123.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 732.15, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d6f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 154.25,
    y1: 73.34,
    x2: 162.76,
    y2: 81.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 157.1,
    y1: 156.05,
    x2: 166.38,
    y2: 70.79,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 208.47,
    y1: 124.17,
    x2: 134.86,
    y2: 69.37,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 161.98,
    y1: 107.87,
    x2: 163.96,
    y2: 88.92,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 162.05,
    y1: 82.87,
    x2: 171.33,
    y2: 90.28,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 173.33,
    y1: 100.69,
    x2: 174.04,
    y2: 93.89,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1904.46,
    y1: 69.66,
    x2: 1908.05,
    y2: 89.67,
    gradientTransform: "translate(-1749.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 152.6,
    y1: 139.46,
    x2: 152.6,
    y2: 44.77,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 564.49,
    y1: 84.3,
    x2: 600.09,
    y2: 110.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 732.15, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7dce0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1068.47,
    y1: 66.52,
    x2: 1072.91,
    y2: 70.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1057.3,
    y1: 55.75,
    x2: 1064.86,
    y2: 71.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1052.52,
    y1: 58.21,
    x2: 1071.86,
    y2: 72.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1060.02,
    y1: 69.73,
    x2: 1060.02,
    y2: 90.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1075.69,
    y1: 74.27,
    x2: 1055.9,
    y2: 58.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 456.4,
    y1: 175.5,
    x2: 456.4,
    y2: 282.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 576.24,
    y1: 266.3,
    x2: 392.83,
    y2: 110.37,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 431.69,
    y1: 117.94,
    x2: 440.2,
    y2: 126.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 434.54,
    y1: 200.64,
    x2: 443.82,
    y2: 115.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 485.91,
    y1: 168.77,
    x2: 412.3,
    y2: 113.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 439.42,
    y1: 152.47,
    x2: 441.4,
    y2: 133.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 439.49,
    y1: 127.46,
    x2: 448.77,
    y2: 134.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 450.77,
    y1: 145.28,
    x2: 451.48,
    y2: 138.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 450.22,
    y1: 128.28,
    x2: 458.73,
    y2: 136.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 453.07,
    y1: 210.98,
    x2: 462.35,
    y2: 125.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 504.44,
    y1: 179.11,
    x2: 430.83,
    y2: 124.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 457.96,
    y1: 162.81,
    x2: 459.93,
    y2: 143.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 458.02,
    y1: 137.8,
    x2: 467.3,
    y2: 145.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 469.3,
    y1: 155.62,
    x2: 470.01,
    y2: 148.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 431.69,
    y1: 102.88,
    x2: 440.2,
    y2: 111.39,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 434.54,
    y1: 185.58,
    x2: 443.82,
    y2: 100.32,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 485.91,
    y1: 153.7,
    x2: 412.3,
    y2: 98.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 439.42,
    y1: 137.41,
    x2: 441.4,
    y2: 118.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 439.49,
    y1: 112.4,
    x2: 448.77,
    y2: 119.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 450.77,
    y1: 130.22,
    x2: 451.48,
    y2: 123.43,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 468.75,
    y1: 138.62,
    x2: 477.26,
    y2: 147.13,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 471.6,
    y1: 221.33,
    x2: 480.88,
    y2: 136.07,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 522.97,
    y1: 189.45,
    x2: 449.36,
    y2: 134.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 476.49,
    y1: 173.15,
    x2: 478.46,
    y2: 154.2,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 476.55,
    y1: 148.15,
    x2: 485.83,
    y2: 155.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 487.83,
    y1: 165.97,
    x2: 488.54,
    y2: 159.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 412.19,
    y1: 128.87,
    x2: 420.7,
    y2: 137.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 415.04,
    y1: 211.57,
    x2: 424.32,
    y2: 126.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 466.41,
    y1: 179.7,
    x2: 392.8,
    y2: 124.89,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 419.93,
    y1: 163.4,
    x2: 421.9,
    y2: 144.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 419.99,
    y1: 138.39,
    x2: 429.27,
    y2: 145.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 431.28,
    y1: 156.21,
    x2: 431.98,
    y2: 149.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 430.72,
    y1: 139.21,
    x2: 439.23,
    y2: 147.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 433.57,
    y1: 221.92,
    x2: 442.85,
    y2: 136.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 484.94,
    y1: 190.04,
    x2: 411.33,
    y2: 135.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 438.46,
    y1: 173.74,
    x2: 440.43,
    y2: 154.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 438.52,
    y1: 148.74,
    x2: 447.8,
    y2: 156.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 449.81,
    y1: 166.56,
    x2: 450.51,
    y2: 159.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 632.21, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 449.06,
    y1: 148.49,
    x2: 457.57,
    y2: 157,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 630.24, -3.67)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 451.91,
    y1: 231.2,
    x2: 461.18,
    y2: 145.94,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 630.24, -3.67)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 503.28,
    y1: 199.32,
    x2: 429.67,
    y2: 144.52,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 630.24, -3.67)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 456.79,
    y1: 183.02,
    x2: 458.77,
    y2: 164.07,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 630.24, -3.67)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 456.86,
    y1: 158.02,
    x2: 466.13,
    y2: 165.43,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 630.24, -3.67)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 468.14,
    y1: 175.84,
    x2: 468.85,
    y2: 169.04,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 630.24, -3.67)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 580.17,
    y1: 309.27,
    x2: 752.9,
    y2: 136.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 337.76,
    y1: 600.91,
    x2: 562.68,
    y2: 293.22,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 447.82,
    y1: 233.79,
    x2: 579.84,
    y2: 587.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 643.54,
    y1: 379.63,
    x2: 588.4,
    y2: 275.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6679b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbccf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 572.23,
    y1: 326.53,
    x2: 626.5,
    y2: 326.53,
    gradientTransform: "translate(231.65 -236.76) rotate(29.18)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 523.68,
    y1: 294.67,
    x2: 540.53,
    y2: 311.52,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 500.36,
    y1: 233.02,
    x2: 500.36,
    y2: 434.51,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 500.36,
    y1: 305.52,
    x2: 500.36,
    y2: 325.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 564.07,
    y1: 473.84,
    x2: 445.15,
    y2: 257.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3f8fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 514.31,
    y1: 257.74,
    x2: 514.31,
    y2: 216.3,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 514.31,
    y1: 277.26,
    x2: 514.31,
    y2: 473.12,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 481.95,
    y1: 257.74,
    x2: 481.95,
    y2: 216.3,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 481.95,
    y1: 277.26,
    x2: 481.95,
    y2: 473.12,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 487.18,
    y1: -30.3,
    x2: 487.18,
    y2: 546.72,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 430.69,
    y1: 306.8,
    x2: 535.66,
    y2: 289.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc8213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 503.14,
    y1: -30.3,
    x2: 503.14,
    y2: 546.72,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 428.21,
    y1: 322.05,
    x2: 577.86,
    y2: 288.35,
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 473.23,
    y1: 156.03,
    x2: 473.23,
    y2: 201.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 537.17,
    y1: 250.31,
    x2: 435.39,
    y2: 178.76,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 496.63,
    y1: 156.03,
    x2: 496.63,
    y2: 201.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 499.37,
    y1: 344.81,
    x2: 499.37,
    y2: 94.24,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 492.3,
    y1: 344.81,
    x2: 492.3,
    y2: 94.24,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 491.95,
    y1: 187.9,
    x2: 523.65,
    y2: 219.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 564.24,
    y1: 277.04,
    x2: 475.98,
    y2: 209.34,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 498.1,
    y1: 202.45,
    x2: 519.94,
    y2: 224.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 488.86,
    y1: 208.22,
    x2: 513.33,
    y2: 232.68,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 523.58,
    y1: 273.49,
    x2: 444.66,
    y2: 194.57,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 498.87,
    y1: 211.12,
    x2: 498.87,
    y2: 257.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 504.22,
    y1: 156.03,
    x2: 504.22,
    y2: 201.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 579.29,
    y1: 306.42,
    x2: 468.06,
    y2: 196.18,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 412.41,
    y1: 229.88,
    x2: 585.91,
    y2: 274.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7dce0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 513.76,
    y1: 205.6,
    x2: 485.44,
    y2: 177.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 498.8,
    y1: 178.21,
    x2: 498.8,
    y2: 217.63,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 508.91,
    y1: 173.23,
    x2: 517.92,
    y2: 182.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 486.22,
    y1: 151.35,
    x2: 501.58,
    y2: 182.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 476.51,
    y1: 156.35,
    x2: 515.8,
    y2: 185.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 491.74,
    y1: 179.76,
    x2: 491.74,
    y2: 221.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 523.58,
    y1: 188.96,
    x2: 483.39,
    y2: 157.43,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 592.64,
    y1: 291.51,
    x2: 592.64,
    y2: 420.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56ccf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f80ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 583.57,
    y1: 420.4,
    x2: 583.57,
    y2: 360.1,
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 601.71,
    y1: 338.81,
    x2: 601.71,
    y2: 358.57,
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 578.87,
    y1: 459.04,
    x2: 578.87,
    y2: 367.48,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 667.5,
    y1: 435.13,
    x2: 523.7,
    y2: 328.06,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 599.61,
    y1: 361.34,
    x2: 604.96,
    y2: 370.85,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 689.28,
    y1: 361.34,
    x2: 694.63,
    y2: 370.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 1274.95, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 586.19,
    y1: 304.22,
    x2: 586.19,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 586.67,
    y1: 304.22,
    x2: 586.67,
    y2: 332.31,
    gradientTransform: "translate(684.68 -288.12) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 590.56,
    y1: 304.22,
    x2: 590.56,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 591.04,
    y1: 304.22,
    x2: 591.04,
    y2: 332.31,
    gradientTransform: "translate(684.74 -293.24) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 595.23,
    y1: 304.22,
    x2: 595.23,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 595.71,
    y1: 304.22,
    x2: 595.71,
    y2: 332.31,
    gradientTransform: "translate(685.11 -298.53) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 599.59,
    y1: 304.22,
    x2: 599.59,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 600.07,
    y1: 304.22,
    x2: 600.07,
    y2: 332.31,
    gradientTransform: "translate(685.15 -303.64) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 471.24,
    y1: 304.22,
    x2: 471.24,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 470.76,
    y1: 304.22,
    x2: 470.76,
    y2: 332.31,
    gradientTransform: "translate(262.87 -175.21) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 466.87,
    y1: 304.22,
    x2: 466.87,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 466.39,
    y1: 304.22,
    x2: 466.39,
    y2: 332.31,
    gradientTransform: "translate(261.11 -173.41) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 462.2,
    y1: 304.22,
    x2: 462.2,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 461.72,
    y1: 304.22,
    x2: 461.72,
    y2: 332.31,
    gradientTransform: "translate(259.4 -171.44) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 457.85,
    y1: 304.22,
    x2: 457.85,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 457.36,
    y1: 304.22,
    x2: 457.36,
    y2: 332.31,
    gradientTransform: "translate(257.63 -169.65) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 445.66,
    y1: 304.22,
    x2: 445.66,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 445.18,
    y1: 304.22,
    x2: 445.18,
    y2: 332.31,
    gradientTransform: "translate(252.42 -164.7) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 441.29,
    y1: 304.22,
    x2: 441.29,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 440.81,
    y1: 304.22,
    x2: 440.81,
    y2: 332.31,
    gradientTransform: "translate(250.66 -162.89) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 436.62,
    y1: 304.22,
    x2: 436.62,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 436.14,
    y1: 304.22,
    x2: 436.14,
    y2: 332.31,
    gradientTransform: "translate(248.95 -160.92) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 432.26,
    y1: 304.22,
    x2: 432.26,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 431.78,
    y1: 304.22,
    x2: 431.78,
    y2: 332.31,
    gradientTransform: "translate(247.19 -159.13) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 417.9,
    y1: 304.22,
    x2: 417.9,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 417.42,
    y1: 304.22,
    x2: 417.42,
    y2: 332.31,
    gradientTransform: "translate(241.11 -153.29) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 413.53,
    y1: 304.22,
    x2: 413.53,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 413.05,
    y1: 304.22,
    x2: 413.05,
    y2: 332.31,
    gradientTransform: "translate(239.35 -151.48) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 408.86,
    y1: 304.22,
    x2: 408.86,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 408.38,
    y1: 304.22,
    x2: 408.38,
    y2: 332.31,
    gradientTransform: "translate(237.64 -149.51) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 404.51,
    y1: 304.22,
    x2: 404.51,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 404.03,
    y1: 304.22,
    x2: 404.03,
    y2: 332.31,
    gradientTransform: "translate(235.87 -147.72) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 554.13,
    y1: 188,
    x2: 538.41,
    y2: 154.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 511.11,
    y1: 78.67,
    x2: 539.8,
    y2: 62.16,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 498.62,
    y1: 144.81,
    x2: 505.96,
    y2: 144.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 529.13,
    y1: 297.34,
    x2: 529.13,
    y2: -235.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 585.81,
    y1: 97.69,
    x2: 484.4,
    y2: 140.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585e81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 513.37,
    y1: 286.49,
    x2: 513.37,
    y2: -207.18,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 520.46,
    y1: 138.94,
    x2: 520.46,
    y2: -90.97,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 559.16,
    y1: 41.87,
    x2: 484.08,
    y2: 121.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 519.12,
    y1: 54.51,
    x2: 528.98,
    y2: 64.38,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 522.42,
    y1: 150.35,
    x2: 533.17,
    y2: 51.55,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 581.94,
    y1: 113.42,
    x2: 496.65,
    y2: 49.91,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 528.08,
    y1: 94.53,
    x2: 530.37,
    y2: 72.56,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 528.16,
    y1: 65.55,
    x2: 538.9,
    y2: 74.14,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 541.23,
    y1: 86.2,
    x2: 542.05,
    y2: 78.33,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 516.96,
    y1: 53.84,
    x2: 521.92,
    y2: 73.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8ebed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 514.37,
    y1: 57.07,
    x2: 526.86,
    y2: 57.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 482.67,
    y1: 97.43,
    x2: 541.59,
    y2: 139.49,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 704.06,
    y1: 55.71,
    x2: 708.5,
    y2: 60.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 692.89,
    y1: 44.94,
    x2: 700.45,
    y2: 60.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 688.11,
    y1: 47.4,
    x2: 707.45,
    y2: 61.9,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 695.61,
    y1: 58.93,
    x2: 695.61,
    y2: 79.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 711.28,
    y1: 63.46,
    x2: 691.49,
    y2: 47.93,
    gradientTransform: "matrix(-1, 0, 0, 1, 1219.2, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 514.02,
    y1: 110.03,
    x2: 514.02,
    y2: 14.29,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 550.16,
    y1: 54.03,
    x2: 482.09,
    y2: 98.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 408.77,
    y1: 64.95,
    x2: 408.77,
    y2: 172.18,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 528.61,
    y1: 155.75,
    x2: 345.2,
    y2: -0.18,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 384.06,
    y1: 7.39,
    x2: 392.57,
    y2: 15.9,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 386.91,
    y1: 90.09,
    x2: 396.19,
    y2: 4.83,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 438.28,
    y1: 58.22,
    x2: 364.67,
    y2: 3.41,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 391.8,
    y1: 41.92,
    x2: 393.77,
    y2: 22.96,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 391.86,
    y1: 16.91,
    x2: 401.14,
    y2: 24.32,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 403.14,
    y1: 34.73,
    x2: 403.85,
    y2: 27.94,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 402.59,
    y1: 17.73,
    x2: 411.1,
    y2: 26.24,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 405.44,
    y1: 100.44,
    x2: 414.72,
    y2: 15.17,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 456.81,
    y1: 68.56,
    x2: 383.2,
    y2: 13.75,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 410.33,
    y1: 52.26,
    x2: 412.3,
    y2: 33.3,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 410.39,
    y1: 27.25,
    x2: 419.67,
    y2: 34.66,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 421.67,
    y1: 45.08,
    x2: 422.38,
    y2: 38.28,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 384.06,
    y1: -7.67,
    x2: 392.57,
    y2: 0.84,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 386.91,
    y1: 75.03,
    x2: 396.19,
    y2: -10.23,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 438.28,
    y1: 43.16,
    x2: 364.67,
    y2: -11.65,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 391.8,
    y1: 26.86,
    x2: 393.77,
    y2: 7.9,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 391.86,
    y1: 1.85,
    x2: 401.14,
    y2: 9.26,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 403.14,
    y1: 19.67,
    x2: 403.85,
    y2: 12.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 364.56,
    y1: 18.32,
    x2: 373.07,
    y2: 26.83,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 367.41,
    y1: 101.02,
    x2: 376.69,
    y2: 15.76,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 418.78,
    y1: 69.15,
    x2: 345.17,
    y2: 14.34,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 372.3,
    y1: 52.85,
    x2: 374.27,
    y2: 33.89,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 372.36,
    y1: 27.84,
    x2: 381.64,
    y2: 35.25,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 383.65,
    y1: 45.66,
    x2: 384.35,
    y2: 38.87,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 383.09,
    y1: 28.66,
    x2: 391.6,
    y2: 37.17,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 385.94,
    y1: 111.37,
    x2: 395.22,
    y2: 26.11,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 437.31,
    y1: 79.49,
    x2: 363.7,
    y2: 24.69,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 390.83,
    y1: 63.19,
    x2: 392.8,
    y2: 44.24,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 390.89,
    y1: 38.19,
    x2: 400.17,
    y2: 45.6,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 402.18,
    y1: 56.01,
    x2: 402.88,
    y2: 49.21,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 401.62,
    y1: 39.01,
    x2: 410.13,
    y2: 47.52,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 404.47,
    y1: 121.71,
    x2: 413.75,
    y2: 36.45,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 455.84,
    y1: 89.83,
    x2: 382.23,
    y2: 35.03,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 409.36,
    y1: 73.54,
    x2: 411.33,
    y2: 54.58,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 409.42,
    y1: 48.53,
    x2: 418.7,
    y2: 55.94,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 420.71,
    y1: 66.35,
    x2: 421.41,
    y2: 59.56,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 381.39,
    y1: 108.4,
    x2: 414.04,
    y2: 141.05,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 372.21,
    y1: 117.57,
    x2: 404.86,
    y2: 150.23,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 381.86,
    y1: 151.33,
    x2: 381.86,
    y2: -133.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 974.59,
    y1: 75.96,
    x2: 1025.04,
    y2: 82.78,
    gradientTransform: "matrix(-1, 0, -0.08, 1, 1391.04, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54597b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 370.97,
    y1: 18.87,
    x2: 395.59,
    y2: 43.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 374.53,
    y1: 151.33,
    x2: 374.53,
    y2: -133.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 381.39,
    y1: 72.9,
    x2: 377.2,
    y2: 40.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 990.38,
    y1: 66.24,
    x2: 1018.09,
    y2: -6.22,
    gradientTransform: "matrix(-1, 0, -0.08, 1, 1391.04, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 1008.97,
    y1: 10.24,
    x2: 1004.86,
    y2: 28.08,
    gradientTransform: "matrix(-1, 0, -0.08, 1, 1391.04, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 998.42,
    y1: 24.88,
    x2: 1011.14,
    y2: 29.05,
    gradientTransform: "matrix(-1, 0, -0.08, 1, 1391.04, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 982.24,
    y1: 89.65,
    x2: 1026.58,
    y2: 83.07,
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 372.75,
    y1: 8.16,
    x2: 372.75,
    y2: 26.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 382.31,
    y1: 11.07,
    x2: 382.31,
    y2: 40.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 380.06,
    y1: -11.14,
    x2: 380.06,
    y2: 26.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 359.1,
    y1: 24.15,
    x2: 392.46,
    y2: -2.9,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 385.59,
    y1: 4.85,
    x2: 408.21,
    y2: -3.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 380.87,
    y1: 1.12,
    x2: 380.59,
    y2: 19.89,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 402.37,
    y1: 70.41,
    x2: 340.63,
    y2: 25.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 498.57,
    y1: 304.22,
    x2: 498.57,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 498.09,
    y1: 304.22,
    x2: 498.09,
    y2: 332.31,
    gradientTransform: "translate(273.75 -186.51) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 494.2,
    y1: 304.22,
    x2: 494.2,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 493.72,
    y1: 304.22,
    x2: 493.72,
    y2: 332.31,
    gradientTransform: "translate(271.99 -184.71) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 489.53,
    y1: 304.22,
    x2: 489.53,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 489.05,
    y1: 304.22,
    x2: 489.05,
    y2: 332.31,
    gradientTransform: "translate(270.28 -182.74) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 485.18,
    y1: 304.22,
    x2: 485.18,
    y2: 332.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 484.7,
    y1: 304.22,
    x2: 484.7,
    y2: 332.31,
    gradientTransform: "translate(268.51 -180.95) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 407.19,
    y1: -63.06,
    x2: 407.19,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 413.53,
    y1: -63.06,
    x2: 413.53,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 420.02,
    y1: -63.06,
    x2: 420.02,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 425.46,
    y1: -63.06,
    x2: 425.46,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 286.86,
    y1: -63.06,
    x2: 286.86,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 291.22,
    y1: -63.06,
    x2: 291.22,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 295.3,
    y1: -63.06,
    x2: 295.3,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 299.09,
    y1: -63.06,
    x2: 299.09,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 322.04,
    y1: -63.06,
    x2: 322.04,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 321.39,
    y1: -63.06,
    x2: 321.39,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 320.78,
    y1: -63.06,
    x2: 320.78,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 320.13,
    y1: -63.06,
    x2: 320.13,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 242.81,
    y1: -63.06,
    x2: 242.81,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 242.81,
    y1: -63.06,
    x2: 242.81,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 242.23,
    y1: -63.06,
    x2: 242.23,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 242.27,
    y1: -63.06,
    x2: 242.27,
    y2: -8.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: -29.77,
    y1: 407.25,
    x2: 200.12,
    y2: 605.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 118.72,
    y1: 446.54,
    x2: 118.72,
    y2: 1052.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 217.17,
    y1: 357.69,
    x2: -137.58,
    y2: 934.41,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 298.41,
    y1: 333.88,
    x2: 97.26,
    y2: 535.02,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 67.07,
    y1: 498.81,
    x2: 46.53,
    y2: 519.35,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 69.62,
    y1: 495.89,
    x2: 64.03,
    y2: 501.48,
    gradientTransform: "translate(254.05 37.25) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 61.02,
    y1: 504.49,
    x2: 58.69,
    y2: 506.82,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 42.96,
    y1: 516.45,
    x2: 42.96,
    y2: 546.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 31.64,
    y1: 520.23,
    x2: 93.13,
    y2: 581.72,
    gradientTransform: "translate(574.02 483.18) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 50.32,
    y1: 524.16,
    x2: 47.52,
    y2: 526.96,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 93.55,
    y1: 556.61,
    x2: 22.03,
    y2: 499.87,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 167.16,
    y1: 556.25,
    x2: 146.61,
    y2: 576.8,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 169.71,
    y1: 553.33,
    x2: 164.11,
    y2: 558.92,
    gradientTransform: "translate(294.36 -4.02) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 161.11,
    y1: 561.93,
    x2: 158.77,
    y2: 564.26,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 143.05,
    y1: 573.89,
    x2: 143.05,
    y2: 604.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 131.73,
    y1: 577.68,
    x2: 193.21,
    y2: 639.16,
    gradientTransform: "translate(730.53 439.96) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 150.41,
    y1: 581.61,
    x2: 147.61,
    y2: 584.4,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 193.64,
    y1: 614.05,
    x2: 122.11,
    y2: 557.32,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 181.06,
    y1: 383.05,
    x2: 454.82,
    y2: 109.29,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 210.92,
    y1: 268.6,
    x2: 112.64,
    y2: 384.61,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: -40.83,
    y1: 229.02,
    x2: 157.55,
    y2: 502.75,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 97.18,
    y1: 279.87,
    x2: 97.18,
    y2: 294.83,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: -3.56,
    y1: 411.75,
    x2: 425.86,
    y2: 411.75,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 30.73,
    y1: 449.97,
    x2: 287.86,
    y2: 192.85,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 54.14,
    y1: 283.95,
    x2: 54.14,
    y2: 450.45,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 97.18,
    y1: 283.95,
    x2: 97.18,
    y2: 450.45,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 140.23,
    y1: 283.95,
    x2: 140.23,
    y2: 450.45,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 183.27,
    y1: 283.95,
    x2: 183.27,
    y2: 450.45,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 226.31,
    y1: 283.95,
    x2: 226.31,
    y2: 450.45,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 41.6,
    y1: 272.8,
    x2: 41.6,
    y2: 749.24,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 41.6,
    y1: 264.74,
    x2: 41.6,
    y2: 417.76,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 53.15,
    y1: 264.74,
    x2: 53.15,
    y2: 417.76,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 66.39,
    y1: 301.84,
    x2: 66.39,
    y2: 430.05,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 40.07,
    y1: 354.83,
    x2: 46.34,
    y2: 354.83,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 40.07,
    y1: 355.62,
    x2: 46.34,
    y2: 355.62,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 39.29,
    y1: 291.86,
    x2: 39.29,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 39.29,
    y1: 312.88,
    x2: 39.29,
    y2: 456.09,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#96c93d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 39.17,
    y1: 290.43,
    x2: 39.17,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 46.03,
    y1: 291.86,
    x2: 46.03,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 20.1,
    y1: 350.65,
    x2: 145.59,
    y2: 476.14,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 45.91,
    y1: 290.43,
    x2: 45.91,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 52.76,
    y1: 291.86,
    x2: 52.76,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 52.76,
    y1: 454.34,
    x2: 52.76,
    y2: 339.6,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 52.65,
    y1: 290.43,
    x2: 52.65,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 12.19,
    y1: 358.56,
    x2: 137.68,
    y2: 484.06,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 7.88,
    y1: 320.15,
    x2: 104.98,
    y2: 417.25,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: -47.57,
    y1: 411.75,
    x2: 266.73,
    y2: 411.75,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 72.24,
    y1: 365.16,
    x2: 28.67,
    y2: 321.59,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 93.76,
    y1: 343.64,
    x2: 50.19,
    y2: 300.07,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 115.28,
    y1: 322.12,
    x2: 71.71,
    y2: 278.55,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 84.99,
    y1: 272.8,
    x2: 84.99,
    y2: 749.24,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 84.99,
    y1: 264.74,
    x2: 84.99,
    y2: 417.76,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 96.54,
    y1: 264.74,
    x2: 96.54,
    y2: 417.76,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 82.68,
    y1: 291.86,
    x2: 82.68,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 82.68,
    y1: 312.88,
    x2: 82.68,
    y2: 456.09,
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: 82.56,
    y1: 290.43,
    x2: 82.56,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 89.42,
    y1: 291.86,
    x2: 89.42,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 49.21,
    y1: 321.55,
    x2: 174.7,
    y2: 447.04,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 89.3,
    y1: 290.43,
    x2: 89.3,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: 96.15,
    y1: 291.86,
    x2: 96.15,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 96.15,
    y1: 454.34,
    x2: 96.15,
    y2: 339.6,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: 96.03,
    y1: 290.43,
    x2: 96.03,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 74.04,
    y1: 328.78,
    x2: 156.19,
    y2: 410.93,
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 171.45,
    y1: 272.8,
    x2: 171.45,
    y2: 749.24,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 171.45,
    y1: 264.74,
    x2: 171.45,
    y2: 417.76,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 183,
    y1: 264.74,
    x2: 183,
    y2: 417.76,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 169.14,
    y1: 291.86,
    x2: 169.14,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 169.14,
    y1: 347.98,
    x2: 169.14,
    y2: 368.97,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 169.02,
    y1: 290.43,
    x2: 169.02,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 175.88,
    y1: 291.86,
    x2: 175.88,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: 175.88,
    y1: 352.52,
    x2: 175.88,
    y2: 377.79,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 175.76,
    y1: 290.43,
    x2: 175.76,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: 182.61,
    y1: 291.86,
    x2: 182.61,
    y2: 540.94,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: 182.61,
    y1: 343.37,
    x2: 182.61,
    y2: 366.29,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 182.49,
    y1: 290.43,
    x2: 182.49,
    y2: 386.52,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    x1: 84.99,
    y1: 355.25,
    x2: 84.99,
    y2: 381.97,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    x1: 96.54,
    y1: 355.25,
    x2: 96.54,
    y2: 381.97,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    x1: 41.25,
    y1: 329.5,
    x2: 166.75,
    y2: 454.99,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    x1: 66.09,
    y1: 336.73,
    x2: 148.24,
    y2: 418.88,
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    x1: 33.3,
    y1: 337.45,
    x2: 158.79,
    y2: 462.95,
    gradientTransform: "matrix(0.74, 0.43, 0, 1, 13.41, -21.55)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    x1: 58.14,
    y1: 344.69,
    x2: 140.28,
    y2: 426.83,
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    x1: 170.2,
    y1: 523.39,
    x2: 400.08,
    y2: 721.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    x1: 318.69,
    y1: 562.69,
    x2: 318.69,
    y2: 1168.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    x1: 414.08,
    y1: 478.81,
    x2: 59.33,
    y2: 1055.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    x1: 456.46,
    y1: 491.94,
    x2: 255.32,
    y2: 693.08,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    x1: 267.04,
    y1: 614.96,
    x2: 246.49,
    y2: 635.5,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    x1: 269.59,
    y1: 612.03,
    x2: 264,
    y2: 617.63,
    gradientTransform: "matrix(0.88, 0.48, -0.48, 0.88, 335.26, -45.03)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    x1: 260.99,
    y1: 620.64,
    x2: 258.66,
    y2: 622.97,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    x1: 242.93,
    y1: 632.6,
    x2: 242.93,
    y2: 662.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    x1: 231.61,
    y1: 636.38,
    x2: 293.09,
    y2: 697.87,
    gradientTransform: "translate(888.09 398.19) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    x1: 250.29,
    y1: 640.31,
    x2: 247.49,
    y2: 643.11,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    x1: 293.52,
    y1: 672.75,
    x2: 221.99,
    y2: 616.02,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    x1: 367.13,
    y1: 672.4,
    x2: 346.58,
    y2: 692.95,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    x1: 369.68,
    y1: 669.48,
    x2: 364.08,
    y2: 675.07,
    gradientTransform: "translate(375.58 -86.3) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    x1: 361.07,
    y1: 678.08,
    x2: 358.74,
    y2: 680.41,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    x1: 343.01,
    y1: 690.04,
    x2: 343.01,
    y2: 720.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    x1: 331.7,
    y1: 693.83,
    x2: 393.18,
    y2: 755.31,
    gradientTransform: "matrix(0.01, 1, -1, 0.01, 1044.6, 354.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    x1: 350.37,
    y1: 697.76,
    x2: 347.58,
    y2: 700.55,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    x1: 393.6,
    y1: 730.2,
    x2: 322.08,
    y2: 673.46,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-389",
    x1: 384.42,
    y1: 493.38,
    x2: 443.91,
    y2: 433.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-390",
    x1: 235.87,
    y1: 568.16,
    x2: 357.77,
    y2: 454.52,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-391",
    x1: 212.59,
    y1: 230.99,
    x2: 521.86,
    y2: 540.26,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-392",
    x1: 319.09,
    y1: 420.84,
    x2: 309.98,
    y2: 585.78,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-393",
    x1: 314.29,
    y1: 350.95,
    x2: 314.29,
    y2: 469.74,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-394",
    x1: 320.19,
    y1: 489.8,
    x2: 320.19,
    y2: 572.72,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-395",
    x1: 272.9,
    y1: 395.9,
    x2: 340.58,
    y2: 395.9,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-396",
    x1: 350.28,
    y1: 489.83,
    x2: 350.28,
    y2: 572.75,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-397",
    x1: 380.36,
    y1: 489.86,
    x2: 380.36,
    y2: 572.78,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-398",
    x1: 384.07,
    y1: 515.7,
    x2: 384.07,
    y2: 310.37,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-399",
    x1: 320.19,
    y1: 372.18,
    x2: 320.19,
    y2: 409.84,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-400",
    x1: 380.36,
    y1: 368.62,
    x2: 380.36,
    y2: 442.63,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-401",
    x1: 418.4,
    y1: 403.39,
    x2: 468.54,
    y2: 403.39,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-402",
    x1: 386.01,
    y1: 384.56,
    x2: 601.99,
    y2: 384.56,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-403",
    x1: 386.01,
    y1: 392.23,
    x2: 601.99,
    y2: 392.23,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-404",
    x1: 386.01,
    y1: 399.9,
    x2: 601.99,
    y2: 399.9,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-405",
    x1: 386.01,
    y1: 407.57,
    x2: 601.99,
    y2: 407.57,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-406",
    x1: 386.01,
    y1: 415.24,
    x2: 601.99,
    y2: 415.24,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-407",
    x1: 386.01,
    y1: 422.91,
    x2: 601.99,
    y2: 422.91,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-408",
    x1: 377.01,
    y1: 472.36,
    x2: 377.01,
    y2: 533.71,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-409",
    x1: 377.01,
    y1: 469.55,
    x2: 377.01,
    y2: 530.9,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-410",
    x1: 377.01,
    y1: 466.74,
    x2: 377.01,
    y2: 528.09,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-411",
    x1: 377.01,
    y1: 463.94,
    x2: 377.01,
    y2: 525.29,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-412",
    x1: 202.97,
    y1: 486.88,
    x2: 413.7,
    y2: 450.59,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-413",
    x1: 377.01,
    y1: 461.13,
    x2: 377.01,
    y2: 522.48,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-414",
    x1: 317.32,
    y1: 449.42,
    x2: 373.23,
    y2: 505.34,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-415",
    x1: 313.67,
    y1: 453.08,
    x2: 369.58,
    y2: 509,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-416",
    x1: 310.01,
    y1: 456.74,
    x2: 365.93,
    y2: 512.66,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-417",
    x1: 306.36,
    y1: 460.4,
    x2: 362.28,
    y2: 516.32,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-418",
    x1: 302.71,
    y1: 464.06,
    x2: 358.62,
    y2: 519.98,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-419",
    x1: 349.81,
    y1: 440.29,
    x2: 349.81,
    y2: 533.82,
    gradientTransform: "matrix(0.52, 0.67, -0.38, 0.93, 265.81, -82.02)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-420",
    x1: 379.86,
    y1: 440.32,
    x2: 379.86,
    y2: 533.85,
    gradientTransform: "matrix(0.52, 0.67, -0.38, 0.93, 274.4, -89.03)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-421",
    x1: 415.42,
    y1: 440.36,
    x2: 415.42,
    y2: 533.88,
    gradientTransform: "matrix(0.52, 0.67, -0.38, 0.93, 276.2, -98.96)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-422",
    x1: 349.71,
    y1: 405.92,
    x2: 349.71,
    y2: 487.8,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-423",
    x1: 379.46,
    y1: 405.95,
    x2: 379.46,
    y2: 487.82,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-424",
    x1: 415.35,
    y1: 405.99,
    x2: 415.35,
    y2: 487.87,
    gradientTransform: "matrix(0.74, 0.42, 0, 1, 18.2, -29.4)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-425",
    x1: 643.02,
    y1: 249.53,
    x2: 643.02,
    y2: 269.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-426",
    x1: 638.65,
    y1: 250.9,
    x2: 638.65,
    y2: 270.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-427",
    x1: 634.27,
    y1: 252.24,
    x2: 634.27,
    y2: 272.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-428",
    x1: 629.89,
    y1: 253.55,
    x2: 629.89,
    y2: 273.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-429",
    x1: 909.62,
    y1: 618.72,
    x2: 939.58,
    y2: 588.76,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-430",
    x1: 861.35,
    y1: 645.43,
    x2: 798.05,
    y2: 582.13,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-431",
    x1: 852.75,
    y1: 633.86,
    x2: 921.99,
    y2: 703.1,
    gradientTransform: "translate(1027.34 -418.26) rotate(62.29)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-432",
    x1: 827.71,
    y1: 608.82,
    x2: 898.28,
    y2: 679.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-433",
    x1: 865.79,
    y1: 685.06,
    x2: 891.24,
    y2: 564.28,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-434",
    x1: 995.58,
    y1: 601.19,
    x2: 1015.93,
    y2: 580.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-435",
    x1: 983.11,
    y1: 624.55,
    x2: 941.89,
    y2: 583.33,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-436",
    x1: 977.51,
    y1: 617.02,
    x2: 1022.6,
    y2: 662.1,
    gradientTransform: "translate(1075.74 -536.88) rotate(62.29)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-437",
    x1: 961.21,
    y1: 600.71,
    x2: 1007.16,
    y2: 646.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-438",
    x1: 902.16,
    y1: 669.7,
    x2: 838.86,
    y2: 606.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-439",
    x1: 893.56,
    y1: 658.13,
    x2: 962.79,
    y2: 727.37,
    gradientTransform: "translate(1070.66 -441.4) rotate(62.29)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-440",
    x1: 868.52,
    y1: 633.1,
    x2: 939.09,
    y2: 703.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-441",
    x1: 959.48,
    y1: 738.65,
    x2: 959.48,
    y2: 517.96,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-442",
    x1: 966.68,
    y1: 498.12,
    x2: 966.68,
    y2: 707.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcac0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-443",
    x1: 902.51,
    y1: 882.56,
    x2: 902.51,
    y2: 501.7,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-444",
    x1: 895.17,
    y1: 466.21,
    x2: 914.79,
    y2: 824.05,
    xlinkHref: "#linear-gradient-442"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-445",
    x1: 923.58,
    y1: 730.99,
    x2: 923.58,
    y2: 576.35,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-446",
    x1: 867.87,
    y1: 544,
    x2: 831.52,
    y2: 507.64,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-447",
    x1: 848.29,
    y1: 524.08,
    x2: 860.73,
    y2: 536.53,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-448",
    x1: 865.51,
    y1: 551.3,
    x2: 865.51,
    y2: 474.97,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-449",
    x1: 883.84,
    y1: 618.48,
    x2: 883.84,
    y2: 497.93,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-450",
    x1: 923.58,
    y1: 620.81,
    x2: 923.58,
    y2: 361.5,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-451",
    x1: 696.86,
    y1: 635.33,
    x2: 935.79,
    y2: 444.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-452",
    x1: 928.32,
    y1: 587.4,
    x2: 724.85,
    y2: 587.4,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-453",
    x1: 900.1,
    y1: 586.01,
    x2: 705.88,
    y2: 586.01,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-454",
    x1: 850.22,
    y1: 640.1,
    x2: 902.11,
    y2: 533.77,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-455",
    x1: 855,
    y1: 592.43,
    x2: 888.2,
    y2: 542.71,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-456",
    x1: 962.61,
    y1: 567.35,
    x2: 962.61,
    y2: 581.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-457",
    x1: 962.61,
    y1: 591,
    x2: 962.61,
    y2: 529.04,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-458",
    x1: 715.2,
    y1: 658.31,
    x2: 954.12,
    y2: 467.65,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-459",
    x1: 910.71,
    y1: 613.79,
    x2: 763.07,
    y2: 580.95,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-460",
    x1: 840.51,
    y1: 607.84,
    x2: 1108.17,
    y2: 561.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-461",
    x1: 887.14,
    y1: 552.81,
    x2: 861.56,
    y2: 527.23,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-462",
    x1: 878.93,
    y1: 544.28,
    x2: 863.35,
    y2: 528.69,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-463",
    x1: 821.6,
    y1: 669.49,
    x2: 948.19,
    y2: 435.97,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-464",
    x1: 792.26,
    y1: 672,
    x2: 944.03,
    y2: 514.66,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-465",
    x1: 848.26,
    y1: 656.61,
    x2: 935.7,
    y2: 549.52,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-466",
    x1: 834.31,
    y1: 688.47,
    x2: 894.35,
    y2: 558.69,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-467",
    x1: 843.01,
    y1: 679.28,
    x2: 780.14,
    y2: 616.42,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-468",
    x1: 863,
    y1: 699.39,
    x2: 792.85,
    y2: 629.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-469",
    x1: 891.53,
    y1: 689.66,
    x2: 699.84,
    y2: 611.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-470",
    x1: 883.3,
    y1: 701.04,
    x2: 808.09,
    y2: 641.12,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-471",
    x1: 919.69,
    y1: 584.14,
    x2: 1014.33,
    y2: 817.33,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-472",
    x1: 571.85,
    y1: 275.18,
    x2: 481.87,
    y2: 226.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-473",
    x1: 402.62,
    y1: 292.75,
    x2: 455.72,
    y2: 269.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-474",
    x1: 805.57,
    y1: 457.59,
    x2: 715.58,
    y2: 408.98,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-475",
    x1: 636.33,
    y1: 475.16,
    x2: 689.43,
    y2: 451.9,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-476",
    x1: 1255.99,
    y1: 979.05,
    x2: 515.49,
    y2: 258.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-477",
    x1: 572.35,
    y1: 303.84,
    x2: 375.54,
    y2: 107.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-478",
    x1: 1260.08,
    y1: 974.85,
    x2: 519.58,
    y2: 254.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-479",
    x1: 670.49,
    y1: 514.36,
    x2: 773.43,
    y2: 779.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6bd7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-480",
    x1: 740.47,
    y1: 452.67,
    x2: 2140.31,
    y2: 345.62,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-481",
    x1: 1285.82,
    y1: 1034.52,
    x2: 396.4,
    y2: 66.93,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-482",
    x1: 748.31,
    y1: 253.97,
    x2: 748.31,
    y2: 122.84,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-483",
    x1: 386.32,
    y1: 319.38,
    x2: 1502.44,
    y2: 721.87,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-484",
    x1: 812.22,
    y1: 454.45,
    x2: 680.52,
    y2: 341.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-485",
    x1: 729.14,
    y1: 433.25,
    x2: 792.47,
    y2: 404.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-486",
    x1: 713.18,
    y1: 663.66,
    x2: 754.94,
    y2: 652.66,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-487",
    x1: 246.93,
    y1: 213.68,
    x2: 1119.78,
    y2: 1086.53,
    gradientTransform: "translate(410.57 -255.72) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-488",
    x1: 775.07,
    y1: 747.73,
    x2: 1109.09,
    y2: 1081.75,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-489",
    x1: 243,
    y1: 217.61,
    x2: 1115.85,
    y2: 1090.46,
    gradientTransform: "translate(402.95 -248) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-490",
    x1: 771.14,
    y1: 751.66,
    x2: 1105.16,
    y2: 1085.68,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-491",
    x1: 239.07,
    y1: 221.54,
    x2: 1111.92,
    y2: 1094.39,
    gradientTransform: "translate(395.33 -240.29) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-492",
    x1: 767.21,
    y1: 755.59,
    x2: 1101.23,
    y2: 1089.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-493",
    x1: 235.14,
    y1: 225.47,
    x2: 1107.99,
    y2: 1098.32,
    gradientTransform: "translate(387.71 -232.57) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-494",
    x1: 763.28,
    y1: 759.52,
    x2: 1097.3,
    y2: 1093.54,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-495",
    x1: 231.21,
    y1: 229.4,
    x2: 1104.06,
    y2: 1102.25,
    gradientTransform: "translate(380.09 -224.85) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-496",
    x1: 759.35,
    y1: 763.45,
    x2: 1093.37,
    y2: 1097.47,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-497",
    x1: 227.28,
    y1: 233.33,
    x2: 1100.14,
    y2: 1106.18,
    gradientTransform: "translate(372.48 -217.13) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-498",
    x1: 759.83,
    y1: 762.98,
    x2: 1093.84,
    y2: 1096.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-499",
    x1: 227.88,
    y1: 232.73,
    x2: 1100.73,
    y2: 1105.58,
    gradientTransform: "translate(128.19 -104.34) rotate(11.25)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-500",
    x1: 806.82,
    y1: 715.98,
    x2: 1140.84,
    y2: 1050,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-501",
    x1: 275.9,
    y1: 184.71,
    x2: 1148.75,
    y2: 1057.56,
    gradientTransform: "translate(814.45 -277.92) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-502",
    x1: 821.65,
    y1: 701.16,
    x2: 1155.66,
    y2: 1035.17,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-503",
    x1: 290.72,
    y1: 169.88,
    x2: 1163.58,
    y2: 1042.74,
    gradientTransform: "translate(814.59 -299.95) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-504",
    x1: 840.12,
    y1: 682.68,
    x2: 1174.13,
    y2: 1016.7,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-505",
    x1: 309.2,
    y1: 151.41,
    x2: 1182.05,
    y2: 1024.26,
    gradientTransform: "translate(814.91 -327.44) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-506",
    x1: 854.94,
    y1: 667.86,
    x2: 1188.96,
    y2: 1001.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-507",
    x1: 324.02,
    y1: 136.59,
    x2: 1196.87,
    y2: 1009.44,
    gradientTransform: "translate(815.05 -349.47) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-508",
    x1: 873.41,
    y1: 649.39,
    x2: 1207.43,
    y2: 983.4,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-509",
    x1: 342.49,
    y1: 118.12,
    x2: 1215.34,
    y2: 990.97,
    gradientTransform: "translate(815.37 -376.95) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-510",
    x1: 888.24,
    y1: 634.56,
    x2: 1222.26,
    y2: 968.58,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-511",
    x1: 357.32,
    y1: 103.29,
    x2: 1230.17,
    y2: 976.14,
    gradientTransform: "translate(815.51 -398.99) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-512",
    x1: 906.71,
    y1: 616.09,
    x2: 1240.73,
    y2: 950.11,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-513",
    x1: 375.79,
    y1: 84.82,
    x2: 1248.64,
    y2: 957.67,
    gradientTransform: "translate(815.83 -426.47) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-514",
    x1: 921.53,
    y1: 601.27,
    x2: 1255.55,
    y2: 935.28,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-515",
    x1: 390.61,
    y1: 70,
    x2: 1263.46,
    y2: 942.85,
    gradientTransform: "translate(815.97 -448.5) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-516",
    x1: 940.01,
    y1: 582.8,
    x2: 1274.02,
    y2: 916.81,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-517",
    x1: 409.08,
    y1: 51.53,
    x2: 1281.94,
    y2: 924.38,
    gradientTransform: "translate(816.29 -475.99) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-518",
    x1: 954.83,
    y1: 567.97,
    x2: 1288.85,
    y2: 901.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-519",
    x1: 423.91,
    y1: 36.7,
    x2: 1296.76,
    y2: 909.55,
    gradientTransform: "translate(816.43 -498.02) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-520",
    x1: 973.3,
    y1: 549.5,
    x2: 1307.32,
    y2: 883.52,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-521",
    x1: 442.38,
    y1: 18.23,
    x2: 1315.23,
    y2: 891.08,
    gradientTransform: "translate(816.75 -525.51) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-522",
    x1: 988.13,
    y1: 534.67,
    x2: 1322.14,
    y2: 868.69,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-523",
    x1: 457.21,
    y1: 3.4,
    x2: 1330.06,
    y2: 876.25,
    gradientTransform: "translate(816.89 -547.54) rotate(61.05)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-524",
    x1: 1005.38,
    y1: 517.42,
    x2: 1339.39,
    y2: 851.44,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-525",
    x1: 474.45,
    y1: -13.84,
    x2: 1347.3,
    y2: 859.01,
    gradientTransform: "translate(1114.89 -549.98) rotate(78.75)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-526",
    x1: 1021.85,
    y1: 500.95,
    x2: 1355.87,
    y2: 834.96,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-527",
    x1: 489.79,
    y1: -29.18,
    x2: 1362.64,
    y2: 843.67,
    gradientTransform: "translate(267.18 -370.51) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-528",
    x1: 1017.92,
    y1: 504.88,
    x2: 1351.94,
    y2: 838.89,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-529",
    x1: 485.86,
    y1: -25.25,
    x2: 1358.71,
    y2: 847.6,
    gradientTransform: "translate(259.56 -362.79) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-530",
    x1: 1013.03,
    y1: 509.77,
    x2: 1347.05,
    y2: 843.79,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-531",
    x1: 480.96,
    y1: -20.35,
    x2: 1353.81,
    y2: 852.5,
    gradientTransform: "translate(250.39 -353.37) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-532",
    x1: 1009.1,
    y1: 513.7,
    x2: 1343.12,
    y2: 847.72,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-533",
    x1: 477.03,
    y1: -16.42,
    x2: 1349.88,
    y2: 856.43,
    gradientTransform: "translate(242.77 -345.65) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-534",
    x1: 1005.09,
    y1: 517.71,
    x2: 1339.11,
    y2: 851.72,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-535",
    x1: 473.03,
    y1: -12.42,
    x2: 1345.88,
    y2: 860.43,
    gradientTransform: "translate(234.55 -337.52) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-536",
    x1: 1001.16,
    y1: 521.64,
    x2: 1335.18,
    y2: 855.65,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-537",
    x1: 469.1,
    y1: -8.49,
    x2: 1341.95,
    y2: 864.36,
    gradientTransform: "translate(226.94 -329.8) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-538",
    x1: 997.21,
    y1: 525.6,
    x2: 1331.22,
    y2: 859.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-539",
    x1: 465.14,
    y1: -4.53,
    x2: 1337.99,
    y2: 868.32,
    gradientTransform: "translate(218.89 -321.81) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-540",
    x1: 993.25,
    y1: 529.55,
    x2: 1327.27,
    y2: 863.57,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-541",
    x1: 461.18,
    y1: -0.57,
    x2: 1334.03,
    y2: 872.28,
    gradientTransform: "translate(211.88 -314.43) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-542",
    x1: 990.09,
    y1: 532.71,
    x2: 1324.11,
    y2: 866.73,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-543",
    x1: 458.02,
    y1: 2.59,
    x2: 1330.87,
    y2: 875.44,
    gradientTransform: "translate(205.56 -308.11) rotate(28.95)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-544",
    x1: 719.52,
    y1: 200.99,
    x2: 729.38,
    y2: 210.86,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-545",
    x1: 722.82,
    y1: 296.83,
    x2: 733.57,
    y2: 198.03,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-546",
    x1: 782.35,
    y1: 259.89,
    x2: 697.05,
    y2: 196.38,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-547",
    x1: 728.48,
    y1: 241.01,
    x2: 730.77,
    y2: 219.04,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-548",
    x1: 728.56,
    y1: 212.03,
    x2: 739.3,
    y2: 220.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-549",
    x1: 741.63,
    y1: 232.68,
    x2: 742.45,
    y2: 224.81,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-550",
    x1: 802,
    y1: 245.87,
    x2: 811.86,
    y2: 255.73,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-551",
    x1: 805.3,
    y1: 341.71,
    x2: 816.05,
    y2: 242.91,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-552",
    x1: 864.83,
    y1: 304.77,
    x2: 779.53,
    y2: 241.26,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-553",
    x1: 810.96,
    y1: 285.88,
    x2: 813.25,
    y2: 263.92,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-554",
    x1: 811.04,
    y1: 256.91,
    x2: 821.79,
    y2: 265.49,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-555",
    x1: 824.11,
    y1: 277.56,
    x2: 824.93,
    y2: 269.68,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-556",
    x1: 840.97,
    y1: 270.09,
    x2: 850.83,
    y2: 279.95,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-557",
    x1: 844.27,
    y1: 365.93,
    x2: 855.02,
    y2: 267.13,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-558",
    x1: 903.8,
    y1: 328.99,
    x2: 818.5,
    y2: 265.48,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-559",
    x1: 849.93,
    y1: 310.1,
    x2: 852.22,
    y2: 288.14,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-560",
    x1: 850.01,
    y1: 281.13,
    x2: 860.76,
    y2: 289.71,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-561",
    x1: 863.08,
    y1: 301.78,
    x2: 863.9,
    y2: 293.9,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-562",
    x1: 851.45,
    y1: 350.99,
    x2: 861.31,
    y2: 360.85,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-563",
    x1: 854.76,
    y1: 446.83,
    x2: 865.5,
    y2: 348.03,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-564",
    x1: 914.28,
    y1: 409.89,
    x2: 828.98,
    y2: 346.38,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-565",
    x1: 860.41,
    y1: 391,
    x2: 862.7,
    y2: 369.04,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-566",
    x1: 860.49,
    y1: 362.03,
    x2: 871.24,
    y2: 370.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-567",
    x1: 873.56,
    y1: 382.68,
    x2: 874.38,
    y2: 374.8,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-568",
    x1: 796.3,
    y1: 386.18,
    x2: 806.16,
    y2: 396.04,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-569",
    x1: 799.61,
    y1: 482.02,
    x2: 810.35,
    y2: 383.21,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-570",
    x1: 859.13,
    y1: 445.08,
    x2: 773.83,
    y2: 381.57,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-571",
    x1: 805.26,
    y1: 426.19,
    x2: 807.55,
    y2: 404.22,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-572",
    x1: 805.34,
    y1: 397.21,
    x2: 816.09,
    y2: 405.8,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-573",
    x1: 818.41,
    y1: 417.86,
    x2: 819.23,
    y2: 409.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-574",
    x1: 735.9,
    y1: 420.42,
    x2: 745.76,
    y2: 430.28,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-575",
    x1: 739.2,
    y1: 516.26,
    x2: 749.95,
    y2: 417.46,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-576",
    x1: 798.73,
    y1: 479.32,
    x2: 713.43,
    y2: 415.81,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-577",
    x1: 744.86,
    y1: 460.43,
    x2: 747.15,
    y2: 438.47,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-578",
    x1: 744.94,
    y1: 431.46,
    x2: 755.69,
    y2: 440.04,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-579",
    x1: 758.01,
    y1: 452.11,
    x2: 758.83,
    y2: 444.23,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-580",
    x1: 675.5,
    y1: 454.66,
    x2: 685.36,
    y2: 464.53,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-581",
    x1: 678.8,
    y1: 550.5,
    x2: 689.55,
    y2: 451.7,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-582",
    x1: 738.33,
    y1: 513.56,
    x2: 653.03,
    y2: 450.05,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-583",
    x1: 684.46,
    y1: 494.68,
    x2: 686.75,
    y2: 472.71,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-584",
    x1: 684.54,
    y1: 465.7,
    x2: 695.29,
    y2: 474.29,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-585",
    x1: 697.61,
    y1: 486.35,
    x2: 698.43,
    y2: 478.48,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-586",
    x1: 615.1,
    y1: 488.91,
    x2: 624.96,
    y2: 498.77,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-587",
    x1: 618.4,
    y1: 584.74,
    x2: 629.15,
    y2: 485.94,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-588",
    x1: 677.93,
    y1: 547.81,
    x2: 592.63,
    y2: 484.3,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-589",
    x1: 624.06,
    y1: 528.92,
    x2: 626.35,
    y2: 506.95,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-590",
    x1: 624.14,
    y1: 499.94,
    x2: 634.89,
    y2: 508.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-591",
    x1: 637.21,
    y1: 520.59,
    x2: 638.03,
    y2: 512.72,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-592",
    x1: 612.99,
    y1: 560.11,
    x2: 622.85,
    y2: 569.98,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-593",
    x1: 616.29,
    y1: 655.95,
    x2: 627.04,
    y2: 557.15,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-594",
    x1: 675.82,
    y1: 619.01,
    x2: 590.52,
    y2: 555.5,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-595",
    x1: 621.95,
    y1: 600.13,
    x2: 624.24,
    y2: 578.16,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-596",
    x1: 622.03,
    y1: 571.15,
    x2: 632.78,
    y2: 579.73,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-597",
    x1: 635.1,
    y1: 591.8,
    x2: 635.92,
    y2: 583.93,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-598",
    x1: 685.46,
    y1: 601.8,
    x2: 695.32,
    y2: 611.66,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-599",
    x1: 688.76,
    y1: 697.64,
    x2: 699.51,
    y2: 598.84,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-600",
    x1: 748.29,
    y1: 660.7,
    x2: 662.99,
    y2: 597.19,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-601",
    x1: 694.42,
    y1: 641.81,
    x2: 696.71,
    y2: 619.84,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-602",
    x1: 694.5,
    y1: 612.83,
    x2: 705.25,
    y2: 621.42,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-603",
    x1: 707.57,
    y1: 633.48,
    x2: 708.39,
    y2: 625.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-604",
    x1: 697.46,
    y1: 507.26,
    x2: 847.1,
    y2: 357.63,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-605",
    x1: 729.68,
    y1: 519.11,
    x2: 775.11,
    y2: 401.23,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-606",
    x1: 916.68,
    y1: 557.33,
    x2: 559.92,
    y2: 250.5,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-607",
    x1: 567.82,
    y1: 496.23,
    x2: 593.16,
    y2: 478.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 1369.45, 0)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-608",
    x1: 575.87,
    y1: 488.49,
    x2: 606.01,
    y2: 486.49,
    gradientTransform: "matrix(-0.48, -0.88, -0.88, 0.48, 1497.76, 758.89)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-609",
    x1: 571.31,
    y1: 512.7,
    x2: 571.31,
    y2: 528.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 1369.45, 0)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-610",
    x1: 582.36,
    y1: 516,
    x2: 551.36,
    y2: 484.99,
    gradientTransform: "matrix(-1, -0.01, -0.01, 1, 1374.56, 5.85)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-611",
    x1: 765.69,
    y1: 529.01,
    x2: 793.28,
    y2: 497.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-612",
    x1: 578.51,
    y1: 272.04,
    x2: 446.81,
    y2: 158.77,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-613",
    x1: 495.43,
    y1: 250.84,
    x2: 558.76,
    y2: 221.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-614",
    x1: 463.75,
    y1: 324.85,
    x2: 613.38,
    y2: 175.22,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-615",
    x1: 495.97,
    y1: 336.7,
    x2: 541.39,
    y2: 218.82,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-616",
    x1: 801.53,
    y1: 313.82,
    x2: 826.87,
    y2: 296.5,
    gradientTransform: "translate(-44.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-617",
    x1: 809.59,
    y1: 306.08,
    x2: 839.73,
    y2: 304.08,
    gradientTransform: "translate(204.73 -355.39) rotate(28.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-618",
    x1: 805.02,
    y1: 330.29,
    x2: 805.02,
    y2: 345.94,
    gradientTransform: "translate(-44.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-619",
    x1: 816.07,
    y1: 333.59,
    x2: 785.07,
    y2: 302.58,
    gradientTransform: "translate(1074.38 -485.73) rotate(89.42)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-620",
    x1: 531.97,
    y1: 346.6,
    x2: 559.57,
    y2: 315.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 1324.5, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-621",
    x1: 818.1,
    y1: 519.23,
    x2: 847.2,
    y2: 445.97,
    gradientTransform: "translate(-18.19 154.64) rotate(-16.4)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-622",
    x1: 921.64,
    y1: 480.54,
    x2: 954.83,
    y2: 513.72,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-623",
    x1: 911.61,
    y1: 490.57,
    x2: 944.79,
    y2: 523.76,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-624",
    x1: 910.25,
    y1: 522.01,
    x2: 910.25,
    y2: 181.27,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-625",
    x1: 856.88,
    y1: 353.78,
    x2: 955.29,
    y2: 512.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-626",
    x1: 901.33,
    y1: 522.01,
    x2: 901.33,
    y2: 181.27,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-627",
    x1: 847.33,
    y1: 359.69,
    x2: 945.74,
    y2: 518.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-628",
    x1: 904.11,
    y1: 343.43,
    x2: 904.11,
    y2: 565.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-629",
    x1: 903,
    y1: 410.3,
    x2: 903,
    y2: 353.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-630",
    x1: 896.38,
    y1: 362.91,
    x2: 896.38,
    y2: 381.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-631",
    x1: 906,
    y1: 365.85,
    x2: 906,
    y2: 395.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-632",
    x1: 903.74,
    y1: 343.49,
    x2: 903.74,
    y2: 380.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-633",
    x1: 882.63,
    y1: 379.01,
    x2: 916.22,
    y2: 351.78,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-634",
    x1: 909.3,
    y1: 359.59,
    x2: 932.07,
    y2: 351.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-635",
    x1: 904.54,
    y1: 355.83,
    x2: 904.27,
    y2: 374.72,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-636",
    x1: 904.38,
    y1: 379.29,
    x2: 907.28,
    y2: 396.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-637",
    x1: 874.02,
    y1: 440.48,
    x2: 914.03,
    y2: 339.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-638",
    x1: 544.26,
    y1: 667.08,
    x2: 578.94,
    y2: 701.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-639",
    x1: 534.51,
    y1: 676.83,
    x2: 569.19,
    y2: 711.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-640",
    x1: 544.76,
    y1: 712.68,
    x2: 544.76,
    y2: 409.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-641",
    x1: 766.92,
    y1: 632.63,
    x2: 820.5,
    y2: 639.87,
    gradientTransform: "matrix(1, 0, 0.08, 1, -253.11, 0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-642",
    x1: 533.19,
    y1: 572,
    x2: 559.34,
    y2: 598.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-643",
    x1: 536.97,
    y1: 712.68,
    x2: 536.97,
    y2: 409.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-644",
    x1: 544.26,
    y1: 629.38,
    x2: 539.8,
    y2: 594.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-645",
    x1: 783.68,
    y1: 622.31,
    x2: 813.12,
    y2: 545.35,
    gradientTransform: "matrix(1, 0, 0.08, 1, -253.11, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-646",
    x1: 803.43,
    y1: 562.83,
    x2: 799.07,
    y2: 581.79,
    gradientTransform: "matrix(1, 0, 0.08, 1, -253.11, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-647",
    x1: 792.23,
    y1: 578.39,
    x2: 805.73,
    y2: 582.81,
    gradientTransform: "matrix(1, 0, 0.08, 1, -253.11, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-648",
    x1: 775.05,
    y1: 647.17,
    x2: 822.13,
    y2: 640.18,
    gradientTransform: "matrix(1, 0, 0.08, 1, -253.11, 0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-649",
    x1: 535.09,
    y1: 560.62,
    x2: 535.09,
    y2: 579.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-650",
    x1: 545.24,
    y1: 563.72,
    x2: 545.24,
    y2: 595.39,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-651",
    x1: 542.85,
    y1: 540.13,
    x2: 542.85,
    y2: 579.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-652",
    x1: 520.58,
    y1: 577.6,
    x2: 556.02,
    y2: 548.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-653",
    x1: 548.72,
    y1: 557.11,
    x2: 572.74,
    y2: 548.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-654",
    x1: 543.7,
    y1: 553.15,
    x2: 543.41,
    y2: 573.08,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-655",
    x1: 566.54,
    y1: 626.74,
    x2: 500.98,
    y2: 579.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 1137.93, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-656",
    x1: 818.5,
    y1: 697.4,
    x2: 818.5,
    y2: 826.74,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-657",
    x1: 963.05,
    y1: 806.93,
    x2: 741.82,
    y2: 618.85,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-658",
    x1: 773.52,
    y1: 620.53,
    x2: 789.44,
    y2: 636.45,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-659",
    x1: 778.85,
    y1: 775.21,
    x2: 796.2,
    y2: 615.75,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-660",
    x1: 874.92,
    y1: 715.59,
    x2: 737.26,
    y2: 613.09,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-661",
    x1: 787.99,
    y1: 685.11,
    x2: 791.68,
    y2: 649.66,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-662",
    x1: 788.11,
    y1: 638.34,
    x2: 805.46,
    y2: 652.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-663",
    x1: 809.21,
    y1: 671.67,
    x2: 810.53,
    y2: 658.96,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-664",
    x1: 799.88,
    y1: 635.49,
    x2: 815.8,
    y2: 651.41,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-665",
    x1: 805.21,
    y1: 790.16,
    x2: 822.56,
    y2: 630.71,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-666",
    x1: 901.28,
    y1: 730.55,
    x2: 763.62,
    y2: 628.05,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-667",
    x1: 814.35,
    y1: 700.07,
    x2: 818.04,
    y2: 664.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-668",
    x1: 814.47,
    y1: 653.3,
    x2: 831.82,
    y2: 667.16,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-669",
    x1: 835.57,
    y1: 686.63,
    x2: 836.89,
    y2: 673.92,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-670",
    x1: 773.52,
    y1: 591.93,
    x2: 789.44,
    y2: 607.84,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-671",
    x1: 778.85,
    y1: 746.6,
    x2: 796.2,
    y2: 587.15,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-672",
    x1: 874.92,
    y1: 686.99,
    x2: 737.26,
    y2: 584.49,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-673",
    x1: 787.99,
    y1: 656.5,
    x2: 791.68,
    y2: 621.05,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-674",
    x1: 788.11,
    y1: 609.74,
    x2: 805.46,
    y2: 623.59,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-675",
    x1: 809.21,
    y1: 643.07,
    x2: 810.53,
    y2: 630.36,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-676",
    x1: 799.88,
    y1: 606.88,
    x2: 815.8,
    y2: 622.8,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-677",
    x1: 805.21,
    y1: 761.56,
    x2: 822.56,
    y2: 602.1,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-678",
    x1: 901.28,
    y1: 701.94,
    x2: 763.62,
    y2: 599.45,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-679",
    x1: 814.35,
    y1: 671.46,
    x2: 818.04,
    y2: 636.01,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-680",
    x1: 814.47,
    y1: 624.7,
    x2: 831.82,
    y2: 638.55,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-681",
    x1: 835.57,
    y1: 658.02,
    x2: 836.89,
    y2: 645.32,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-682",
    x1: 451.1,
    y1: 114.65,
    x2: 483.36,
    y2: 186.11,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-683",
    x1: 344.91,
    y1: 78.73,
    x2: 404.56,
    y2: 171.23,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-684",
    x1: 426.46,
    y1: 253.96,
    x2: 426.46,
    y2: -0.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-685",
    x1: 425.79,
    y1: 293.38,
    x2: 425.79,
    y2: 28.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-686",
    x1: 404.01,
    y1: 352.84,
    x2: 404.01,
    y2: 126.3,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-687",
    x1: 412.56,
    y1: 329.98,
    x2: 412.56,
    y2: 59.65,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-688",
    x1: 459.7,
    y1: 123.48,
    x2: 459.7,
    y2: 140.64,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-689",
    x1: 441.83,
    y1: 127.95,
    x2: 463.97,
    y2: 154.05,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-690",
    x1: 498.46,
    y1: 167.33,
    x2: 449.27,
    y2: 121.8,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-691",
    x1: 440.51,
    y1: 130.58,
    x2: 416.59,
    y2: 123.32,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-692",
    x1: 449.13,
    y1: 37.3,
    x2: 488.1,
    y2: 227.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-693",
    x1: 523.6,
    y1: 222.55,
    x2: 428.63,
    y2: 127.59,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-694",
    x1: 521.32,
    y1: 224.83,
    x2: 426.35,
    y2: 129.86,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-695",
    x1: 455.19,
    y1: 99.86,
    x2: 492.31,
    y2: 62.74,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-696",
    x1: 409.29,
    y1: 97.39,
    x2: 440.17,
    y2: 128.27,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-697",
    x1: 393.19,
    y1: 111.81,
    x2: 426.95,
    y2: 75.96,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-698",
    x1: 413.25,
    y1: 235.07,
    x2: 413.25,
    y2: 24.98,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-699",
    x1: 424.35,
    y1: 155.3,
    x2: 466.62,
    y2: 201.28,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-700",
    x1: 401.12,
    y1: 149.03,
    x2: 401.12,
    y2: 105.16,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-701",
    x1: 448.13,
    y1: 205.13,
    x2: 413.88,
    y2: 151.56,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-702",
    x1: 434.43,
    y1: -48.79,
    x2: 434.43,
    y2: 217.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8496ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-703",
    x1: 418.88,
    y1: 139.91,
    x2: 422.6,
    y2: 143.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-704",
    x1: 402.66,
    y1: 156.13,
    x2: 406.38,
    y2: 159.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-705",
    x1: 486.6,
    y1: 225.14,
    x2: 378.95,
    y2: 126.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-706",
    x1: 449.84,
    y1: 148,
    x2: 392.37,
    y2: 121.65,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-707",
    x1: 446.93,
    y1: 133.11,
    x2: 427.92,
    y2: 152.12,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-708",
    x1: 420.5,
    y1: 158.63,
    x2: 462.98,
    y2: 118.23,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-709",
    x1: 400.41,
    y1: 182.83,
    x2: 478.28,
    y2: 93.91,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-710",
    x1: 430.14,
    y1: 166.18,
    x2: 430.14,
    y2: 69.65,
    gradientTransform: "translate(125.53 -189.69) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-711",
    x1: 436.09,
    y1: 142.33,
    x2: 450.17,
    y2: 128.24,
    gradientTransform: "translate(125.53 -189.69) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-712",
    x1: 415.73,
    y1: 162.07,
    x2: 449.08,
    y2: 127.11,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-713",
    x1: 417.31,
    y1: 153.56,
    x2: 465.99,
    y2: 137.73,
    gradientTransform: "translate(126.2 -187.44) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-714",
    x1: 429.28,
    y1: 149.54,
    x2: 438.2,
    y2: 146.3,
    gradientTransform: "translate(126.2 -187.44) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-715",
    x1: 406.29,
    y1: 138.56,
    x2: 434.74,
    y2: 180.93,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-716",
    x1: 426.41,
    y1: 163.51,
    x2: 403.38,
    y2: 140.48,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-717",
    x1: 434.03,
    y1: 147.81,
    x2: 463.59,
    y2: 177.36,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-718",
    x1: 432.82,
    y1: 166.62,
    x2: 392.13,
    y2: 101.52,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-719",
    x1: 444.19,
    y1: 136.44,
    x2: 481.11,
    y2: 173.36,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-720",
    x1: 320.07,
    y1: 127.61,
    x2: 546.17,
    y2: 353.72,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-721",
    x1: 354.45,
    y1: 165.36,
    x2: 286.41,
    y2: 146.13,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-722",
    x1: 351.85,
    y1: 145,
    x2: 391.75,
    y2: 145,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-723",
    x1: 351.85,
    y1: 145.79,
    x2: 391.75,
    y2: 145.79,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-724",
    x1: 351.85,
    y1: 146.59,
    x2: 391.75,
    y2: 146.59,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-725",
    x1: 351.85,
    y1: 147.39,
    x2: 391.75,
    y2: 147.39,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-726",
    x1: 377.36,
    y1: 167.42,
    x2: 425.44,
    y2: 150.75,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-727",
    x1: 289.8,
    y1: 128.91,
    x2: 521.94,
    y2: 257.04,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-728",
    x1: 362.6,
    y1: 253.96,
    x2: 362.6,
    y2: -0.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-729",
    x1: 361.62,
    y1: 293.38,
    x2: 361.62,
    y2: 28.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-730",
    x1: 339.51,
    y1: 192.81,
    x2: 364.85,
    y2: 175.5,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-731",
    x1: 347.56,
    y1: 185.08,
    x2: 377.7,
    y2: 183.07,
    gradientTransform: "translate(133.36 -146.86) rotate(28.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-732",
    x1: 355.27,
    y1: 180.66,
    x2: 353.68,
    y2: 182.25,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-733",
    x1: 343,
    y1: 209.28,
    x2: 343,
    y2: 224.93,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-734",
    x1: 354.05,
    y1: 212.58,
    x2: 323.04,
    y2: 181.58,
    gradientTransform: "translate(541 -143.5) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-735",
    x1: 338.51,
    y1: 184.97,
    x2: 351.73,
    y2: 197.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-736",
    x1: 393.96,
    y1: 170.58,
    x2: 437.67,
    y2: 141.08,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-737",
    x1: 413.76,
    y1: 153.74,
    x2: 445.23,
    y2: 185.21,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-738",
    x1: 434.16,
    y1: 170.9,
    x2: 414.41,
    y2: 151.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-739",
    x1: 427.36,
    y1: 170.9,
    x2: 414.14,
    y2: 147.66,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-740",
    x1: 438.56,
    y1: 171.22,
    x2: 395.53,
    y2: 136.9,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-741",
    x1: 414.9,
    y1: 150.81,
    x2: 427.36,
    y2: 164.32,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-742",
    x1: 404.52,
    y1: 87.05,
    x2: 440.4,
    y2: 172.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-743",
    x1: 421.62,
    y1: 105.55,
    x2: 452.18,
    y2: 153.75,
    gradientTransform: "translate(514.56 -318.94) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-744",
    x1: 446.85,
    y1: 211.25,
    x2: 424.47,
    y2: 168,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-745",
    x1: 394.64,
    y1: 113.16,
    x2: 463.54,
    y2: 135.65,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-746",
    x1: 394.57,
    y1: 91.39,
    x2: 408.4,
    y2: 108.72,
    gradientTransform: "translate(506.54 -301.45) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-747",
    x1: 513.15,
    y1: 164.4,
    x2: 394.19,
    y2: 90.27,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-748",
    x1: 465.46,
    y1: 129.4,
    x2: 471.33,
    y2: 135.27,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-749",
    x1: 474.15,
    y1: 145.77,
    x2: 426.36,
    y2: 72.9,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-750",
    x1: 463.3,
    y1: 143.89,
    x2: 481.97,
    y2: 172.86,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-751",
    x1: 456.32,
    y1: 103.13,
    x2: 456.32,
    y2: 118,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-752",
    x1: 466.84,
    y1: 141.61,
    x2: 485.51,
    y2: 170.58,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-753",
    x1: 459.96,
    y1: 103.13,
    x2: 459.96,
    y2: 118,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-754",
    x1: 470.38,
    y1: 139.33,
    x2: 489.05,
    y2: 168.3,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-755",
    x1: 463.6,
    y1: 103.13,
    x2: 463.6,
    y2: 118,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-756",
    x1: 467.61,
    y1: 119.18,
    x2: 470.87,
    y2: 119.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-757",
    x1: 466.37,
    y1: 114.71,
    x2: 467.7,
    y2: 116.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-758",
    x1: 465.04,
    y1: 119.29,
    x2: 466.54,
    y2: 120.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-759",
    x1: 468.04,
    y1: 123.56,
    x2: 470.87,
    y2: 123.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-760",
    x1: 453.02,
    y1: 133.99,
    x2: 463.29,
    y2: 144.27,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-761",
    x1: 453.62,
    y1: 134.5,
    x2: 455.06,
    y2: 135.95,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-762",
    x1: 453.19,
    y1: 128.4,
    x2: 461.19,
    y2: 136.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-763",
    x1: 455.26,
    y1: 130.23,
    x2: 472.17,
    y2: 147.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-764",
    x1: 456.87,
    y1: 126.99,
    x2: 464.13,
    y2: 133.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-765",
    x1: 457.42,
    y1: 122.97,
    x2: 477.44,
    y2: 155.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-766",
    x1: 452,
    y1: 137.21,
    x2: 456.13,
    y2: 141.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-767",
    x1: 453.61,
    y1: 138.38,
    x2: 462.7,
    y2: 148.63,
    gradientTransform: "translate(359.12 -326.31) rotate(61.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-768",
    x1: 460.68,
    y1: 131.88,
    x2: 460.68,
    y2: 143.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-769",
    x1: 458.69,
    y1: 138.99,
    x2: 465.31,
    y2: 138.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-770",
    x1: 367.71,
    y1: 53.97,
    x2: 406.68,
    y2: 244.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-771",
    x1: 350.18,
    y1: 113.57,
    x2: 422.54,
    y2: 185.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-772",
    x1: 407.31,
    y1: 56.44,
    x2: 479.67,
    y2: 128.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-773",
    x1: 400.84,
    y1: 267.88,
    x2: 400.84,
    y2: 153.69,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-774",
    x1: 411.86,
    y1: 115.73,
    x2: 443.63,
    y2: 157.41,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-775",
    x1: 425.8,
    y1: 141.3,
    x2: 425.8,
    y2: 178.16,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-776",
    x1: 405.8,
    y1: 165.11,
    x2: 449.58,
    y2: 165.11,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-777",
    x1: 391.92,
    y1: 167.17,
    x2: 434.85,
    y2: 159.75,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-778",
    x1: 433.69,
    y1: 178.38,
    x2: 447.19,
    y2: 193.06,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-779",
    x1: 406.65,
    y1: 105.38,
    x2: 425.13,
    y2: 85.76,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-780",
    x1: 415.18,
    y1: 76.34,
    x2: 415.18,
    y2: 139.34,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-781",
    x1: 321.35,
    y1: 39.48,
    x2: 353.6,
    y2: 110.94,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-782",
    x1: 215.15,
    y1: 3.56,
    x2: 274.8,
    y2: 96.06,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-783",
    x1: 296.7,
    y1: 178.8,
    x2: 296.7,
    y2: -75.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-784",
    x1: 296.03,
    y1: 218.21,
    x2: 296.03,
    y2: -46.33,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-785",
    x1: 274.25,
    y1: 277.67,
    x2: 274.25,
    y2: 51.13,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-786",
    x1: 282.81,
    y1: 254.81,
    x2: 282.81,
    y2: -15.52,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-787",
    x1: 329.95,
    y1: 48.31,
    x2: 329.95,
    y2: 65.47,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-788",
    x1: 312.07,
    y1: 52.78,
    x2: 334.21,
    y2: 78.89,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-789",
    x1: 368.7,
    y1: 92.17,
    x2: 319.52,
    y2: 46.63,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-790",
    x1: 310.75,
    y1: 55.41,
    x2: 286.84,
    y2: 48.15,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-791",
    x1: 319.37,
    y1: -37.87,
    x2: 358.35,
    y2: 152.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-792",
    x1: 393.84,
    y1: 147.39,
    x2: 298.87,
    y2: 52.42,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-793",
    x1: 391.56,
    y1: 149.66,
    x2: 296.6,
    y2: 54.7,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-794",
    x1: 325.43,
    y1: 24.69,
    x2: 362.55,
    y2: -12.43,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-795",
    x1: 279.53,
    y1: 22.22,
    x2: 310.42,
    y2: 53.1,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-796",
    x1: 263.43,
    y1: 36.64,
    x2: 297.2,
    y2: 0.79,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-797",
    x1: 283.49,
    y1: 159.9,
    x2: 283.49,
    y2: -50.19,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-798",
    x1: 294.59,
    y1: 80.14,
    x2: 336.86,
    y2: 126.11,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-799",
    x1: 271.37,
    y1: 73.86,
    x2: 271.37,
    y2: 29.99,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-800",
    x1: 318.38,
    y1: 129.97,
    x2: 284.13,
    y2: 76.39,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-801",
    x1: 304.67,
    y1: -123.95,
    x2: 304.67,
    y2: 142.09,
    xlinkHref: "#linear-gradient-702"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-802",
    x1: 289.13,
    y1: 64.74,
    x2: 292.85,
    y2: 68.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-803",
    x1: 272.91,
    y1: 80.96,
    x2: 276.63,
    y2: 84.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-804",
    x1: 356.85,
    y1: 149.97,
    x2: 249.19,
    y2: 51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-805",
    x1: 320.08,
    y1: 72.83,
    x2: 262.61,
    y2: 46.49,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-806",
    x1: 317.17,
    y1: 57.94,
    x2: 298.16,
    y2: 76.95,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-807",
    x1: 290.75,
    y1: 83.46,
    x2: 333.22,
    y2: 43.06,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-808",
    x1: 270.65,
    y1: 107.66,
    x2: 348.52,
    y2: 18.74,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-809",
    x1: 300.38,
    y1: 91.01,
    x2: 300.38,
    y2: -5.52,
    gradientTransform: "translate(72.93 -136.27) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-810",
    x1: 306.33,
    y1: 67.16,
    x2: 320.41,
    y2: 53.08,
    gradientTransform: "translate(72.93 -136.27) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-811",
    x1: 285.98,
    y1: 86.9,
    x2: 319.32,
    y2: 51.94,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-812",
    x1: 287.56,
    y1: 78.39,
    x2: 336.23,
    y2: 62.57,
    gradientTransform: "translate(73.6 -134.02) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-813",
    x1: 299.53,
    y1: 74.38,
    x2: 308.44,
    y2: 71.13,
    gradientTransform: "translate(73.6 -134.02) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-814",
    x1: 276.53,
    y1: 63.39,
    x2: 304.99,
    y2: 105.76,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-815",
    x1: 296.65,
    y1: 88.34,
    x2: 273.62,
    y2: 65.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-816",
    x1: 304.28,
    y1: 72.64,
    x2: 333.83,
    y2: 102.19,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-817",
    x1: 303.06,
    y1: 91.46,
    x2: 262.37,
    y2: 26.35,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-818",
    x1: 314.43,
    y1: 61.27,
    x2: 351.35,
    y2: 98.19,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-819",
    x1: 190.31,
    y1: 52.45,
    x2: 416.42,
    y2: 278.55,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-820",
    x1: 224.69,
    y1: 90.19,
    x2: 156.65,
    y2: 70.97,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-821",
    x1: 222.09,
    y1: 69.83,
    x2: 261.99,
    y2: 69.83,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-822",
    x1: 222.09,
    y1: 70.63,
    x2: 261.99,
    y2: 70.63,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-823",
    x1: 222.09,
    y1: 71.42,
    x2: 261.99,
    y2: 71.42,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-824",
    x1: 222.09,
    y1: 72.22,
    x2: 261.99,
    y2: 72.22,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-825",
    x1: 247.6,
    y1: 92.25,
    x2: 295.68,
    y2: 75.58,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-826",
    x1: 160.04,
    y1: 53.74,
    x2: 392.18,
    y2: 181.87,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-827",
    x1: 232.85,
    y1: 178.8,
    x2: 232.85,
    y2: -75.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-828",
    x1: 231.86,
    y1: 218.21,
    x2: 231.86,
    y2: -46.33,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-829",
    x1: 209.75,
    y1: 117.64,
    x2: 235.09,
    y2: 100.33,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-830",
    x1: 217.8,
    y1: 109.91,
    x2: 247.95,
    y2: 107.9,
    gradientTransform: "translate(80.75 -93.44) rotate(28.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-831",
    x1: 225.51,
    y1: 105.5,
    x2: 223.93,
    y2: 107.08,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-832",
    x1: 213.24,
    y1: 134.11,
    x2: 213.24,
    y2: 149.76,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-833",
    x1: 224.29,
    y1: 137.41,
    x2: 193.29,
    y2: 106.41,
    gradientTransform: "translate(337.41 -88.16) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-834",
    x1: 208.75,
    y1: 109.8,
    x2: 221.97,
    y2: 122.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-835",
    x1: 264.21,
    y1: 95.41,
    x2: 307.91,
    y2: 65.91,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-836",
    x1: 284,
    y1: 78.57,
    x2: 315.47,
    y2: 110.04,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-837",
    x1: 304.41,
    y1: 95.74,
    x2: 284.66,
    y2: 75.99,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-838",
    x1: 297.61,
    y1: 95.73,
    x2: 284.39,
    y2: 72.5,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-839",
    x1: 308.8,
    y1: 96.05,
    x2: 265.77,
    y2: 61.73,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-840",
    x1: 285.15,
    y1: 75.64,
    x2: 297.6,
    y2: 89.15,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-841",
    x1: 274.77,
    y1: 11.88,
    x2: 310.65,
    y2: 97.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-842",
    x1: 291.86,
    y1: 30.39,
    x2: 322.42,
    y2: 78.59,
    gradientTransform: "translate(310.96 -263.59) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-843",
    x1: 317.09,
    y1: 136.09,
    x2: 294.71,
    y2: 92.84,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-844",
    x1: 264.89,
    y1: 37.99,
    x2: 333.78,
    y2: 60.48,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-845",
    x1: 264.81,
    y1: 16.22,
    x2: 278.64,
    y2: 33.55,
    gradientTransform: "translate(302.94 -246.11) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-846",
    x1: 383.39,
    y1: 89.23,
    x2: 264.43,
    y2: 15.1,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-847",
    x1: 335.7,
    y1: 54.23,
    x2: 341.57,
    y2: 60.1,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-848",
    x1: 344.39,
    y1: 70.6,
    x2: 296.6,
    y2: -2.26,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-849",
    x1: 333.54,
    y1: 68.72,
    x2: 352.22,
    y2: 97.7,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-850",
    x1: 326.56,
    y1: 27.97,
    x2: 326.56,
    y2: 42.83,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-851",
    x1: 337.08,
    y1: 66.44,
    x2: 355.75,
    y2: 95.42,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-852",
    x1: 330.2,
    y1: 27.97,
    x2: 330.2,
    y2: 42.83,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-853",
    x1: 340.62,
    y1: 64.16,
    x2: 359.29,
    y2: 93.14,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-854",
    x1: 333.85,
    y1: 27.97,
    x2: 333.85,
    y2: 42.83,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-855",
    x1: 337.85,
    y1: 44.01,
    x2: 341.12,
    y2: 44.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-856",
    x1: 336.61,
    y1: 39.55,
    x2: 337.94,
    y2: 41.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-857",
    x1: 335.28,
    y1: 44.12,
    x2: 336.79,
    y2: 45.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-858",
    x1: 338.28,
    y1: 48.39,
    x2: 341.12,
    y2: 48.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-859",
    x1: 323.26,
    y1: 58.82,
    x2: 333.54,
    y2: 69.1,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-860",
    x1: 323.86,
    y1: 59.34,
    x2: 325.31,
    y2: 60.78,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-861",
    x1: 323.43,
    y1: 53.24,
    x2: 331.43,
    y2: 61.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-862",
    x1: 325.5,
    y1: 55.07,
    x2: 342.41,
    y2: 72.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-863",
    x1: 327.11,
    y1: 51.83,
    x2: 334.38,
    y2: 58.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-864",
    x1: 327.66,
    y1: 47.8,
    x2: 347.68,
    y2: 80.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-865",
    x1: 322.24,
    y1: 62.04,
    x2: 326.38,
    y2: 66.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-866",
    x1: 323.85,
    y1: 63.21,
    x2: 332.94,
    y2: 73.46,
    gradientTransform: "translate(226.4 -251.55) rotate(61.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-867",
    x1: 330.92,
    y1: 56.71,
    x2: 330.92,
    y2: 68.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-868",
    x1: 328.93,
    y1: 63.82,
    x2: 335.56,
    y2: 63.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-869",
    x1: 237.95,
    y1: -21.19,
    x2: 276.93,
    y2: 169.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-870",
    x1: 220.42,
    y1: 38.41,
    x2: 292.78,
    y2: 110.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-871",
    x1: 277.56,
    y1: -18.73,
    x2: 349.92,
    y2: 53.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-872",
    x1: 271.08,
    y1: 192.71,
    x2: 271.08,
    y2: 78.53,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-873",
    x1: 282.1,
    y1: 40.56,
    x2: 313.87,
    y2: 82.24,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-874",
    x1: 296.04,
    y1: 66.14,
    x2: 296.04,
    y2: 102.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-875",
    x1: 276.04,
    y1: 89.94,
    x2: 319.82,
    y2: 89.94,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-876",
    x1: 262.16,
    y1: 92,
    x2: 305.09,
    y2: 84.59,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-877",
    x1: 303.93,
    y1: 103.21,
    x2: 317.43,
    y2: 117.9,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-878",
    x1: 276.9,
    y1: 30.22,
    x2: 295.38,
    y2: 10.59,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-879",
    x1: 285.42,
    y1: 1.18,
    x2: 285.42,
    y2: 64.18,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-880",
    x1: 250.97,
    y1: 231.2,
    x2: 283.23,
    y2: 302.66,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-881",
    x1: 144.78,
    y1: 195.27,
    x2: 204.43,
    y2: 287.77,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-882",
    x1: 226.33,
    y1: 370.51,
    x2: 226.33,
    y2: 116.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-883",
    x1: 225.66,
    y1: 409.92,
    x2: 225.66,
    y2: 145.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-884",
    x1: 203.88,
    y1: 469.39,
    x2: 203.88,
    y2: 242.85,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-885",
    x1: 212.43,
    y1: 446.52,
    x2: 212.43,
    y2: 176.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-886",
    x1: 259.57,
    y1: 240.02,
    x2: 259.57,
    y2: 257.18,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-887",
    x1: 241.7,
    y1: 244.49,
    x2: 263.84,
    y2: 270.6,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-888",
    x1: 298.33,
    y1: 283.88,
    x2: 249.14,
    y2: 238.34,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-889",
    x1: 240.38,
    y1: 247.13,
    x2: 216.46,
    y2: 239.87,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-890",
    x1: 249,
    y1: 153.84,
    x2: 287.97,
    y2: 344.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-891",
    x1: 323.47,
    y1: 339.1,
    x2: 228.5,
    y2: 244.14,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-892",
    x1: 321.19,
    y1: 341.38,
    x2: 226.22,
    y2: 246.41,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-893",
    x1: 255.06,
    y1: 216.41,
    x2: 292.18,
    y2: 179.29,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-894",
    x1: 209.16,
    y1: 213.93,
    x2: 240.04,
    y2: 244.82,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-895",
    x1: 193.06,
    y1: 228.36,
    x2: 226.82,
    y2: 192.5,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-896",
    x1: 213.12,
    y1: 351.61,
    x2: 213.12,
    y2: 141.53,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-897",
    x1: 224.22,
    y1: 271.85,
    x2: 266.49,
    y2: 317.82,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-898",
    x1: 200.99,
    y1: 265.58,
    x2: 200.99,
    y2: 221.7,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-899",
    x1: 248,
    y1: 321.68,
    x2: 213.75,
    y2: 268.11,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-900",
    x1: 234.3,
    y1: 67.76,
    x2: 234.3,
    y2: 333.81,
    xlinkHref: "#linear-gradient-702"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-901",
    x1: 218.75,
    y1: 256.46,
    x2: 222.47,
    y2: 260.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-902",
    x1: 202.53,
    y1: 272.68,
    x2: 206.25,
    y2: 276.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-903",
    x1: 286.47,
    y1: 341.68,
    x2: 178.82,
    y2: 242.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-904",
    x1: 249.71,
    y1: 264.55,
    x2: 192.24,
    y2: 238.2,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-905",
    x1: 246.8,
    y1: 249.65,
    x2: 227.79,
    y2: 268.67,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-906",
    x1: 220.37,
    y1: 275.18,
    x2: 262.85,
    y2: 234.78,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-907",
    x1: 200.28,
    y1: 299.37,
    x2: 278.15,
    y2: 210.46,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-908",
    x1: 230.01,
    y1: 282.73,
    x2: 230.01,
    y2: 186.2,
    gradientTransform: "translate(156.94 -78.25) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-909",
    x1: 235.96,
    y1: 258.87,
    x2: 250.04,
    y2: 244.79,
    gradientTransform: "translate(156.94 -78.25) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-910",
    x1: 215.6,
    y1: 278.62,
    x2: 248.95,
    y2: 243.66,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-911",
    x1: 217.18,
    y1: 270.11,
    x2: 265.86,
    y2: 254.28,
    gradientTransform: "translate(157.61 -75.99) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-912",
    x1: 229.15,
    y1: 266.09,
    x2: 238.07,
    y2: 262.85,
    gradientTransform: "translate(157.61 -75.99) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-913",
    x1: 206.16,
    y1: 255.1,
    x2: 234.61,
    y2: 297.48,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-914",
    x1: 226.28,
    y1: 280.06,
    x2: 203.25,
    y2: 257.03,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-915",
    x1: 233.9,
    y1: 264.36,
    x2: 263.45,
    y2: 293.91,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-916",
    x1: 232.69,
    y1: 283.17,
    x2: 192,
    y2: 218.07,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-917",
    x1: 244.06,
    y1: 252.98,
    x2: 280.98,
    y2: 289.9,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-918",
    x1: 119.94,
    y1: 244.16,
    x2: 346.04,
    y2: 470.26,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-919",
    x1: 154.32,
    y1: 281.91,
    x2: 86.28,
    y2: 262.68,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-920",
    x1: 151.72,
    y1: 261.54,
    x2: 191.62,
    y2: 261.54,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-921",
    x1: 151.72,
    y1: 262.34,
    x2: 191.62,
    y2: 262.34,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-922",
    x1: 151.72,
    y1: 263.14,
    x2: 191.62,
    y2: 263.14,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-923",
    x1: 151.72,
    y1: 263.93,
    x2: 191.62,
    y2: 263.93,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-924",
    x1: 177.23,
    y1: 283.97,
    x2: 225.31,
    y2: 267.29,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-925",
    x1: 89.67,
    y1: 245.45,
    x2: 321.81,
    y2: 373.59,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-926",
    x1: 162.47,
    y1: 370.51,
    x2: 162.47,
    y2: 116.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-927",
    x1: 161.49,
    y1: 409.92,
    x2: 161.49,
    y2: 145.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-928",
    x1: 139.38,
    y1: 309.36,
    x2: 164.72,
    y2: 292.04,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-929",
    x1: 147.43,
    y1: 301.62,
    x2: 177.57,
    y2: 299.62,
    gradientTransform: "translate(164.76 -35.41) rotate(28.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-930",
    x1: 155.14,
    y1: 297.21,
    x2: 153.55,
    y2: 298.8,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-931",
    x1: 142.87,
    y1: 325.83,
    x2: 142.87,
    y2: 341.48,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-932",
    x1: 153.92,
    y1: 329.12,
    x2: 122.91,
    y2: 298.12,
    gradientTransform: "translate(459.45 171.98) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-933",
    x1: 138.38,
    y1: 301.52,
    x2: 151.6,
    y2: 314.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-934",
    x1: 193.83,
    y1: 287.12,
    x2: 237.54,
    y2: 257.63,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-935",
    x1: 213.63,
    y1: 270.28,
    x2: 245.1,
    y2: 301.75,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-936",
    x1: 234.03,
    y1: 287.45,
    x2: 214.28,
    y2: 267.7,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-937",
    x1: 227.23,
    y1: 287.45,
    x2: 214.01,
    y2: 264.21,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-938",
    x1: 238.43,
    y1: 287.77,
    x2: 195.4,
    y2: 253.45,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-939",
    x1: 214.77,
    y1: 267.36,
    x2: 227.22,
    y2: 280.87,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-940",
    x1: 204.39,
    y1: 203.6,
    x2: 240.27,
    y2: 289.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-941",
    x1: 221.49,
    y1: 222.1,
    x2: 252.05,
    y2: 270.3,
    gradientTransform: "translate(433.01 -3.46) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-942",
    x1: 246.71,
    y1: 327.8,
    x2: 224.34,
    y2: 284.55,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-943",
    x1: 194.51,
    y1: 229.71,
    x2: 263.41,
    y2: 252.19,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-944",
    x1: 194.44,
    y1: 207.93,
    x2: 208.27,
    y2: 225.27,
    gradientTransform: "translate(424.99 14.03) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-945",
    x1: 313.02,
    y1: 280.94,
    x2: 194.06,
    y2: 206.82,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-946",
    x1: 265.33,
    y1: 245.95,
    x2: 271.2,
    y2: 251.82,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-947",
    x1: 274.02,
    y1: 262.32,
    x2: 226.23,
    y2: 189.45,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-948",
    x1: 263.17,
    y1: 260.44,
    x2: 281.84,
    y2: 289.41,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-949",
    x1: 256.19,
    y1: 219.68,
    x2: 256.19,
    y2: 234.55,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-950",
    x1: 266.71,
    y1: 258.16,
    x2: 285.38,
    y2: 287.13,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-951",
    x1: 259.83,
    y1: 219.68,
    x2: 259.83,
    y2: 234.55,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-952",
    x1: 270.25,
    y1: 255.88,
    x2: 288.92,
    y2: 284.85,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-953",
    x1: 263.47,
    y1: 219.68,
    x2: 263.47,
    y2: 234.55,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-954",
    x1: 267.48,
    y1: 235.73,
    x2: 270.74,
    y2: 235.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-955",
    x1: 266.24,
    y1: 231.26,
    x2: 267.56,
    y2: 233.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-956",
    x1: 264.91,
    y1: 235.84,
    x2: 266.41,
    y2: 237.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-957",
    x1: 267.91,
    y1: 240.11,
    x2: 270.74,
    y2: 240.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-958",
    x1: 252.89,
    y1: 250.54,
    x2: 263.16,
    y2: 260.81,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-959",
    x1: 253.49,
    y1: 251.05,
    x2: 254.93,
    y2: 252.5,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-960",
    x1: 253.06,
    y1: 244.95,
    x2: 261.06,
    y2: 252.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-961",
    x1: 255.13,
    y1: 246.78,
    x2: 272.04,
    y2: 264.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-962",
    x1: 256.74,
    y1: 243.54,
    x2: 264,
    y2: 250.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-963",
    x1: 257.29,
    y1: 239.52,
    x2: 277.31,
    y2: 271.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-964",
    x1: 251.87,
    y1: 253.76,
    x2: 256,
    y2: 257.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-965",
    x1: 253.48,
    y1: 254.93,
    x2: 262.57,
    y2: 265.18,
    gradientTransform: "translate(357.85 -91.06) rotate(61.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-966",
    x1: 260.55,
    y1: 248.42,
    x2: 260.55,
    y2: 260.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-967",
    x1: 258.56,
    y1: 255.54,
    x2: 265.18,
    y2: 255.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-968",
    x1: 167.58,
    y1: 170.52,
    x2: 206.55,
    y2: 360.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-969",
    x1: 150.05,
    y1: 230.12,
    x2: 222.41,
    y2: 302.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-970",
    x1: 207.18,
    y1: 172.99,
    x2: 279.54,
    y2: 245.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-971",
    x1: 200.71,
    y1: 384.43,
    x2: 200.71,
    y2: 270.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-972",
    x1: 211.73,
    y1: 232.28,
    x2: 243.49,
    y2: 273.96,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-973",
    x1: 225.67,
    y1: 257.85,
    x2: 225.67,
    y2: 294.71,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-974",
    x1: 205.67,
    y1: 281.66,
    x2: 249.45,
    y2: 281.66,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-975",
    x1: 191.79,
    y1: 283.72,
    x2: 234.72,
    y2: 276.3,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-976",
    x1: 233.56,
    y1: 294.92,
    x2: 247.06,
    y2: 309.61,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-977",
    x1: 206.52,
    y1: 221.93,
    x2: 225,
    y2: 202.31,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-978",
    x1: 215.05,
    y1: 192.89,
    x2: 215.05,
    y2: 255.89,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-979",
    x1: 118.41,
    y1: 153.98,
    x2: 150.66,
    y2: 225.44,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-980",
    x1: 12.21,
    y1: 118.05,
    x2: 71.86,
    y2: 210.55,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-981",
    x1: 93.76,
    y1: 293.29,
    x2: 93.76,
    y2: 39.09,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-982",
    x1: 93.09,
    y1: 332.7,
    x2: 93.09,
    y2: 68.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-983",
    x1: 71.31,
    y1: 392.17,
    x2: 71.31,
    y2: 165.63,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-984",
    x1: 79.86,
    y1: 369.3,
    x2: 79.86,
    y2: 98.98,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-985",
    x1: 127,
    y1: 162.8,
    x2: 127,
    y2: 179.96,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-986",
    x1: 109.13,
    y1: 167.27,
    x2: 131.27,
    y2: 193.38,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-987",
    x1: 165.76,
    y1: 206.66,
    x2: 116.57,
    y2: 161.12,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-988",
    x1: 107.81,
    y1: 169.91,
    x2: 83.89,
    y2: 162.65,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-989",
    x1: 116.43,
    y1: 76.62,
    x2: 155.41,
    y2: 266.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-990",
    x1: 190.9,
    y1: 261.88,
    x2: 95.93,
    y2: 166.91,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-991",
    x1: 188.62,
    y1: 264.16,
    x2: 93.66,
    y2: 169.19,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-992",
    x1: 122.49,
    y1: 139.19,
    x2: 159.61,
    y2: 102.07,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-993",
    x1: 76.59,
    y1: 136.71,
    x2: 107.48,
    y2: 167.6,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-994",
    x1: 60.49,
    y1: 151.14,
    x2: 94.25,
    y2: 115.28,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-995",
    x1: 80.55,
    y1: 274.39,
    x2: 80.55,
    y2: 64.31,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-996",
    x1: 91.65,
    y1: 194.63,
    x2: 133.92,
    y2: 240.6,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-997",
    x1: 68.42,
    y1: 188.36,
    x2: 68.42,
    y2: 144.48,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-998",
    x1: 115.43,
    y1: 244.46,
    x2: 81.19,
    y2: 190.89,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-999",
    x1: 101.73,
    y1: -9.46,
    x2: 101.73,
    y2: 256.59,
    xlinkHref: "#linear-gradient-702"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1000",
    x1: 86.19,
    y1: 179.24,
    x2: 89.9,
    y2: 182.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1001",
    x1: 69.97,
    y1: 195.46,
    x2: 73.68,
    y2: 199.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1002",
    x1: 153.9,
    y1: 264.46,
    x2: 46.25,
    y2: 165.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1003",
    x1: 117.14,
    y1: 187.33,
    x2: 59.67,
    y2: 160.98,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1004",
    x1: 114.23,
    y1: 172.43,
    x2: 95.22,
    y2: 191.45,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1005",
    x1: 87.81,
    y1: 197.96,
    x2: 130.28,
    y2: 157.56,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1006",
    x1: 67.71,
    y1: 222.15,
    x2: 145.58,
    y2: 133.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1007",
    x1: 97.44,
    y1: 205.51,
    x2: 97.44,
    y2: 108.98,
    gradientTransform: "translate(102.99 -23.72) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1008",
    x1: 103.39,
    y1: 181.65,
    x2: 117.47,
    y2: 167.57,
    gradientTransform: "translate(102.99 -23.72) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1009",
    x1: 83.03,
    y1: 201.4,
    x2: 116.38,
    y2: 166.44,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1010",
    x1: 84.61,
    y1: 192.89,
    x2: 133.29,
    y2: 177.06,
    gradientTransform: "translate(103.66 -21.47) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1011",
    x1: 96.58,
    y1: 188.87,
    x2: 105.5,
    y2: 185.63,
    gradientTransform: "translate(103.66 -21.47) rotate(28.95)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1012",
    x1: 73.59,
    y1: 177.88,
    x2: 102.04,
    y2: 220.26,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1013",
    x1: 93.71,
    y1: 202.84,
    x2: 70.68,
    y2: 179.81,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1014",
    x1: 101.33,
    y1: 187.14,
    x2: 130.89,
    y2: 216.69,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1015",
    x1: 100.12,
    y1: 205.95,
    x2: 59.43,
    y2: 140.85,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1016",
    x1: 111.49,
    y1: 175.76,
    x2: 148.41,
    y2: 212.68,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1017",
    x1: -12.63,
    y1: 166.94,
    x2: 213.47,
    y2: 393.04,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1018",
    x1: 21.75,
    y1: 204.69,
    x2: -46.29,
    y2: 185.46,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1019",
    x1: 19.15,
    y1: 184.32,
    x2: 59.05,
    y2: 184.32,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1020",
    x1: 19.15,
    y1: 185.12,
    x2: 59.05,
    y2: 185.12,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1021",
    x1: 19.15,
    y1: 185.92,
    x2: 59.05,
    y2: 185.92,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1022",
    x1: 19.15,
    y1: 186.71,
    x2: 59.05,
    y2: 186.71,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1023",
    x1: 44.66,
    y1: 206.75,
    x2: 92.74,
    y2: 190.07,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1024",
    x1: -42.9,
    y1: 168.23,
    x2: 189.24,
    y2: 296.37,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1025",
    x1: 29.9,
    y1: 293.29,
    x2: 29.9,
    y2: 39.09,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1026",
    x1: 28.92,
    y1: 332.7,
    x2: 28.92,
    y2: 68.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1027",
    x1: 6.81,
    y1: 232.13,
    x2: 32.15,
    y2: 214.82,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1028",
    x1: 14.86,
    y1: 224.4,
    x2: 45,
    y2: 222.4,
    gradientTransform: "translate(110.81 19.11) rotate(28.95)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1029",
    x1: 22.57,
    y1: 219.99,
    x2: 20.98,
    y2: 221.58,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1030",
    x1: 10.3,
    y1: 248.6,
    x2: 10.3,
    y2: 264.26,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1031",
    x1: 21.35,
    y1: 251.9,
    x2: -9.65,
    y2: 220.9,
    gradientTransform: "translate(251.02 228.1) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1032",
    x1: 5.81,
    y1: 224.3,
    x2: 19.03,
    y2: 237.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1033",
    x1: 61.26,
    y1: 209.9,
    x2: 104.97,
    y2: 180.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1034",
    x1: 81.06,
    y1: 193.06,
    x2: 112.53,
    y2: 224.53,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1035",
    x1: 101.46,
    y1: 210.23,
    x2: 81.71,
    y2: 190.48,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1036",
    x1: 94.66,
    y1: 210.23,
    x2: 81.44,
    y2: 186.99,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1037",
    x1: 105.86,
    y1: 210.55,
    x2: 62.83,
    y2: 176.23,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1038",
    x1: 82.21,
    y1: 190.14,
    x2: 94.66,
    y2: 203.65,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1039",
    x1: 71.83,
    y1: 126.37,
    x2: 107.7,
    y2: 211.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1040",
    x1: 88.92,
    y1: 144.88,
    x2: 119.48,
    y2: 193.08,
    gradientTransform: "translate(224.57 52.67) rotate(89.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1041",
    x1: 114.15,
    y1: 250.58,
    x2: 91.77,
    y2: 207.33,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1042",
    x1: 61.94,
    y1: 152.49,
    x2: 130.84,
    y2: 174.97,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1043",
    x1: 61.87,
    y1: 130.71,
    x2: 75.7,
    y2: 148.05,
    gradientTransform: "translate(216.56 70.16) rotate(89.42)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1044",
    x1: 180.45,
    y1: 203.72,
    x2: 61.49,
    y2: 129.6,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1045",
    x1: 132.76,
    y1: 168.73,
    x2: 138.63,
    y2: 174.6,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1046",
    x1: 141.45,
    y1: 185.1,
    x2: 93.66,
    y2: 112.23,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1047",
    x1: 130.6,
    y1: 183.22,
    x2: 149.27,
    y2: 212.19,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1048",
    x1: 123.62,
    y1: 142.46,
    x2: 123.62,
    y2: 157.33,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1049",
    x1: 134.14,
    y1: 180.94,
    x2: 152.81,
    y2: 209.91,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1050",
    x1: 127.26,
    y1: 142.46,
    x2: 127.26,
    y2: 157.33,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1051",
    x1: 137.68,
    y1: 178.66,
    x2: 156.35,
    y2: 207.63,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1052",
    x1: 130.91,
    y1: 142.46,
    x2: 130.91,
    y2: 157.33,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1053",
    x1: 134.91,
    y1: 158.51,
    x2: 138.18,
    y2: 158.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1054",
    x1: 133.67,
    y1: 154.04,
    x2: 135,
    y2: 156,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-295"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1055",
    x1: 132.34,
    y1: 158.62,
    x2: 133.84,
    y2: 160.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1056",
    x1: 135.34,
    y1: 162.89,
    x2: 138.18,
    y2: 162.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1057",
    x1: 120.32,
    y1: 173.32,
    x2: 130.59,
    y2: 183.59,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1058",
    x1: 120.92,
    y1: 173.83,
    x2: 122.36,
    y2: 175.28,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1059",
    x1: 120.49,
    y1: 167.73,
    x2: 128.49,
    y2: 175.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1060",
    x1: 122.56,
    y1: 169.56,
    x2: 139.47,
    y2: 187.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1061",
    x1: 124.17,
    y1: 166.32,
    x2: 131.43,
    y2: 172.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1062",
    x1: 124.72,
    y1: 162.3,
    x2: 144.74,
    y2: 194.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1063",
    x1: 119.3,
    y1: 176.54,
    x2: 123.44,
    y2: 180.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1064",
    x1: 120.91,
    y1: 177.71,
    x2: 130,
    y2: 187.96,
    gradientTransform: "translate(221.89 -14.9) rotate(61.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1065",
    x1: 127.98,
    y1: 171.2,
    x2: 127.98,
    y2: 182.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1066",
    x1: 125.99,
    y1: 178.32,
    x2: 132.61,
    y2: 178.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1067",
    x1: 35.01,
    y1: 93.3,
    x2: 73.98,
    y2: 283.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1068",
    x1: 17.48,
    y1: 152.9,
    x2: 89.84,
    y2: 225.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1069",
    x1: 74.61,
    y1: 95.77,
    x2: 146.97,
    y2: 168.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1070",
    x1: 68.14,
    y1: 307.21,
    x2: 68.14,
    y2: 193.02,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1071",
    x1: 79.16,
    y1: 155.06,
    x2: 110.93,
    y2: 196.74,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1072",
    x1: 93.1,
    y1: 180.63,
    x2: 93.1,
    y2: 217.49,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1073",
    x1: 73.1,
    y1: 204.44,
    x2: 116.88,
    y2: 204.44,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1074",
    x1: 59.22,
    y1: 206.5,
    x2: 102.15,
    y2: 199.08,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1075",
    x1: 100.99,
    y1: 217.7,
    x2: 114.49,
    y2: 232.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1076",
    x1: 73.95,
    y1: 144.71,
    x2: 92.43,
    y2: 125.09,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1077",
    x1: 82.48,
    y1: 115.67,
    x2: 82.48,
    y2: 178.67,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1078",
    x1: 278.08,
    y1: 205.3,
    x2: 304.57,
    y2: 138.62,
    gradientTransform: "translate(-18.19 154.64) rotate(-16.4)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1079",
    x1: 314.21,
    y1: 326.56,
    x2: 344.41,
    y2: 356.77,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1080",
    x1: 305.07,
    y1: 335.7,
    x2: 335.27,
    y2: 365.9,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1081",
    x1: 303.83,
    y1: 364.31,
    x2: 303.83,
    y2: 54.18,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1082",
    x1: 255.26,
    y1: 211.19,
    x2: 344.83,
    y2: 355.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1083",
    x1: 295.72,
    y1: 364.31,
    x2: 295.72,
    y2: 54.18,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1084",
    x1: 246.57,
    y1: 216.58,
    x2: 336.14,
    y2: 361.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1085",
    x1: 298.24,
    y1: 201.78,
    x2: 298.24,
    y2: 404.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1086",
    x1: 297.23,
    y1: 262.63,
    x2: 297.23,
    y2: 211.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1087",
    x1: 291.21,
    y1: 219.51,
    x2: 291.21,
    y2: 236.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1088",
    x1: 299.96,
    y1: 222.18,
    x2: 299.96,
    y2: 249.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1089",
    x1: 297.91,
    y1: 201.83,
    x2: 297.91,
    y2: 235.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1090",
    x1: 278.69,
    y1: 234.16,
    x2: 309.27,
    y2: 209.37,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1091",
    x1: 302.97,
    y1: 216.48,
    x2: 323.69,
    y2: 208.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1092",
    x1: 298.64,
    y1: 213.06,
    x2: 298.39,
    y2: 230.26,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1093",
    x1: 298.49,
    y1: 234.41,
    x2: 301.13,
    y2: 250.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1094",
    x1: 270.86,
    y1: 290.1,
    x2: 307.28,
    y2: 198.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1095",
    x1: 546.69,
    y1: 271.61,
    x2: 546.69,
    y2: 237.34,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1096",
    x1: 548.13,
    y1: 297.04,
    x2: 525.07,
    y2: 230.2,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1097",
    x1: 539.52,
    y1: 260.5,
    x2: 539.52,
    y2: 289.96,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1098",
    x1: 388.8,
    y1: 267.51,
    x2: 388.8,
    y2: 233.24,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1099",
    x1: 390.23,
    y1: 292.94,
    x2: 367.18,
    y2: 226.1,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1100",
    x1: 381.62,
    y1: 256.4,
    x2: 381.62,
    y2: 285.86,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1101",
    x1: 287.26,
    y1: 400.53,
    x2: 287.26,
    y2: 366.26,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1102",
    x1: 288.7,
    y1: 425.96,
    x2: 265.64,
    y2: 359.13,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1103",
    x1: 280.08,
    y1: 389.42,
    x2: 280.08,
    y2: 418.88,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1104",
    x1: 249.81,
    y1: 427.02,
    x2: 249.81,
    y2: 392.75,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1105",
    x1: 251.24,
    y1: 452.45,
    x2: 228.19,
    y2: 385.61,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1106",
    x1: 242.63,
    y1: 415.91,
    x2: 242.63,
    y2: 445.37,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1107",
    x1: 103.84,
    y1: 342.47,
    x2: 103.84,
    y2: 308.2,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1108",
    x1: 105.27,
    y1: 367.9,
    x2: 82.22,
    y2: 301.06,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1109",
    x1: 96.66,
    y1: 331.36,
    x2: 96.66,
    y2: 360.82,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1110",
    x1: 637.66,
    y1: 487.26,
    x2: 637.66,
    y2: 452.99,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1111",
    x1: 639.09,
    y1: 512.69,
    x2: 616.04,
    y2: 445.86,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1112",
    x1: 630.48,
    y1: 476.16,
    x2: 630.48,
    y2: 505.62,
    xlinkHref: "#linear-gradient-86"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.69,325.7a.55.55,0,0,1-.49-.28.56.56,0,0,1,.21-.78l79-45.57a2.55,2.55,0,0,0,0-4.41L432.05,204.87a.57.57,0,0,1,.58-1L552,273.67a3.69,3.69,0,0,1,0,6.39l-79,45.57A.59.59,0,0,1,472.69,325.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M479.09,325.7a.57.57,0,0,1-.49-.28.56.56,0,0,1,.21-.78L554.53,281a4.68,4.68,0,0,0,2.38-4.09,4.73,4.73,0,0,0-2.35-4.11L435.24,203a.57.57,0,0,1,.58-1l119.32,69.73a5.88,5.88,0,0,1,0,10.17l-75.73,43.69A.59.59,0,0,1,479.09,325.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M485.5,325.7a.57.57,0,0,1-.29-1.06l73.37-42.33a6.32,6.32,0,0,0,0-10.93L438.25,201.29a.58.58,0,0,1-.21-.78.59.59,0,0,1,.79-.21l120.36,70.09a7.47,7.47,0,0,1,0,12.92l-73.36,42.32A.62.62,0,0,1,485.5,325.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M491.9,325.7a.57.57,0,0,1-.49-.28.56.56,0,0,1,.21-.78l69.82-40.28a8.7,8.7,0,0,0,0-15.05L440.7,199.88a.57.57,0,0,1-.22-.78.59.59,0,0,1,.79-.21l120.79,69.43a9.84,9.84,0,0,1,0,17l-69.82,40.28A.59.59,0,0,1,491.9,325.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M411.24,337a.57.57,0,0,1-.28-.08l-47.69-27.53a8.66,8.66,0,0,1,0-15L397,274.92,250,189.77a9.57,9.57,0,0,1,0-16.57l59.89-34.59L298.38,132a.58.58,0,0,1-.21-.79.57.57,0,0,1,.78-.2l12.37,7.14a.57.57,0,0,1,0,1l-60.75,35.08a8.43,8.43,0,0,0,0,14.59l147.88,85.64a.56.56,0,0,1,.28.5.58.58,0,0,1-.28.49l-34.6,20a7.52,7.52,0,0,0,0,13l47.69,27.53a.57.57,0,0,1,.21.78A.59.59,0,0,1,411.24,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M418.39,337a.57.57,0,0,1-.28-.08l-51.56-29.77a6.08,6.08,0,0,1,0-10.52l35-20.21a1.74,1.74,0,0,0,0-3L252.4,187a6.4,6.4,0,0,1,0-11.09L317,138.61l-15.47-8.93a.57.57,0,1,1,.57-1l16.33,9.43a.57.57,0,0,1,0,1L253,176.93a5.26,5.26,0,0,0,0,9.11l149.16,86.38a2.88,2.88,0,0,1,0,5l-35,20.21a4.93,4.93,0,0,0,0,8.54l51.55,29.77a.57.57,0,0,1,.21.78A.59.59,0,0,1,418.39,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.54,337a.57.57,0,0,1-.28-.08l-55.57-32.09a3.39,3.39,0,0,1,0-5.88l35.09-20.27a4.35,4.35,0,0,0,0-7.54L255.27,184.55a3.55,3.55,0,0,1,0-6.14l68.92-39.8-18.66-10.77a.57.57,0,0,1-.21-.78.56.56,0,0,1,.78-.21l19.52,11.27a.57.57,0,0,1,0,1L255.84,179.4a2.4,2.4,0,0,0,0,4.16l149.52,86.59a5.49,5.49,0,0,1,0,9.52l-35.1,20.27a2.25,2.25,0,0,0,0,3.9l55.57,32.09a.57.57,0,0,1,.21.78A.59.59,0,0,1,425.54,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M432.69,337a.57.57,0,0,1-.28-.08L372.6,302.39a.59.59,0,0,1-.29-.5.56.56,0,0,1,.29-.49l34.87-20.14a7.33,7.33,0,0,0,0-12.7l-149-86.31a.89.89,0,0,1,0-1.55l72.89-42.09-22.23-12.84a.56.56,0,0,1-.21-.78.57.57,0,0,1,.78-.21l22.62,13.06a.91.91,0,0,1,.44.77.89.89,0,0,1-.44.77l-72.91,42.1,148.66,86.09a8.48,8.48,0,0,1,0,14.68l-34,19.64,59,34a.57.57,0,0,1,.21.78A.59.59,0,0,1,432.69,337Zm-101-198.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M161.39,80.07c.31,1,.7,2.33,1.13,3.71,1.08,3.48,2.43,7.42,3.36,8.46,1.8,2,8.27,4.77,8.27,4.77l.65-.69a31.23,31.23,0,0,0,2.37-2.65c0-.18-5.38-3.64-6.33-4.54s-2.22-3.4-3.16-7.54a10.67,10.67,0,0,0-4.34-6.25A3.64,3.64,0,0,0,161.39,80.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M162.52,83.78c1.08,3.48,2.43,7.42,3.36,8.46,1.8,2,8.27,4.77,8.27,4.77l.65-.69-.22-.22c-.23-.21-5.39-2.36-6.92-3.86-.78-.77-1.18-5.85-1.7-9C165.56,80.84,163.45,82.78,162.52,83.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148,154.89a17.18,17.18,0,0,1,0,3.24c-.18,1.14.47,1.43,3.14,3.22s3.89,2.21,5.16,1.33-.85-2.73-1.63-3.5-2.32-2.08-2.42-3.71S148,154.89,148,154.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.24,150.25a18.13,18.13,0,0,1,0,3.24c-.19,1.13.46,1.43,3.13,3.22s3.89,2.21,5.16,1.33-.85-2.74-1.63-3.5-2.31-2.08-2.42-3.71S160.24,150.25,160.24,150.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M156.53,111s2.35,10.42,3.07,16.52.23,22.28.33,23.71c0,.42.41.77.95,1h0c1.26.51,3.41.37,4.15-.87,0,0,3-21.5,3-26.14s-1.7-22.37-1.7-22.37-7.51.48-9.4,5.25A6.82,6.82,0,0,0,156.53,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M156.52,111s2.34,10.42,3.06,16.52.23,22.28.33,23.71c0,.42.41.77,1,1-.23-7,.23-20.24-.42-25s-2.75-16.8-2.75-16.8a10.84,10.84,0,0,0-.78-2.36A6.67,6.67,0,0,0,156.52,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M146.89,118.17c.63,6.39,1.45,13.53,1.45,13.53s-1.79,9.18-.84,23.58a6.06,6.06,0,0,0,.6.33,4.17,4.17,0,0,0,4.68-.37s2.41-17.48,3.27-22.94,1.77-24.22,1.77-24.22-3.75-2.65-11.18-1.7l-1,.15S146.26,111.78,146.89,118.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146.89,118.17c.63,6.39,1.45,13.53,1.45,13.53s-1.79,9.18-.84,23.58a6.06,6.06,0,0,0,.6.33v-.17c-.48-17.11,1.39-24.27,1.39-24.27-1.33-11.3-2.78-24.6-2.78-24.6a1.46,1.46,0,0,1-.07-.19l-1,.15S146.26,111.78,146.89,118.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 155.45,
    cy: 68.55,
    rx: 6.74,
    ry: 6.35,
    transform: "translate(14.56 163.49) rotate(-57.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M145.59,107c0,.59,1.36,1.67,3.42,2.45a13.9,13.9,0,0,0,2.53.72,10.51,10.51,0,0,0,7.48-1.13c5.59-3.45,8.15-3.81,7.34-7.49a36.62,36.62,0,0,1-1-6.76c0-.15,0-.3,0-.44,0-2.64.85-3.33,1.37-4.89a8.92,8.92,0,0,0,.43-3,49.4,49.4,0,0,0-2.71-9.81c-1.22-2.7-5.11-3.25-10.56-.27-.3.16-5.42,2.79-7.2,5.46a5.06,5.06,0,0,0-.36.63,2.71,2.71,0,0,0-.23.79,12.78,12.78,0,0,0,.67,4.42c.73,2.77,1.76,6.13,1.57,9.72C148.35,97.42,145.68,105.65,145.59,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M145.59,107c0,.59,1.36,1.67,3.42,2.45a13.9,13.9,0,0,0,2.53.72,10.51,10.51,0,0,0,7.48-1.13c5.59-3.45,8.15-3.81,7.34-7.49a36.62,36.62,0,0,1-1-6.76c0-.15,0-.3,0-.44-.39,8.9-8.49,10.72-11,2.37-.31-1-2.48-11.65-2.48-11.65-1.07-.82-3,.49-5.07,2.59.73,2.77,1.76,6.13,1.57,9.72C148.35,97.42,145.68,105.65,145.59,107Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "170.15 97.24 184.25 89.24 170.03 81.17 156.05 89.24 170.15 97.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "170.15 97.24 170.15 112.54 156.05 104.54 156.05 89.25 161.29 92.22 164.51 94.05 170.15 97.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "184.25 89.24 184.25 94.09 184.25 99.69 184.25 104.54 170.15 112.54 170.15 107.69 170.15 102.09 170.15 97.24 184.25 89.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "164.51 94.05 164.51 105.91 161.29 104.03 161.29 92.22 164.51 94.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "161.29 92.22 175.18 84.09 178.22 85.82 164.51 94.05 161.29 92.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "171.64 99.71 171.64 97.72 175.69 95.35 175.69 97.24 171.64 99.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M153.21,76.77s-.91.29-1,.59,3.3,4.44,4,4.8,1.58-1.33,2.1-1.46,1.69.23,2.21,0-1.85-4.4-1.85-4.4S153.71,76.29,153.21,76.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M158.79,75.17v3.15c0,1.74-.3,2.26-1.48,2.17s-3.68-1.12-4.1-3.48l.11-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M158.79,75.17v2c-5.13.16-5.47-5.1-5.47-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M151.45,70.19c0,2.42,1.86,1.84,1.86,1.84a5.3,5.3,0,0,0,5.51,4.37c4.14,0,3.17-9.47,3.17-9.47l0-.15s0-2.49-1.28-1.92c0,0-1.26-.64-2.4,2.76-.71,2.11-3.17,2.59-4.93,2.65-.08-1.22-.48-1.57-1.34-1.53C151.42,68.76,151.45,70.19,151.45,70.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M152.26,69.15a.51.51,0,0,0-.36.34,1.51,1.51,0,0,0-.05.52,2.35,2.35,0,0,0,.16.87.87.87,0,0,0,.67.52,1.89,1.89,0,0,1-.55-1,1,1,0,0,1,.25-.79c.09-.09.26-.13.24-.27S152.39,69.13,152.26,69.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M153.36,70.27c3.28.76,5-.83,5.6-3.17s1.73-2.24,1.73-2.24-1.26-.64-2.4,2.76C157.58,69.73,155.12,70.21,153.36,70.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M159.55,106.16a11.46,11.46,0,0,0,2.43-1c.72-.38,1.24.81.15,1.22a1,1,0,0,0-.15,1.5l1.73,1a6.51,6.51,0,0,1-2.08.27,12.31,12.31,0,0,1-3-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M145.73,98.44c.78,2.49,11.66,10.33,12.4,10.32a.74.74,0,0,0,.39-.14c.74-.5,1.66-2.1,1.09-2.84s-7.94-8.56-7.94-8.56,0-5.23-.21-10-1.15-6.26-3.17-6.18a2.14,2.14,0,0,0-1.77,1.14,5.53,5.53,0,0,0-.7,1.91S145,96,145.73,98.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M145.73,98.44c.78,2.49,11.66,10.33,12.4,10.32a.74.74,0,0,0,.39-.14c-4.66-3.49-11.78-8.91-12-11-1.55-14,0-15.44,0-15.44a5.53,5.53,0,0,0-.7,1.91S145,96,145.73,98.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M150.19,63.75s-1.29,1.34-.77,2.42a.87.87,0,0,0,.65.46,6.39,6.39,0,0,1,2.2,1C154.12,68.85,150.19,63.75,150.19,63.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M153.52,68.38l.6.31h0l.57.3c1.4.76,5.26,2.46,8.44,0a2.28,2.28,0,0,0,.45-3.56,5.43,5.43,0,0,0-.79-.8h0a7.83,7.83,0,0,0-6.86-6l-.16,0c-2.39-.31-3.21,1-3.44,1.45l-.07.18h0c-1.13.91-1.68,1.77-2.31,4.11C149.52,66,152.21,67.75,153.52,68.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M159.48,66.8l-.13-.09.24,2.15s2.63,1.4,3.59-.5a6.64,6.64,0,0,0,.4-2.91,5.43,5.43,0,0,0-.79-.8h0a7.83,7.83,0,0,0-6.86-6l-.16,0c2.49.54,5.8,2.28,6.51,7.55A1.92,1.92,0,0,1,159.48,66.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M154.12,68.69l.57.3c1.4.76,5.26,2.46,8.44,0,2.65-2.05-.25-4.29-.34-4.36s1.14,2.43-1.71,3.73S154.27,68.72,154.12,68.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M159.71,68.83s0-8.49-7.38-8.77l-.07.19s6.77,0,7.22,8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M129,172.93v-5l5.25,1.48,44.46-25.65a7.17,7.17,0,0,1,7.14,0c18,10.42,18.75,8.05,34.26,17h2.54v4.83a.74.74,0,0,1,0,.21h0a1.16,1.16,0,0,1-.59.92c-19.45,11.22-44.73,25.83-51.28,29.61a4.41,4.41,0,0,1-3.17-.2c-18.91-10.86-33-19-38-22A1.19,1.19,0,0,1,129,172.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M185.84,138.76l36.21,20.91a1.18,1.18,0,0,1,0,2.06l-50.4,29.1a4.57,4.57,0,0,1-4.58,0l-37.5-21.67a1.19,1.19,0,0,1,0-2.06l49.13-28.34A7.17,7.17,0,0,1,185.84,138.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "184.62 141.84 170.52 133.84 184.74 125.77 198.72 133.84 184.62 141.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "184.62 141.84 184.62 157.13 198.72 149.14 198.72 133.84 193.48 136.81 190.26 138.64 184.62 141.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "170.52 133.84 170.52 138.69 170.52 144.28 170.52 149.13 184.62 157.13 184.62 152.28 184.62 146.69 184.62 141.84 170.52 133.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "190.26 138.64 190.26 150.51 193.48 148.63 193.48 136.81 190.26 138.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "193.48 136.81 179.59 128.69 176.55 130.42 190.26 138.64 193.48 136.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "183.13 144.31 183.13 142.32 179.08 139.94 179.08 141.84 183.13 144.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "166.09 152.18 151.99 144.18 166.21 136.11 180.19 144.18 166.09 152.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "166.09 152.18 166.09 167.48 180.19 159.48 180.19 144.18 174.95 147.16 171.73 148.99 166.09 152.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "151.99 144.18 151.99 149.03 151.99 154.63 151.99 159.48 166.09 167.47 166.09 162.62 166.09 157.03 166.09 152.18 151.99 144.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "171.73 148.99 171.73 160.85 174.95 158.97 174.95 147.16 171.73 148.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "174.95 147.16 161.06 139.03 158.02 140.76 171.73 148.99 174.95 147.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "164.6 154.65 164.6 152.66 160.55 150.28 160.55 152.18 164.6 154.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "184.62 126.78 170.52 118.78 184.74 110.71 198.72 118.78 184.62 126.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "184.62 126.78 184.62 142.07 198.72 134.07 198.72 118.78 193.48 121.75 190.26 123.58 184.62 126.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "170.52 118.78 170.52 123.63 170.52 129.22 170.52 134.07 184.62 142.07 184.62 137.22 184.62 131.63 184.62 126.78 170.52 118.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "190.26 123.58 190.26 135.44 193.48 133.57 193.48 121.75 190.26 123.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "193.48 121.75 179.59 113.63 176.55 115.35 190.26 123.58 193.48 121.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "183.13 129.25 183.13 127.26 179.08 124.88 179.08 126.78 183.13 129.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "147.56 162.52 133.46 154.52 147.68 146.46 161.66 154.52 147.56 162.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "147.56 162.52 147.56 177.82 161.66 169.82 161.66 154.53 156.42 157.5 153.2 159.33 147.56 162.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "133.46 154.52 133.46 159.38 133.46 164.97 133.46 169.82 147.56 177.82 147.56 172.97 147.56 167.37 147.56 162.52 133.46 154.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "153.2 159.33 153.2 171.19 156.42 169.31 156.42 157.5 153.2 159.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "156.42 157.5 142.53 149.38 139.49 151.1 153.2 159.33 156.42 157.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "146.07 164.99 146.07 163 142.02 160.63 142.02 162.52 146.07 164.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "204.12 152.77 190.02 144.77 204.24 136.7 218.22 144.77 204.12 152.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "204.12 152.77 204.12 168.07 218.21 160.07 218.21 144.77 212.98 147.74 209.75 149.58 204.12 152.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "190.02 144.77 190.02 149.62 190.02 155.21 190.02 160.06 204.12 168.06 204.12 163.21 204.12 157.62 204.12 152.77 190.02 144.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "209.75 149.58 209.75 161.44 212.98 159.56 212.98 147.74 209.75 149.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "212.98 147.74 199.09 139.62 196.05 141.35 209.75 149.58 212.98 147.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "202.63 155.24 202.63 153.25 198.58 150.87 198.58 152.77 202.63 155.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "185.59 163.11 171.49 155.11 185.71 147.04 199.69 155.11 185.59 163.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "185.59 163.11 185.59 178.41 199.68 170.41 199.68 155.12 194.45 158.09 191.22 159.92 185.59 163.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "171.49 155.11 171.49 159.96 171.49 165.56 171.49 170.41 185.59 178.41 185.59 173.56 185.59 167.96 185.59 163.11 171.49 155.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "191.22 159.92 191.22 171.78 194.45 169.9 194.45 158.09 191.22 159.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "194.45 158.09 180.56 149.97 177.52 151.69 191.22 159.92 194.45 158.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "184.1 165.58 184.1 163.59 180.05 161.22 180.05 163.11 184.1 165.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "167.06 173.46 152.88 165.6 167.02 157.39 181.08 165.31 167.06 173.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "167.06 173.46 167.22 188.75 181.23 180.61 181.08 165.31 175.87 168.34 172.66 170.21 167.06 173.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "152.88 165.6 152.93 170.45 152.99 176.04 153.04 180.9 167.22 188.75 167.17 183.9 167.11 178.31 167.06 173.45 152.88 165.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "172.66 170.21 172.79 182.07 175.99 180.16 175.87 168.34 172.66 170.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "175.87 168.34 161.9 160.36 158.88 162.12 172.66 170.21 175.87 168.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "165.6 175.94 165.58 173.95 161.5 171.62 161.52 173.51 165.6 175.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M623.54,415.33v-3.11l0-3.46a.36.36,0,0,0,0-.11l0-6.34a5.75,5.75,0,0,1-.09,1,6.47,6.47,0,0,1-.18.73c0,.05,0,.1,0,.16a6.52,6.52,0,0,1-.36.83s-.06.1-.08.16a7.12,7.12,0,0,1-.48.78l-.07.09a7.64,7.64,0,0,1-.64.79l-.07.07a8.38,8.38,0,0,1-.8.77l-.05.05a12.19,12.19,0,0,1-1,.76l-.08.05q-.54.38-1.14.72l-64.09,36.47c-.42.23-.84.46-1.29.66l-.08,0c-.41.19-.84.37-1.27.53l-.15.06c-.42.16-.86.3-1.3.43l-.16.06q-.68.2-1.38.36l-.11,0c-.51.11-1,.22-1.53.3h0c-.53.08-1.06.16-1.6.22h-.06c-.47.05-.94.08-1.42.11l-.93,0-.77,0h-.38l-1.28,0h-.14c-.53,0-1.05-.07-1.56-.13h-.08c-.51-.06-1-.12-1.5-.21h-.1q-.76-.14-1.5-.3l-.09,0c-.48-.11-.94-.23-1.4-.37l-.13,0c-.47-.14-.94-.3-1.39-.47h0c-.46-.17-.9-.36-1.33-.56l-.1-.05c-.44-.2-.86-.41-1.26-.64L382.16,361.59c-.4-.23-.77-.47-1.12-.71l-.1-.07c-.32-.23-.62-.46-.9-.7l-.11-.1a10.23,10.23,0,0,1-.75-.71l-.13-.14c-.21-.24-.4-.48-.58-.71l-.06-.09a7,7,0,0,1-.53-.85,1.17,1.17,0,0,0-.05-.11,7.44,7.44,0,0,1-.31-.72,2,2,0,0,1-.08-.26,4.21,4.21,0,0,1-.16-.61c0-.08,0-.17,0-.24a2.85,2.85,0,0,1,0-.29V359s0-.08,0-.12a.36.36,0,0,1,0-.11,3.39,3.39,0,0,1,0-.45l.06,14.32a6,6,0,0,0,.07.84,2.21,2.21,0,0,0,0,.25,4.57,4.57,0,0,0,.16.61c0,.08.05.17.08.26s.19.47.31.71a1.17,1.17,0,0,0,.05.11,0,0,0,0,1,0,0,7.69,7.69,0,0,0,.5.81l0,0,.06.08.37.48a2.29,2.29,0,0,1,.21.23l.13.14.11.12.46.45.18.15.11.1.17.14c.15.12.3.25.46.36l.27.19.1.07.11.09.48.3.51.31h0l147.86,84.19.48.27.53.26.24.11.11.06.19.08a5.38,5.38,0,0,0,.55.24l.57.23h0l.55.2.62.2.21.07.14,0,.28.07c.21.07.42.12.65.18l.47.11.09,0,.09,0,.65.13c.21,0,.42.09.64.12l.12,0,.1,0,.41.06c.21,0,.42.06.64.09l.44.06H539l.09,0,.65.06.71.05h.25l.57,0h1.23l.63,0c.3,0,.62,0,.93,0h.15l1.26-.11h.08c.3,0,.59-.06.89-.11l.7-.11h0l.71-.13.7-.15.11,0,.11,0,.48-.11.69-.19.21-.06.16-.05.33-.1.69-.23.28-.11.15-.05a2,2,0,0,0,.22-.09l.62-.25.43-.2.08,0,.08,0,.55-.27.54-.28.12-.08,64.09-36.46.38-.22.47-.3.29-.2.08-.05.08-.06.42-.32a4.23,4.23,0,0,0,.41-.33l.06-.05.06-.05.26-.23.38-.36.16-.18.07-.08.11-.12a4.23,4.23,0,0,0,.34-.4l.19-.26a.86.86,0,0,0,.07-.1l.06-.08q.17-.24.3-.48l.12-.22.08-.16.09-.17a5.87,5.87,0,0,0,.26-.65h0s0-.1,0-.15c.07-.23.13-.46.18-.68v-.06a5.63,5.63,0,0,0,.09-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M554.35,445.75c-6.74,3.83-17.63,3.84-24.33,0L382.17,361.59c-6.7-3.82-6.68-10,.06-13.84l64.09-36.47c6.73-3.83,17.62-3.85,24.32,0l147.85,84.19c6.7,3.81,6.68,10,0,13.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-84",
    cx: 500.36,
    cy: 374.63,
    rx: 60.21,
    ry: 34.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M575.69,334l-9.77-15.7,60.62-37.95.18-.11h0a5.51,5.51,0,0,1,2.9-.74c4.54.05,9.44,4.81,10.94,10.64,1.09,4.2.11,7.81-2.21,9.47h0a5.41,5.41,0,0,1-1.06.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-86",
    cx: 570.55,
    cy: 326.53,
    rx: 6.37,
    ry: 9.42,
    transform: "translate(-86.8 319.66) rotate(-29.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M553.59,342.85l-7.76-8.28L566,322.68h0c4.26-2.87,9.65,5.95,6.28,9.18h0a2.71,2.71,0,0,1-1,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M443.94,358.32c2.27,3.79,2.28,6.88,4.7,9,4.16,3.64,15.9,14.23,26.52,16s39.67,3.69,48.29-.08,20.8-7.85,25.37-13a56.65,56.65,0,0,0,5.37-6.64c1.79-2.58,6.38-8.13,6.38-8.13v8.17c0,18.86-27,34.16-60.21,34.16s-60.21-15.3-60.21-34.16v-9.66A17.35,17.35,0,0,1,443.94,358.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 500.36,
    cy: 353.92,
    rx: 60.21,
    ry: 34.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M553.06,353.92a17.83,17.83,0,0,1-.52,4.24,19.27,19.27,0,0,1-1.47,3.93c-6.27,12.54-26.6,21.73-50.71,21.73s-44.44-9.19-50.71-21.73a19.87,19.87,0,0,1-1.47-3.93,17.83,17.83,0,0,1-.52-4.24c0-16.51,23.6-29.9,52.7-29.9S553.06,337.41,553.06,353.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M552.54,358.16a19.27,19.27,0,0,1-1.47,3.93c-6.27,12.54-26.6,21.73-50.71,21.73s-44.44-9.19-50.71-21.73a19.87,19.87,0,0,1-1.47-3.93c3.61-14.51,25.6-25.67,52.18-25.67S548.93,343.65,552.54,358.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M520.71,357.4a2.31,2.31,0,0,1-1,1.93c-1.39,1-.3,6.58-2.62,8.91-2.64,2.66-9.38,3-9.19-1.81a12.13,12.13,0,0,1,.11-1.23v0a86.75,86.75,0,0,1,2.35-10c-.1-4.82,5-2.72,5-2.72s4.86.35,5.09,2.38A18.86,18.86,0,0,1,520.71,357.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M520.71,357.4a2.31,2.31,0,0,1-1,1.93c-1.39,1-.3,6.58-2.62,8.91-2.64,2.66-9.38,3-9.19-1.81a12.13,12.13,0,0,1,.11-1.23c0,.44-.1,3.9,3.43,4.09,3.76.21,6.55-2.09,6.77-5s.2-4.61,1.18-5.32A5.29,5.29,0,0,0,520.71,357.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M493,349.69c.06.8-4.8,2.57-5.75,2.49s-1.85-.24-4.32,2.1-6.33,2.56-8.3,2.37c-1.74-.17-4.54-1.69-3.64-3.73a2.77,2.77,0,0,1,.58-.86c2.27-2.46,10.16-7.92,11.55-9s9.06.27,9.06.27.6,4.38.77,5.93C493,349.44,493,349.6,493,349.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M493,349.69c.06.8-4.8,2.57-5.75,2.49s-1.85-.24-4.32,2.1-6.33,2.56-8.3,2.37c-1.74-.17-4.54-1.69-3.64-3.73a2.4,2.4,0,0,0,1.76,2.25,10,10,0,0,0,8.4-.68c2.25-1.48,2.68-3,5.29-3.05a11.61,11.61,0,0,0,5.74-1.78,5,5,0,0,1,.77-.41C493,349.44,493,349.6,493,349.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M499.76,250.57s-2.1,9.74-4.05,21.05c-.08.44-.15.89-.23,1.34-.75,4.44-1.46,9.08-2,13.43-.91,7.25-1.34,13.69-.66,17.08,2.67,13.41-.22,40.52-.22,40.52a15,15,0,0,1-2,1c-6.29,2.63-9.26-1.91-9.26-1.91-1.48-18.9-2.63-24.92-5.1-56.73s-1.44-35.79-1.44-35.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M493.48,286.39c.13-1.09.28-2.19.43-3.29V283c.07-.46.13-.92.2-1.39l.06-.43.21-1.39.06-.44c.06-.36.11-.72.17-1.08,0-.18.05-.37.08-.55l.21-1.31,0-.13.27-1.66h0c.1-.56.19-1.12.28-1.67h0c.08-.45.15-.9.23-1.34l-.56.37-4.54-13.27L487,250.57l-.42-1s-.15.36-.36,1c-.58,1.67-1.61,5.15-1.06,7.46,0,0,2.95,17,5.42,25.81a87.94,87.94,0,0,0-.06,14.35s.15,3.44,1.12,10.61.64,20-1.06,36.2a15,15,0,0,0,2-1s2.89-27.11.22-40.52c-.68-3.39-.25-9.83.66-17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M520.55,355.1a11,11,0,0,1-1.46,1.46c-2,1.62-5.54,3.43-8.72-1.37a215.61,215.61,0,0,0-6.87-36.48c-5.72-21-15.52-41.95-17.95-65.19-2.17-20.8,19.88-20.09,25.68-5.15a20.65,20.65,0,0,1,1.3,5.9s2.58,30.6,2.42,48.15C514.9,309.24,522.54,316,520.55,355.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M520.55,355.1a11,11,0,0,1-1.46,1.46c.15-3.42.25-10.17-.23-22.62-.81-20.77-5.38-23.06-5.7-30.3s-2.51-41.54-2.51-41.54c-11.17,3.3-16.7.64-16.7.64l17.28-14.37a20.65,20.65,0,0,1,1.3,5.9s2.58,30.6,2.42,48.15C514.9,309.24,522.54,316,520.55,355.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M464.24,236.21s1.48,3.49,3.06,3.53,2.05-2.09,2.29-2.79-.92-1.75-1.3-3-1.2-4.08-1.2-4.08-3.21,3.24-3.09,4.46S464.24,236.21,464.24,236.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M483.05,200.33a181.62,181.62,0,0,0-12.91,15.33l1,12.42a4.06,4.06,0,0,1-.53,1.19,2.73,2.73,0,0,1-.3.42,4.35,4.35,0,0,1-3,1.58c-2.14.23-3.69-.4-4.54-1.64a5.54,5.54,0,0,1-.75-2.06c-.58-2.73-2.75-10.77-2.18-13.43.5-2.39,5.36-9.54,11.46-18.63s9.92-9.78,10.16-9.82h0C486.39,186,489.54,193.64,483.05,200.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M483.05,200.33a181.62,181.62,0,0,0-12.91,15.33l1,12.42a4.06,4.06,0,0,1-.53,1.19,2.73,2.73,0,0,1-.3.42c-.19-1.59-1.35-14.39-1.35-14.39l5.83-8.69s.35-17.16,6.64-20.92h0C486.39,186,489.54,193.64,483.05,200.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M513.77,240.57c0,13.62.47,17.36.47,17.36l-.66.42a36,36,0,0,1-22.78,4.09s-4.42-.76-4.54-8.62v-.3a2.49,2.49,0,0,1,0,.26h0c-.1,1.27-.71,6.61-3.93,5.83-3.65-.87-6.91-6.2-7.7-8.92s.79-19.11.79-35.69,2.42-29.27,7.11-29.62c1.77-.13,5.54.68,9.54,1.73,2.48.66,5.06,1.41,7.3,2.09,3.68,1.12,6.45,2,6.45,2s6.73,5.23,11.57,9c1,.79,1.43,2.4,1.49,4.57C519.06,213.16,513.74,229.76,513.77,240.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M506.26,191.65l4.35,3.65a20.68,20.68,0,0,1-4.57,8.94,67.34,67.34,0,0,1-5.45,5.62h-2.87l1,1.79L488.13,221l8.6-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M499.25,189.21A59.66,59.66,0,0,0,488.13,221s-3.09-8.37-2.76-15.79h1.76l-1.69-1.52s-.47-10.16,6.61-16.55C494.5,187.78,497,188.53,499.25,189.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M501.27,202.76a88.29,88.29,0,0,0-8.61,10.75,70.78,70.78,0,0,0-4.53,7.47s-.34-2.41-.47-5.94c-.24-6.24.19-16,4.36-22.23,6.76-10.14,14.24-1.16,14.24-1.16S508,195.59,501.27,202.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M502.48,187.74s3.25,1.35,4,3.91-7.86,9.72-7.86,9.72l-2.19-4.23-2.21-1.25-3,2.81S491.39,184,502.48,187.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M513.77,240.57c0,13.62.47,17.36.47,17.36l-.66.42c-.45-4.66-.46-6.16-1.29-6.05s-12.42,2.36-17.28,2.87-6.53,1.75-7.83,0c-.25-.33-.57-.8-.92-1.35l0,0h0c-1.5-2.34-3.61-6-3.61-6l23.89-8.67s.57-11.1,1.78-21.76,4.38-12.83,4.38-12.83l6.18.37C519.06,213.16,513.74,229.76,513.77,240.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "493.13 196.9 497.06 198.37 495.3 201.16 492.95 200.33 493.13 196.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M495.3,201.15c-.78,3.9-2.12,8.1-2.64,12.36a70.78,70.78,0,0,0-4.53,7.47s-.34-2.41-.47-5.94c2.21-10.45,5.29-14.71,5.29-14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M486.26,253.63h0a.12.12,0,0,1-.11-.12l1.89-32.8a.11.11,0,0,1,.12-.11.12.12,0,0,1,.12.12l-1.89,32.8A.11.11,0,0,1,486.26,253.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M494.59,220a21.21,21.21,0,0,0,8.55,2.27v1.62s-6.24-.81-8.55-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M522.16,220.92c-1.75,15.17,1.25,27.73-8.66,30.27,0,0-20.59,3-23.86,3.92-1.53.4-2.8-1.19-3.36-3.11-.65-2.2-.39-4.83,1.43-5.43L508,239.93s-.63-41.86,10.05-38.78c0,0,3.13,2.48,4.11,9.8A40.9,40.9,0,0,1,522.16,220.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M522.16,220.92c-1.75,15.17,1.25,27.73-8.66,30.27,0,0-20.59,3-23.86,3.92-1.53.4-2.8-1.19-3.36-3.11a21.31,21.31,0,0,1,5.13,1.91s13.44-2.31,19.84-3.34,7.75-4.42,8.4-8.4,1-10.29,1.23-16.67c.27-6.22,1.27-14.16,1.32-14.55A40.9,40.9,0,0,1,522.16,220.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M473,251c0,.11,2.46,2.36,4.24,2.1a14.07,14.07,0,0,0,3.3-.94l-.11-1.88-6.72-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M482.63,251v-.69l-1.46-.3L458,236.73a.28.28,0,0,0-.13,0H448l-2.15-.49v.72h0a.27.27,0,0,0,.12.23l24.66,14a.28.28,0,0,0,.13,0l11.61.08a.25.25,0,0,0,.25-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M446,236.46l24.66,14a.28.28,0,0,0,.13,0l11.61.08a.25.25,0,0,0,.13-.46L458,236a.28.28,0,0,0-.13,0H446.11A.25.25,0,0,0,446,236.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "470.96 249.54 448.78 236.95 457.68 236.95 479.71 249.59 470.96 249.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M487,247.81a3,3,0,0,1,1.81-.84c1.3-.22,2.54.17,3.15,2.62s.18,4-.55,4.32a3.53,3.53,0,0,1-2.79,0C487.94,253.24,487,247.81,487,247.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M470.13,229.27a4,4,0,0,1-6.81.36,3.92,3.92,0,0,1,.32-1.53,3.52,3.52,0,0,1,4.19-2,3.24,3.24,0,0,1,2.26,2.44A2.75,2.75,0,0,1,470.13,229.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M469.59,228.66a10.27,10.27,0,0,0-.66,3.12c.15.85.6,2.25,0,2.75s-.89,2.81-.77,3.71-1.28,1.34-1.67-.16-.65-3.81-.68-3.93a7.48,7.48,0,0,0-1,2.57c-.18,1.09,1.58,4.16,1.81,5.15s-.53,1.67-1.16.67a45.63,45.63,0,0,1-2.94-6.33c-.33-1.18.77-5.84,1.16-7S467.68,225.12,469.59,228.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M510.16,175.07a28.93,28.93,0,0,1-7.68,12.67l-.91.85c-.53-.52-1.06-1-1.6-1.52-1.32-1.19-2.71-2.31-4.14-3.38-3.32-2.51-6.84-4.8-10.1-7.37-1.56-1.23-1.62-1.79-1.74-3.75s1.27-2.63,2.83-3.79c.88-.66.43-3.63,1.53-3.58a8.53,8.53,0,0,0,5.12-1.54,10.56,10.56,0,0,1,9.91-1.2,8.25,8.25,0,0,1,4.7,4.86,4.1,4.1,0,0,1,2.36,2.53,3.46,3.46,0,0,1,.21.78A9.9,9.9,0,0,1,510.16,175.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M507.8,180.91a4.53,4.53,0,0,1-1.41,3.4,5.51,5.51,0,0,1-2,.84l-.43.11a1.5,1.5,0,0,1-.35.09s-.28,0-.29.05a6.24,6.24,0,0,0-.4.92,5.88,5.88,0,0,0-.27,2,5.4,5.4,0,0,0,.31,1.58c.22.66.47,1.3.75,1.94a8.83,8.83,0,0,1-6.7,4.3,4.71,4.71,0,0,1-1.61-.63,4.33,4.33,0,0,1-1.33-1.3l-.21-.34s0,0,0,0a3.09,3.09,0,0,1-.62.15l-.15,0c-2.52.48-4.22-1-5.34-3.15-.06-.13-.13-.26-.19-.41-1.78-3.55-1.44-13.34-1.32-15.89v0a5,5,0,0,1,0-.58.93.93,0,0,1,0-.24s.28,1.93,4,1.75,7.54-1.7,7.65,1.23,2.43,2.71,2.43,2.71,1.8.3,1.8,4.44l1.1-.65a5.5,5.5,0,0,1-.33-2.36c.13-2.19,1.33-4,2.67-4S507.94,178.72,507.8,180.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M503.73,191.88a8.83,8.83,0,0,1-6.7,4.3,4.71,4.71,0,0,1-1.61-.63,4.33,4.33,0,0,1-1.33-1.3c5.69-2.7,8-6.26,8.85-7.93a5.88,5.88,0,0,0-.27,2,5.4,5.4,0,0,0,.31,1.58C503.2,190.6,503.45,191.24,503.73,191.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M493.88,193.9a4.34,4.34,0,0,0,.62.88c7-2.9,7.66-6.86,8.46-8.5a9.07,9.07,0,0,0,.38-.89h0a23,23,0,0,1-4.23,5.26,37,37,0,0,1-5.22,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M502.19,183.92c0-2-.71-3.49-2.12-3.78s-2.83-.87-2.87-2.94-2.55-1.34-7.2-.9c-3,.28-3.65-.84-3.75-1.67v0a2.17,2.17,0,0,1,.07-.82s.28,1.93,4,1.75,7.54-1.7,7.65,1.23,2.43,2.71,2.43,2.71S502.19,179.78,502.19,183.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M504.39,179.14a1.16,1.16,0,0,1,.9-.75,1.14,1.14,0,0,1,.94.42,2.28,2.28,0,0,1,.45.94,3.53,3.53,0,0,1,0,2.18,2,2,0,0,1-1.65,1.34,3,3,0,0,0,1.05-2.78,1.62,1.62,0,0,0-.3-.76.84.84,0,0,0-1.37,0,1.34,1.34,0,0,0-.22.36C504.29,179.74,504.27,179.43,504.39,179.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M493.88,193.9a4.34,4.34,0,0,0,.62.88,4.23,4.23,0,0,0,.92.77,4.92,4.92,0,0,0,1.61.63,8.83,8.83,0,0,0,6.7-4.3c-.28-.64-.52-1.29-.75-1.94a5.4,5.4,0,0,1-.31-1.58,5.81,5.81,0,0,1,.67-3h0a21.47,21.47,0,0,1-4,4.69c-2.14,1.68-5.46,3.81-5.46,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M504,178.15a.24.24,0,0,0-.32-.11l-8.51,3.9c-.38-1.21-1.16-2-2.07-2s-1.69.81-2.08,2l-2-.91c-.23-1.74-1.15-3-2.3-3-1.31,0-2.34,1.67-2.34,3.81s1,3.82,2.34,3.82S489,184,489,181.83c0-.09,0-.17,0-.26l1.83.83a6.39,6.39,0,0,0-.15,1.34c0,2.14,1,3.81,2.35,3.81s2.34-1.67,2.34-3.81a6.4,6.4,0,0,0-.14-1.34l8.59-3.93A.24.24,0,0,0,504,178.15Zm-17.27,7c-1,0-1.86-1.53-1.86-3.35s.85-3.34,1.86-3.34,1.87,1.53,1.87,3.34S487.7,185.18,486.69,185.18Zm6.37,1.9c-1,0-1.86-1.53-1.86-3.34s.85-3.35,1.86-3.35,1.86,1.53,1.86,3.35S494.07,187.08,493.06,187.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M510,167.61s2.63,2.71,1.58,4.91a1.79,1.79,0,0,1-1.32.93,13.26,13.26,0,0,0-4.48,2.09C502,178,510,167.61,510,167.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M503.25,177l-1.22.62h0l-1.16.62c-2.83,1.54-10.67,5-17.13,0-3.47-2.67-2.27-5.5-.92-7.22a10.05,10.05,0,0,1,1.6-1.62h0a15.9,15.9,0,0,1,13.93-12.23l.34-.05c4.84-.63,6.52,2,7,3a2.54,2.54,0,0,1,.14.37h0c2.3,1.84,3.41,3.6,4.7,8.35C511.37,172.08,505.91,175.72,503.25,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M491.13,173.79l.26-.17-.47,4.36s-5.35,2.84-7.3-1a13.67,13.67,0,0,1-.81-5.91,10.05,10.05,0,0,1,1.6-1.62h0a15.9,15.9,0,0,1,13.93-12.23l.34-.05c-5.06,1.11-11.78,4.63-13.23,15.34A3.89,3.89,0,0,0,491.13,173.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M502,177.63l-1.16.62c-2.83,1.54-10.67,5-17.13,0-5.39-4.15.5-8.71.68-8.84-.06.14-2.32,4.93,3.47,7.57S501.72,177.71,502,177.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M490.67,177.92s-.1-17.25,15-17.81l.14.38s-13.74.07-14.66,17.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M487.52,247.74s-3.51.5-4.89,0-2.55-1.4-3.47-1.11-3.53,1.73-4.34,1.87-.48,1.11,1,1.09,2.75-.34,3.88-.39-1,2.05-1.75,2.62-2,.72-4-.62h-2.41a15,15,0,0,0,4.79,2.83,26.92,26.92,0,0,0,7.05.87c1.48-.15,5.08-1.09,6.34-1.16S491.45,246.58,487.52,247.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "592.64 382.52 620.18 366.89 592.64 351.27 565.1 366.89 592.64 382.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "592.64 370.01 610.78 359.72 592.64 349.43 574.51 359.72 592.64 370.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "592.64 370.01 592.64 376.25 592.64 383.45 592.64 389.69 574.51 379.4 574.51 373.16 574.51 365.96 574.51 359.72 592.64 370.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "610.78 359.72 610.78 365.96 610.78 373.16 610.78 379.4 592.64 389.69 592.64 383.45 592.64 376.25 592.64 370.01 610.78 359.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "592.64 382.52 592.64 392 592.64 402.92 592.64 412.4 565.1 396.77 565.1 387.3 565.1 376.37 565.1 366.89 592.64 382.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "620.18 366.89 620.18 376.37 620.18 387.3 620.18 396.77 592.64 412.4 592.64 402.92 592.64 392 592.64 382.52 620.18 366.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "627.29 376.97 620.18 366.89 592.64 382.52 599.75 392.6 627.29 376.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "558 376.97 565.1 366.89 592.64 382.52 585.54 392.6 558 376.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M584.57,436.25a2.53,2.53,0,0,1,2-2,1.06,1.06,0,0,1,.57.16h0l.52.3.13.63a2.65,2.65,0,0,1,0,.8,4.85,4.85,0,0,1-.55,1.16l-.48.28a2,2,0,0,1-1,.58l-.33.2-.49-.29h0A1.58,1.58,0,0,1,584.57,436.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-136",
    cx: 586.67,
    cy: 436.57,
    rx: 2.11,
    ry: 1.43,
    transform: "translate(-79.33 738.59) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M588.94,433.74a2.53,2.53,0,0,1,2-2,1.06,1.06,0,0,1,.57.16h0l.52.3.13.63a2.65,2.65,0,0,1,0,.8,4.85,4.85,0,0,1-.55,1.16l-.48.28a2,2,0,0,1-1,.58l-.33.2-.49-.29h0A1.58,1.58,0,0,1,588.94,433.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-138",
    cx: 591.04,
    cy: 434.06,
    rx: 2.11,
    ry: 1.43,
    transform: "translate(-74.88 741.12) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M593.61,431.42a2.53,2.53,0,0,1,2-2,1,1,0,0,1,.57.15h0l.52.3.12.63a2.5,2.5,0,0,1,.06.8,4.85,4.85,0,0,1-.55,1.16l-.48.29a2.11,2.11,0,0,1-.95.57l-.33.2-.49-.29h0A1.57,1.57,0,0,1,593.61,431.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-140",
    cx: 595.71,
    cy: 431.73,
    rx: 2.11,
    ry: 1.43,
    transform: "translate(-70.43 744) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M598,428.89a2.52,2.52,0,0,1,2-2,1,1,0,0,1,.56.15h0l.52.31.13.62a2.73,2.73,0,0,1,0,.81,4.38,4.38,0,0,1-.55,1.15l-.47.29a2.07,2.07,0,0,1-1,.57l-.33.2-.5-.28h0A1.57,1.57,0,0,1,598,428.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-142",
    cx: 600.07,
    cy: 429.2,
    rx: 2.11,
    ry: 1.43,
    transform: "translate(-65.98 746.51) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M472.86,421.17a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.63a2.87,2.87,0,0,0-.06.8,4.78,4.78,0,0,0,.56,1.16l.47.28a2.1,2.1,0,0,0,.95.58l.33.2.5-.29h0A1.57,1.57,0,0,0,472.86,421.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-144",
    cx: 470.76,
    cy: 421.49,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-145.2 280.56) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M468.49,418.66a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.63a2.87,2.87,0,0,0-.06.8,4.78,4.78,0,0,0,.56,1.16l.47.28a2.1,2.1,0,0,0,1,.58l.33.2.5-.29h0A1.57,1.57,0,0,0,468.49,418.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-146",
    cx: 466.39,
    cy: 418.98,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-144.53 278.13) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M463.82,416.34a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.15h0l-.52.3-.13.63a2.92,2.92,0,0,0-.06.8,4.78,4.78,0,0,0,.56,1.16l.47.29a2.16,2.16,0,0,0,.95.57l.33.2.5-.29h0A1.56,1.56,0,0,0,463.82,416.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-148",
    cx: 461.72,
    cy: 416.65,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-143.99 275.58) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M459.47,413.81a2.54,2.54,0,0,0-2-2,1.05,1.05,0,0,0-.57.15h0l-.52.31-.13.62a2.73,2.73,0,0,0,0,.81,4.73,4.73,0,0,0,.55,1.15l.48.29a2,2,0,0,0,.95.57l.33.2.49-.28h0A1.58,1.58,0,0,0,459.47,413.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-150",
    cx: 457.36,
    cy: 414.12,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-143.31 273.16) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M447.28,406.2a2.53,2.53,0,0,0-2-2,1.06,1.06,0,0,0-.57.16h0l-.52.3-.13.63a2.65,2.65,0,0,0,0,.8,4.85,4.85,0,0,0,.55,1.16l.48.28a2,2,0,0,0,.95.58l.33.2.49-.29h0A1.58,1.58,0,0,0,447.28,406.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-152",
    cx: 445.18,
    cy: 406.52,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-141.15 266.31) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M442.91,403.69a2.53,2.53,0,0,0-2-2,1.06,1.06,0,0,0-.57.16h0l-.52.3-.13.63a2.65,2.65,0,0,0,0,.8,4.85,4.85,0,0,0,.55,1.16l.48.28a2,2,0,0,0,.95.58l.33.2.49-.29h0A1.58,1.58,0,0,0,442.91,403.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-154",
    cx: 440.81,
    cy: 404.01,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-140.48 263.88) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M438.24,401.37a2.53,2.53,0,0,0-2-2,1,1,0,0,0-.57.15h0l-.52.3-.13.63a2.65,2.65,0,0,0-.05.8,4.85,4.85,0,0,0,.55,1.16l.48.29a2.06,2.06,0,0,0,1,.57l.33.2.49-.29h0A1.57,1.57,0,0,0,438.24,401.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-156",
    cx: 436.14,
    cy: 401.68,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-139.94 261.33) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M433.88,398.84a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.15h0l-.52.31-.13.62a2.73,2.73,0,0,0-.05.81,4.38,4.38,0,0,0,.55,1.15l.47.29a2.07,2.07,0,0,0,.95.57l.33.2.5-.28h0A1.56,1.56,0,0,0,433.88,398.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-158",
    cx: 431.78,
    cy: 399.15,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-139.26 258.9) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M419.52,390a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.62a2.73,2.73,0,0,0,0,.81,4.49,4.49,0,0,0,.55,1.16l.47.28a2.19,2.19,0,0,0,.95.58l.33.19.5-.28h0A1.56,1.56,0,0,0,419.52,390Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-160",
    cx: 417.42,
    cy: 390.31,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-136.77 250.84) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M415.15,387.48a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.62a2.73,2.73,0,0,0,0,.81,4.38,4.38,0,0,0,.55,1.15l.47.29a2.19,2.19,0,0,0,.95.58l.33.19.5-.28h0A1.56,1.56,0,0,0,415.15,387.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-162",
    cx: 413.05,
    cy: 387.8,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-136.1 248.42) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M410.48,385.15a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.63a2.65,2.65,0,0,0-.05.8,4.49,4.49,0,0,0,.55,1.16l.47.28a2.1,2.1,0,0,0,.95.58l.33.2.5-.29h0A1.56,1.56,0,0,0,410.48,385.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-164",
    cx: 408.38,
    cy: 385.47,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-135.56 245.86) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M406.13,382.63a2.53,2.53,0,0,0-2-2,1,1,0,0,0-.57.15h0l-.52.3-.13.63a2.69,2.69,0,0,0-.05.8,4.85,4.85,0,0,0,.55,1.16l.48.29a2.06,2.06,0,0,0,.95.57l.33.2.49-.29h0A1.57,1.57,0,0,0,406.13,382.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-166",
    cx: 404.03,
    cy: 382.94,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-134.88 243.44) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M532.93,147.28a17.52,17.52,0,0,1,0,3.44c-.21,1.21.52,1.52,3.55,3.42s4.39,2.35,5.83,1.42-1-2.91-1.84-3.72-2.62-2.21-2.74-3.94S532.93,147.28,532.93,147.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M528,63.75a21.24,21.24,0,0,1,3.15,2.61c1.67,1.67,4.15-2.21,5.32-2.28s1.07,2.55,1.07,2.55L535.17,70l-3.62,1.19-3.29-.92L527,66.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M503.89,142a3.6,3.6,0,0,0,.24,2.08c.47,1.39,1.69,4.41,1.82,5.16s-1.07.79-2.8.24c-1.33-.43-3.41-3-4.51-6.22-.28-.84,2.06-1.4,2.87-2.82s.09-.14.09-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M537.69,147.25s-.5,1.8-3.93,1.1a7.08,7.08,0,0,1-1-.29s-3.51-19.39-1.72-26.72c0,0-9.37-12.45-11.26-25l10.7-4.1s7.6,25.16,8,28.21S537.69,147.25,537.69,147.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M533.76,148.35a7.08,7.08,0,0,1-1-.29s-3.51-19.39-1.72-26.72c0,0-9.37-12.45-11.26-25h.69c.48,1.26.81,2.33.94,2.76a74.84,74.84,0,0,0,10.85,22S530.16,130.53,533.76,148.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M525.67,97.8v0c0,.15-.08.63-.16,1.34v0c-.6,5-2.11,22-3.73,25.91-1.32,3.22-17.88,17.61-17.88,17.61-.21-.1-.41-.21-.59-.31-3.29-1.78-2-3-2-3,8.23-14.2,13.28-17.09,13.28-17.09a87.84,87.84,0,0,1-2-26.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M531,92.25a3.14,3.14,0,0,1-1.41,2.2c-.26.19-.56.38-.91.63a25.79,25.79,0,0,0-3.55,3c-3.14,3.06-7.59,2.34-10.51,1-1.77-.79-3-1.78-3-2.29,0-1.32,0-7-.36-12.19q-.06-.89-.18-1.74l-.06-.45c-.57-3.68-1.73-7-1.17-9.43a4.38,4.38,0,0,1,.42-1.11c.91-1.66,3.83-3.48,6.17-4.74l1.12-.59c1.19-.6,2-1,2-1s1.43-.53,3.14-1l.59-.17a15.37,15.37,0,0,1,4.17-.76c2.19.14,3.42,6.16,3.48,10.78,0,2.64.24,7.24.29,11.19v.51A33.91,33.91,0,0,1,531,92.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M525.85,97.31l0,0,.34-.3.07-.06.27-.23.06-.06.3-.25,0,0,.25-.21.07-.05.51-.4.08-.06.16-.12.08-.06.18-.13.32-.22h0c.35-.25.65-.44.91-.63l-.86-.18a21.74,21.74,0,0,0,.07-3.83c-.26-.19-6.84-2.19-7.57-3S515.49,73,515.49,73l-1.84,8.16.08,2.37A104,104,0,0,1,509.82,73c-.56,2.44.6,5.75,1.17,9.43l.06.45q.12.85.18,1.74c.34,5.17.34,10.87.36,12.19,0,.87,3.58,3.2,7.45,3.39h0a7.23,7.23,0,0,0,1,0h0l.32,0h0l.33,0h0l.68-.13h0l.29-.07.06,0,.29-.08,0,0c.21-.07.43-.15.64-.24l.06,0,.26-.12.07,0,.25-.14.06,0a4.67,4.67,0,0,0,.6-.38l.08,0,.21-.17.09-.07.21-.17.08-.07.27-.25.38-.36.09-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "537.54 82.21 553.88 72.94 537.4 63.59 521.21 72.94 537.54 82.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "537.54 82.21 537.54 99.94 521.21 90.67 521.21 72.94 527.27 76.39 531.01 78.51 537.54 82.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "553.88 72.94 553.88 78.56 553.88 85.04 553.88 90.67 537.54 99.93 537.54 94.31 537.54 87.83 537.54 82.21 553.88 72.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "531.01 78.51 531.01 92.26 527.27 90.08 527.27 76.39 531.01 78.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "527.27 76.39 543.37 66.97 546.89 68.97 531.01 78.51 527.27 76.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "539.27 85.07 539.27 82.77 543.96 80.01 543.96 82.21 539.27 85.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M522.7,70.76c-2.29.49-5.22-2.34-6.29-3.62l1.12-.59c1.19-.6,2-1,2-1s1.43-.53,3.14-1l.59-.17C524.64,69.25,525.58,70.15,522.7,70.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M526.13,56.51c.53-1.24,1-2.65.5-3.88a3.21,3.21,0,0,0-1.83-1.58,8,8,0,0,0-2.43-.43,10.6,10.6,0,0,0-4.19,1c-1.15.51-2.27,1.23-2.19,2.48a3.25,3.25,0,0,0-1.62,3c0,1.28,1.33,2.35,2,3.41a16.69,16.69,0,0,0,2.12,3c2.1-2.22,4.33-4.2,6.43-6.42A1.58,1.58,0,0,1,526.13,56.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M522.58,70c-2.14,0-4.64-2.57-4.64-4s0-4.31,0-4.36,4.91-.51,4.91,3a10.4,10.4,0,0,0,.16,1.86C523.42,68.87,524.3,70,522.58,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M523,66.54a5.39,5.39,0,0,1-5.07-4.9s4.91-.51,4.91,3A10.4,10.4,0,0,0,523,66.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M526.37,59.65a11,11,0,0,1-.35,3.24,2.31,2.31,0,0,1-.1.28c-.84,2-4.3,5.26-8-1.53,0,0-2,.34-2-2.34,0-.62.18-1.57,1-1.6a1.68,1.68,0,0,1,1.42,1.09,1.6,1.6,0,0,1,.17.46c0,.2,0,.46.21.58s.39-.11.45-.36a2.38,2.38,0,0,1,.39-1c.38-.49,1.09-.71,1.56-1.12a11.66,11.66,0,0,0,1.22-1.49,2.78,2.78,0,0,1,1.2-.82c.29.13.63.23.7.28a1.16,1.16,0,0,1,.53,1.22,1.38,1.38,0,0,0-.06-1.62h0a1.62,1.62,0,0,1,1.35,1,3.59,3.59,0,0,1,.23,1.08c0,.28,0,.57,0,.85C526.36,58.46,526.37,59.05,526.37,59.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M516.71,60a2,2,0,0,1-.12-1,.73.73,0,0,1,.56-.65.66.66,0,0,1,.59.46,1.87,1.87,0,0,1,.1.85.84.84,0,0,0-.26-.5.39.39,0,0,0-.49-.05.73.73,0,0,0-.2.65,4.77,4.77,0,0,0,.29.95C516.93,60.68,516.79,60.27,516.71,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M525.67,97.85c0,.15-.08.63-.16,1.34v0c-.6,5-2.11,22-3.73,25.91-1.32,3.22-17.88,17.61-17.88,17.61-.21-.1-.41-.21-.59-.31,4.86-4.88,17.13-15.37,18-18.4S525.48,99.07,525.67,97.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M533.56,65.53l-1.07.48s-.64-.38.34-1,1.64-1,1.64-1,2.92-1.68,3.61-1a18.77,18.77,0,0,1,2.51,3.25c.26.63-.26.59-.57.46s0,.62-.66.38-.93.72-1.28.1a20.32,20.32,0,0,0-2.52-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M514.6,53s-1.29,1.34-.77,2.41a.86.86,0,0,0,.65.47,6.37,6.37,0,0,1,2.2,1C518.53,58,514.6,53,514.6,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M517.92,57.58l.61.3h0l.57.31c1.4.76,5.25,2.45,8.43,0a2.26,2.26,0,0,0,.46-3.55,4.9,4.9,0,0,0-.79-.8h0a7.82,7.82,0,0,0-6.86-6l-.16,0c-2.39-.31-3.21,1-3.44,1.46,0,.09-.06.16-.07.18h0c-1.13.91-1.68,1.78-2.31,4.12C513.93,55.15,516.62,56.94,517.92,57.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M523.89,56l-.13-.08.23,2.14s2.64,1.4,3.6-.49a6.66,6.66,0,0,0,.4-2.91,4.9,4.9,0,0,0-.79-.8h0a7.82,7.82,0,0,0-6.86-6l-.16,0c2.49.55,5.8,2.28,6.51,7.56A1.91,1.91,0,0,1,523.89,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M518.53,57.88l.57.31c1.4.76,5.25,2.45,8.43,0,2.66-2-.24-4.28-.33-4.35s1.14,2.43-1.71,3.73S518.68,57.92,518.53,57.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M524.12,58s0-8.5-7.38-8.77l-.07.18s6.77,0,7.22,8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M536.11,95.85c-.21.19,1.15,2.1,2.31,2.86s1.12.63.69,1.14,0,.59-.61.81c-.17.06-.23.16-.24.25-.06.27.22.56-.37.26a8.68,8.68,0,0,1-3.63-2.93l-1.78-1.11-14.29-3.66a4,4,0,0,1-2.59-2.12l-3.16-6.57,6-2.37,0,.09,1.79,5.1a1.5,1.5,0,0,0,.82.8l12.4,5.08a4.94,4.94,0,0,0,3.89.58c1.84-.71,2.58.39,1.92.78S536.33,95.65,536.11,95.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M537.89,101.17a8.68,8.68,0,0,1-3.63-2.93l-1.78-1.11-14.29-3.66a4,4,0,0,1-2.59-2.12l-3.16-6.57,6-2.37,0,.09a.08.08,0,0,1,0,0l-4.93,2.53s2.85,6.31,3.86,7.19,15.22,4.3,16,4.63,2.6,3.13,4.85,4C538.2,101.18,538.48,101.47,537.89,101.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M518.43,82.41l-6,2.37-.68.27-.05,0c-1.22-4.8-2-10-2-10a3.51,3.51,0,0,1,0-1c.22-2.8,3.25-5.49,5.19-2.38,1.2,1.94,2.58,6.73,3.58,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M512.44,84.78l-.68.27-.05,0c-1.22-4.8-2-10-2-10a3.51,3.51,0,0,1,0-1c.15.62,1.42,5.93,2.79,10.61A.36.36,0,0,0,512.44,84.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M455.59,62.38v-5l-5.25,1.47L405.88,33.17a7.17,7.17,0,0,0-7.14,0c-18.05,10.42-18.74,8-34.26,17h-2.54v5h0a1.19,1.19,0,0,0,.59.92C382,67.36,407.26,82,413.81,85.75a4.41,4.41,0,0,0,3.17-.2c18.91-10.86,33-19,38-22A1.19,1.19,0,0,0,455.59,62.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M398.74,28.21,362.53,49.12a1.19,1.19,0,0,0,0,2.06l50.4,29.1a4.57,4.57,0,0,0,4.58,0L455,58.62a1.2,1.2,0,0,0,0-2.07L405.88,28.21A7.17,7.17,0,0,0,398.74,28.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "399.96 31.29 414.06 23.29 399.84 15.22 385.86 23.29 399.96 31.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "399.96 31.29 399.96 46.59 385.87 38.59 385.87 23.29 391.1 26.26 394.32 28.09 399.96 31.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "414.06 23.29 414.06 28.14 414.06 33.73 414.06 38.58 399.96 46.58 399.96 41.73 399.96 36.14 399.96 31.29 414.06 23.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "394.32 28.09 394.32 39.96 391.1 38.08 391.1 26.26 394.32 28.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "391.1 26.26 404.99 18.14 408.03 19.87 394.32 28.09 391.1 26.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "401.45 33.76 401.45 31.77 405.5 29.39 405.5 31.29 401.45 33.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "418.49 41.63 432.59 33.63 418.37 25.56 404.39 33.63 418.49 41.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "418.49 41.63 418.49 56.93 404.39 48.93 404.39 33.63 409.63 36.6 412.86 38.44 418.49 41.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "432.59 33.63 432.59 38.48 432.59 44.08 432.59 48.93 418.49 56.93 418.49 52.07 418.49 46.48 418.49 41.63 432.59 33.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "412.86 38.44 412.86 50.3 409.63 48.42 409.63 36.6 412.86 38.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "409.63 36.6 423.52 28.48 426.56 30.21 412.86 38.44 409.63 36.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "419.98 44.1 419.98 42.11 424.03 39.74 424.03 41.63 419.98 44.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "399.96 16.23 414.06 8.23 399.84 0.16 385.86 8.23 399.96 16.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "399.96 16.23 399.96 31.52 385.87 23.52 385.87 8.23 391.1 11.2 394.32 13.03 399.96 16.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "414.06 8.23 414.06 13.08 414.06 18.67 414.06 23.52 399.96 31.52 399.96 26.67 399.96 21.08 399.96 16.23 414.06 8.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "394.32 13.03 394.32 24.89 391.1 23.02 391.1 11.2 394.32 13.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "391.1 11.2 404.99 3.08 408.03 4.8 394.32 13.03 391.1 11.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "401.45 18.7 401.45 16.71 405.5 14.33 405.5 16.23 401.45 18.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "380.46 42.22 394.56 34.22 380.34 26.15 366.37 34.22 380.46 42.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "380.46 42.22 380.46 57.52 366.37 49.52 366.37 34.22 371.6 37.19 374.83 39.03 380.46 42.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "394.56 34.22 394.56 39.07 394.56 44.66 394.56 49.52 380.46 57.52 380.46 52.66 380.46 47.07 380.46 42.22 394.56 34.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "374.83 39.03 374.83 50.89 371.6 49.01 371.6 37.19 374.83 39.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "371.6 37.19 385.49 29.07 388.53 30.8 374.83 39.03 371.6 37.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "381.95 44.69 381.95 42.7 386 40.33 386 42.22 381.95 44.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "398.99 52.56 413.09 44.56 398.87 36.49 384.9 44.56 398.99 52.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "398.99 52.56 398.99 67.86 384.9 59.86 384.9 44.57 390.13 47.54 393.36 49.37 398.99 52.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "413.09 44.56 413.09 49.41 413.09 55.01 413.09 59.86 398.99 67.86 398.99 63.01 398.99 57.41 398.99 52.56 413.09 44.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "393.36 49.37 393.36 61.23 390.13 59.35 390.13 47.54 393.36 49.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "390.13 47.54 404.02 39.41 407.06 41.14 393.36 49.37 390.13 47.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "400.48 55.03 400.48 53.04 404.54 50.67 404.54 52.56 400.48 55.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "417.52 62.91 431.62 54.91 417.4 46.84 403.43 54.91 417.52 62.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "417.52 62.91 417.52 78.2 403.43 70.2 403.43 54.91 408.66 57.88 411.89 59.71 417.52 62.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "431.62 54.91 431.62 59.76 431.62 65.35 431.62 70.2 417.52 78.2 417.52 73.35 417.52 67.76 417.52 62.91 431.62 54.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "411.89 59.71 411.89 71.58 408.66 69.7 408.66 57.88 411.89 59.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "408.66 57.88 422.55 49.76 425.59 51.48 411.89 59.71 408.66 57.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "419.01 65.38 419.01 63.39 423.06 61.01 423.06 62.91 419.01 65.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M361.34,59.61a2.37,2.37,0,0,1-1,1.09,2.48,2.48,0,0,1-1.46.31.33.33,0,0,0-.09.44.35.35,0,0,0,.45.13,1.63,1.63,0,0,0,1.09-.07,2.47,2.47,0,0,1-1.7.73.33.33,0,0,0,.37.39.37.37,0,0,0,.5.28,1.2,1.2,0,0,0,.76.27.71.71,0,0,0,.65.11,2.28,2.28,0,0,0,.6-.31.83.83,0,0,0,.7-.06,2.09,2.09,0,0,0,.56-.43,7.53,7.53,0,0,0,1.08-1.44,2.64,2.64,0,0,0,.37-.94,1.25,1.25,0,0,0-.22-1,1.33,1.33,0,0,0-1.39-.33A1.89,1.89,0,0,0,361.34,59.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M377.17,105.91c1.47-.11,5.43.74,7.74.07,0,0,.15,3.94.19,4.91a1.83,1.83,0,0,1-2.66,1.6,49.52,49.52,0,0,1-7.45-4.56S373.94,106.15,377.17,105.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M363.44,110.55c1.47-.11,5.44.74,7.74.07,0,0,.19,3.94.24,4.91a1.8,1.8,0,0,1-2.63,1.6,50.22,50.22,0,0,1-7.5-4.56S360.21,110.79,363.44,110.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M377,69.6c3.17,17.34,2.19,36,2.19,36a2.45,2.45,0,0,0,.9,1.49c1.65,1.21,4.68-.62,4.68-.62s1.35-10.44,1.93-16.52-1.6-10.94.7-23.2-.21-17.38-.21-17.38l-7.85,3.76-3.24,1.55S373.85,52.25,377,69.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M377,69.6c3.17,17.34,2.19,36,2.19,36a2.45,2.45,0,0,0,.9,1.49c.53-12.39-.54-28.15-1-33.83a9.23,9.23,0,0,1,.63-4.07,58.28,58.28,0,0,0,2.69-9.7c.24-2.65-1.25-4.77-3.09-6.36l-3.24,1.55S373.85,52.25,377,69.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M388.83,25.49c.17-.36,2.35,9.5,1.05,13.39-1.12,3.33-9.66.51-9.66.51l1.46-16.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M371.42,13a2.87,2.87,0,0,1,.71,2.13c.07,1.15.12,2.3,1.17,2.8h0a3.3,3.3,0,0,0,1.47.25c2.49,0,.43,4.92.43,4.92a2.66,2.66,0,0,0,3,.77c1.87-.74,3.53-1.64,3.26-3.19s-.92-3.62-.68-4.89a2.73,2.73,0,0,1,.61-1.05c.94-1.19,2.59-2.89,2.14-5.9-.61-4-6.24-7.9-10.8-2.11a7,7,0,0,0-.76,3.48C372.07,12.39,371,12.35,371.42,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M366.67,71c.84,12.84,1.66,19.19.76,26.94s-1,12.9-1,12.9a3.88,3.88,0,0,0,4.76.74,5.53,5.53,0,0,0,1-.74s3.31-12.23,3.07-21,0-15.23,4-22.79a38.63,38.63,0,0,0,3-6.81,12.17,12.17,0,0,0,0-8.09c-1.28-3.67-14-4.32-16,1.86C366.18,54.12,365.84,58.17,366.67,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M372,24.92a28,28,0,0,0,5.59-3.59s7.4-4.19,9.45-1.36c1.49,2.05.28,7.47-1.15,15.26s3.26,12.4,1.81,14S374.44,59,370.12,57.62s-4-4.61-4-4.61c1.14-6.08.67-7.69.09-13.53a16.85,16.85,0,0,1-.09-1.73S365.22,27.83,372,24.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M375.21,23.14a2.66,2.66,0,0,0,3,.77c1.87-.74,3.53-1.64,3.26-3.19s-.92-3.62-.68-4.89a2.73,2.73,0,0,1,.61-1.05c-1.08-.49-2.71.74-4.34,1.8A7.3,7.3,0,0,1,373.31,18a3.3,3.3,0,0,0,1.47.25C377.27,18.19,375.21,23.14,375.21,23.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M372.64,7.13c-.05,1.93.65,1.89,3.6,4.27,2.22,1.81.71,2,1.76,5.16a5.46,5.46,0,0,0,2.28,2.63,3.08,3.08,0,0,0,.58.28h0l-.18.17h0c-1,1-5.69,5.9-4.69,10.91.57,2.87,3.79,5,7.08,5.16A6.77,6.77,0,0,0,390.23,31a9.35,9.35,0,0,0,.48-2.26c.48-6.26-6.48-9.88-6.48-9.88a6.15,6.15,0,0,0,.62-.63,4.94,4.94,0,0,0,.5-.7c4.33-7.31,0-12.77-4.13-13.6C376.28,2.93,372.69,5.2,372.64,7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M380.28,19.19a3.08,3.08,0,0,0,.58.28,3.45,3.45,0,0,1,3.37-.62,6.15,6.15,0,0,0,.62-.63A3.35,3.35,0,0,0,380.28,19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M376,30.57c.57,2.87,3.79,5,7.08,5.16-11.62-3.78-3.64-14.5-2.39-16.07C379.71,20.63,375,25.56,376,30.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M371.23,111.59a5.53,5.53,0,0,0,1-.74s3.31-12.23,3.07-21,0-15.23,4-22.79a38.63,38.63,0,0,0,3-6.81v-.06s-4.52,8.15-6.38,12.3-1.74,8-1.6,14.49S374,99.55,371.23,111.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M372.7,8.19a12.83,12.83,0,0,1-3.09-1.92c-1-1,1.08-4.29,5.14-3.28S372.7,8.19,372.7,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M387.19,10.68s1.39,2.24-1.49,3.36c-3.07,1.19-8.6-3.17-8.6-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M372.7,8.19a35,35,0,0,0,4.39,2.68h0c2.28,1.16,5,2.19,7.2,1.84a3,3,0,0,0,.67-.16,3.39,3.39,0,0,0,1.25-.68,3.86,3.86,0,0,0,1-1.19s1.74-7.45-4.08-10A8.36,8.36,0,0,0,379.73,0h0a6.79,6.79,0,0,0-3.31.85,5.13,5.13,0,0,0-.79.52A8.26,8.26,0,0,0,372.7,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M375.62,1.37c3.63-.09,5.5.16,7.26,2.86s.9,8.24.9,8.24l.53.24a3,3,0,0,0,.67-.16c.16-.68.35-1.57.56-2.72a8.79,8.79,0,0,0-3.84-8.47c-1.2-.72-3.62-.7-5.29-.51A5.13,5.13,0,0,0,375.62,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M375.62,1.37c2.81-.69,10-1.28,8.69,11.34a3.8,3.8,0,0,0,1.92-.84S388.52,1.12,379.73,0h0A6.74,6.74,0,0,0,375.62,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M377.11,10.87c2.28,1.16,5,2.19,7.2,1.84l-.53-.24A16.66,16.66,0,0,1,377.11,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M368.19,28.17s-2.25,1.81-2.07,7a92.19,92.19,0,0,1-.79,12.38l-4.19,11.13a3.18,3.18,0,0,0,3.52,2s5.56-8.22,6.67-12.5,1.22-13.1.88-16.79S368.19,28.17,368.19,28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M500.19,436.6a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.62a2.73,2.73,0,0,0-.05.81,4.49,4.49,0,0,0,.55,1.16l.47.28a2.19,2.19,0,0,0,.95.58l.33.2.5-.29h0A1.56,1.56,0,0,0,500.19,436.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-248",
    cx: 498.09,
    cy: 436.92,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-149.25 295.72) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M495.82,434.09a2.52,2.52,0,0,0-2-2,1,1,0,0,0-.56.16h0l-.52.3-.13.62a2.73,2.73,0,0,0-.05.81,4.49,4.49,0,0,0,.55,1.16l.47.28a2.19,2.19,0,0,0,.95.58l.33.2.5-.29h0A1.56,1.56,0,0,0,495.82,434.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-250",
    cx: 493.72,
    cy: 434.41,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-148.58 293.29) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M491.15,431.76a2.5,2.5,0,0,0-2-2,1,1,0,0,0-.56.15h0l-.52.3-.13.63a2.65,2.65,0,0,0,0,.8,4.49,4.49,0,0,0,.55,1.16l.47.29a2.16,2.16,0,0,0,.95.57l.33.2.5-.29h0A1.56,1.56,0,0,0,491.15,431.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-252",
    cx: 489.05,
    cy: 432.08,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-148.04 290.74) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M486.8,429.24a2.53,2.53,0,0,0-2-2,1.05,1.05,0,0,0-.57.15h0l-.52.31-.12.62a2.58,2.58,0,0,0-.06.81,4.73,4.73,0,0,0,.55,1.15l.48.29a2.11,2.11,0,0,0,1,.57l.33.2.49-.29h0A1.57,1.57,0,0,0,486.8,429.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-254",
    cx: 484.7,
    cy: 429.55,
    rx: 1.43,
    ry: 2.11,
    transform: "translate(-147.36 288.32) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M339.66,636.48a.55.55,0,0,1-.49-.28.57.57,0,0,1,.21-.79l64-36.95a5.27,5.27,0,0,0,0-9.15l-72.72-41.54a2.65,2.65,0,0,1-1.36-2.33,2.68,2.68,0,0,1,1.35-2.35l57.59-33.33L481.38,456a1.57,1.57,0,0,0,.78-1.35V443.43a1.53,1.53,0,0,0-.43-1.07l-2.17-2.29a2.67,2.67,0,0,1-.74-1.86v-4.3a2.71,2.71,0,0,1,1.34-2.33l4.07-2.37a.57.57,0,1,1,.58,1l-4.07,2.37a1.55,1.55,0,0,0-.78,1.34v4.3a1.58,1.58,0,0,0,.43,1.07l2.17,2.3a2.66,2.66,0,0,1,.74,1.85v11.19A2.7,2.7,0,0,1,482,457l-93.16,53.79L331.2,544.08a1.56,1.56,0,0,0,0,2.7l72.72,41.54a6.42,6.42,0,0,1,0,11.13l-64,37A.59.59,0,0,1,339.66,636.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M344.12,638.94a.54.54,0,0,1-.49-.29.57.57,0,0,1,.2-.78l65.44-38.21a6.87,6.87,0,0,0-.06-11.9l-70.34-40.18a2.7,2.7,0,0,1,0-4.69l53.8-30.68,93.16-53.79a1.57,1.57,0,0,0,.78-1.35V445.88a1.58,1.58,0,0,0-.43-1.07L484,442.52a2.67,2.67,0,0,1-.74-1.86v-4.3a2.69,2.69,0,0,1,1.34-2.33l4.07-2.36a.57.57,0,0,1,.58,1L485.2,435a1.56,1.56,0,0,0-.78,1.34v4.3a1.53,1.53,0,0,0,.43,1.07L487,444a2.66,2.66,0,0,1,.74,1.85v11.19a2.72,2.72,0,0,1-1.35,2.34L393.25,513.2l-53.81,30.69a1.56,1.56,0,0,0,0,2.7l70.34,40.18a8,8,0,0,1,.07,13.88l-65.44,38.21A.6.6,0,0,1,344.12,638.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M348.58,641.39a.58.58,0,0,1-.5-.28.57.57,0,0,1,.21-.79l66.35-39.09a9,9,0,0,0-.1-15.6l-67.15-38.36a2.7,2.7,0,0,1,0-4.7l49.73-27.91,93.16-53.79a1.55,1.55,0,0,0,.77-1.35V448.34a1.57,1.57,0,0,0-.42-1.07l-2.17-2.3a2.66,2.66,0,0,1-.74-1.85v-4.3a2.71,2.71,0,0,1,1.34-2.34l4.07-2.36a.57.57,0,0,1,.78.2.58.58,0,0,1-.21.79l-4.07,2.36a1.57,1.57,0,0,0-.77,1.35v4.3a1.53,1.53,0,0,0,.43,1.07l2.17,2.29a2.67,2.67,0,0,1,.74,1.86v11.18a2.72,2.72,0,0,1-1.35,2.34L397.7,515.65,348,543.57a1.56,1.56,0,0,0,0,2.71l67.15,38.35a10.17,10.17,0,0,1,.11,17.59l-66.35,39.09A.6.6,0,0,1,348.58,641.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M353,643.84a.58.58,0,0,1-.49-.28.57.57,0,0,1,.2-.78l69.12-41a9.81,9.81,0,0,0-.14-17l-68.41-39.08a.57.57,0,0,1,0-1l48.28-27.63,93.94-54.24v-12.7l-3.18-3.36a.59.59,0,0,1-.16-.39V440a.56.56,0,0,1,.29-.49l5.12-3a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.78l-4.84,2.81v5.82l3.18,3.36a.55.55,0,0,1,.16.39V463.2a.57.57,0,0,1-.29.5l-94.23,54.41-47.41,27.13,67.54,38.58a11,11,0,0,1,.16,18.94l-69.13,41A.51.51,0,0,1,353,643.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M116.62,531.35a.57.57,0,0,1-.29-1.07l83.86-48.42a19.55,19.55,0,0,1,19.66.09l79.62,47a1.6,1.6,0,0,0,1.65,0l59.67-34.54,93.13-53.77a1.64,1.64,0,0,0,.81-1.42V428.08a1.6,1.6,0,0,0-.44-1.12l-2.13-2.25a2.76,2.76,0,0,1-.76-1.91v-4.22a2.8,2.8,0,0,1,1.38-2.41l4-2.34a.57.57,0,0,1,.78.21.56.56,0,0,1-.21.78l-4,2.34a1.65,1.65,0,0,0-.81,1.42v4.22a1.65,1.65,0,0,0,.45,1.13l2.13,2.24a2.78,2.78,0,0,1,.76,1.91v11.11a2.78,2.78,0,0,1-1.39,2.41l-93.12,53.77-59.68,34.54a2.78,2.78,0,0,1-2.8,0l-79.62-47a18.4,18.4,0,0,0-18.51-.09L116.9,531.27A.6.6,0,0,1,116.62,531.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M300.84,535a2.79,2.79,0,0,1-1.42-.39L219,487.23a18.39,18.39,0,0,0-18.56-.06l-79.26,46.1a.58.58,0,0,1-.78-.21.56.56,0,0,1,.21-.78l79.26-46.1a19.52,19.52,0,0,1,19.71.06L300,533.66a1.62,1.62,0,0,0,1.65,0l63.6-36.83,93.13-53.77a1.63,1.63,0,0,0,.81-1.41V430.54a1.65,1.65,0,0,0-.45-1.13l-2.13-2.25a2.74,2.74,0,0,1-.76-1.91V421a2.76,2.76,0,0,1,1.39-2.4l4-2.34a.57.57,0,1,1,.57,1l-4,2.35A1.63,1.63,0,0,0,457,421v4.22a1.65,1.65,0,0,0,.45,1.13l2.13,2.24a2.78,2.78,0,0,1,.76,1.92v11.11a2.8,2.8,0,0,1-1.39,2.4l-93.13,53.77-63.59,36.83A2.77,2.77,0,0,1,300.84,535Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M301.53,539.64a2.81,2.81,0,0,1-1.41-.38l-80.94-47.41a18.39,18.39,0,0,0-18.52,0L124.87,536a.57.57,0,1,1-.57-1l75.78-44.15a19.56,19.56,0,0,1,19.68,0l80.94,47.41a1.63,1.63,0,0,0,1.64,0l67.37-39,93.12-53.77a1.62,1.62,0,0,0,.82-1.41V433a1.65,1.65,0,0,0-.45-1.13l-2.13-2.24a2.78,2.78,0,0,1-.76-1.91v-4.23a2.78,2.78,0,0,1,1.38-2.4l4-2.34a.57.57,0,0,1,.78.2.58.58,0,0,1-.2.79l-4,2.34a1.63,1.63,0,0,0-.81,1.41v4.23a1.6,1.6,0,0,0,.44,1.12l2.13,2.25a2.76,2.76,0,0,1,.76,1.91V444.1a2.76,2.76,0,0,1-1.39,2.4l-93.12,53.77-67.36,39A2.77,2.77,0,0,1,301.53,539.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M301.51,544.68a2.88,2.88,0,0,1-1.42-.38L219,496.42a18.33,18.33,0,0,0-18.64,0L128,538.94a.56.56,0,0,1-.78-.2.57.57,0,0,1,.2-.78l72.36-42.55a19.54,19.54,0,0,1,19.81,0l81.07,47.88a1.65,1.65,0,0,0,1.65,0l71.84-41.58L467.29,448a1.67,1.67,0,0,0,.82-1.42V435.44a1.61,1.61,0,0,0-.45-1.12l-2.13-2.25a2.78,2.78,0,0,1-.76-1.91v-4.23a2.8,2.8,0,0,1,1.38-2.4l4-2.34a.57.57,0,0,1,.78.21.56.56,0,0,1-.21.78l-4,2.34a1.62,1.62,0,0,0-.82,1.41v4.23a1.61,1.61,0,0,0,.45,1.12l2.13,2.25a2.78,2.78,0,0,1,.76,1.91v11.11a2.79,2.79,0,0,1-1.39,2.41l-93.12,53.77L302.9,544.31A2.76,2.76,0,0,1,301.51,544.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M364.13,430.71a7.77,7.77,0,0,1-3.88-1l-119.2-68.44a2.71,2.71,0,0,1-1.38-2.35,2.74,2.74,0,0,1,1.35-2.38L255.4,348a13.9,13.9,0,0,0,0-23.92l-13.89-8.18a.58.58,0,0,1,.59-1L256,323.08a15,15,0,0,1,0,25.9L241.6,357.5a1.59,1.59,0,0,0,0,2.75l119.2,68.44a6.68,6.68,0,0,0,6.63,0l33.23-19.19a1.59,1.59,0,0,0,.8-1.37V397a1.59,1.59,0,0,0-.44-1.09l-2.15-2.27a2.7,2.7,0,0,1-.75-1.88v-4.27a2.75,2.75,0,0,1,1.36-2.37l4.05-2.35a.57.57,0,0,1,.58,1l-4.06,2.35a1.62,1.62,0,0,0-.79,1.38v4.27a1.59,1.59,0,0,0,.44,1.09l2.15,2.27a2.7,2.7,0,0,1,.75,1.88v11.16a2.71,2.71,0,0,1-1.37,2.36L368,429.67A7.83,7.83,0,0,1,364.13,430.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M363.2,435.8a12.21,12.21,0,0,1-6.14-1.64L237.13,364.85a6.45,6.45,0,0,1,0-11.15l16.07-9.43a9.06,9.06,0,0,0,0-15.65l-16.82-9.72a.57.57,0,1,1,.57-1l16.82,9.72a10.2,10.2,0,0,1,.06,17.63l-16.07,9.43a5.31,5.31,0,0,0,0,9.17l119.93,69.31a11.19,11.19,0,0,0,11.18,0L405.15,412a1.6,1.6,0,0,0,.78-1.37V399.41a1.6,1.6,0,0,0-.43-1.09l-2.15-2.27a2.7,2.7,0,0,1-.75-1.88V389.9a2.73,2.73,0,0,1,1.36-2.36l4.05-2.36a.57.57,0,0,1,.78.21.56.56,0,0,1-.21.78l-4.05,2.36a1.58,1.58,0,0,0-.79,1.37v4.27a1.57,1.57,0,0,0,.44,1.09l2.15,2.27a2.74,2.74,0,0,1,.75,1.88v11.17a2.75,2.75,0,0,1-1.36,2.36l-36.34,21.19A12.16,12.16,0,0,1,363.2,435.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M362.25,440.8a15,15,0,0,1-7.53-2L233.41,368.71a10.34,10.34,0,0,1,0-17.91l14.6-8.42a6.24,6.24,0,0,0,.1-10.75l-16.62-10a.58.58,0,0,1-.2-.79.57.57,0,0,1,.79-.19l16.62,10a7.38,7.38,0,0,1-.12,12.72L234,351.79a9.19,9.19,0,0,0,0,15.93l121.31,70.07a14,14,0,0,0,13.93,0L409.6,414.4a1.59,1.59,0,0,0,.79-1.38V401.87a1.6,1.6,0,0,0-.43-1.1l-2.16-2.27a2.74,2.74,0,0,1-.75-1.88v-4.27a2.74,2.74,0,0,1,1.36-2.36l4-2.36a.59.59,0,0,1,.79.21.57.57,0,0,1-.21.78L409,391a1.58,1.58,0,0,0-.79,1.37v4.27a1.56,1.56,0,0,0,.43,1.09l2.16,2.28a2.72,2.72,0,0,1,.75,1.88V413a2.76,2.76,0,0,1-1.37,2.37l-40.38,23.39A15.09,15.09,0,0,1,362.25,440.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M361.67,445.89a16.35,16.35,0,0,1-8.15-2.18L229.26,372a13.57,13.57,0,0,1,0-23.51L244,340a3.55,3.55,0,0,0,0-6.14l-16.76-9.68a.57.57,0,0,1,.58-1l16.75,9.68a4.68,4.68,0,0,1,0,8.12l-14.72,8.5a12.44,12.44,0,0,0,0,21.53L354.1,442.72a15.18,15.18,0,0,0,15.15,0l44.8-25.87a1.6,1.6,0,0,0,.8-1.38V404.32a1.57,1.57,0,0,0-.44-1.09L412.26,401a2.72,2.72,0,0,1-.75-1.88v-4.26a2.74,2.74,0,0,1,1.36-2.37l4.05-2.35a.57.57,0,0,1,.78.2.58.58,0,0,1-.2.79l-4.05,2.35a1.6,1.6,0,0,0-.8,1.38v4.26a1.61,1.61,0,0,0,.44,1.1l2.15,2.27a2.7,2.7,0,0,1,.75,1.88v11.15a2.74,2.74,0,0,1-1.36,2.37l-44.81,25.87A16.3,16.3,0,0,1,361.67,445.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M349.89,471.49a3.48,3.48,0,0,1-1.72-.45L55.33,303.93a3.46,3.46,0,0,1,0-6l64.57-37.47a7.67,7.67,0,0,0-.06-13.3L106,239.32a.57.57,0,0,1-.21-.78.57.57,0,0,1,.78-.22l13.79,7.85a8.82,8.82,0,0,1,.06,15.29L55.89,298.93a2.29,2.29,0,0,0-1.16,2,2.32,2.32,0,0,0,1.17,2L348.74,470.05a2.33,2.33,0,0,0,2.3,0L428,425.64a2.32,2.32,0,0,0,1.15-2V413.19a2.28,2.28,0,0,0-.63-1.59l-1.76-1.86a3.43,3.43,0,0,1-.94-2.38V403.8a3.47,3.47,0,0,1,1.72-3l3.69-2.14a.57.57,0,0,1,.78.2.56.56,0,0,1-.21.78l-3.69,2.15a2.32,2.32,0,0,0-1.15,2v3.56a2.33,2.33,0,0,0,.63,1.59l1.76,1.86a3.44,3.44,0,0,1,.95,2.38v10.44a3.48,3.48,0,0,1-1.73,3L351.62,471A3.45,3.45,0,0,1,349.89,471.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M349.35,476.62A4.85,4.85,0,0,1,347,476L52.69,307.09a7.09,7.09,0,0,1,0-12.3L114.4,259.2a5.67,5.67,0,0,0,0-9.85L101.7,242.2a.56.56,0,0,1-.22-.78.58.58,0,0,1,.78-.22l12.66,7.16a6.81,6.81,0,0,1,0,11.83L53.25,295.78a6,6,0,0,0,0,10.32L347.53,475a3.66,3.66,0,0,0,3.65,0l81.23-46.9a2.32,2.32,0,0,0,1.15-2V415.64a2.28,2.28,0,0,0-.63-1.59l-1.76-1.86a3.44,3.44,0,0,1-.95-2.37v-3.57a3.47,3.47,0,0,1,1.72-3l3.7-2.14a.57.57,0,0,1,.78.2.58.58,0,0,1-.21.79l-3.69,2.14a2.32,2.32,0,0,0-1.15,2v3.57a2.32,2.32,0,0,0,.63,1.59l1.76,1.85a3.46,3.46,0,0,1,.95,2.38v10.45a3.48,3.48,0,0,1-1.73,3L351.75,476A4.77,4.77,0,0,1,349.35,476.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M348.61,481.74a6.9,6.9,0,0,1-3.46-.92l-297.37-172a8.57,8.57,0,0,1,0-14.84l61.43-35.5a4.15,4.15,0,0,0,0-7.19l-11.68-6.71a.58.58,0,0,1-.21-.78.57.57,0,0,1,.78-.21l11.68,6.7a5.3,5.3,0,0,1,0,9.18L48.36,295a7.42,7.42,0,0,0,0,12.85l297.38,172a5.77,5.77,0,0,0,5.77,0l85.36-49.29a2.31,2.31,0,0,0,1.16-2V418.09a2.34,2.34,0,0,0-.63-1.59l-1.76-1.86a3.42,3.42,0,0,1-.95-2.37V408.7a3.46,3.46,0,0,1,1.72-3l3.69-2.15a.56.56,0,0,1,.78.21.57.57,0,0,1-.2.78L437,406.7a2.33,2.33,0,0,0-1.15,2v3.57a2.3,2.3,0,0,0,.63,1.59l1.76,1.85a3.45,3.45,0,0,1,.94,2.38v10.45a3.46,3.46,0,0,1-1.72,3l-85.37,49.29A6.87,6.87,0,0,1,348.61,481.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M348.82,486.55a7.57,7.57,0,0,1-3.77-1L45.13,312.3a12,12,0,0,1,0-20.81l59.31-34.25a2.3,2.3,0,0,0,0-4l-11-6.34a.57.57,0,1,1,.57-1l11,6.34a3.45,3.45,0,0,1,0,6L45.7,292.48a10.88,10.88,0,0,0,0,18.83L345.63,484.56a6.4,6.4,0,0,0,6.39,0L441.32,433a2.33,2.33,0,0,0,1.16-2V420.54a2.31,2.31,0,0,0-.64-1.59l-1.76-1.85a3.45,3.45,0,0,1-.94-2.38v-3.56a3.46,3.46,0,0,1,1.72-3l3.69-2.15a.57.57,0,0,1,.78.21.56.56,0,0,1-.21.78l-3.69,2.15a2.31,2.31,0,0,0-1.15,2v3.56a2.31,2.31,0,0,0,.64,1.59l1.75,1.86a3.42,3.42,0,0,1,.95,2.37V431a3.45,3.45,0,0,1-1.73,3l-89.3,51.57A7.55,7.55,0,0,1,348.82,486.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M111.78,518.6,41.37,488.76v23.65h0a2,2,0,0,0,1,1.69L174.64,590.5a5.13,5.13,0,0,0,5.14,0l15.67-9.12a1.25,1.25,0,0,0,.56-.71l.06,0V556.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M42.35,487.07l15.14-8.76a4.13,4.13,0,0,1,4.11,0L195.45,555.6a1.23,1.23,0,0,1,0,2.13l-15.67,9.12a5.11,5.11,0,0,1-5.14,0L42.36,490.48A2,2,0,0,1,42.35,487.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "77.16 493.45 59.54 483.28 58.23 484.04 50.05 479.98 50.05 488.77 177.2 562.19 186.67 556.68 186.67 547.88 77.16 493.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "50.05 479.98 59.54 474.48 186.67 547.88 177.2 553.39 50.05 479.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M60.24,509.83c-.71-2.78-3.05-5.06-5.21-5.09a2.64,2.64,0,0,0-1.44.4h0l-1.33.77-.33,1.6a7,7,0,0,0-.14,2.06,12.28,12.28,0,0,0,1.41,2.95l1.22.74a5.36,5.36,0,0,0,2.43,1.46l.84.51L59,514.5h0C60.23,513.78,60.79,512,60.24,509.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-276",
    cx: 54.87,
    cy: 510.63,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-240.33 90.38) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M56.1,512.51a1.22,1.22,0,0,1-.19.12,1.18,1.18,0,0,1-.5.1,2.66,2.66,0,0,1-2.17-2.11,1.65,1.65,0,0,1,.6-2,1.1,1.1,0,0,1,.49-.11,2.68,2.68,0,0,1,2.17,2.13A1.73,1.73,0,0,1,56.1,512.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M41,536.61c2.78.75,5.91-.16,7-2a2.52,2.52,0,0,0,.37-1.45h0v-1.54l-1.23-1.07a7.09,7.09,0,0,0-1.73-1.14,12.31,12.31,0,0,0-3.26-.23l-1.24.7a5.34,5.34,0,0,0-2.47,1.39l-.86.48v1.47h0C37.57,534.65,38.87,536,41,536.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-279",
    cx: 42.95,
    cy: 531.54,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-489 569.07) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M45.19,531.55v0a1,1,0,0,1-.12.46l0,.07a2.7,2.7,0,0,1-2.91.85,2,2,0,0,1-1.3-.93.92.92,0,0,1-.11-.58s0,0,0-.05a1,1,0,0,1,.14-.41,2.68,2.68,0,0,1,2.91-.85C44.65,530.37,45.19,531,45.19,531.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M56.1,512.51l-.1.07-.09,0-7.71,4.45a6,6,0,0,0-3,5.19v9a2.64,2.64,0,0,1,0,.28v0a1.73,1.73,0,0,1-.12.46l0,.07a2.7,2.7,0,0,1-2.91.85,2,2,0,0,1-1.3-.93,1.92,1.92,0,0,1-.11-.58s0,0,0-.05a.45.45,0,0,1,0-.12v-9A10.56,10.56,0,0,1,46,513.18l7.8-4.5.09,0a1.1,1.1,0,0,1,.49-.11,2.68,2.68,0,0,1,2.17,2.13A1.73,1.73,0,0,1,56.1,512.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M160.33,567.27c-.72-2.78-3.05-5.06-5.21-5.08a2.58,2.58,0,0,0-1.45.39h0l-1.33.78L152,565a6.64,6.64,0,0,0-.14,2.06,12,12,0,0,0,1.41,3l1.21.73a5.44,5.44,0,0,0,2.43,1.47l.85.51,1.27-.74h0C160.32,571.23,160.88,569.41,160.33,567.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-283",
    cx: 154.96,
    cy: 568.08,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-255.63 146.01) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M156.19,570a.82.82,0,0,1-.2.12,1.1,1.1,0,0,1-.49.11,2.67,2.67,0,0,1-2.17-2.12,1.64,1.64,0,0,1,.59-2,1.18,1.18,0,0,1,.5-.11,2.7,2.7,0,0,1,2.17,2.13A1.77,1.77,0,0,1,156.19,570Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M141.09,594.05c2.77.75,5.9-.16,7-2a2.58,2.58,0,0,0,.37-1.45h0l0-1.54L147.2,588a6.73,6.73,0,0,0-1.72-1.13,12,12,0,0,0-3.27-.23l-1.23.69a5.46,5.46,0,0,0-2.48,1.39l-.86.49v1.46h0C137.65,592.09,139,593.48,141.09,594.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-286",
    cx: 143.03,
    cy: 588.98,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-447.38 726.01) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M145.27,589h0a1,1,0,0,1-.11.46l0,.08a2.7,2.7,0,0,1-2.91.84,2,2,0,0,1-1.29-.93.91.91,0,0,1-.12-.58s0,0,0,0a1.18,1.18,0,0,1,.14-.41,2.7,2.7,0,0,1,2.91-.85C144.73,587.82,145.27,588.39,145.27,589Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M156.19,570a.34.34,0,0,1-.11.07l-.09.05-7.7,4.45a6,6,0,0,0-3,5.2v9a2.64,2.64,0,0,1,0,.28h0a2.07,2.07,0,0,1-.11.46l0,.08a2.7,2.7,0,0,1-2.91.84,2,2,0,0,1-1.29-.93,1.81,1.81,0,0,1-.12-.58s0,0,0,0a.41.41,0,0,1,0-.11v-9a10.54,10.54,0,0,1,5.25-9.09l7.79-4.5.09,0a1.18,1.18,0,0,1,.5-.11,2.7,2.7,0,0,1,2.17,2.13A1.77,1.77,0,0,1,156.19,570Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M200.14,421V559.4a2.29,2.29,0,0,1-.69,1.87h0l-3.82,2.19-8.18-8.18L43.54,472.13a5.78,5.78,0,0,1-2.38-4.61V337.91L39.78,334l-1.66-4.66,3.71-2.13h0a1.43,1.43,0,0,1,1.7,0l154.23,89.13A5.75,5.75,0,0,1,200.14,421Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M200.14,421v3.56l-3.87,2.34L39.78,334l-1.66-4.66,3.71-2.13h0a1.43,1.43,0,0,1,1.7,0l154.23,89.13A5.75,5.75,0,0,1,200.14,421Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M196.27,423.21V561.64c0,1.78-1.07,2.61-2.37,1.85L39.67,474.37a5.77,5.77,0,0,1-2.38-4.6V331.34c0-1.78,1.07-2.61,2.38-1.85L193.9,418.61A5.79,5.79,0,0,1,196.27,423.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M98.1,395.18,71.77,380a1.44,1.44,0,0,1-.59-1.16V367.17c0-.45.26-.66.59-.47L98.1,381.91a1.45,1.45,0,0,1,.6,1.16v11.65C98.7,395.17,98.43,395.38,98.1,395.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M161.73,432l-26.32-15.22a1.43,1.43,0,0,1-.6-1.15V403.94c0-.45.27-.66.6-.47l26.32,15.22a1.45,1.45,0,0,1,.6,1.15v11.65C162.33,431.94,162.06,432.15,161.73,432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M98.1,411.09,71.77,395.88a1.46,1.46,0,0,1-.59-1.16V383.07c0-.45.26-.66.59-.47L98.1,397.82a1.45,1.45,0,0,1,.6,1.16v11.64C98.7,411.07,98.43,411.28,98.1,411.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M98.1,427,71.77,411.78a1.44,1.44,0,0,1-.59-1.16V399c0-.45.26-.66.59-.47L98.1,413.72a1.45,1.45,0,0,1,.6,1.16v11.65C98.7,427,98.43,427.19,98.1,427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M69.19,353.43v138L39.67,474.37a5.77,5.77,0,0,1-2.38-4.6V335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M66.17,391.44l-25.95-15a1.89,1.89,0,0,1-.79-1.52V363.78c0-.59.35-.86.79-.61l26,15a1.9,1.9,0,0,1,.78,1.51v11.15C67,391.41,66.6,391.69,66.17,391.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M66.17,407.26l-25.95-15a1.89,1.89,0,0,1-.79-1.52V379.6c0-.59.35-.86.79-.61l26,15a1.91,1.91,0,0,1,.78,1.52v11.14C67,407.24,66.6,407.51,66.17,407.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M196.27,423.21v3.66L37.29,335v-3.66c0-1.78,1.07-2.61,2.38-1.85L193.9,418.61A5.79,5.79,0,0,1,196.27,423.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 41.61,
    cy: 334.05,
    rx: 0.92,
    ry: 1.64,
    transform: "translate(-123.14 40.49) rotate(-22.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 46.71,
    cy: 337,
    rx: 0.92,
    ry: 1.64,
    transform: "translate(-123.88 42.63) rotate(-22.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 51.81,
    cy: 339.94,
    rx: 0.92,
    ry: 1.64,
    transform: "translate(-124.61 44.78) rotate(-22.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M60.65,355.17l-14.78-8.54A2,2,0,0,1,45,345h0c0-.63.38-.93.85-.66l14.78,8.54a2,2,0,0,1,.84,1.64h0C61.49,355.15,61.12,355.44,60.65,355.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M92.33,373.48l-14.78-8.54a2,2,0,0,1-.85-1.64h0c0-.63.38-.92.85-.65l14.78,8.54a2.06,2.06,0,0,1,.84,1.63h0C93.17,373.46,92.79,373.75,92.33,373.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M124,391.79l-14.79-8.54a2.08,2.08,0,0,1-.84-1.64h0c0-.63.38-.93.84-.66L124,389.5a2,2,0,0,1,.84,1.63h0C124.85,391.76,124.47,392.06,124,391.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M155.69,410.09l-14.79-8.54a2.06,2.06,0,0,1-.84-1.63h0c0-.63.38-.93.84-.66l14.79,8.54a2.06,2.06,0,0,1,.84,1.64h0C156.53,410.07,156.15,410.36,155.69,410.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M187.36,428.4l-14.78-8.54a2.06,2.06,0,0,1-.84-1.63h0c0-.64.38-.93.84-.66l14.78,8.54a2,2,0,0,1,.85,1.63h0C188.21,428.38,187.83,428.67,187.36,428.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M47.42,370.18l-6.78-3.91a.94.94,0,0,1-.38-.75h0c0-.29.17-.42.38-.3l6.78,3.91a1,1,0,0,1,.38.75h0C47.8,370.17,47.63,370.31,47.42,370.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M47.42,372.43l-6.78-3.91a.94.94,0,0,1-.38-.75h0c0-.29.17-.42.38-.3l6.78,3.91a1,1,0,0,1,.38.75h0C47.8,372.42,47.63,372.56,47.42,372.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M55.92,377.35l-6.78-3.92a.94.94,0,0,1-.38-.75h0c0-.29.17-.42.38-.3l6.78,3.92a.92.92,0,0,1,.38.74h0C56.3,377.33,56.13,377.47,55.92,377.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M65.79,366.44l-25.2-14.56a2.84,2.84,0,0,1-1.16-2.26v-2.19c0-.88.52-1.28,1.16-.91l25.2,14.56A2.82,2.82,0,0,1,67,363.33v2.2C67,366.4,66.43,366.81,65.79,366.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M55.57,367.67l-15-8.65a2.82,2.82,0,0,1-1.16-2.25v-2.2c0-.87.52-1.28,1.16-.91l15,8.66a2.81,2.81,0,0,1,1.16,2.25v2.19C56.73,367.64,56.21,368,55.57,367.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M65.79,373.58l-7-4.07a2.82,2.82,0,0,1-1.16-2.25v-2.2c0-.87.52-1.28,1.16-.91l7,4.07A2.83,2.83,0,0,1,67,370.48v2.19C67,373.54,66.43,374,65.79,373.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M41.18,350.12A1.42,1.42,0,0,1,40.6,349c0-.44.26-.64.58-.46a1.44,1.44,0,0,1,.58,1.13C41.76,350.1,41.5,350.3,41.18,350.12Zm0-1.24c-.18-.11-.33,0-.33.25a.83.83,0,0,0,.33.65c.18.1.33,0,.33-.26A.8.8,0,0,0,41.18,348.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M42,351.1a.45.45,0,0,1-.09-.1l-.5-1c0-.09,0-.2,0-.24s.13,0,.18.11l.5,1c0,.09,0,.2,0,.24A.08.08,0,0,1,42,351.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M44.4,372.71v3.84c0,.49-.29.72-.66.51l-2.83-1.63a1.6,1.6,0,0,1-.65-1.27v-3.84c0-.5.29-.72.65-.51l2.83,1.63A1.58,1.58,0,0,1,44.4,372.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M44.4,372.71v.81l-4.14-2.39v-.81c0-.5.29-.72.65-.51l2.83,1.63A1.58,1.58,0,0,1,44.4,372.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M43.7,372.44,41,370.87a.3.3,0,0,1-.12-.25c0-.09,0-.13.12-.09l2.72,1.57a.28.28,0,0,1,.12.24C43.82,372.43,43.77,372.48,43.7,372.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M42.75,375.57l-1-.59a.92.92,0,0,1-.38-.74V373c0-.29.17-.42.38-.3l1,.59a1,1,0,0,1,.39.74v1.22C43.14,375.56,43,375.69,42.75,375.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M49.36,375.57v3.85c0,.49-.3.72-.66.51l-2.83-1.64a1.58,1.58,0,0,1-.65-1.26v-3.85c0-.49.29-.72.65-.51l2.83,1.64A1.58,1.58,0,0,1,49.36,375.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M49.36,375.57v.82L45.22,374v-.82c0-.49.29-.72.65-.51l2.83,1.64A1.58,1.58,0,0,1,49.36,375.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M48.66,375.3l-2.72-1.57a.3.3,0,0,1-.12-.24c0-.09,0-.14.12-.1L48.66,375a.3.3,0,0,1,.12.24C48.78,375.3,48.73,375.34,48.66,375.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M47.71,378.44l-1-.59a1,1,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.92.92,0,0,1,.38.74v1.22C48.09,378.43,47.92,378.56,47.71,378.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M54.31,378.44v3.84c0,.49-.29.72-.65.51l-2.83-1.63a1.6,1.6,0,0,1-.65-1.27v-3.84c0-.5.29-.72.65-.51l2.83,1.63A1.6,1.6,0,0,1,54.31,378.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M54.31,378.44v.81l-4.13-2.39v-.81c0-.5.29-.72.65-.51l2.83,1.63A1.6,1.6,0,0,1,54.31,378.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M53.61,378.17,50.9,376.6a.31.31,0,0,1-.13-.24c0-.1.06-.14.13-.1l2.71,1.57a.31.31,0,0,1,.13.24C53.74,378.16,53.68,378.21,53.61,378.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M52.67,381.3l-1-.59a.9.9,0,0,1-.39-.74v-1.22c0-.29.17-.42.39-.3l1,.59a1,1,0,0,1,.38.74V381C53.05,381.29,52.88,381.43,52.67,381.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M47.42,386l-6.78-3.92a.94.94,0,0,1-.38-.75h0c0-.29.17-.42.38-.3L47.42,385a.92.92,0,0,1,.38.74h0C47.8,386,47.63,386.13,47.42,386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M47.42,388.26l-6.78-3.92a.94.94,0,0,1-.38-.75h0c0-.29.17-.42.38-.3l6.78,3.92a.92.92,0,0,1,.38.74h0C47.8,388.24,47.63,388.38,47.42,388.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M55.92,393.17l-6.78-3.91a1,1,0,0,1-.38-.75h0c0-.29.17-.43.38-.31l6.78,3.92a.94.94,0,0,1,.38.75h0C56.3,393.16,56.13,393.29,55.92,393.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M44.4,388.53v3.84c0,.5-.29.72-.66.52l-2.83-1.64a1.58,1.58,0,0,1-.65-1.27v-3.84c0-.49.29-.72.65-.51l2.83,1.63A1.58,1.58,0,0,1,44.4,388.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M44.4,388.53v.81L40.26,387v-.81c0-.49.29-.72.65-.51l2.83,1.63A1.58,1.58,0,0,1,44.4,388.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M43.7,388.26,41,386.69a.3.3,0,0,1-.12-.24c0-.1,0-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.24C43.82,388.26,43.77,388.3,43.7,388.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M42.75,391.4l-1-.6a.92.92,0,0,1-.38-.74v-1.22c0-.28.17-.42.38-.29l1,.59a.93.93,0,0,1,.39.74v1.22C43.14,391.38,43,391.52,42.75,391.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M49.36,391.4v3.84c0,.49-.3.72-.66.51l-2.83-1.63a1.6,1.6,0,0,1-.65-1.27V389c0-.49.29-.72.65-.51l2.83,1.64A1.59,1.59,0,0,1,49.36,391.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M49.36,391.4v.81l-4.14-2.39V389c0-.49.29-.72.65-.51l2.83,1.64A1.59,1.59,0,0,1,49.36,391.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M48.66,391.13l-2.72-1.57a.3.3,0,0,1-.12-.25c0-.09,0-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.25C48.78,391.12,48.73,391.17,48.66,391.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M47.71,394.26l-1-.59a.92.92,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.93.93,0,0,1,.38.74V394C48.09,394.25,47.92,394.38,47.71,394.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M54.31,394.26v3.84c0,.5-.29.73-.65.52L50.83,397a1.58,1.58,0,0,1-.65-1.27v-3.84c0-.49.29-.72.65-.51L53.66,393A1.6,1.6,0,0,1,54.31,394.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M54.31,394.26v.81l-4.13-2.39v-.81c0-.49.29-.72.65-.51L53.66,393A1.6,1.6,0,0,1,54.31,394.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M53.61,394l-2.71-1.57a.31.31,0,0,1-.13-.24c0-.1.06-.14.13-.1l2.71,1.57a.31.31,0,0,1,.13.24C53.74,394,53.68,394,53.61,394Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M52.67,397.13l-1-.6a.9.9,0,0,1-.39-.74v-1.22c0-.28.17-.42.39-.29l1,.59a.92.92,0,0,1,.38.74v1.22C53.05,397.11,52.88,397.25,52.67,397.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "69.19 377.24 37.29 358.81 37.29 358.46 69.19 376.9 69.19 377.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "69.32 491.5 69.07 491.36 69.07 353.36 69.32 353.51 69.32 491.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "101 509.81 100.75 509.67 100.75 371.67 101 371.81 101 509.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "132.68 528.12 132.42 527.97 132.42 389.98 132.68 390.12 132.68 528.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "164.35 546.42 164.1 546.28 164.1 408.28 164.35 408.43 164.35 546.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M79.35,373.82l-6.77-3.92a.92.92,0,0,1-.39-.75h0c0-.29.17-.42.39-.3l6.77,3.92a.93.93,0,0,1,.39.74h0C79.74,373.8,79.56,373.94,79.35,373.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M79.35,376.07l-6.77-3.92a.92.92,0,0,1-.39-.75h0c0-.29.17-.42.39-.3L79.35,375a.93.93,0,0,1,.39.74h0C79.74,376.05,79.56,376.19,79.35,376.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M87.85,381l-6.77-3.92a.9.9,0,0,1-.39-.74h0c0-.29.17-.43.39-.31l6.77,3.92a1,1,0,0,1,.39.75h0C88.24,381,88.06,381.1,87.85,381Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M76.33,376.34v3.84c0,.5-.29.72-.65.51l-2.83-1.63a1.56,1.56,0,0,1-.66-1.27V374c0-.49.29-.72.66-.51l2.83,1.63A1.6,1.6,0,0,1,76.33,376.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M76.33,376.34v.81l-4.14-2.39V374c0-.49.29-.72.66-.51l2.83,1.63A1.6,1.6,0,0,1,76.33,376.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M75.63,376.07l-2.72-1.57a.33.33,0,0,1-.12-.24c0-.1.06-.14.12-.1l2.72,1.57a.31.31,0,0,1,.13.24C75.76,376.07,75.7,376.11,75.63,376.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M74.69,379.2l-1-.59a.92.92,0,0,1-.38-.74v-1.22c0-.28.17-.42.38-.3l1,.6a.92.92,0,0,1,.38.74v1.22C75.07,379.19,74.9,379.33,74.69,379.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M81.29,379.21v3.84c0,.49-.29.72-.66.51l-2.83-1.63a1.6,1.6,0,0,1-.65-1.27v-3.85c0-.49.29-.72.65-.51l2.83,1.64A1.56,1.56,0,0,1,81.29,379.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M81.29,379.21V380l-4.14-2.39v-.82c0-.49.29-.72.65-.51l2.83,1.64A1.56,1.56,0,0,1,81.29,379.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M80.59,378.93l-2.72-1.56a.3.3,0,0,1-.12-.25c0-.09,0-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.25C80.71,378.93,80.66,379,80.59,378.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M79.64,382.07l-1-.59a.93.93,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.93.93,0,0,1,.39.74v1.22C80,382.06,79.85,382.19,79.64,382.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M86.25,382.07v3.84c0,.5-.3.72-.66.52l-2.83-1.64a1.58,1.58,0,0,1-.65-1.27v-3.84c0-.49.29-.72.65-.51l2.83,1.63A1.6,1.6,0,0,1,86.25,382.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M86.25,382.07v.81l-4.14-2.39v-.81c0-.49.29-.72.65-.51l2.83,1.63A1.6,1.6,0,0,1,86.25,382.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M85.55,381.8l-2.72-1.57a.3.3,0,0,1-.12-.24c0-.1.05-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.24C85.67,381.8,85.62,381.84,85.55,381.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M84.6,384.94l-1-.6a.92.92,0,0,1-.38-.74v-1.22c0-.28.17-.42.38-.3l1,.6a.92.92,0,0,1,.38.74v1.22C85,384.92,84.81,385.06,84.6,384.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M97,393.37l-3.87-2.23a1.83,1.83,0,0,1-.75-1.45h0c0-.57.34-.83.75-.59L97,391.33a1.84,1.84,0,0,1,.75,1.46h0C97.71,393.35,97.37,393.61,97,393.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M143,410.59l-6.77-3.91a1,1,0,0,1-.39-.75h0c0-.29.18-.43.39-.3l6.77,3.91a.92.92,0,0,1,.39.75h0C143.37,410.58,143.2,410.71,143,410.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M143,412.84l-6.77-3.91a1,1,0,0,1-.39-.75h0c0-.29.18-.43.39-.3l6.77,3.91a.92.92,0,0,1,.39.75h0C143.37,412.83,143.2,413,143,412.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M151.48,417.75l-6.77-3.91a1,1,0,0,1-.39-.75h0c0-.29.18-.43.39-.3l6.77,3.91a.92.92,0,0,1,.39.75h0C151.87,417.74,151.7,417.87,151.48,417.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M140,413.11V417c0,.49-.29.72-.65.51l-2.83-1.64a1.58,1.58,0,0,1-.65-1.26v-3.85c0-.49.29-.72.65-.51l2.83,1.64A1.58,1.58,0,0,1,140,413.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M140,413.11v.82l-4.13-2.39v-.82c0-.49.29-.72.65-.51l2.83,1.64A1.58,1.58,0,0,1,140,413.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M139.26,412.84l-2.71-1.57a.31.31,0,0,1-.13-.24c0-.09.06-.14.13-.1l2.71,1.57a.31.31,0,0,1,.13.24C139.39,412.84,139.33,412.88,139.26,412.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M138.32,416l-1-.59a.93.93,0,0,1-.39-.74v-1.22c0-.29.17-.42.39-.3l1,.59a.92.92,0,0,1,.38.74v1.22C138.7,416,138.53,416.1,138.32,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M144.92,416v3.84c0,.49-.29.72-.65.51l-2.83-1.63a1.6,1.6,0,0,1-.66-1.27v-3.84c0-.49.3-.72.66-.51l2.83,1.63A1.6,1.6,0,0,1,144.92,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M144.92,416v.81l-4.14-2.39v-.81c0-.49.3-.72.66-.51l2.83,1.63A1.6,1.6,0,0,1,144.92,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M144.22,415.71l-2.71-1.57a.31.31,0,0,1-.13-.24c0-.1.06-.14.13-.1l2.71,1.57a.31.31,0,0,1,.13.24C144.35,415.7,144.29,415.75,144.22,415.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M143.28,418.84l-1-.59a.92.92,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a1,1,0,0,1,.38.74v1.22C143.66,418.83,143.49,419,143.28,418.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M149.88,418.84v3.85c0,.49-.29.72-.66.51l-2.82-1.64a1.56,1.56,0,0,1-.66-1.26v-3.85c0-.49.29-.72.66-.51l2.82,1.64A1.56,1.56,0,0,1,149.88,418.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M149.88,418.84v.82l-4.14-2.39v-.82c0-.49.29-.72.66-.51l2.82,1.64A1.56,1.56,0,0,1,149.88,418.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M149.18,418.57,146.46,417a.33.33,0,0,1-.12-.24c0-.09.06-.14.12-.1l2.72,1.57a.31.31,0,0,1,.13.24C149.31,418.57,149.25,418.61,149.18,418.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M148.24,421.71l-1-.59a1,1,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.92.92,0,0,1,.38.74v1.22C148.62,421.7,148.45,421.83,148.24,421.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M79.35,389.72l-6.77-3.91a.93.93,0,0,1-.39-.75h0c0-.29.17-.43.39-.3l6.77,3.91a1,1,0,0,1,.39.75h0C79.74,389.71,79.56,389.84,79.35,389.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M79.35,392l-6.77-3.91a.93.93,0,0,1-.39-.75h0c0-.29.17-.43.39-.3l6.77,3.91a1,1,0,0,1,.39.75h0C79.74,392,79.56,392.09,79.35,392Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M87.85,396.88,81.08,393a.92.92,0,0,1-.39-.75h0c0-.29.17-.42.39-.3l6.77,3.91a1,1,0,0,1,.39.75h0C88.24,396.87,88.06,397,87.85,396.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M76.33,392.25v3.84c0,.49-.29.72-.65.51L72.85,395a1.58,1.58,0,0,1-.66-1.27v-3.85c0-.49.29-.72.66-.51L75.68,391A1.58,1.58,0,0,1,76.33,392.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M76.33,392.25v.81l-4.14-2.39v-.82c0-.49.29-.72.66-.51L75.68,391A1.58,1.58,0,0,1,76.33,392.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M75.63,392l-2.72-1.56a.33.33,0,0,1-.12-.25c0-.09.06-.14.12-.1l2.72,1.57a.31.31,0,0,1,.13.25C75.76,392,75.7,392,75.63,392Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M74.69,395.11l-1-.59a.93.93,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.92.92,0,0,1,.38.74v1.22C75.07,395.1,74.9,395.23,74.69,395.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M81.29,395.11V399c0,.5-.29.72-.66.52l-2.83-1.64a1.58,1.58,0,0,1-.65-1.27v-3.84c0-.49.29-.72.65-.51l2.83,1.63A1.58,1.58,0,0,1,81.29,395.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M81.29,395.11v.81l-4.14-2.39v-.81c0-.49.29-.72.65-.51l2.83,1.63A1.58,1.58,0,0,1,81.29,395.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M80.59,394.84l-2.72-1.57a.3.3,0,0,1-.12-.24c0-.1,0-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.24C80.71,394.84,80.66,394.88,80.59,394.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M79.64,398l-1-.6a.92.92,0,0,1-.38-.74v-1.22c0-.28.17-.42.38-.3l1,.6a.93.93,0,0,1,.39.74v1.22C80,398,79.85,398.1,79.64,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M86.25,398v3.84c0,.49-.3.72-.66.51l-2.83-1.63a1.6,1.6,0,0,1-.65-1.27v-3.85c0-.49.29-.72.65-.51l2.83,1.64A1.59,1.59,0,0,1,86.25,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M86.25,398v.81l-4.14-2.39v-.82c0-.49.29-.72.65-.51l2.83,1.64A1.59,1.59,0,0,1,86.25,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M85.55,397.7l-2.72-1.56a.3.3,0,0,1-.12-.25c0-.09.05-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.25C85.67,397.7,85.62,397.74,85.55,397.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M84.6,400.84l-1-.59a.92.92,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.93.93,0,0,1,.38.74v1.22C85,400.83,84.81,401,84.6,400.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M97,409.28,93.09,407a1.8,1.8,0,0,1-.75-1.45h0c0-.56.34-.82.75-.58L97,407.24a1.83,1.83,0,0,1,.75,1.45h0C97.71,409.26,97.37,409.52,97,409.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M79.35,405.63l-6.77-3.92a.92.92,0,0,1-.39-.75h0c0-.29.17-.42.39-.3l6.77,3.92a.93.93,0,0,1,.39.74h0C79.74,405.61,79.56,405.75,79.35,405.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M79.35,407.88,72.58,404a.92.92,0,0,1-.39-.75h0c0-.29.17-.42.39-.3l6.77,3.92a.93.93,0,0,1,.39.74h0C79.74,407.86,79.56,408,79.35,407.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M87.85,412.79l-6.77-3.92a.9.9,0,0,1-.39-.74h0c0-.29.17-.43.39-.31l6.77,3.92a1,1,0,0,1,.39.75h0C88.24,412.78,88.06,412.91,87.85,412.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M76.33,408.15V412c0,.5-.29.72-.65.52l-2.83-1.64a1.56,1.56,0,0,1-.66-1.27v-3.84c0-.49.29-.72.66-.51l2.83,1.63A1.6,1.6,0,0,1,76.33,408.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M76.33,408.15V409l-4.14-2.39v-.81c0-.49.29-.72.66-.51l2.83,1.63A1.6,1.6,0,0,1,76.33,408.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M75.63,407.88l-2.72-1.57a.33.33,0,0,1-.12-.24c0-.1.06-.14.12-.1l2.72,1.57a.31.31,0,0,1,.13.24C75.76,407.88,75.7,407.92,75.63,407.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M74.69,411l-1-.59a.92.92,0,0,1-.38-.74v-1.22c0-.28.17-.42.38-.3l1,.6a.92.92,0,0,1,.38.74v1.22C75.07,411,74.9,411.14,74.69,411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M81.29,411v3.84c0,.49-.29.72-.66.51l-2.83-1.63a1.6,1.6,0,0,1-.65-1.27v-3.85c0-.49.29-.72.65-.51l2.83,1.64A1.56,1.56,0,0,1,81.29,411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M81.29,411v.81l-4.14-2.39v-.82c0-.49.29-.72.65-.51l2.83,1.64A1.56,1.56,0,0,1,81.29,411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M80.59,410.74l-2.72-1.56a.3.3,0,0,1-.12-.25c0-.09,0-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.25C80.71,410.74,80.66,410.78,80.59,410.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M79.64,413.88l-1-.59a.93.93,0,0,1-.38-.74v-1.22c0-.29.17-.42.38-.3l1,.59a.93.93,0,0,1,.39.74v1.22C80,413.87,79.85,414,79.64,413.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M86.25,413.88v3.84c0,.5-.3.72-.66.52l-2.83-1.64a1.58,1.58,0,0,1-.65-1.27v-3.84c0-.49.29-.72.65-.51l2.83,1.63A1.6,1.6,0,0,1,86.25,413.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M86.25,413.88v.81l-4.14-2.39v-.81c0-.49.29-.72.65-.51l2.83,1.63A1.6,1.6,0,0,1,86.25,413.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M85.55,413.61,82.83,412a.3.3,0,0,1-.12-.24c0-.1.05-.14.12-.1l2.72,1.57a.3.3,0,0,1,.12.24C85.67,413.61,85.62,413.65,85.55,413.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M84.6,416.75l-1-.6a.92.92,0,0,1-.38-.74v-1.22c0-.28.17-.42.38-.3l1,.6a.92.92,0,0,1,.38.74v1.22C85,416.73,84.81,416.87,84.6,416.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M97,425.18,93.09,423a1.83,1.83,0,0,1-.75-1.45h0c0-.57.34-.83.75-.59L97,423.15a1.8,1.8,0,0,1,.75,1.45h0C97.71,425.16,97.37,425.42,97,425.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M311.74,634.75l-70.4-29.84v23.66h0a2,2,0,0,0,1,1.69L374.6,706.65a5.13,5.13,0,0,0,5.14,0l15.68-9.12a1.25,1.25,0,0,0,.56-.71l0,0V672.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M242.32,603.22l15.13-8.76a4.08,4.08,0,0,1,4.11,0l133.86,77.28a1.24,1.24,0,0,1,0,2.14L379.74,683a5.13,5.13,0,0,1-5.14,0L242.32,606.63A2,2,0,0,1,242.32,603.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-354",
    points: "277.12 609.6 259.51 599.43 258.19 600.19 250.02 596.12 250.02 604.92 377.17 678.34 386.63 672.83 386.63 664.03 277.12 609.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-355",
    points: "250.02 596.12 259.51 590.63 386.63 664.03 377.17 669.54 250.02 596.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M260.21,626c-.72-2.79-3-5.06-5.21-5.09a2.61,2.61,0,0,0-1.44.4h0l-1.33.77-.33,1.6a7,7,0,0,0-.14,2.06,11.91,11.91,0,0,0,1.41,2.95l1.22.74a5.31,5.31,0,0,0,2.43,1.46l.84.51,1.27-.73h0C260.2,629.93,260.76,628.12,260.21,626Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-357",
    cx: 254.84,
    cy: 626.78,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-271.56 201.7) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M256.07,628.66a.64.64,0,0,1-.2.11,1,1,0,0,1-.49.11,2.67,2.67,0,0,1-2.17-2.11,1.66,1.66,0,0,1,.59-2,1.18,1.18,0,0,1,.5-.11,2.69,2.69,0,0,1,2.17,2.12A1.78,1.78,0,0,1,256.07,628.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M241,652.76c2.77.74,5.91-.16,7-2a2.54,2.54,0,0,0,.37-1.45h0l0-1.54-1.23-1.07a6.94,6.94,0,0,0-1.72-1.14,11.89,11.89,0,0,0-3.26-.23l-1.24.7a5.33,5.33,0,0,0-2.48,1.39l-.85.48v1.47h0C237.53,650.79,238.84,652.18,241,652.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-360",
    cx: 242.91,
    cy: 647.69,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-407.21 883.99) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M245.16,647.7v0a1,1,0,0,1-.12.46.25.25,0,0,1,0,.07,2.7,2.7,0,0,1-2.9.85,2,2,0,0,1-1.3-.93,1,1,0,0,1-.12-.59s0,0,0,0a1.07,1.07,0,0,1,.15-.41,2.65,2.65,0,0,1,2.9-.85C244.62,646.52,245.16,647.1,245.16,647.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M256.07,628.66l-.11.07-.09,0-7.7,4.46a6,6,0,0,0-3,5.19v9c0,.09,0,.19,0,.28v0a2.39,2.39,0,0,1-.12.46.25.25,0,0,1,0,.07,2.7,2.7,0,0,1-2.9.85,2,2,0,0,1-1.3-.93,2.29,2.29,0,0,1-.12-.59s0,0,0,0a.49.49,0,0,1,0-.12v-9a10.55,10.55,0,0,1,5.25-9.09l7.79-4.5.09,0a1.18,1.18,0,0,1,.5-.11,2.69,2.69,0,0,1,2.17,2.12A1.78,1.78,0,0,1,256.07,628.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M360.3,683.42c-.72-2.78-3.05-5.06-5.21-5.09a2.67,2.67,0,0,0-1.45.4h0l-1.33.77-.33,1.6a7,7,0,0,0-.14,2.06,12.28,12.28,0,0,0,1.41,3l1.22.74a5.48,5.48,0,0,0,2.43,1.47l.84.5,1.27-.73h0C360.28,687.37,360.85,685.56,360.3,683.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-364",
    cx: 354.93,
    cy: 684.23,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-286.86 257.33) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M356.16,686.1a1.06,1.06,0,0,1-.2.12,1.15,1.15,0,0,1-.5.11,2.66,2.66,0,0,1-2.16-2.12,1.63,1.63,0,0,1,.59-2,1.1,1.1,0,0,1,.49-.11,2.69,2.69,0,0,1,2.17,2.13A1.75,1.75,0,0,1,356.16,686.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M341.05,710.2c2.78.75,5.91-.16,7-2a2.68,2.68,0,0,0,.37-1.45h0l0-1.54-1.23-1.07a6.94,6.94,0,0,0-1.72-1.14,12.38,12.38,0,0,0-3.27-.23l-1.24.7a5.34,5.34,0,0,0-2.47,1.39l-.86.48v1.47h0C337.62,708.24,338.92,709.62,341.05,710.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-367",
    cx: 343,
    cy: 705.13,
    rx: 3.64,
    ry: 5.4,
    transform: "translate(-365.59 1040.93) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M345.24,705.14v0a1,1,0,0,1-.12.46s0,0,0,.07a2.68,2.68,0,0,1-2.91.85,2,2,0,0,1-1.3-.93,1,1,0,0,1-.11-.58s0,0,0,0a1.11,1.11,0,0,1,.14-.41,2.7,2.7,0,0,1,2.91-.85C344.7,704,345.24,704.54,345.24,705.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M356.16,686.1l-.11.07-.09.05-7.7,4.45a6,6,0,0,0-3,5.2v9a2.45,2.45,0,0,1,0,.27v0a1.73,1.73,0,0,1-.12.46s0,0,0,.07a2.68,2.68,0,0,1-2.91.85,2,2,0,0,1-1.3-.93,2.29,2.29,0,0,1-.11-.58s0,0,0,0a.41.41,0,0,1,0-.11v-9a10.52,10.52,0,0,1,5.25-9.09l7.79-4.5.09,0a1.1,1.1,0,0,1,.49-.11,2.69,2.69,0,0,1,2.17,2.13A1.75,1.75,0,0,1,356.16,686.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M398,535.88V675.69a1.78,1.78,0,0,1-.57,1.48h0l-3.53,2-3.7-5.41-149.31-86a4.49,4.49,0,0,1-1.87-3.62V450a2.44,2.44,0,0,0-.23-.32,31.52,31.52,0,0,1-2.46-5l3.15-1.72h0a1.09,1.09,0,0,1,1.4-.06l155.23,89.39A4.49,4.49,0,0,1,398,535.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M398,535.88v4.22l-3.46,2.06L239,450v0a2.44,2.44,0,0,0-.23-.32,31.52,31.52,0,0,1-2.46-5l3.15-1.72h0a1.09,1.09,0,0,1,1.4-.06l155.23,89.39A4.49,4.49,0,0,1,398,535.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M394.53,537.8V677.61c0,1.4-.84,2.06-1.87,1.46L237.43,589.68a4.49,4.49,0,0,1-1.87-3.61V446.26c0-1.4.83-2.05,1.87-1.46l155.23,89.39A4.53,4.53,0,0,1,394.53,537.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M394.53,537.8v4.36l-159-91.55v-4.35c0-1.4.83-2.05,1.87-1.46l155.23,89.39A4.53,4.53,0,0,1,394.53,537.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 239.87,
    cy: 449.65,
    rx: 0.92,
    ry: 1.64,
    transform: "translate(-151.99 123.81) rotate(-22.18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 244.97,
    cy: 452.59,
    rx: 0.92,
    ry: 1.64,
    transform: "translate(-152.72 125.96) rotate(-22.18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 250.07,
    cy: 455.52,
    rx: 0.92,
    ry: 1.64,
    transform: "translate(-153.45 128.1) rotate(-22.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M258.81,478.34l-17.52-10.1a2.38,2.38,0,0,1-1-1.93h0c0-.75.44-1.1,1-.78l17.52,10.09a2.42,2.42,0,0,1,1,1.93h0C259.81,478.3,259.36,478.65,258.81,478.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M311.79,567.59l-70.4-40.54a4.74,4.74,0,0,1-1.95-3.77V478.46c0-1.47.88-2.15,1.95-1.53l70.4,40.54a4.71,4.71,0,0,1,1.95,3.77v44.82C313.74,567.53,312.87,568.21,311.79,567.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M254.4,514c-4.79-2.75-8.68-10.29-8.68-16.79s3.89-9.56,8.68-6.8,8.68,10.29,8.68,16.8S259.19,516.75,254.4,514Zm0-20.17c-3.4-2-6.17.2-6.17,4.82s2.77,10,6.17,11.93,6.17-.2,6.17-4.82S257.8,495.77,254.4,493.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M254.4,514a3,3,0,0,1-1.26-2.43c0-.95.56-1.39,1.26-1,3.4,2,6.17-.2,6.17-4.82s-2.77-10-6.17-11.93a3,3,0,0,1-1.26-2.44c0-.94.56-1.38,1.26-1,4.79,2.75,8.68,10.29,8.68,16.8S259.19,516.75,254.4,514Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M276.59,526.77c-4.78-2.75-8.68-10.29-8.68-16.79s3.9-9.56,8.68-6.8,8.69,10.29,8.69,16.8S281.38,529.53,276.59,526.77Zm0-20.17c-3.4-2-6.16.2-6.16,4.82s2.76,10,6.16,11.93,6.17-.2,6.17-4.82S280,508.55,276.59,506.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M284,521a3,3,0,0,1-1.26-2.43c0-4.62-2.77-10-6.17-11.93a3.05,3.05,0,0,1-1.25-2.44c0-.94.56-1.38,1.25-1,4.79,2.75,8.69,10.29,8.69,16.8C285.28,520.92,284.71,521.36,284,521Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M298.79,539.55c-4.79-2.75-8.69-10.29-8.69-16.79s3.9-9.56,8.69-6.8,8.68,10.29,8.68,16.8S303.57,542.31,298.79,539.55Zm0-20.17c-3.4-2-6.17.2-6.17,4.82s2.77,10,6.17,11.93,6.16-.2,6.16-4.82S302.19,521.33,298.79,519.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M304.25,525.78a2.4,2.4,0,0,1-.92-1.08,12.47,12.47,0,0,0-4.54-5.32,3,3,0,0,1-1.26-2.44c0-.94.56-1.38,1.26-1a17.46,17.46,0,0,1,6.39,7.49c.47,1,.43,2-.08,2.37A.78.78,0,0,1,304.25,525.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M260,524.86l-11.22-6.46a2.94,2.94,0,0,1-1.2-2.33h0c0-.9.54-1.32,1.2-.94L260,521.59a2.91,2.91,0,0,1,1.2,2.32h0C261.21,524.82,260.67,525.24,260,524.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M282.2,537.64,271,531.18a2.94,2.94,0,0,1-1.2-2.33h0c0-.9.54-1.32,1.2-.94l11.22,6.46a2.88,2.88,0,0,1,1.2,2.32h0C283.4,537.6,282.87,538,282.2,537.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M304.4,550.42,293.18,544a2.91,2.91,0,0,1-1.2-2.33h0c0-.9.53-1.32,1.2-.94l11.22,6.46a2.91,2.91,0,0,1,1.2,2.32h0C305.6,550.38,305.06,550.8,304.4,550.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M387.6,611.25l-69.54-40A4,4,0,0,1,316.4,568V522.38c0-1.25.74-1.83,1.66-1.3l69.54,40a4,4,0,0,1,1.66,3.2V610C389.26,611.19,388.52,611.77,387.6,611.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M329.87,574.07a.31.31,0,0,1-.13-.25V532.11c0-.1.06-.14.13-.1a.31.31,0,0,1,.13.24V574C330,574.06,329.94,574.11,329.87,574.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M326.48,533.31l-6-3.44a1.9,1.9,0,0,1-.77-1.5h0c0-.58.35-.85.77-.61l6,3.45a1.9,1.9,0,0,1,.77,1.5h0C327.25,533.29,326.9,533.56,326.48,533.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M326.48,541l-4-2.29a1.84,1.84,0,0,1-.77-1.49h0c0-.58.34-.85.77-.61l4,2.29a1.9,1.9,0,0,1,.77,1.5h0C327.25,541,326.9,541.23,326.48,541Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M326.48,548.65l-4-2.29a1.84,1.84,0,0,1-.77-1.49h0c0-.58.34-.85.77-.61l4,2.29a1.9,1.9,0,0,1,.77,1.5h0C327.25,548.63,326.9,548.9,326.48,548.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M326.48,556.32l-4-2.28a1.87,1.87,0,0,1-.77-1.5h0c0-.58.34-.85.77-.61l4,2.29a1.9,1.9,0,0,1,.77,1.5h0C327.25,556.3,326.9,556.57,326.48,556.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M326.48,564l-2.7-1.55A1.9,1.9,0,0,1,323,561h0c0-.58.35-.85.77-.61l2.7,1.55a1.9,1.9,0,0,1,.77,1.5h0C327.25,564,326.9,564.24,326.48,564Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M326.48,571.67l-5.05-2.91a1.87,1.87,0,0,1-.78-1.5h0c0-.58.35-.85.78-.6l5.05,2.91a1.87,1.87,0,0,1,.77,1.49h0C327.25,571.64,326.9,571.91,326.48,571.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M384.92,567.8,333.12,538a3.09,3.09,0,0,1-1.26-2.44h0c0-.95.57-1.39,1.26-1l51.8,29.83a3,3,0,0,1,1.26,2.44h0C386.18,567.76,385.62,568.2,384.92,567.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M366.62,564.76l-33.5-19.29a3.06,3.06,0,0,1-1.26-2.43h0c0-.95.57-1.39,1.26-1l33.5,19.29a3,3,0,0,1,1.26,2.44h0C367.88,564.72,367.32,565.16,366.62,564.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M355.77,566l-22.65-13a3.06,3.06,0,0,1-1.26-2.44h0c0-.94.57-1.38,1.26-1l22.65,13A3.09,3.09,0,0,1,357,565h0C357,566,356.46,566.41,355.77,566Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M354.54,572.8l-21.42-12.33a3.06,3.06,0,0,1-1.26-2.44h0c0-.94.57-1.39,1.26-1l21.42,12.34a3,3,0,0,1,1.26,2.43h0C355.8,572.76,355.24,573.2,354.54,572.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M353.78,579.86,333.12,568a3.08,3.08,0,0,1-1.26-2.44h0c0-.95.57-1.39,1.26-1l20.66,11.9a3,3,0,0,1,1.26,2.43h0C355,579.82,354.48,580.26,353.78,579.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M337.94,578.24l-4.82-2.78a3.06,3.06,0,0,1-1.26-2.43h0c0-.95.57-1.39,1.26-1l4.82,2.77a3,3,0,0,1,1.26,2.44h0C339.2,578.2,338.64,578.64,337.94,578.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M347.83,637.54,240.9,576a3.64,3.64,0,0,1-1.5-2.91V532.79c0-1.13.67-1.66,1.5-1.18l106.93,61.57a3.66,3.66,0,0,1,1.5,2.92v40.25C349.33,637.49,348.66,638,347.83,637.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M343.64,598.14,249,543.63a.31.31,0,0,1-.13-.24c0-.09.06-.14.13-.1l94.65,54.51a.28.28,0,0,1,.12.24C343.76,598.13,343.71,598.18,343.64,598.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M343.64,605.62,249,551.12a.31.31,0,0,1-.13-.25c0-.09.06-.13.13-.09l94.65,54.5a.3.3,0,0,1,.12.24C343.76,605.62,343.71,605.66,343.64,605.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M343.64,613.1,249,558.6a.31.31,0,0,1-.13-.24c0-.1.06-.14.13-.1l94.65,54.5a.3.3,0,0,1,.12.25C343.76,613.1,343.71,613.14,343.64,613.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M343.64,620.59,249,566.08a.31.31,0,0,1-.13-.24c0-.09.06-.14.13-.1l94.65,54.51a.28.28,0,0,1,.12.24C343.76,620.58,343.71,620.63,343.64,620.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M257,574c-4.82-2.78-8.23-8.46-8.37-8.7a1.65,1.65,0,0,1-.13-1.76c.31-.33.86-.09,1.24.54h0c0,.05,3.09,5.12,7.26,7.52,1.72,1,3.79.85,6.19.69,3.46-.22,7.77-.51,13,2.52,4.61,2.66,8.33,6.31,11.92,9.85,3.36,3.3,6.54,6.42,10.25,8.56s7.79.92,12.21-.32c4.66-1.3,9.47-2.65,14,0a38.35,38.35,0,0,1,8.44,6.78A29,29,0,0,0,343.53,607a2,2,0,0,1,1,1.6c.06.69-.29,1.09-.77.89a31.35,31.35,0,0,1-11.17-7.87,36.1,36.1,0,0,0-7.92-6.38c-4-2.32-8.64-1-13.09.21-4.63,1.3-9,2.52-13.14.14s-7.42-5.67-10.75-9c-3.48-3.42-7.07-7-11.42-9.45-4.88-2.81-8.81-2.55-12.28-2.32C261.37,575,259.13,575.17,257,574Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M343.64,628.07,249,573.57a.31.31,0,0,1-.13-.25c0-.09.06-.13.13-.09l94.65,54.5a.3.3,0,0,1,.12.24C343.76,628.07,343.71,628.11,343.64,628.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M246.3,542.82l-1.28-.74a1.3,1.3,0,0,1-.54-1h0c0-.41.24-.6.54-.43l1.28.74a1.33,1.33,0,0,1,.54,1h0C246.84,542.8,246.59,543,246.3,542.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M246.3,550.13,245,549.4a1.32,1.32,0,0,1-.54-1h0c0-.41.24-.59.54-.42l1.28.73a1.33,1.33,0,0,1,.54,1.05h0C246.84,550.11,246.59,550.3,246.3,550.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M246.3,557.44l-1.28-.73a1.3,1.3,0,0,1-.54-1.05h0c0-.4.24-.59.54-.42l1.28.73a1.35,1.35,0,0,1,.54,1h0C246.84,557.43,246.59,557.61,246.3,557.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M246.3,564.76,245,564a1.3,1.3,0,0,1-.54-1h0c0-.41.24-.6.54-.43l1.28.74a1.33,1.33,0,0,1,.54,1h0C246.84,564.74,246.59,564.93,246.3,564.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M246.3,572.07l-1.28-.74a1.3,1.3,0,0,1-.54-1h0c0-.41.24-.6.54-.42l1.28.73a1.33,1.33,0,0,1,.54,1h0C246.84,572.05,246.59,572.24,246.3,572.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-401",
    cx: 276.25,
    cy: 575.97,
    rx: 0.71,
    ry: 1.26,
    transform: "translate(-196.98 146.89) rotate(-22.18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-402",
    cx: 298.42,
    cy: 594.38,
    rx: 0.71,
    ry: 1.26,
    transform: "translate(-202.29 156.62) rotate(-22.18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-403",
    cx: 324.65,
    cy: 594.03,
    rx: 0.71,
    ry: 1.26,
    transform: "translate(-200.22 166.5) rotate(-22.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M278.81,568l-5.26-3c-.41-.23-.74,0-.74.58v2.55a1.77,1.77,0,0,0,.74,1.43l1.84,1.06.79,1.38.79-.47,1.84,1.06c.41.24.74,0,.74-.58v-2.55A1.8,1.8,0,0,0,278.81,568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M277.91,570.53l-3.47-2a1.17,1.17,0,0,1-.45-.94c0-.38.2-.57.45-.43l3.47,2a1.16,1.16,0,0,1,.45.94C278.36,570.48,278.16,570.67,277.91,570.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M300.75,586.37l-5.26-3c-.41-.24-.74,0-.74.57v2.55a1.77,1.77,0,0,0,.74,1.43l1.84,1.06.79,1.38.79-.47,1.84,1.07c.41.23.74,0,.74-.58V587.8A1.77,1.77,0,0,0,300.75,586.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M299.86,588.85l-3.47-2a1.16,1.16,0,0,1-.45-.94c0-.38.2-.57.45-.42l3.47,2a1.19,1.19,0,0,1,.45.95C300.31,588.8,300.11,589,299.86,588.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M327.23,587.56l-5.26-3c-.41-.23-.74,0-.74.58v2.55a1.77,1.77,0,0,0,.74,1.43l1.84,1.06.79,1.38.79-.47,1.84,1.06c.41.24.74,0,.74-.58V589A1.77,1.77,0,0,0,327.23,587.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.33,590l-3.46-2a1.16,1.16,0,0,1-.46-.94c0-.38.21-.57.46-.43l3.46,2a1.18,1.18,0,0,1,.46.94C326.79,590,326.58,590.18,326.33,590Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M686.44,503.59l-1.13.68-82.57-47.69a2.7,2.7,0,0,1-1.34-2.34V443.06a2.72,2.72,0,0,1,.73-1.86l2.18-2.29a1.54,1.54,0,0,0,.43-1.08v-4.29a1.6,1.6,0,0,0-.78-1.35l-4.07-2.37a.57.57,0,1,1,.58-1l4.07,2.34a2.76,2.76,0,0,1,1.34,2.35v4.29a2.67,2.67,0,0,1-.74,1.86L603,442a1.54,1.54,0,0,0-.43,1.08v11.18a1.55,1.55,0,0,0,.78,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M682.16,506.13l-1.13.67L598.29,459a2.7,2.7,0,0,1-1.35-2.33V445.5a2.65,2.65,0,0,1,.74-1.84l2.18-2.31a1.56,1.56,0,0,0,.42-1.06V436a1.58,1.58,0,0,0-.77-1.34l-4.08-2.36a.57.57,0,0,1,.58-1l4.08,2.36a2.73,2.73,0,0,1,1.34,2.33v4.31a2.74,2.74,0,0,1-.75,1.86l-2.17,2.29a1.56,1.56,0,0,0-.42,1.06v11.2a1.53,1.53,0,0,0,.78,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M677.84,508.67l-1.13.68-82.88-47.86a2.69,2.69,0,0,1-1.34-2.35V448a2.72,2.72,0,0,1,.73-1.86l2.18-2.29a1.6,1.6,0,0,0,.41-1.07v-4.3a1.55,1.55,0,0,0-.76-1.34L591,434.73a.55.55,0,0,1-.21-.77.59.59,0,0,1,.79-.22l4.06,2.37a2.68,2.68,0,0,1,1.34,2.33v4.3a2.7,2.7,0,0,1-.73,1.86l-2.17,2.29a1.58,1.58,0,0,0-.43,1.07v11.18a1.55,1.55,0,0,0,.78,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M673.54,511.22l-1.13.67-84.1-48.57a.57.57,0,0,1-.29-.49V449.56a.5.5,0,0,1,.17-.38l3.17-3.37V440l-4.84-2.81a.6.6,0,0,1-.21-.79.57.57,0,0,1,.79-.2l5.13,3a.58.58,0,0,1,.27.49V446a.51.51,0,0,1-.15.39l-3.19,3.36V462.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-411",
    points: "915.74 661.72 859.5 629.11 859.5 619.72 927.17 636.53 915.74 661.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M867.18,624.4l-9.29-5h0a6,6,0,0,0-.56-.3h0c-5.32-2.54-13.13,1.94-17.78,10.36-4.83,8.74-4.44,18.4.87,21.58.19.11.39.22.58.31l10,5.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-413",
    cx: 859.71,
    cy: 640.82,
    rx: 18.08,
    ry: 11.2,
    transform: "translate(-107.35 1104.01) rotate(-62.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M868.2,640.11c-.15.62-.34,1.23-.56,1.86a21.44,21.44,0,0,1-1.29,2.82,16.8,16.8,0,0,1-5.85,6.35,10.91,10.91,0,0,1-1.58.77,5.87,5.87,0,0,1-5.25-.18l-.39-.26a5.26,5.26,0,0,1-1.08-1.08,6.38,6.38,0,0,1-.66-1.11h0a12,12,0,0,1-.32-7.76,17,17,0,0,1,.57-1.85,20.78,20.78,0,0,1,1.28-2.83,16.84,16.84,0,0,1,5.85-6.34,11,11,0,0,1,1.58-.78,6.5,6.5,0,0,1,3.87-.37,4.63,4.63,0,0,1,1.37.55,4.86,4.86,0,0,1,1.47,1.35,5.61,5.61,0,0,1,.66,1.11A11.86,11.86,0,0,1,868.2,640.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M864.59,644c-3,5.32-7.72,8.36-11.31,7.49-3.29-2.43-3.41-8.82-.21-14.63,2.94-5.32,7.71-8.36,11.3-7.49C867.67,631.77,867.8,638.17,864.59,644Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M862.46,640.59a4.62,4.62,0,0,1-.19.6,6.69,6.69,0,0,1-.41.91,5.38,5.38,0,0,1-1.9,2.06,4,4,0,0,1-.51.25,1.91,1.91,0,0,1-1.69-.06.6.6,0,0,1-.13-.09,1.61,1.61,0,0,1-.35-.34,2.12,2.12,0,0,1-.21-.36h0a3.83,3.83,0,0,1-.11-2.51,4.62,4.62,0,0,1,.19-.6,6.81,6.81,0,0,1,.41-.92,5.48,5.48,0,0,1,1.89-2,2.76,2.76,0,0,1,.52-.25,2,2,0,0,1,1.25-.12,1.28,1.28,0,0,1,.44.18,1.63,1.63,0,0,1,.48.43,2.12,2.12,0,0,1,.21.36A3.89,3.89,0,0,1,862.46,640.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "881.64 660.54 854.5 644.58 854.5 617.47 893.34 635.77 899.64 645.6 881.64 660.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "992.01 613.68 980.47 607.38 989.63 602.39 993.59 608.22 992.01 613.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M986.91,610.86l-6-3.27h0l-.37-.19h0c-3.46-1.65-8.55,1.27-11.58,6.75-3.15,5.69-2.89,12,.57,14.06l.37.2,6.52,3.46Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-419",
    cx: 982.04,
    cy: 621.55,
    rx: 11.77,
    ry: 7.29,
    transform: "translate(-24.83 1202.01) rotate(-62.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M987.57,621.09a11.79,11.79,0,0,1-.36,1.21,15,15,0,0,1-.84,1.84,11.05,11.05,0,0,1-3.81,4.13,7,7,0,0,1-1,.5,3.82,3.82,0,0,1-3.42-.12,1.38,1.38,0,0,1-.25-.17,3.36,3.36,0,0,1-.71-.7,4.24,4.24,0,0,1-.42-.72h0a7.76,7.76,0,0,1-.22-5.06c.1-.39.23-.8.37-1.2a14.35,14.35,0,0,1,.84-1.84,11,11,0,0,1,3.81-4.13,6.15,6.15,0,0,1,1-.51,4.21,4.21,0,0,1,2.52-.24,3,3,0,0,1,.89.36,3.32,3.32,0,0,1,1,.87,4.38,4.38,0,0,1,.43.73A7.8,7.8,0,0,1,987.57,621.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M985.22,623.6c-1.92,3.47-5,5.45-7.36,4.88-2.15-1.58-2.23-5.74-.14-9.52,1.91-3.47,5-5.45,7.36-4.88C987.23,615.65,987.31,619.82,985.22,623.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M983.83,621.4a2.91,2.91,0,0,1-.12.39,3.47,3.47,0,0,1-.27.59,3.43,3.43,0,0,1-1.23,1.34,1.66,1.66,0,0,1-.33.16,1.23,1.23,0,0,1-1.11,0l-.08-.06a1,1,0,0,1-.23-.23,1.28,1.28,0,0,1-.14-.23h0a2.53,2.53,0,0,1-.07-1.63l.12-.4c.08-.19.17-.39.27-.59a3.6,3.6,0,0,1,1.24-1.34,2.49,2.49,0,0,1,.33-.16,1.36,1.36,0,0,1,.81-.08.74.74,0,0,1,.29.12,1,1,0,0,1,.31.28,1,1,0,0,1,.14.24A2.46,2.46,0,0,1,983.83,621.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M908,648.68l-9.29-5h0c-.19-.11-.37-.21-.56-.3h0c-5.32-2.54-13.13,1.94-17.79,10.37-4.83,8.73-4.44,18.39.88,21.57a4.63,4.63,0,0,0,.58.31l10,5.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-422",
    cx: 900.51,
    cy: 665.09,
    rx: 18.08,
    ry: 11.2,
    transform: "translate(-107 1153.13) rotate(-62.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M909,664.39a17,17,0,0,1-.57,1.85,19.12,19.12,0,0,1-1.29,2.82,16.72,16.72,0,0,1-5.85,6.35,10,10,0,0,1-1.58.77,5.88,5.88,0,0,1-5.24-.17,3.83,3.83,0,0,1-.39-.27,5,5,0,0,1-1.08-1.08,6.29,6.29,0,0,1-.66-1.1h0a12,12,0,0,1-.33-7.76c.15-.61.35-1.23.57-1.85a20.87,20.87,0,0,1,1.29-2.83,16.9,16.9,0,0,1,5.84-6.34,11.66,11.66,0,0,1,1.59-.78,6.5,6.5,0,0,1,3.87-.37,4.63,4.63,0,0,1,1.37.55,5.24,5.24,0,0,1,1.47,1.35,6.77,6.77,0,0,1,.66,1.11A12,12,0,0,1,909,664.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M905.39,668.25c-2.94,5.32-7.71,8.37-11.3,7.49-3.29-2.42-3.42-8.82-.21-14.63,2.94-5.32,7.7-8.36,11.3-7.49C908.47,656,908.61,662.44,905.39,668.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M903.26,664.86q-.07.3-.18.6a6.25,6.25,0,0,1-.42.92,5.48,5.48,0,0,1-1.89,2,4,4,0,0,1-.51.25,1.9,1.9,0,0,1-1.7-.06l-.13-.08a1.88,1.88,0,0,1-.34-.35,2.16,2.16,0,0,1-.22-.36h0a3.9,3.9,0,0,1-.1-2.51q.08-.3.18-.6a6.25,6.25,0,0,1,.42-.92,5.48,5.48,0,0,1,1.89-2,4,4,0,0,1,.51-.25,2.12,2.12,0,0,1,1.25-.12,1.46,1.46,0,0,1,.45.18,1.75,1.75,0,0,1,.47.43,2.16,2.16,0,0,1,.22.36A3.9,3.9,0,0,1,903.26,664.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M992,613.68a7,7,0,0,0-3.06-4.63c-4.2-2.51-10.69,1-14.51,8a19.15,19.15,0,0,0-2.55,11.43c-5.07,3.3-11.32,7.21-19,11.84l-8.22-23L939.58,603l-14.41-40.4s19.51-7.29,32.91-7.29c8.1,0,17.35,3.6,23.92,9.23,4.31,3.69,7.46,8.24,8.4,13.23,2.36,12.62,3.35,33.31,3.35,33.31h0C993.8,611.12,994,611.66,992,613.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M992,613.68a7,7,0,0,0-3.06-4.63c-4.2-2.51-10.69,1-14.51,8a20.91,20.91,0,0,0-2.61,8.26,13.87,13.87,0,0,0,.06,3.17c-5.07,3.3-11.32,7.21-19,11.84l-1.14-3.19-7.08-19.84L939.58,603,949,582.44l3.88,2.24,2.18,1.26a15,15,0,0,0,15,0l16.56-9.56s1.43-4.56-4.57-11.87c4.31,3.69,7.46,8.24,8.4,13.23,2.36,12.62,3.35,33.31,3.35,33.31h0C993.8,611.12,994,611.66,992,613.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M952.89,586.58v53.69l-22.8,13.17-10.88,6.28-3.47,2s0-1.62,0-3.47a16.88,16.88,0,0,0-2.26-8.39,7.87,7.87,0,0,0-6.83-3.94,7.79,7.79,0,0,0-3.93,1.06,5.62,5.62,0,0,1-5.61,0l-2.8-1.62-36.19-20.9a12.05,12.05,0,0,1-6-11.34c2.17-28.73,15.64-57.38,21.28-68.27a16.87,16.87,0,0,1,2.7-3.83,17.05,17.05,0,0,1,4-3.22l23.26-13.43a12.32,12.32,0,0,1,12.32,0l27.89,16.11a10,10,0,0,1,3.38,3.17,10.09,10.09,0,0,1,1.65,4.47l4,34.73A30.94,30.94,0,0,1,952.89,586.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M952.89,586.58v53.69l-22.8,13.17-10.88,6.28-3.47,2s0-1.62,0-3.47a16.88,16.88,0,0,0-2.26-8.39,7.87,7.87,0,0,0-6.83-3.94,7.79,7.79,0,0,0-3.93,1.06,5.62,5.62,0,0,1-5.61,0l-2.8-1.62-36.19-20.9a12.05,12.05,0,0,1-6-11.34c2.17-28.73,15.64-57.38,21.28-68.27a16.87,16.87,0,0,1,2.7-3.83L910.55,562a4.57,4.57,0,0,0,4.67,0L947,543.66a10.09,10.09,0,0,1,1.65,4.47l4,34.73c.08.61.13,1.22.16,1.82S952.89,586,952.89,586.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M916.81,659.58v-.33s0-1.61,0-3.41a16.1,16.1,0,0,0-.57-4.24,16.37,16.37,0,0,0-1.66-4,7.75,7.75,0,0,0-10.51-2.78,5.86,5.86,0,0,1-5.79,0l-2.91-1.66v-.11c1.2-12.23,6-53.84,17.16-76a9.81,9.81,0,0,1,4-4.15l30.44-17,4.72,42.46a3.67,3.67,0,0,1-1.14,3.06c-4.62,4.33-19.88,18.84-22,23.9a46.88,46.88,0,0,0-3,11.63l4.61,2.06a2.39,2.39,0,0,1,1.43,2.18v19.85l-.16.18ZM908,643.5a8.1,8.1,0,0,1,7,4,16.72,16.72,0,0,1,1.7,4,17.24,17.24,0,0,1,.59,4.33c0,1.33,0,2.54,0,3.1l14-8V631.2a2,2,0,0,0-1.22-1.85l-4.85-2.16v-.13a47.21,47.21,0,0,1,3.08-11.87h0c2.13-5.12,17.43-19.68,22.07-24a3.31,3.31,0,0,0,1-2.76l-4.66-41.92-30,16.78a9.37,9.37,0,0,0-3.82,4c-11.13,22-15.9,63.4-17.11,75.76l2.7,1.54a5.53,5.53,0,0,0,5.43,0A8.08,8.08,0,0,1,908,643.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M853.3,518.49v2.21a.93.93,0,0,1-.2.58l-7.72,10a.95.95,0,0,1-1.7-.58V523a1,1,0,0,1,.47-.82l7.73-4.46a.93.93,0,0,1,1.17.18A1,1,0,0,1,853.3,518.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M853.3,518.49v2.21a.93.93,0,0,1-.2.58l-7.72,10a1,1,0,0,1-.52.34.91.91,0,0,1-.24-.63v-7.78a1,1,0,0,1,.47-.83l7.73-4.46.23-.1A1,1,0,0,1,853.3,518.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M880,537.24a1.09,1.09,0,0,1-1.49.39l-27.16-15.86-.19-.11h0a.92.92,0,0,1-.15-.87,1.32,1.32,0,0,1,1.06-1,.59.59,0,0,1,.23,0l.1.06h0l27.23,15.9A1.09,1.09,0,0,1,880,537.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M876.09,546.48l33.28,19.06a1,1,0,0,1,.46,1.29c-1.88,4.67-11,27.82-14.33,44.28a1,1,0,0,1-1.54.7L858.3,591.39a1,1,0,0,1-.5-1.16c1.06-4.32,6.7-26.13,16.87-43.38A1,1,0,0,1,876.09,546.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M900,637.5s1.06-40.27,13.6-67.69a6,6,0,0,1,2.45-2.7l25.53-14.74a1.58,1.58,0,0,1,2.35,1.17l3.17,25.77a16.48,16.48,0,0,1-4.93,13.9l-14.65,14.1a27,27,0,0,0-8.28,19.45h0a9,9,0,0,1-4.49,7.77l-9.94,5.74A3.2,3.2,0,0,1,900,637.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-434",
    points: "836.13 519.83 840.94 522.61 850.56 517.06 845.75 514.28 836.13 519.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-435",
    points: "836.13 519.83 836.13 652.19 840.94 654.97 840.94 522.61 836.13 519.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-436",
    points: "840.94 522.61 840.94 654.97 850.56 649.41 850.56 517.06 840.94 522.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M873.68,630a1.1,1.1,0,0,1-.94.54,1.08,1.08,0,0,1-.55-.15L845,614.56l-.19-.11,0,0a.92.92,0,0,1-.15-.87,1.31,1.31,0,0,1,1.06-1,.59.59,0,0,1,.23,0l.1.06h0l27.23,15.9A1.09,1.09,0,0,1,873.68,630Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M873.68,594.5a1.09,1.09,0,0,1-.94.53,1,1,0,0,1-.55-.15L845,579l-.19-.1,0,0a.92.92,0,0,1-.15-.87,1.32,1.32,0,0,1,1.06-1,.59.59,0,0,1,.23,0l.1.06h0L873.29,593A1.1,1.1,0,0,1,873.68,594.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M965.92,558.62v.91c0,1.05-1.48,1.91-3.31,1.91a5.46,5.46,0,0,1-.82-.06,4.52,4.52,0,0,1-1.36-.41l-.1-.06h0a2.35,2.35,0,0,1-.77-.63,1.26,1.26,0,0,1-.26-.75v-.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-440",
    cx: 962.61,
    cy: 558.62,
    rx: 3.31,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-441",
    points: "862.86 536.11 867.67 538.89 877.29 533.34 872.48 530.56 862.86 536.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-442",
    points: "862.86 536.11 862.86 668.47 867.67 671.25 867.67 538.89 862.86 536.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "867.67 538.89 867.67 671.25 877.29 665.69 877.29 533.34 867.67 538.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M880,534.77V537a.93.93,0,0,1-.2.58l-7.72,10a.92.92,0,0,1-.52.34,1,1,0,0,1-1.18-.92v-7.78a1,1,0,0,1,.47-.82l7.73-4.46a1,1,0,0,1,1.18.18A1,1,0,0,1,880,534.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M880,534.77V537a.93.93,0,0,1-.2.58l-7.72,10a.42.42,0,1,1-.76-.3v-7.78a1,1,0,0,1,.47-.82l7.73-4.46.24-.1A1,1,0,0,1,880,534.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "853.78 554.48 858.82 557.39 858.82 657.26 853.78 654.48 853.15 554.87 853.78 554.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-447",
    points: "853.15 554.87 858.19 557.78 858.19 657.66 853.15 654.88 853.15 554.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-448",
    points: "836.13 633.97 834.79 634.71 836.13 636.29 836.13 652.19 863.65 668.82 866.33 671.99 867.67 671.25 867.67 652.18 836.13 633.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-449",
    points: "834.79 634.71 866.33 652.92 866.33 671.99 834.79 652.93 834.79 634.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-450",
    points: "835.32 635.02 834.79 635.33 834.79 653.61 800 674.23 800 674.91 802.42 676.31 840.07 656.12 840.16 637.81 835.32 635.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-451",
    points: "834.79 635.33 834.79 652.93 800 674.23 802.42 675.62 839.47 655.76 839.47 638.04 834.79 635.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-452",
    points: "861.49 650.13 860.96 650.44 860.96 668.73 826.17 689.34 826.17 690.02 828.59 691.42 866.24 671.23 866.33 652.92 861.49 650.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-453",
    points: "860.96 650.44 860.96 668.04 826.17 689.34 828.59 690.73 865.64 670.87 865.64 653.15 860.96 650.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M971.89,628.43c-5.07,3.3-11.32,7.21-19,11.84l-22.8,13.17-10.88,6.28-3.47,2s0-1.62,0-3.47l36-21.18,1.14-.67,18.94-11.15A13.87,13.87,0,0,0,971.89,628.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-455",
    points: "821.59 298.92 821.59 196.65 804 186.46 804 288.57 821.59 298.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-456",
    points: "817.81 299.55 817.81 197.28 800.23 187.08 800.23 289.19 817.81 299.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-457",
    points: "736.63 481.33 736.63 379.06 754.21 368.87 754.21 470.98 736.63 481.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-458",
    points: "740.4 481.96 740.4 379.69 757.98 369.49 757.98 471.6 740.4 481.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M914.68,363.88V388c0,25-15.85,48.49-43.46,64.45L639.5,586.23a41.53,41.53,0,0,0-6.36,4.44,26.34,26.34,0,0,0-2.9,2.88c-1.72,2.06-2.55,3.91-2.55,5.28,0,2.87,3.65,7.89,11.81,12.6l108.3,30.15,6.59,1.83v21.9a17.2,17.2,0,0,1-8.59,14.89l-30.56,17.73a16.94,16.94,0,0,1-6.62,2.2A17.31,17.31,0,0,1,698.14,698l-7.9-4.47-73.62-42.5c-22-12.74-34.69-31.78-34.69-52.24v-27.2l2.64,11.31c4.77-14.22,15.86-27,32-36.34l231.7-133.78c12.89-7.45,20.6-16.72,20.6-24.82a15.07,15.07,0,0,0-1-5.28,19.65,19.65,0,0,0-1.35-2.89c-3.18-5.78-9.53-11.63-18.23-16.65L712.24,284.6l-8.93-5.14a19.12,19.12,0,0,1-9.56-16.57V242.11c1.23.08,64.25,16.05,64.25,16.05l113.22,65.38c23.43,13.54,38,10.85,42,31.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "M914.68,363.88v13.58c0,25-15.85,48.49-43.46,64.45L639.5,575.69c-5.86,3.39-9.38,6.91-10.89,9.7a6,6,0,0,0-.92,2.9c0,1.36.83,3.19,2.55,5.26-1.72,2.06-2.55,3.91-2.55,5.28,0,2.87,3.65,7.89,11.81,12.6l108.3,30.15,6.59,1.83v11.36a17.21,17.21,0,0,1-8.59,14.89l-30.56,17.73a16.93,16.93,0,0,1-6.62,2.19,17.17,17.17,0,0,1-10.48-2.09l-7.9-4.47-73.62-42.5c-22-12.73-34.69-31.77-34.69-52.23v-27.2l2.64,11.31c4.77-14.22,15.86-27,32-36.34l231.7-133.79c10.16-5.87,17.1-12.87,19.58-19.55a15,15,0,0,0,1-5.26,13.78,13.78,0,0,0-.32-2.9c-1.57-7.37-8.9-15.36-20.28-21.92L712.24,274.06l-8.93-5.14a19.14,19.14,0,0,1-9.56-16.57V242.11c1.23.08,64.25,16.05,64.25,16.05l113.22,65.38c23.43,13.54,38,10.85,42,31.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "M914.68,363.88v7.78c0,25-15.85,48.49-43.46,64.45L639.5,569.89c-8.16,4.72-11.81,9.72-11.81,12.61a6,6,0,0,0,.92,2.89,19.82,19.82,0,0,0,4.53,5.28,26.34,26.34,0,0,0-2.9,2.88c-1.72,2.06-2.55,3.91-2.55,5.28,0,2.87,3.65,7.89,11.81,12.6l108.3,30.15,6.59,1.83V649a17.2,17.2,0,0,1-8.59,14.88l-30.56,17.73a16.78,16.78,0,0,1-6.62,2.2,17.31,17.31,0,0,1-10.48-2.09l-7.9-4.47-73.62-42.5c-22-12.74-34.69-31.78-34.69-52.23V555.3l2.64,11.3c4.77-14.22,15.86-27,32-36.34l231.7-133.78c8.7-5,15-10.88,18.23-16.65a18.7,18.7,0,0,0,2.05-5.27,13.92,13.92,0,0,0,.32-2.9c0-8.1-7.71-17.39-20.6-24.82L712.24,268.26l-8.93-5.14a19.12,19.12,0,0,1-9.56-16.57v-4.44c1.23.08,64.25,16.05,64.25,16.05l113.22,65.38c23.43,13.54,38,10.85,42,31.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M754.39,643.41v21.9a17.2,17.2,0,0,1-8.59,14.89l-30.56,17.73a16.94,16.94,0,0,1-6.62,2.2V670l39.18-28.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M914.68,362V346.49L913.25,342c-4-20.72-18.59-30.7-42-44.23L758,232.4,725.87,251l-23.73-13.7a5.6,5.6,0,0,0-8.39,4.85,10.48,10.48,0,0,0,5.25,9.08l13.24,7.65,136.09,78.57c12.89,7.43,20.59,16.72,20.59,24.82s-7.7,17.38-20.59,24.82L616.62,520.84c-16.19,9.35-27.28,22.11-32,36.33l-2.64-.46v16.36c0,20.46,12.65,39.49,34.69,52.23l73.62,42.5,11,6.32a5,5,0,0,0,7.44-4.12,12.41,12.41,0,0,0-4.85-10L736,641.38,639.5,585.67c-8.16-4.71-11.8-9.73-11.8-12.6s3.64-7.89,11.8-12.6L871.23,426.68c27.61-15.95,43.46-39.44,43.46-64.45C914.69,362.17,914.68,362.1,914.68,362Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M914.68,346.49c0,25-15.85,48.49-43.46,64.45L639.5,544.72c-8.16,4.72-11.81,9.72-11.81,12.6s3.65,7.89,11.81,12.61l89.7,51.79h0l6.78,3.92,12.19,7a12.39,12.39,0,0,1,6.21,10.74,5,5,0,0,1-.29,1.66,4.87,4.87,0,0,1-1.84,2.38l-.83.49L747.84,650l-34,19.65-7.69,4.46a4.93,4.93,0,0,0,2.48-4.29,12.39,12.39,0,0,0-6.21-10.74l-12.19-7-73.62-42.5c-22-12.74-34.69-31.78-34.69-52.24s12.65-39.49,34.69-52.23l231.7-133.78c12.89-7.45,20.6-16.72,20.6-24.82s-7.71-17.39-20.6-24.82L732.81,255l-30.67-17.71a5.56,5.56,0,0,0-2.79-.76,5.35,5.35,0,0,0-2.55.63L705,232.4l34-19.64,3.32-1.92a.11.11,0,0,0,.08,0l.09-.06h0a5.48,5.48,0,0,1,5.44.08l10.1,5.82L871.22,282C898.83,298,914.68,321.47,914.68,346.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M908.58,346.49c0,.33,0,.67,0,1-.43,22.4-15.11,43.54-40.4,58.17L636.45,539.45c-9.44,5.44-14.86,12-14.86,17.87,0,.34,0,.68,0,1,.61,5.58,6,11.81,14.81,16.87l91.12,52.62h0l5.36,3.09L745.13,638a6.34,6.34,0,0,1,3.12,4.78,15.43,15.43,0,0,1,.23,3.86,13.82,13.82,0,0,1-.64,3.41L714,669.55l-.19.11c.08-.5.14-1,.17-1.45a13.71,13.71,0,0,0-.64-5.32,18.59,18.59,0,0,0-7.9-9.09l-85.81-49.52c-19.74-11.41-31.21-28.12-31.62-45.95,0-.33,0-.67,0-1,0-18.21,11.53-35.33,31.64-47L851.38,376.59c14.52-8.38,23.06-18.92,23.61-29.06v-.07c0-.32,0-.65,0-1,0-10.47-8.62-21.45-23.64-30.12L705,232.4,737,213.86l1.91-1.1,129.22,74.55C893.84,302.14,908.58,323.71,908.58,346.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M908.57,347.49c-.43,22.4-15.11,43.54-40.4,58.17L636.45,539.45c-9.44,5.44-14.86,12-14.86,17.87,0,.34,0,.68,0,1s0,.67,0,1c0,5.83,5.55,12.51,14.86,17.88l91.12,52.61h0l5.36,3.1L745.13,640a6.33,6.33,0,0,1,3.12,4.77,16.09,16.09,0,0,1,.23,1.85,13.82,13.82,0,0,1-.64,3.41L714,669.55c0-.47,0-.93,0-1.34a13.71,13.71,0,0,0-.64-5.32,18.59,18.59,0,0,0-7.9-9.09l-85.81-49.52c-19.74-11.41-31.21-28.12-31.62-45.95.41-17.83,11.88-34.54,31.62-46L851.38,378.6C866.4,369.93,875,359,875,348.5c0-.32,0-.65,0-1v-.07c0-.32,0-.65,0-1,0-10.47-8.62-21.45-23.64-30.12L705,232.4,737,213.86l131.13,75.47C893.46,303.94,908.14,325.09,908.57,347.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-467",
    points: "764.32 395.1 764.32 432.35 767.69 434.19 767.69 397.05 764.32 395.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-468",
    points: "767.69 434.19 769.81 432.88 769.81 398.28 767.69 397.05 767.69 434.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M705.59,666.52c-.68-2.62-2.87-4.76-4.91-4.79a2.54,2.54,0,0,0-1.36.37h0l-1.25.73-.31,1.51a6.72,6.72,0,0,0-.13,1.94,11.61,11.61,0,0,0,1.33,2.78l1.14.69a5.08,5.08,0,0,0,2.29,1.38l.79.48,1.2-.69h0C705.57,670.24,706.1,668.53,705.59,666.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-470",
    cx: 700.53,
    cy: 667.28,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-235.47 422.51) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "M686.83,655.62c-.67-2.62-2.87-4.76-4.9-4.78a2.35,2.35,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.39,6.39,0,0,0-.13,1.94,11.11,11.11,0,0,0,1.32,2.78l1.15.69a5,5,0,0,0,2.29,1.38l.79.48,1.19-.69h0C686.82,659.35,687.35,657.64,686.83,655.62Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-472",
    cx: 681.78,
    cy: 656.38,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-232.54 412.07) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-473",
    d: "M668.08,644.73c-.68-2.62-2.87-4.77-4.91-4.79a2.54,2.54,0,0,0-1.36.37h0l-1.25.73-.31,1.51a6.67,6.67,0,0,0-.13,1.93,11.41,11.41,0,0,0,1.33,2.78l1.14.7a5.17,5.17,0,0,0,2.29,1.38l.79.47,1.2-.68h0C668.06,648.45,668.6,646.74,668.08,644.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-474",
    cx: 663.02,
    cy: 645.49,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-229.61 401.63) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M649.32,633.83c-.67-2.62-2.87-4.76-4.9-4.78a2.35,2.35,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.35,6.35,0,0,0-.13,1.94,11.3,11.3,0,0,0,1.32,2.78l1.15.69a5,5,0,0,0,2.29,1.38l.79.48,1.19-.69h0C649.31,637.55,649.84,635.85,649.32,633.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-476",
    cx: 644.27,
    cy: 634.59,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-226.67 391.19) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-477",
    d: "M630.57,622.94c-.68-2.62-2.87-4.77-4.91-4.79a2.45,2.45,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.76,6.76,0,0,0-.13,1.94,11.41,11.41,0,0,0,1.33,2.78l1.14.69a5,5,0,0,0,2.29,1.38l.79.48,1.2-.69h0C630.56,626.66,631.09,625,630.57,622.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-478",
    cx: 625.51,
    cy: 623.7,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-223.74 380.75) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "M611.81,612c-.67-2.62-2.87-4.76-4.9-4.79a2.51,2.51,0,0,0-1.36.37h0l-1.25.73-.31,1.51a6.35,6.35,0,0,0-.13,1.94,11.3,11.3,0,0,0,1.32,2.78l1.15.69a5,5,0,0,0,2.29,1.38l.79.48,1.19-.69h0C611.8,615.76,612.33,614.05,611.81,612Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-480",
    cx: 606.76,
    cy: 612.8,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-220.81 370.31) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M597.85,598.87c-.19-2.7-1.58-5.16-3.1-5.5a1.42,1.42,0,0,0-1.06.15h0l-1,.52-.41,1.44a8.41,8.41,0,0,0-.33,1.89,13.92,13.92,0,0,0,.66,3l.78.86a4.25,4.25,0,0,0,1.55,1.72l.53.6,1-.49h0C597.4,602.54,598,600.94,597.85,598.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-482",
    cx: 593.97,
    cy: 598.82,
    rx: 2.65,
    ry: 4.99,
    transform: "translate(-105.38 127.34) rotate(-11.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M637.85,551c.68-2.62,2.87-4.77,4.91-4.79a2.56,2.56,0,0,1,1.36.37h0l1.25.73.31,1.51a6.67,6.67,0,0,1,.13,1.93,11.41,11.41,0,0,1-1.33,2.78l-1.14.7a5.17,5.17,0,0,1-2.29,1.38l-.79.47-1.2-.68h0C637.86,554.68,637.33,553,637.85,551Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-484",
    cx: 642.91,
    cy: 551.72,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-151.08 847.2) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M656.61,540.06c.67-2.62,2.87-4.76,4.9-4.78a2.35,2.35,0,0,1,1.36.37h0l1.25.73.31,1.5a6.35,6.35,0,0,1,.13,1.94,11.3,11.3,0,0,1-1.32,2.78l-1.15.69a5,5,0,0,1-2.29,1.38l-.79.48-1.2-.69h0C656.62,543.78,656.09,542.08,656.61,540.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-486",
    cx: 661.66,
    cy: 540.82,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-131.87 857.99) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M680.07,526.59c.68-2.62,2.87-4.77,4.91-4.79a2.54,2.54,0,0,1,1.36.37h0l1.25.73.31,1.5a6.76,6.76,0,0,1,.13,1.94,11.41,11.41,0,0,1-1.33,2.78l-1.14.7a5.17,5.17,0,0,1-2.29,1.38l-.79.47-1.2-.69h0C680.09,530.31,679.56,528.6,680.07,526.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-488",
    cx: 685.13,
    cy: 527.35,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-107.97 871.57) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M698.83,515.69c.67-2.62,2.87-4.76,4.9-4.78a2.35,2.35,0,0,1,1.36.37h0l1.26.73.3,1.5a6.35,6.35,0,0,1,.13,1.94,11.3,11.3,0,0,1-1.32,2.78l-1.15.69A5,5,0,0,1,702,520.3l-.79.48-1.19-.69h0C698.84,519.41,698.31,517.71,698.83,515.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-490",
    cx: 703.88,
    cy: 516.45,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-88.76 882.36) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "M722.3,502.22c.67-2.62,2.87-4.77,4.9-4.79a2.51,2.51,0,0,1,1.36.37h0l1.25.73.31,1.5a6.39,6.39,0,0,1,.13,1.94,11,11,0,0,1-1.33,2.78l-1.14.69a5.11,5.11,0,0,1-2.29,1.39l-.79.47-1.2-.69h0C722.31,505.94,721.78,504.23,722.3,502.22Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-492",
    cx: 727.35,
    cy: 502.98,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-64.86 895.94) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M741.05,491.32c.68-2.62,2.87-4.76,4.91-4.78a2.34,2.34,0,0,1,1.35.37h0l1.26.73.31,1.5a6.72,6.72,0,0,1,.13,1.94,11.61,11.61,0,0,1-1.33,2.78l-1.15.69a5,5,0,0,1-2.28,1.38l-.8.48-1.19-.69h0C741.06,495,740.53,493.34,741.05,491.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-494",
    cx: 746.11,
    cy: 492.08,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-45.65 906.73) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "M764.52,477.85c.67-2.62,2.87-4.77,4.9-4.79a2.51,2.51,0,0,1,1.36.37h0l1.26.73.3,1.5a6.39,6.39,0,0,1,.13,1.94,11.11,11.11,0,0,1-1.32,2.78l-1.15.69a5.05,5.05,0,0,1-2.29,1.39l-.79.47-1.19-.69h0C764.53,481.57,764,479.86,764.52,477.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-496",
    cx: 769.57,
    cy: 478.61,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-21.75 920.32) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M783.27,467c.68-2.62,2.87-4.76,4.91-4.78a2.37,2.37,0,0,1,1.36.37h0l1.25.73.31,1.5a6.72,6.72,0,0,1,.13,1.94,11.61,11.61,0,0,1-1.33,2.78l-1.14.69a5.08,5.08,0,0,1-2.29,1.38l-.79.48-1.2-.69h0C783.29,470.67,782.76,469,783.27,467Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-498",
    cx: 788.33,
    cy: 467.71,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(-2.54 931.11) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "M806.74,453.48c.68-2.62,2.87-4.77,4.91-4.79a2.5,2.5,0,0,1,1.35.37h0l1.26.73.31,1.5a6.76,6.76,0,0,1,.13,1.94,11.41,11.41,0,0,1-1.33,2.78l-1.15.69a5,5,0,0,1-2.28,1.39l-.8.47-1.19-.69h0C806.75,457.2,806.22,455.49,806.74,453.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-500",
    cx: 811.8,
    cy: 454.24,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(21.35 944.69) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M825.5,442.58c.67-2.62,2.87-4.76,4.9-4.78a2.35,2.35,0,0,1,1.36.37h0l1.25.72.31,1.51a6.35,6.35,0,0,1,.13,1.94,11.23,11.23,0,0,1-1.33,2.78l-1.14.69a5.08,5.08,0,0,1-2.29,1.38l-.79.48-1.2-.69h0C825.51,446.3,825,444.59,825.5,442.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-502",
    cx: 830.55,
    cy: 443.34,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(40.56 955.48) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-503",
    d: "M849,429.11c.68-2.62,2.87-4.77,4.91-4.79a2.54,2.54,0,0,1,1.36.37h0l1.25.73.31,1.5a6.76,6.76,0,0,1,.13,1.94,11.41,11.41,0,0,1-1.33,2.78l-1.14.69a5.11,5.11,0,0,1-2.29,1.39l-.79.47-1.2-.69h0C849,432.83,848.44,431.12,849,429.11Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-504",
    cx: 854.02,
    cy: 429.87,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(64.46 969.06) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "M867.72,418.21c.67-2.62,2.87-4.76,4.9-4.78a2.35,2.35,0,0,1,1.36.37h0l1.25.72.31,1.51a6.35,6.35,0,0,1,.13,1.94,11.3,11.3,0,0,1-1.32,2.78l-1.15.69a5,5,0,0,1-2.29,1.38l-.79.48-1.19-.69h0C867.73,421.93,867.2,420.22,867.72,418.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-506",
    cx: 872.77,
    cy: 418.97,
    rx: 5.08,
    ry: 3.43,
    transform: "translate(83.67 979.85) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-507",
    d: "M888.62,404.26c.2-2.7,1.59-5.16,3.11-5.5a1.43,1.43,0,0,1,1.06.15h0l1,.52.41,1.44a8.41,8.41,0,0,1,.33,1.89,14.42,14.42,0,0,1-.67,3l-.77.86a4.32,4.32,0,0,1-1.55,1.72l-.54.6-1-.49h0C889.08,407.93,888.48,406.33,888.62,404.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-508",
    cx: 892.5,
    cy: 404.21,
    rx: 4.99,
    ry: 2.65,
    transform: "translate(322 1200.75) rotate(-78.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-509",
    d: "M856.21,331.43c-.68-2.62-2.87-4.76-4.91-4.78a2.37,2.37,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.72,6.72,0,0,0-.13,1.94,11.61,11.61,0,0,0,1.33,2.78l1.14.69A5.08,5.08,0,0,0,853,336l.79.48,1.2-.69h0C856.2,335.15,856.73,333.45,856.21,331.43Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-510",
    cx: 851.15,
    cy: 332.19,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-54.43 453.54) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "M837.45,320.54c-.67-2.62-2.87-4.77-4.9-4.79a2.43,2.43,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.39,6.39,0,0,0-.13,1.94,11.11,11.11,0,0,0,1.32,2.78l1.15.69a4.94,4.94,0,0,0,2.29,1.38l.79.48,1.19-.69h0C837.44,324.26,838,322.55,837.45,320.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-512",
    cx: 832.4,
    cy: 321.3,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-51.5 443.1) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-513",
    d: "M814.61,307.48c-.68-2.62-2.87-4.77-4.91-4.79a2.45,2.45,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.76,6.76,0,0,0-.13,1.94A11.41,11.41,0,0,0,808,310l1.14.69a5,5,0,0,0,2.29,1.38l.79.48,1.2-.69h0C814.59,311.2,815.12,309.49,814.61,307.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-514",
    cx: 809.55,
    cy: 308.23,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-48.04 430.41) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "M795.85,296.58c-.67-2.62-2.87-4.76-4.9-4.79a2.51,2.51,0,0,0-1.36.37h0l-1.26.73-.3,1.51a6.35,6.35,0,0,0-.13,1.94,11.3,11.3,0,0,0,1.32,2.78l1.15.69a5,5,0,0,0,2.29,1.38l.79.48,1.19-.69h0C795.84,300.3,796.37,298.59,795.85,296.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-516",
    cx: 790.8,
    cy: 297.34,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-45.11 419.97) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "M776,284.74c-.68-2.62-2.87-4.76-4.91-4.79a2.54,2.54,0,0,0-1.36.37h0l-1.25.73-.31,1.51a6.72,6.72,0,0,0-.13,1.94,11.61,11.61,0,0,0,1.33,2.78l1.14.69a5.08,5.08,0,0,0,2.29,1.38l.79.48,1.2-.69h0C776,288.46,776.52,286.75,776,284.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-518",
    cx: 770.94,
    cy: 285.5,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-41.85 408.88) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "M757.24,273.84c-.67-2.62-2.87-4.76-4.9-4.78a2.35,2.35,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.39,6.39,0,0,0-.13,1.94,11.11,11.11,0,0,0,1.32,2.78l1.15.69a5,5,0,0,0,2.29,1.38l.79.48,1.19-.69h0C757.23,277.57,757.76,275.86,757.24,273.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-520",
    cx: 752.19,
    cy: 274.6,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-38.92 398.44) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-521",
    d: "M737.74,262.26c-.67-2.62-2.87-4.76-4.9-4.78a2.35,2.35,0,0,0-1.36.37h0l-1.25.73-.31,1.5a6.39,6.39,0,0,0-.13,1.94,11,11,0,0,0,1.33,2.78l1.14.69a5.08,5.08,0,0,0,2.29,1.38l.79.48,1.2-.69h0C737.73,266,738.26,264.28,737.74,262.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-522",
    cx: 732.69,
    cy: 263.02,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-35.76 387.55) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-523",
    d: "M719.94,252.37c-.67-2.62-2.87-4.76-4.9-4.78a2.35,2.35,0,0,0-1.36.37h0l-1.26.73-.3,1.5a6.35,6.35,0,0,0-.13,1.94,11.3,11.3,0,0,0,1.32,2.78l1.15.69a5.05,5.05,0,0,0,2.28,1.38l.8.48,1.19-.69h0C719.93,256.09,720.46,254.39,719.94,252.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-524",
    cx: 714.89,
    cy: 253.13,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-33.19 377.7) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "M704.54,243.3c-.67-2.62-2.87-4.77-4.9-4.79a2.43,2.43,0,0,0-1.36.37h0l-1.26.73-.3,1.5a6.39,6.39,0,0,0-.13,1.94,11.11,11.11,0,0,0,1.32,2.78l1.15.69a5,5,0,0,0,2.28,1.38l.8.48,1.19-.69h0C704.53,247,705.06,245.31,704.54,243.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-526",
    cx: 699.49,
    cy: 244.05,
    rx: 3.43,
    ry: 5.08,
    transform: "translate(-30.72 369.11) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-527",
    points: "737.94 228.69 754.28 219.42 737.8 210.07 721.61 219.42 737.94 228.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "737.94 228.69 737.94 246.41 721.61 237.15 721.61 219.42 727.67 222.87 731.41 224.99 737.94 228.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-529",
    points: "754.28 219.42 754.28 225.04 754.28 231.52 754.28 237.14 737.94 246.41 737.94 240.79 737.94 234.31 737.94 228.69 754.28 219.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "731.41 224.99 731.41 238.73 727.67 236.56 727.67 222.87 731.41 224.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-531",
    points: "727.67 222.87 743.76 213.45 747.29 215.45 731.41 224.99 727.67 222.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-532",
    points: "739.67 231.55 739.67 229.25 744.36 226.49 744.36 228.69 739.67 231.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "820.42 273.57 836.76 264.3 820.28 254.95 804.09 264.3 820.42 273.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-534",
    points: "820.42 273.57 820.42 291.29 804.09 282.02 804.09 264.3 810.15 267.74 813.89 269.87 820.42 273.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-535",
    points: "836.76 264.3 836.76 269.92 836.76 276.4 836.76 282.02 820.42 291.29 820.42 285.67 820.42 279.19 820.42 273.57 836.76 264.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-536",
    points: "813.89 269.87 813.89 283.61 810.15 281.44 810.15 267.74 813.89 269.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-537",
    points: "810.15 267.74 826.25 258.33 829.77 260.33 813.89 269.87 810.15 267.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-538",
    points: "822.15 276.43 822.15 274.12 826.85 271.37 826.85 273.57 822.15 276.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-539",
    points: "859.39 297.79 875.73 288.52 859.25 279.17 843.06 288.52 859.39 297.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-540",
    points: "859.39 297.79 859.39 315.51 843.06 306.24 843.06 288.52 849.12 291.96 852.86 294.09 859.39 297.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-541",
    points: "875.73 288.52 875.73 294.14 875.73 300.62 875.73 306.24 859.39 315.51 859.39 309.89 859.39 303.41 859.39 297.79 875.73 288.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-542",
    points: "852.86 294.09 852.86 307.83 849.12 305.65 849.12 291.96 852.86 294.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "849.12 291.96 865.22 282.55 868.74 284.55 852.86 294.09 849.12 291.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-544",
    points: "861.12 300.65 861.12 298.34 865.81 295.59 865.81 297.79 861.12 300.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-545",
    points: "869.88 378.68 886.21 369.42 869.74 360.06 853.54 369.42 869.88 378.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-546",
    points: "869.88 378.69 869.88 396.41 853.54 387.14 853.54 369.42 859.61 372.86 863.35 374.99 869.88 378.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-547",
    points: "886.21 369.42 886.21 375.04 886.21 381.52 886.21 387.14 869.88 396.41 869.88 390.79 869.88 384.31 869.88 378.68 886.21 369.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-548",
    points: "863.35 374.99 863.35 388.73 859.61 386.55 859.61 372.86 863.35 374.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-549",
    points: "859.61 372.86 875.7 363.45 879.23 365.45 863.35 374.99 859.61 372.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-550",
    points: "871.6 381.55 871.6 379.24 876.3 376.49 876.3 378.68 871.6 381.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-551",
    points: "814.73 413.87 831.06 404.6 814.58 395.25 798.39 404.6 814.73 413.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-552",
    points: "814.72 413.87 814.72 431.6 798.39 422.33 798.39 404.61 804.46 408.05 808.19 410.17 814.72 413.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-553",
    points: "831.06 404.6 831.06 410.22 831.06 416.7 831.06 422.33 814.73 431.6 814.73 425.98 814.73 419.49 814.73 413.87 831.06 404.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-554",
    points: "808.19 410.17 808.19 423.92 804.46 421.74 804.46 408.05 808.19 410.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-555",
    points: "804.46 408.05 820.55 398.64 824.07 400.64 808.19 410.17 804.46 408.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-556",
    points: "816.45 416.74 816.45 414.43 821.15 411.68 821.15 413.87 816.45 416.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-557",
    points: "754.33 448.12 770.66 438.85 754.18 429.5 737.99 438.85 754.33 448.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-558",
    points: "754.32 448.12 754.32 465.84 737.99 456.57 737.99 438.85 744.06 442.29 747.79 444.42 754.32 448.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-559",
    points: "770.66 438.85 770.66 444.47 770.66 450.95 770.66 456.57 754.33 465.84 754.33 460.22 754.33 453.74 754.33 448.12 770.66 438.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-560",
    points: "747.79 444.42 747.79 458.16 744.06 455.99 744.06 442.29 747.79 444.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-561",
    points: "744.06 442.29 760.15 432.88 763.67 434.88 747.79 444.42 744.06 442.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-562",
    points: "756.05 450.98 756.05 448.67 760.75 445.92 760.75 448.12 756.05 450.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-563",
    points: "693.92 482.36 710.26 473.09 693.78 463.74 677.59 473.09 693.92 482.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-564",
    points: "693.92 482.36 693.92 500.08 677.59 490.82 677.59 473.09 683.65 476.54 687.39 478.66 693.92 482.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-565",
    points: "710.26 473.09 710.26 478.71 710.26 485.19 710.26 490.81 693.92 500.08 693.92 494.46 693.92 487.98 693.92 482.36 710.26 473.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-566",
    points: "687.39 478.66 687.39 492.4 683.65 490.23 683.65 476.54 687.39 478.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-567",
    points: "683.65 476.54 699.75 467.12 703.27 469.12 687.39 478.66 683.65 476.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-568",
    points: "695.65 485.22 695.65 482.92 700.35 480.16 700.35 482.36 695.65 485.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-569",
    points: "633.52 516.6 649.86 507.33 633.38 497.98 617.19 507.33 633.52 516.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-570",
    points: "633.52 516.6 633.52 534.33 617.19 525.06 617.19 507.33 623.25 510.78 626.99 512.9 633.52 516.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-571",
    points: "649.86 507.33 649.86 512.95 649.86 519.43 649.86 525.06 633.52 534.33 633.52 528.7 633.52 522.22 633.52 516.6 649.86 507.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-572",
    points: "626.99 512.9 626.99 526.65 623.25 524.47 623.25 510.78 626.99 512.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-573",
    points: "623.25 510.78 639.35 501.37 642.87 503.37 626.99 512.9 623.25 510.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-574",
    points: "635.25 519.47 635.25 517.16 639.95 514.41 639.95 516.6 635.25 519.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-575",
    points: "631.41 587.81 647.75 578.54 631.27 569.19 615.08 578.54 631.41 587.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-576",
    points: "631.41 587.81 631.41 605.53 615.08 596.27 615.08 578.54 621.14 581.99 624.88 584.11 631.41 587.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-577",
    points: "647.75 578.54 647.75 584.16 647.75 590.64 647.75 596.26 631.41 605.53 631.41 599.91 631.41 593.43 631.41 587.81 647.75 578.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-578",
    points: "624.88 584.11 624.88 597.85 621.14 595.68 621.14 581.99 624.88 584.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-579",
    points: "621.14 581.99 637.24 572.57 640.76 574.57 624.88 584.11 621.14 581.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-580",
    points: "633.14 590.67 633.14 588.37 637.84 585.61 637.84 587.81 633.14 590.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-581",
    points: "703.88 629.49 720.22 620.22 703.74 610.87 687.55 620.22 703.88 629.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-582",
    points: "703.88 629.5 703.88 647.22 687.55 637.95 687.55 620.23 693.61 623.67 697.35 625.79 703.88 629.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-583",
    points: "720.22 620.22 720.22 625.85 720.22 632.33 720.22 637.95 703.88 647.22 703.88 641.6 703.88 635.11 703.88 629.49 720.22 620.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-584",
    points: "697.35 625.79 697.35 639.54 693.61 637.36 693.61 623.67 697.35 625.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-585",
    points: "693.61 623.67 709.71 614.26 713.23 616.26 697.35 625.79 693.61 623.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-586",
    points: "705.61 632.36 705.61 630.05 710.3 627.3 710.3 629.49 705.61 632.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-587",
    points: "800.2 391.36 800.2 497.62 782.62 507.82 782.62 401.55 736.63 375 754.21 364.8 800.2 391.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-588",
    points: "782.62 507.82 782.62 401.55 736.63 375 736.63 379.06 779 403.6 779 505.73 782.62 507.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-589",
    points: "800.2 391.36 800.2 497.62 782.62 507.82 782.62 401.55 800.2 391.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-590",
    d: "M786.4,487.71c.48-1.89,2.07-3.44,3.54-3.45a1.77,1.77,0,0,1,1,.26h0l.9.53.22,1.09a4.71,4.71,0,0,1,.1,1.4,8.07,8.07,0,0,1-1,2l-.82.5a3.73,3.73,0,0,1-1.66,1l-.57.34-.86-.5h0C786.41,490.4,786,489.16,786.4,487.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-591",
    cx: 790.05,
    cy: 488.26,
    rx: 3.67,
    ry: 2.48,
    transform: "translate(-19.64 943.21) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-592",
    d: "M799.47,508.38c-1.89.51-4-.11-4.75-1.37a1.74,1.74,0,0,1-.25-1h0v-1l.84-.72a4.62,4.62,0,0,1,1.17-.78,8.29,8.29,0,0,1,2.21-.15l.85.47a3.65,3.65,0,0,1,1.68.95l.58.32v1h0C801.8,507.05,800.92,508,799.47,508.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-593",
    cx: 798.15,
    cy: 504.94,
    rx: 3.67,
    ry: 2.48,
    transform: "translate(-5.1 8.16) rotate(-0.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-594",
    d: "M788.94,488.27a1.82,1.82,0,0,1,1.47-1.44.74.74,0,0,1,.34.07l.06,0,5.3,3.06a7.17,7.17,0,0,1,3.56,6.18v8.7a.82.82,0,0,1-.08.4,1.41,1.41,0,0,1-.88.63,1.84,1.84,0,0,1-2-.58s0,0,0-.05a.6.6,0,0,1-.08-.31h0v-2.47h0a1.23,1.23,0,0,1,0-.19v-6.11a4.1,4.1,0,0,0-2-3.53l-5.24-3-.06,0-.07-.05A1.2,1.2,0,0,1,788.94,488.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-595",
    points: "793.89 212.69 793.89 249.94 790.53 251.78 790.53 214.64 793.89 212.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-596",
    points: "790.53 251.78 788.4 250.47 788.4 215.87 790.53 214.64 790.53 251.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-597",
    points: "758.01 208.95 758.01 315.21 775.6 325.41 775.6 219.14 821.59 192.59 804.01 182.39 758.01 208.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-598",
    points: "775.6 325.41 775.6 219.14 821.59 192.59 821.59 196.65 779.21 221.19 779.21 323.32 775.6 325.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-599",
    d: "M771.82,305.3c-.49-1.89-2.08-3.44-3.54-3.45a1.73,1.73,0,0,0-1,.26h0l-.91.53-.22,1.09a4.71,4.71,0,0,0-.1,1.4,8.45,8.45,0,0,0,1,2l.83.5a3.7,3.7,0,0,0,1.65,1l.57.34.86-.49h0C771.81,308,772.19,306.75,771.82,305.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-600",
    cx: 768.17,
    cy: 305.85,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-52.05 410.08) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-601",
    d: "M758.74,326c1.89.51,4-.1,4.75-1.37a1.74,1.74,0,0,0,.25-1h0v-1.05l-.83-.72a4.85,4.85,0,0,0-1.17-.78,8.38,8.38,0,0,0-2.22-.15l-.84.47a3.6,3.6,0,0,0-1.68.95l-.59.32v1h0C756.41,324.64,757.29,325.58,758.74,326Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-602",
    cx: 760.06,
    cy: 322.53,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(429.81 1079.27) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-603",
    d: "M769.27,305.86a1.82,1.82,0,0,0-1.47-1.44.77.77,0,0,0-.34.07l-.06,0-5.29,3.06a7.16,7.16,0,0,0-3.57,6.18v6.11a.19.19,0,0,0,0,.08s0,0,0,0v2.45s0,0,0,0a.64.64,0,0,0,.08.4,1.38,1.38,0,0,0,.88.63,1.83,1.83,0,0,0,2-.58.13.13,0,0,0,0-.05.68.68,0,0,0,.08-.31h0v-2.47h0c0-.06,0-.13,0-.19v-6.11a4.09,4.09,0,0,1,2-3.53l5.23-3,.06,0a.18.18,0,0,0,.07-.05A1.18,1.18,0,0,0,769.27,305.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M923.3,388.47s1.53,2.88,1.46,4.77-7.6,13.75-7.6,13.75,1.1,3.83-.44,4.32-3.72-3.15-3.37-5.25,5.32-13.17,5.32-13.17l-3.85-5.95S922.38,386.36,923.3,388.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-604",
    d: "M914.44,376.71s8.73,10.85,8.83,11.07c.6,1.42-2.56,4.22-5.25,4.25-.53,0-7-7-7.87-11.71C909.61,377.48,913,376.77,914.44,376.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-605",
    d: "M907,468c1.65-.11,6.13.79,8.67.08,0,0,.38,4.2.47,5.24a1.94,1.94,0,0,1-2.89,1.7,59.73,59.73,0,0,1-8.58-4.86S903.41,468.22,907,468Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-606",
    d: "M891.88,472.91c1.65-.11,6.14.79,8.68.08,0,0,.42,4.2.52,5.24a1.92,1.92,0,0,1-2.87,1.7,60.23,60.23,0,0,1-8.64-4.86S888.28,473.18,891.88,472.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-607",
    d: "M917.39,450.8c-.34,6.5-1.31,17.63-1.31,17.63s-3.6,2.14-5.46.47a3,3,0,0,1-.84-1.39s.13-19.89-4.32-38.4-1.78-15.93-1.78-15.93l6-2.79,6.16-2.88S918.9,413,917,426.05,917.72,444.31,917.39,450.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-608",
    d: "M910.62,468.9a3,3,0,0,1-.84-1.39s.13-19.89-4.32-38.4-1.78-15.93-1.78-15.93l6-2.79a20,20,0,0,1,1,4.06s-.88,6.87-2,13.48a20,20,0,0,0-.08,6.13C909.54,441,911.68,458.2,910.62,468.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-609",
    d: "M907.37,426.48c0,.18-.11.35-.16.53-2.59,8.36-3.84,14.61-3.13,23.79.73,9.38-2.35,22.43-2.35,22.43a5.35,5.35,0,0,1-1.58,1,4.7,4.7,0,0,1-4.86-1,136.07,136.07,0,0,1,.4-13.75c.61-8.28-.64-15.05-2.24-28.75s-1.43-18-1.39-18.16c1.94-6.6,16.24-5.9,17.86-2S910.25,417.3,907.37,426.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-610",
    d: "M904.08,450.8c.73,9.38-2.35,22.43-2.35,22.43a5.35,5.35,0,0,1-1.58,1c.11-.4.25-.83.41-1.29,3.78-11,2.17-31.64,2.33-34s4.32-12,4.32-12C904.62,435.37,903.37,441.62,904.08,450.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-611",
    d: "M916.58,409.5c-1.45,1.63-13.57,7.71-19.06,7.12a4.1,4.1,0,0,1-.9-.18c-4.92-1.51-4.73-4.92-4.73-4.92,1-6.49.35-8.2-.6-14.43,0-.33-.09-.65-.12-1-.62-5.84,1.34-11.16,3.22-13.07s6.14-3.39,6.14-3.39,10.36-5.52,13.12-3.65c3.55,2.41.75,8.87,1.55,17.24C916.24,404.2,918.11,407.77,916.58,409.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M906.45,371.86c-.2,1.35.62,3.55,1,5.21s-1.42,2.62-3.48,3.41a3.2,3.2,0,0,1-3.45-.83s2.06-5.28-.73-5.24a3.85,3.85,0,0,1-1.72-.3h0c-1.14-.54-1.25-1.75-1.38-3a3.17,3.17,0,0,0-.91-2.27c-.49-.74.69-.69.53-3a6.83,6.83,0,0,1,.67-3.71c4.8-6.18,11.32-2,12.2,2.25a6,6,0,0,1-1.07,5C907.37,370.47,906.54,371.22,906.45,371.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M907.46,377.07c.39,1.66-1.42,2.62-3.48,3.41a3.2,3.2,0,0,1-3.45-.83,9.64,9.64,0,0,0,.68-4,1.31,1.31,0,0,0-1.41-1.26,3.85,3.85,0,0,1-1.72-.3,5.81,5.81,0,0,0,4.88-1.26c.62-.47,1.23-.91,1.81-1.31,1.87-1.32,3.33-2.25,3.33-2.25v.12c-.73,1.06-1.56,1.81-1.65,2.45C906.25,373.21,907.07,375.41,907.46,377.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M904.77,371.54l-.22.3s-2,2.46-3.34,3.83a1.31,1.31,0,0,0-1.41-1.26,3.85,3.85,0,0,1-1.72-.3,5.81,5.81,0,0,0,4.88-1.26C903.58,372.38,904.19,371.94,904.77,371.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-612",
    d: "M901.07,368.49s0-1.22,1.68-1.44c1.53-.19,1.54,2.24.86,3.85a11.15,11.15,0,0,0-.46,1.26l-.19.69a4.21,4.21,0,0,0,3.18.31c1.06-.46,1.51-1.1,2.2-3.52s3.14-5.39.86-6.07c0,0,1.43-5.87-5.9-6.37s-6.23,3.69-6.23,3.69-2.71,2.73-.06,4,3.29.05,3.17,2.3S900.64,369.88,901.07,368.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M902.22,367.68a.82.82,0,0,1,.81-.09,1,1,0,0,1,.48.81,2.65,2.65,0,0,1-.4,1.86.55.55,0,0,1-.17.17.2.2,0,0,1-.22,0c-.12-.1,0-.29,0-.41a1.83,1.83,0,0,0,.3-.92.93.93,0,0,0-.46-.81.65.65,0,0,0-.85.23C901.47,368.32,902.06,367.79,902.22,367.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-613",
    d: "M896.32,363a13,13,0,0,1-3.1-1.93c-1-1,1.08-4.32,5.16-3.31S896.32,363,896.32,363Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-614",
    d: "M910.91,365.46s1.4,2.25-1.5,3.37c-3.09,1.2-8.66-3.19-8.66-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-615",
    d: "M896.32,363a35.37,35.37,0,0,0,4.43,2.69h0c2.3,1.16,5.07,2.2,7.26,1.85a4.54,4.54,0,0,0,.66-.16,3.8,3.8,0,0,0,1.27-.68,4.16,4.16,0,0,0,1-1.2s1.75-7.5-4.11-10a8.47,8.47,0,0,0-3.4-.73h0a6.92,6.92,0,0,0-3.34.86,6.72,6.72,0,0,0-.79.52C897.49,357.44,896.32,359.77,896.32,363Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-616",
    d: "M899.26,356.08c3.65-.08,5.54.16,7.31,2.88s.91,8.29.91,8.29l.54.25a4.54,4.54,0,0,0,.66-.16c.17-.68.36-1.58.56-2.74a8.83,8.83,0,0,0-3.86-8.53c-1.21-.72-3.64-.7-5.33-.51A6.72,6.72,0,0,0,899.26,356.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-617",
    d: "M899.26,356.08c2.83-.7,10.08-1.29,8.76,11.42a4,4,0,0,0,1.93-.84s2.29-10.83-6.55-12h0A6.78,6.78,0,0,0,899.26,356.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-618",
    d: "M900.76,365.65c2.3,1.16,5.07,2.2,7.26,1.85l-.54-.25A16.68,16.68,0,0,1,900.76,365.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-619",
    d: "M899.78,379.93a10.49,10.49,0,0,1,3.22-1.74c2.2-.93,5.1-2.28,5.1-2.28l.65,1.39S905.25,383.05,899.78,379.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M891.68,400.88s-5.44,7.1-8.77,6c-2.83-.93-10.61-8-13.36-10.35a1.92,1.92,0,0,1-.21-.16l-.24-.2,0,0a2.72,2.72,0,0,0-.46-.34c-.82-.42-.89-1.17-1.32-1.58s.05-.45-.43-.93a1.71,1.71,0,0,1-.49-1.08,3.37,3.37,0,0,1-.76-1.6c-.2-.66.27-1,.67.15a3.16,3.16,0,0,0,2.41,1.74c.18-.18-.12-.59-.93-1.29s-.59-1.52,0-1.11a11.13,11.13,0,0,1,2.51,1.64A17.61,17.61,0,0,1,871.6,395l11.25,5.72,2.29-3.18.69-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M891.68,400.88s-5.44,7.1-8.77,6c-2.83-.93-10.61-8-13.36-10.35,2.14,1.71,10.83,8.59,13,9.77,2.46,1.35,7.24-3.77,7.24-3.77s-4.64-.35-4.63-5l.69-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-620",
    d: "M893.09,384.66s-8.07,12.35-8,12.55a5.59,5.59,0,0,0,6,5s3.17-4.13,7.26-8.45C902.58,389.25,896.84,378.27,893.09,384.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M615,615.27a2.69,2.69,0,0,0,1.08,1.16,2.61,2.61,0,0,0,1.55.32.39.39,0,0,1,.1.48.39.39,0,0,1-.48.13,1.71,1.71,0,0,1-1.16-.08,2.56,2.56,0,0,0,1.8.78.35.35,0,0,1-.39.41.4.4,0,0,1-.53.3,1.28,1.28,0,0,1-.81.29.77.77,0,0,1-.69.12,2.32,2.32,0,0,1-.64-.34.91.91,0,0,1-.74-.05,2.27,2.27,0,0,1-.6-.47,7.65,7.65,0,0,1-1.14-1.52,2.93,2.93,0,0,1-.39-1,1.31,1.31,0,0,1,.23-1,1.39,1.39,0,0,1,1.48-.35A2,2,0,0,1,615,615.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-621",
    d: "M598.15,664.44c-1.56-.12-5.77.78-8.22.07,0,0-.16,4.19-.2,5.22a1.94,1.94,0,0,0,2.82,1.7,53.26,53.26,0,0,0,7.92-4.84S601.59,664.7,598.15,664.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-622",
    d: "M612.73,669.37c-1.56-.12-5.78.78-8.22.07l-.25,5.22a1.9,1.9,0,0,0,2.79,1.69,53.46,53.46,0,0,0,8-4.83S616.16,669.63,612.73,669.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-623",
    d: "M598.31,625.88c-3.37,18.42-2.32,38.21-2.32,38.21a2.65,2.65,0,0,1-1,1.58c-1.75,1.29-5-.66-5-.66s-1.43-11.08-2-17.55,1.7-11.62-.74-24.63.22-18.46.22-18.46l8.34,4,3.44,1.65S601.68,607.45,598.31,625.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-624",
    d: "M598.31,625.88c-3.37,18.42-2.32,38.21-2.32,38.21a2.65,2.65,0,0,1-1,1.58c-.57-13.15.57-29.89,1-35.93a9.78,9.78,0,0,0-.67-4.32,62.38,62.38,0,0,1-2.86-10.3c-.26-2.82,1.33-5.07,3.29-6.76l3.44,1.65S601.68,607.45,598.31,625.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-625",
    d: "M585.76,579c-.17-.39-2.48,10.08-1.1,14.22,1.18,3.53,10.25.54,10.25.54l-1.55-17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M604.25,565.81a3.12,3.12,0,0,0-.75,2.26c-.07,1.22-.12,2.44-1.24,3h0a3.5,3.5,0,0,1-1.56.27c-2.65,0-.45,5.22-.45,5.22a2.84,2.84,0,0,1-3.24.82c-2-.78-3.74-1.74-3.45-3.39s1-3.84.72-5.18a3,3,0,0,0-.65-1.12c-1-1.27-2.76-3.07-2.28-6.27.65-4.25,6.63-8.39,11.47-2.24a7.34,7.34,0,0,1,.81,3.7C603.57,565.12,604.68,565.07,604.25,565.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-626",
    d: "M609.3,627.38c-.89,13.64-1.76,20.37-.8,28.61s1,13.69,1,13.69a4.11,4.11,0,0,1-5,.79,5.34,5.34,0,0,1-1.05-.79s-3.52-13-3.26-22.32,0-16.19-4.24-24.21a41.43,41.43,0,0,1-3.15-7.24,12.87,12.87,0,0,1,0-8.59c1.35-3.89,14.88-4.59,17,2C609.83,609.43,610.19,613.74,609.3,627.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "M603.7,578.43a30.18,30.18,0,0,1-6-3.82s-7.85-4.44-10-1.45c-1.58,2.18-.3,7.94,1.22,16.22s-3.46,13.17-1.92,14.88,14,10.4,18.62,8.89,4.25-4.89,4.25-4.89c-1.2-6.46-.71-8.17-.09-14.37.06-.62.09-1.23.1-1.84C609.9,592.05,610.84,581.52,603.7,578.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M600.24,576.53a2.84,2.84,0,0,1-3.24.82c-2-.78-3.74-1.74-3.45-3.39s1-3.84.72-5.18a3,3,0,0,0-.65-1.12c1.14-.52,2.87.78,4.61,1.91a7.65,7.65,0,0,0,4,1.47,3.5,3.5,0,0,1-1.56.27C598,571.27,600.24,576.53,600.24,576.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-628",
    d: "M603,559.53c0,2.05-.69,2-3.82,4.54-2.36,1.91-.75,2.12-1.87,5.47a5.74,5.74,0,0,1-2.42,2.8,3.81,3.81,0,0,1-.62.29l0,0,.19.18h0c1.06,1,6.05,6.27,5,11.58-.61,3.06-4,5.28-7.53,5.48a7.18,7.18,0,0,1-7.56-5,9.26,9.26,0,0,1-.52-2.4c-.51-6.65,6.88-10.49,6.88-10.49a6.07,6.07,0,0,1-.66-.68,5.37,5.37,0,0,1-.52-.73c-4.6-7.76,0-13.56,4.38-14.45C599.09,555.07,602.91,557.48,603,559.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-629",
    d: "M594.85,572.34a3.81,3.81,0,0,1-.62.29,3.66,3.66,0,0,0-3.58-.65,6.07,6.07,0,0,1-.66-.68A3.57,3.57,0,0,1,594.85,572.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-630",
    d: "M599.38,584.42c-.61,3.06-4,5.28-7.53,5.48,12.35-4,3.87-15.4,2.54-17.06C595.45,573.87,600.44,579.11,599.38,584.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-631",
    d: "M604.46,670.47a5.34,5.34,0,0,1-1.05-.79s-3.52-13-3.26-22.32,0-16.19-4.24-24.21a41.43,41.43,0,0,1-3.15-7.24v-.06s4.79,8.65,6.78,13.07,1.84,8.48,1.69,15.38S601.51,657.68,604.46,670.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-632",
    d: "M602.9,560.66a13.67,13.67,0,0,0,3.28-2c1.05-1-1.15-4.56-5.46-3.49S602.9,560.66,602.9,560.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-633",
    d: "M587.51,563.3s-1.47,2.38,1.59,3.57c3.25,1.26,9.13-3.37,9.13-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-634",
    d: "M602.9,560.66a37.66,37.66,0,0,1-4.67,2.84h0c-2.43,1.23-5.36,2.32-7.66,2a4,4,0,0,1-.7-.17,3.87,3.87,0,0,1-1.34-.72,4.08,4.08,0,0,1-1-1.27s-1.85-7.91,4.33-10.57a8.77,8.77,0,0,1,3.59-.77h0a7.07,7.07,0,0,1,3.52.91,6.3,6.3,0,0,1,.84.54C601.67,554.84,602.9,557.31,602.9,560.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-635",
    d: "M599.8,553.41c-3.86-.09-5.85.17-7.71,3s-1,8.75-1,8.75l-.57.26a4,4,0,0,1-.7-.17c-.17-.72-.37-1.67-.59-2.89a9.33,9.33,0,0,1,4.07-9c1.28-.76,3.85-.74,5.62-.53A6.3,6.3,0,0,1,599.8,553.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-636",
    d: "M599.8,553.41c-3-.73-10.63-1.35-9.24,12.05a4.09,4.09,0,0,1-2-.89s-2.42-11.42,6.91-12.61h0A7.06,7.06,0,0,1,599.8,553.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-637",
    d: "M598.22,563.5c-2.43,1.23-5.36,2.32-7.66,2l.57-.26A17.67,17.67,0,0,0,598.22,563.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-638",
    d: "M607.69,581.87s2.38,1.92,2.2,7.47a97.88,97.88,0,0,0,.84,13.15l4.45,11.82a3.38,3.38,0,0,1-3.75,2.09s-5.9-8.73-7.08-13.28-1.29-13.91-.93-17.82S607.69,581.87,607.69,581.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-639",
    d: "M875,694.31v-6.08L868.64,690,815,659.08a8.62,8.62,0,0,0-8.62,0c-21.77,12.56-22.61,9.71-41.32,20.51H762v6.08h0a1.4,1.4,0,0,0,.71,1.1l61.85,35.72a5.31,5.31,0,0,0,3.82-.25c22.81-13.1,39.78-23,45.87-26.5A1.42,1.42,0,0,0,875,694.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-640",
    d: "M806.4,653.1l-43.67,25.21a1.44,1.44,0,0,0,0,2.49c21.78,12.56,50.48,29.14,60.79,35.1a5.56,5.56,0,0,0,5.54,0l45.22-26.12a1.44,1.44,0,0,0,0-2.49L815,653.1A8.62,8.62,0,0,0,806.4,653.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-641",
    points: "803.26 665.23 829.62 650.27 803.03 635.18 776.89 650.27 803.26 665.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-642",
    points: "803.25 665.23 803.25 693.84 776.89 678.88 776.89 650.27 786.68 655.83 792.72 659.26 803.25 665.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-643",
    points: "829.62 650.27 829.62 659.34 829.62 669.8 829.62 678.88 803.26 693.84 803.26 684.76 803.26 674.3 803.26 665.23 829.62 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-644",
    points: "792.72 659.26 792.72 681.44 786.68 677.93 786.68 655.83 792.72 659.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-645",
    points: "786.68 655.83 812.66 640.64 818.35 643.87 792.72 659.26 786.68 655.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-646",
    points: "806.04 669.85 806.04 666.13 813.62 661.69 813.62 665.23 806.04 669.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-647",
    points: "829.62 680.19 855.98 665.23 829.39 650.14 803.25 665.23 829.62 680.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-648",
    points: "829.62 680.19 829.62 708.8 803.25 693.84 803.25 665.23 813.04 670.79 819.08 674.22 829.62 680.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-649",
    points: "855.98 665.23 855.98 674.3 855.98 684.76 855.98 693.83 829.62 708.79 829.62 699.72 829.62 689.26 829.62 680.19 855.98 665.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-650",
    points: "819.08 674.22 819.08 696.4 813.04 692.89 813.04 670.79 819.08 674.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-651",
    points: "813.04 670.79 839.02 655.6 844.71 658.83 819.08 674.22 813.04 670.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-652",
    points: "832.4 684.81 832.4 681.09 839.98 676.64 839.98 680.19 832.4 684.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-653",
    points: "803.26 636.62 829.62 621.66 803.03 606.57 776.89 621.66 803.26 636.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-654",
    points: "803.25 636.63 803.25 665.23 776.89 650.27 776.89 621.67 786.68 627.23 792.72 630.65 803.25 636.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-655",
    points: "829.62 621.66 829.62 630.74 829.62 641.2 829.62 650.27 803.26 665.23 803.26 656.16 803.26 645.7 803.26 636.62 829.62 621.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-656",
    points: "792.72 630.65 792.72 652.84 786.68 649.32 786.68 627.23 792.72 630.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-657",
    points: "786.68 627.23 812.66 612.03 818.35 615.26 792.72 630.65 786.68 627.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-658",
    points: "806.04 641.25 806.04 637.52 813.62 633.08 813.62 636.62 806.04 641.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-659",
    points: "829.62 651.58 855.98 636.62 829.39 621.53 803.25 636.62 829.62 651.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-660",
    points: "829.62 651.58 829.62 680.19 803.25 665.23 803.25 636.63 813.04 642.18 819.08 645.61 829.62 651.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-661",
    points: "855.98 636.62 855.98 645.69 855.98 656.15 855.98 665.23 829.62 680.19 829.62 671.11 829.62 660.65 829.62 651.58 855.98 636.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-662",
    points: "819.08 645.61 819.08 667.79 813.04 664.28 813.04 642.18 819.08 645.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-663",
    points: "813.04 642.18 839.02 626.99 844.71 630.22 819.08 645.61 813.04 642.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-664",
    points: "832.4 656.2 832.4 652.48 839.98 648.04 839.98 651.58 832.4 656.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-665",
    points: "484.82 152.12 484.82 155.78 459.47 170.42 459.47 166.76 484.82 152.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-666",
    points: "484.82 152.12 453.11 133.83 348.55 194.21 332.7 203.35 364.39 221.65 392.91 205.18 408.76 214.33 475.32 175.9 459.47 166.76 484.82 152.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-667",
    points: "374.69 209.3 476.89 150.29 478.23 147.34 378.55 202.5 374.69 209.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-668",
    points: "476.89 150.29 476.89 153.95 374.69 212.96 374.69 209.3 476.89 150.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-669",
    points: "332.7 203.35 332.7 207.01 364.39 225.31 392.91 208.84 408.76 217.99 475.31 179.56 475.31 175.9 408.76 214.33 392.91 205.18 364.39 221.65 332.7 203.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-670",
    d: "M479.67,145.86a.34.34,0,0,1,0,.1v0s0,.07,0,.1a.56.56,0,0,1,0,.12,1.54,1.54,0,0,1-.08.19l0,.05-.11.15-.06.06-.06.06-.07,0-.14.1-.08,0-.08,0h0l-99,57.14a1.22,1.22,0,0,1-1.37.1l-31.9-18.42a2.54,2.54,0,0,1-1.27-2.21V138a1,1,0,0,1,.48-.83l2.21-1.27h0l97.07-56,.42-.24.18-.1,1.61-.94a1,1,0,0,1,.95,0l25.91,15a3.59,3.59,0,0,1,.5.37l.14.15a2.78,2.78,0,0,1,.37.51l.09.18,4,8.66a2.71,2.71,0,0,1,.24,1.09C479.58,109,479.89,137.94,479.67,145.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-671",
    d: "M461.83,141.36l-.21-.56-2.29.48-2.69,1.82-1.27,2.32,2.38,2.72,5.49-3.14h0a1.5,1.5,0,0,0,.79-1.33v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-672",
    d: "M458.47,142.82v4a1.5,1.5,0,0,1-2.26,1.29l-2.57-1.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-673",
    points: "465.8 114.48 455.22 141.99 453.13 147.42 451.57 146.55 451.57 120.93 464.25 113.61 465.8 114.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-674",
    points: "455.22 141.99 453.13 147.42 451.57 146.55 451.57 120.93 453.13 121.8 455.22 141.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-675",
    points: "456.39 136.99 456.39 135.61 479.67 122.17 479.68 123.55 456.39 136.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-676",
    d: "M475.32,94.76,376,152.09c-4.21,1.81-1.1-1.21-1.1-1.21l99.29-57.33A2.69,2.69,0,0,1,475.32,94.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-677",
    d: "M479.53,104.51l-34.87,20.13-64.42,37.2s-2.58.83-.24-1.1l64.66-37.33,34.63-20A2.71,2.71,0,0,1,479.53,104.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-678",
    d: "M449.28,158h0l-3.23,5.69L417.65,180l-6.32,3.62h0l-3.85,2.2-.44-.17-.27-.11-.31-.13h0l-.21-.08-.45-.18-.36-.15-.3-.11-.31-.13-.36-.14-.3-.12-.2-.08-.14-.06-.05,0h0v0h0c0-3.24,0-7.24,0-11.4,0-.28,0-.57,0-.85,0-4.78-.06-9.69-.09-13.84,0-1.39,0-2.7,0-3.88,0-2.82-.05-4.94-.06-5.9a2.56,2.56,0,0,0-.25-1.09l-4-8.66a2.71,2.71,0,0,0-1.11-1.21l-20-11.57v-3.66l36-20.81,3.3-1.91h6.08l20.17,11.64a2.65,2.65,0,0,1,.88.82,2.46,2.46,0,0,1,.22.39l4,8.65a2.72,2.72,0,0,1,.18.55,3.31,3.31,0,0,1,.07.55c0,.54,0,1.46,0,2.67,0,2.08.06,5,.08,8.37C449.25,141,449.32,151.19,449.28,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-679",
    d: "M412.69,90.6V106l-5.89-1.69-.47.26V92.12a3.08,3.08,0,0,1,1.41-2.62l0,0,.39-.22h0a3.11,3.11,0,0,1,2.88.14,9.2,9.2,0,0,1,1.27.87C412.44,90.37,412.56,90.48,412.69,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-680",
    d: "M413.48,89l-3.3-.82-2,1.11h0l-.39.22,0,0a3.08,3.08,0,0,0-1.41,2.62v12.49l.47-.26V92.51a2.75,2.75,0,0,1,1.25-2.33l0,0,.36-.19a2.74,2.74,0,0,1,2.56.12,8.87,8.87,0,0,1,1.12.77l.33.29.25.23c.16.16.32.33.47.51a17.31,17.31,0,0,1,1.17-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-681",
    d: "M448.32,157.75l-3,5.24-38.88,22.39h0l-2.72-1.08v0h0v-.9c0-.87,0-1.78,0-2.73h0c0-2.41,0-5,0-7.76,0-.28,0-.57,0-.85,0-4.78-.06-9.69-.09-13.84,0-1.39,0-2.7,0-3.88s0-2,0-2.83v0c0-.85,0-1.58,0-2.16,0-.36,0-.66,0-.89a2.63,2.63,0,0,0-.25-1.09l-.46-1-1.12-2.45-2.38-5.2a2.78,2.78,0,0,0-.74-1l-.37-.25-6.54-3.78-.82-.47-2.64-1.53-.28-.15-9.76-5.64v-2.56l34.73-20,4.88-2.82h5.57L443.28,112a1.68,1.68,0,0,1,.71.78l2.29,5,1.68,3.65a1.75,1.75,0,0,1,.16.71v.06c0,.34,0,.73,0,1.16a1.48,1.48,0,0,0,0,.21v.56c0,.22,0,.45,0,.68v.57c0,.11,0,.23,0,.34v.81c0,.2,0,.4,0,.6,0,.44,0,.89,0,1.36,0,.31,0,.61,0,.93,0,.67,0,1.36,0,2.08,0,.28,0,.58,0,.87s0,.63,0,.95v.66c0,.63,0,1.28,0,1.93,0,.45,0,.9,0,1.36v1.44c0,.38,0,.77,0,1.16v4.11C448.33,148.92,448.34,153.85,448.32,157.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-682",
    d: "M414.32,130v8.67l-11.51,7.65-1.12-2.45-2.38-5.2a2.78,2.78,0,0,0-.74-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-683",
    d: "M414.32,130l-15,8.67a2.71,2.71,0,0,0-1.11-1.21l-6.54-3.78-.82-.47-2.64-1.53-.28-.15L409,120.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-684",
    d: "M403.74,179.48c0-2.09,0-4.33,0-6.61,0-.28,0-.57,0-.85,0-4.78-.06-9.69-.09-13.84,0-1.39,0-2.7,0-3.88s0-2,0-2.83v0l17-9.81,0,0,22.13,12.82,5.63,3.27-44.59,25.62v-1.74c0-.33,0-.66,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-685",
    d: "M448.32,157.75l-27.8-16.11v-41.2h2.82L443.28,112a1.68,1.68,0,0,1,.71.78l2.29,5,1.68,3.65a1.75,1.75,0,0,1,.16.71v.06c0,.45,0,1,0,1.6C448.21,130.82,448.37,147.7,448.32,157.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-686",
    points: "443.62 153.95 443.62 155.02 430.77 162.51 430.24 161.23 443.62 153.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-687",
    d: "M434.08,163.12v1l-30.35,17.47c0-.33,0-.66,0-1v-1.16a2.85,2.85,0,0,1,.33-.25c2.72-1.88,15.37-9,15.37-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-688",
    d: "M442.69,154.48l-11.75,6.79,3.14,1.85-30.34,17.52h0c0-2.41,0-5,0-7.76,0-.28,0-.57,0-.85,0-4.78-.06-9.69-.09-13.84,0-1.39,0-2.7,0-3.88s0-2,0-2.83l17-9.81.89-.51L443.62,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-689",
    d: "M436.92,150.88l8.46-4.89h0c1.36-.76,2-2.7,1.37-5-.76-3-3.25-5.39-5.55-5.41a2.77,2.77,0,0,0-1.54.41h0l-8.88,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-690",
    d: "M439.27,144.18v6.65a.59.59,0,0,1-.26.49h0l-.05,0-1.1.64-.31.18a.56.56,0,0,1-.43-.07l-.74-.43-.08-1.54-5-2.91a.62.62,0,0,1-.3-.52l-1.29-3.44v-3a.45.45,0,0,1,.08-.26l.29-.16,1.13-.66a.42.42,0,0,1,.43,0l7.13,4.14A1.07,1.07,0,0,1,439.27,144.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-691",
    d: "M438,144.91v6.68a.56.56,0,0,1-.16.4.61.61,0,0,1-.31.18.56.56,0,0,1-.43-.07l-.74-.43L430,148a.57.57,0,0,1-.3-.51v-7.24a.45.45,0,0,1,.08-.26.43.43,0,0,1,.29-.16.38.38,0,0,1,.27.05l7.15,4.16A1.05,1.05,0,0,1,438,144.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-692",
    d: "M436.39,147.34c-.84-3.24-3.55-5.89-6.06-5.92a3,3,0,0,0-1.68.46h0l-1.55.9-.38,1.86a7.79,7.79,0,0,0-.16,2.39,14,14,0,0,0,1.64,3.44l1.41.85a6.14,6.14,0,0,0,2.83,1.71l1,.59,1.47-.85h0C436.37,151.94,437,149.82,436.39,147.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-693",
    cx: 430.14,
    cy: 148.27,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(-18.02 226.75) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-694",
    cx: 430.14,
    cy: 148.27,
    rx: 2.97,
    ry: 4.39,
    transform: "translate(-18.02 226.75) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "M432.36,149.76c-.83-3.24-3.55-5.89-6.06-5.91a3,3,0,0,0-1.68.45h0l-1.55.9-.38,1.86a8.2,8.2,0,0,0-.16,2.4,13.85,13.85,0,0,0,1.64,3.43l1.41.86a6.21,6.21,0,0,0,2.83,1.7l1,.6,1.48-.86h0C432.34,154.36,433,152.25,432.36,149.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-696",
    cx: 426.11,
    cy: 150.7,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(-19.7 225.11) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-697",
    cx: 426.11,
    cy: 150.7,
    rx: 2.52,
    ry: 3.73,
    transform: "translate(-19.7 225.11) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-698",
    points: "407.77 154.97 421.57 146.95 427.77 155.78 413.47 164.03 407.77 154.97"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-699",
    cx: 418.39,
    cy: 155.49,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-700",
    points: "427.77 111.86 427.77 112.76 391.66 133.66 390.84 133.19 388.19 131.66 388.91 130.64 427.77 111.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-701",
    points: "427.77 111.86 410.12 122.05 390.84 133.19 378.16 125.87 378.16 123.31 412.89 103.26 427.77 111.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-702",
    d: "M423.22,131.19l10.41-6h0c2.55-1.44,3.69-5.09,2.58-9.39-1.44-5.61-6.14-10.19-10.49-10.24a5.25,5.25,0,0,0-2.9.79h0l-2.68,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-703",
    d: "M348.06,135.93l-2.2,1.27a1,1,0,0,0-.48.83v45.55a2.54,2.54,0,0,0,1.27,2.21l31.9,18.42a1.22,1.22,0,0,0,1.83-1c.22-7.92-.09-36.91-.14-41.35a2.55,2.55,0,0,0-.24-1.09l-4-8.66a2.69,2.69,0,0,0-1.1-1.21L349,135.93A.94.94,0,0,0,348.06,135.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-704",
    d: "M348.55,172.25V154l4.07,2.35a4.52,4.52,0,0,1,2.26,3.92V173a1.64,1.64,0,0,1-2.47,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-705",
    d: "M348.55,139.51v10.71a.12.12,0,0,0,.05.1l.46.27a.11.11,0,0,0,.17-.1V139.77a.12.12,0,0,0-.05-.1l-.46-.26A.11.11,0,0,0,348.55,139.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-706",
    d: "M349.92,140.3V151a.13.13,0,0,0,.06.1l.46.26a.11.11,0,0,0,.17-.1V140.57a.12.12,0,0,0-.05-.1l-.46-.27A.13.13,0,0,0,349.92,140.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-707",
    d: "M351.3,141.1v10.71a.12.12,0,0,0,.06.1l.46.27a.11.11,0,0,0,.17-.1V141.37a.12.12,0,0,0-.05-.1l-.46-.27A.12.12,0,0,0,351.3,141.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-708",
    d: "M352.68,141.9v10.71a.13.13,0,0,0,.06.1l.46.27a.11.11,0,0,0,.17-.1V142.16a.12.12,0,0,0-.05-.1l-.46-.26A.12.12,0,0,0,352.68,141.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-709",
    d: "M373.9,165v24.65a.53.53,0,0,1-.78.41l-14.81-8.55a.54.54,0,0,1-.26-.45v-28a.52.52,0,0,1,.78-.45l0,0,12.67,7.24a.56.56,0,0,1,.22.24l2.1,4.69A.46.46,0,0,1,373.9,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-710",
    d: "M373.9,165v24.65l-14.78-8.53a.52.52,0,0,1-.26-.45V152.66l12.67,7.24a.56.56,0,0,1,.22.24l2.1,4.69A.46.46,0,0,1,373.9,165Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-711",
    points: "346.65 185.79 348.55 194.21 374.69 209.3 378.55 204.21 346.65 185.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-712",
    points: "374.69 209.3 374.69 212.96 348.55 197.86 348.55 194.21 374.69 209.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "M354.74,184.29c-.49-1.89-2.07-3.44-3.54-3.45a1.7,1.7,0,0,0-1,.27h0l-.91.52-.22,1.09a4.88,4.88,0,0,0-.09,1.4,8.07,8.07,0,0,0,1,2l.82.5a3.61,3.61,0,0,0,1.65,1l.58.34.86-.49h0C354.73,187,355.11,185.75,354.74,184.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-714",
    cx: 351.09,
    cy: 184.84,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-45.6 193.06) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-715",
    d: "M351.93,186.11a.39.39,0,0,1-.14.08.7.7,0,0,1-.33.08,1.84,1.84,0,0,1-1.48-1.44,1.12,1.12,0,0,1,.41-1.35.88.88,0,0,1,.33-.07,1.83,1.83,0,0,1,1.48,1.44A1.21,1.21,0,0,1,351.93,186.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-716",
    d: "M341.67,205c1.88.51,4-.1,4.75-1.37a1.74,1.74,0,0,0,.25-1h0v-1l-.84-.73a4.64,4.64,0,0,0-1.17-.77,8.06,8.06,0,0,0-2.22-.16l-.84.47a3.6,3.6,0,0,0-1.68.95l-.58.33v1h0C339.33,203.63,340.22,204.57,341.67,205Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-717",
    cx: 342.99,
    cy: 201.52,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(137.98 542.44) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-718",
    d: "M352.2,184.85a1.83,1.83,0,0,0-1.48-1.44.88.88,0,0,0-.33.07s-.05,0-.06,0l-5.3,3a7.17,7.17,0,0,0-3.56,6.18v8.7a.62.62,0,0,0,.08.4,1.38,1.38,0,0,0,.88.63,1.83,1.83,0,0,0,2-.58.08.08,0,0,0,0-.05.58.58,0,0,0,.08-.31h0v-2.47h0a1.21,1.21,0,0,0,0-.19v-6.11a4.11,4.11,0,0,1,2-3.53l5.23-3,.06,0,.08,0A1.21,1.21,0,0,0,352.2,184.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-719",
    d: "M414.48,163.38a5.12,5.12,0,0,1-2.22,4.63l-6.32,3.59-2.22.42c0-.29,0,0,0,0,0-4.78-.06-9.69-.09-13.84,0-1.39,0-2.7,0-3.88l.52-.31a3.9,3.9,0,0,1,2.23-.63c3.25,0,6.76,3.46,7.83,7.64A9.41,9.41,0,0,1,414.48,163.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-720",
    points: "427.77 155.78 427.77 156.72 413.28 165.23 413.47 164.03 427.77 155.78"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-721",
    cx: 418.39,
    cy: 155.13,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-722",
    d: "M422.79,155.13a3.37,3.37,0,0,1-1,2.36,4.13,4.13,0,0,1-.55.47,4.73,4.73,0,0,1-2.5.88l-.36,0-.36,0a4.76,4.76,0,0,1-2.5-.88,3.5,3.5,0,0,1-.54-.47,3.34,3.34,0,0,1-1-2.36V155a3.64,3.64,0,0,1,.13-.72,3.7,3.7,0,0,1,1.45-1.95,4.5,4.5,0,0,1,.64-.38,5.09,5.09,0,0,1,4.36,0,4.61,4.61,0,0,1,.65.38,3.68,3.68,0,0,1,1.44,1.95,3.64,3.64,0,0,1,.13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-723",
    d: "M419.26,155l2.54,2.54a4.13,4.13,0,0,1-.55.47l-2.5-2.5v3.38l-.36,0-.36,0v-3.38l-2.5,2.5a3.5,3.5,0,0,1-.54-.47l2.53-2.54H414a3.64,3.64,0,0,1,.13-.72h3.4l-1.95-1.95a4.5,4.5,0,0,1,.64-.38l2.18,2.19,2.18-2.19a4.61,4.61,0,0,1,.65.38l-2,1.95h3.4a3.64,3.64,0,0,1,.13.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-724",
    cx: 418.39,
    cy: 154.59,
    rx: 0.64,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M418.39,154.59a6,6,0,0,1-.36-.77c0-.25,0-.51,0-.77V149.2c.11-.25.22-.51.36-.77a7.53,7.53,0,0,1,.36.77v4.62a4.87,4.87,0,0,1-.36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M415.34,141.12v7.21h0c0,.83.73,1.61,1.94,1.94,1.57.42,3.34-.09,4-1.15a1.48,1.48,0,0,0,.21-.82h0v-7.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-726",
    cx: 418.39,
    cy: 141.12,
    rx: 2.06,
    ry: 3.06,
    transform: "translate(273.01 558.06) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-727",
    d: "M410.11,100.1l0,39.88h0c0,2.24,2,4.36,5.27,5.24,4.25,1.15,9.06-.24,10.73-3.11a4,4,0,0,0,.56-2.22h0l0-40.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-728",
    cx: 418.38,
    cy: 100.44,
    rx: 5.59,
    ry: 8.28,
    transform: "translate(313.68 517.78) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-729",
    points: "448.32 157.75 445.34 162.99 406.46 185.38 403.74 184.3 403.73 183.37 448.32 157.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-730",
    d: "M401,105v21.93h0c0,1.23,1.1,2.4,2.9,2.88,2.34.63,5-.13,5.9-1.71a2.22,2.22,0,0,0,.31-1.22h0V104.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-731",
    cx: 405.54,
    cy: 105.14,
    rx: 3.08,
    ry: 4.55,
    transform: "translate(296.28 509.59) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-732",
    points: "453.13 121.8 465.81 114.48 465.81 140.1 453.13 147.42 453.13 121.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-733",
    points: "465.02 116.5 465.02 125.06 454.47 130.87 454.47 122.57 464.74 116.66 465.02 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-734",
    points: "464.74 116.66 464.74 124.89 454.47 130.54 454.47 122.57 464.74 116.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-735",
    d: "M454.47,132.26v2.26a.19.19,0,0,0,.09.17h0l.44.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0L454.65,132A.35.35,0,0,0,454.47,132.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-736",
    d: "M454.9,132.51v2.27a.22.22,0,0,0,.05.14.24.24,0,0,0,.11.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18V130.9a.16.16,0,0,0,0-.09.14.14,0,0,0-.1-.05.1.1,0,0,0-.09,0l-2.44,1.41A.38.38,0,0,0,454.9,132.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-737",
    d: "M458.11,130.14v2.27a.22.22,0,0,0,.09.17h0l.44.26,0,0a.21.21,0,0,0,.15,0l.25-.14,0-.53,1.71-1a.22.22,0,0,0,.1-.18l.44-1.17v-1a.12.12,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,458.11,130.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-738",
    d: "M458.54,130.39v2.28a.2.2,0,0,0,.06.14.17.17,0,0,0,.1.06.21.21,0,0,0,.15,0l.25-.14,2.18-1.27a.21.21,0,0,0,.1-.18v-2.46a.12.12,0,0,0,0-.09.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,458.54,130.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-739",
    d: "M461.76,128v2.26a.19.19,0,0,0,.08.17h0l.45.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.42A.34.34,0,0,0,461.76,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-740",
    d: "M462.19,128.28v2.27a.2.2,0,0,0,.05.14.21.21,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18v-2.47a.11.11,0,0,0,0-.08.1.1,0,0,0-.09-.06.1.1,0,0,0-.09,0L462.37,128A.36.36,0,0,0,462.19,128.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-741",
    d: "M467.61,118.69V121a.19.19,0,0,0,.08.17h0l.45.27h0a.18.18,0,0,0,.14,0l.26-.15,0-.53,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.29.29,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.42A.34.34,0,0,0,467.61,118.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-742",
    d: "M468,118.94v2.27a.22.22,0,0,0,0,.14.24.24,0,0,0,.11.06.18.18,0,0,0,.14,0l.26-.15,2.17-1.26a.2.2,0,0,0,.1-.18v-2.47a.29.29,0,0,0,0-.09.14.14,0,0,0-.1,0,.1.1,0,0,0-.09,0l-2.44,1.41A.36.36,0,0,0,468,118.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-743",
    d: "M467.61,123v2.26a.19.19,0,0,0,.08.17h0l.45.27h0a.18.18,0,0,0,.14,0l.26-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.19.19,0,0,0,0-.08l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.42A.34.34,0,0,0,467.61,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-744",
    d: "M468,123.2v2.27a.2.2,0,0,0,0,.14.24.24,0,0,0,.11.06.18.18,0,0,0,.14,0l.26-.15,2.17-1.26a.2.2,0,0,0,.1-.18v-2.47a.19.19,0,0,0,0-.08.12.12,0,0,0-.1-.06.1.1,0,0,0-.09,0l-2.44,1.41A.36.36,0,0,0,468,123.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "M454.47,136.61v2.26a.19.19,0,0,0,.09.17h0l.44.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.19.19,0,0,0-.15,0l-2.43,1.42A.35.35,0,0,0,454.47,136.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-746",
    d: "M454.9,136.86v2.27a.2.2,0,0,0,.05.14.24.24,0,0,0,.11.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18v-2.47a.11.11,0,0,0,0-.08.12.12,0,0,0-.1-.06.1.1,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,454.9,136.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-747",
    d: "M458.11,134.49v2.27a.22.22,0,0,0,.09.17h0l.44.26,0,0a.21.21,0,0,0,.15,0l.25-.14,0-.53,1.71-1a.22.22,0,0,0,.1-.18l.44-1.17v-1a.12.12,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.37.37,0,0,0,458.11,134.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-748",
    d: "M458.54,134.74V137a.2.2,0,0,0,.06.14.17.17,0,0,0,.1.06.21.21,0,0,0,.15,0l.25-.14,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.12.12,0,0,0,0-.09.17.17,0,0,0-.1-.06l-.09,0-2.44,1.42A.35.35,0,0,0,458.54,134.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-749",
    d: "M461.76,132.38v2.26a.19.19,0,0,0,.08.17h0l.45.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.42A.34.34,0,0,0,461.76,132.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-750",
    d: "M462.19,132.63v2.27a.2.2,0,0,0,.05.14.21.21,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18V131a.11.11,0,0,0,0-.08.11.11,0,0,0-.09-.06.1.1,0,0,0-.09,0l-2.44,1.42A.33.33,0,0,0,462.19,132.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-751",
    d: "M454.81,141.17a1.74,1.74,0,0,1,1.42-1.38.64.64,0,0,1,.39.11h0l.37.21.09.43a1.76,1.76,0,0,1,0,.56,3.26,3.26,0,0,1-.38.81l-.33.19a1.4,1.4,0,0,1-.66.4l-.23.14-.35-.2h0A1.1,1.1,0,0,1,454.81,141.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-752",
    cx: 456.28,
    cy: 141.39,
    rx: 1.47,
    ry: 0.99,
    transform: "translate(111.68 472.2) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-753",
    points: "458.69 139.64 462.67 137.34 462.67 136.68 458.69 138.98 458.69 139.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-754",
    points: "458.69 141.26 465.31 137.44 465.31 136.72 458.69 140.6 458.69 141.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-755",
    points: "380.4 180.16 380.4 178.78 403.67 165.34 403.68 166.72 380.4 180.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-756",
    points: "361.78 143.29 360.59 142.6 383.9 129.18 385.1 129.87 361.78 143.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-757",
    points: "430.68 103.58 429.48 102.89 459.98 85.33 461.18 86.02 430.68 103.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-758",
    points: "392.91 208.84 392.91 205.18 408.76 214.33 408.76 217.99 392.91 208.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-759",
    d: "M448.12,122.1v.06l-27.6,15.89-17.06,9.82a2.31,2.31,0,0,0-.19-.56l-1.58-3.46,18.83-11.08,2.7-1.58,10.41-6,12.65-7.44,1.68,3.65A1.75,1.75,0,0,1,448.12,122.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-760",
    d: "M448.14,123.76l-27.62,15.8-17,9.73c0-.36,0-.66,0-.89a2.33,2.33,0,0,0-.06-.53l17.06-9.82,27.6-15.89c0,.34,0,.73,0,1.16,0,.07,0,.14,0,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-761",
    d: "M404.05,172h-.34c0-4.78-.06-9.69-.09-13.84a11.4,11.4,0,0,1,4.34,6.39C409,168.73,407.28,172.07,404.05,172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-762",
    d: "M403.86,169h-.19c0-2.69,0-5.46-.05-7.79a6.39,6.39,0,0,1,2.44,3.59C406.67,167.15,405.68,169,403.86,169Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-763",
    points: "424.61 175.9 424.61 173.52 432.11 169.27 432.11 171.56 424.61 175.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M449,121.54l-41.53,64.25-.44-.17-.79-.32-.45-.18-2-.81h0L444.64,112a2.46,2.46,0,0,1,.22.39l4,8.65A2.72,2.72,0,0,1,449,121.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M449.18,133.13,417.65,180l-6.32,3.62,37.77-58.83C449.13,126.84,449.16,129.78,449.18,133.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-765",
    d: "M416.15,91.34l-1.82-1.62a17.31,17.31,0,0,0-1.17,2.17,8.69,8.69,0,0,1,.94,1.31,8.52,8.52,0,0,1,1.13,4.25v5.3l.6.39a35.9,35.9,0,0,0,1.3-5.24C417.43,95.7,416.15,91.34,416.15,91.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-766",
    d: "M422.19,94.17v5.45l-6.36,3.52V97.69a9.54,9.54,0,0,0-1.28-4.79,9.4,9.4,0,0,0-1.86-2.3c-.13-.12-.25-.23-.38-.33A9.2,9.2,0,0,0,411,89.4a3.11,3.11,0,0,0-2.88-.14l2-1.11L414,86l.6-.33h0a3.3,3.3,0,0,1,1.21-.24,3,3,0,0,1,1.56.43A9.56,9.56,0,0,1,422.19,94.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-767",
    points: "355.06 76.95 355.06 80.61 329.71 95.25 329.71 91.59 355.06 76.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-768",
    points: "355.06 76.95 323.36 58.66 218.79 119.04 202.94 128.19 234.63 146.49 263.16 130.02 279 139.16 345.56 100.73 329.71 91.59 355.06 76.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-769",
    points: "244.93 134.13 347.13 75.12 348.47 72.18 248.79 127.33 244.93 134.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-770",
    points: "347.13 75.12 347.13 78.78 244.93 137.79 244.93 134.13 347.13 75.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-771",
    points: "202.94 128.19 202.94 131.85 234.63 150.15 263.16 133.68 279 142.82 345.56 104.4 345.56 100.73 279 139.16 263.16 130.02 234.63 146.49 202.94 128.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-772",
    d: "M349.91,70.69v.16s0,.06,0,.09l0,.12a1.11,1.11,0,0,1-.09.19l0,.06a1.34,1.34,0,0,1-.11.14l-.06.06-.06.06-.07.06-.14.09-.08,0s0,0-.08,0h0l-99,57.14a1.2,1.2,0,0,1-1.36.1l-31.9-18.42a2.55,2.55,0,0,1-1.28-2.21V62.86a1,1,0,0,1,.48-.83l2.21-1.27h0l97.07-56,.42-.24.18-.1,1.61-.93a1,1,0,0,1,1,0l25.9,15a3.08,3.08,0,0,1,.5.37l.14.15a2.54,2.54,0,0,1,.37.51,1.51,1.51,0,0,1,.09.18l4,8.66a2.72,2.72,0,0,1,.25,1.09C349.83,33.78,350.14,62.77,349.91,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-773",
    d: "M332.08,66.2l-.22-.57-2.29.48-2.69,1.82-1.26,2.33L328,73l5.48-3.14h0a1.49,1.49,0,0,0,.8-1.32v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-774",
    d: "M328.72,67.65v4A1.51,1.51,0,0,1,326.45,73l-2.57-1.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-775",
    points: "336.05 39.31 325.46 66.82 323.37 72.25 321.82 71.38 321.82 45.76 334.49 38.44 336.05 39.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-776",
    points: "325.46 66.82 323.37 72.25 321.82 71.38 321.82 45.76 323.37 46.63 325.46 66.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-777",
    points: "326.64 61.82 326.64 60.44 349.91 47 349.92 48.38 326.64 61.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-778",
    d: "M345.56,19.59,246.27,76.92c-4.2,1.81-1.1-1.21-1.1-1.21l99.29-57.33A2.69,2.69,0,0,1,345.56,19.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-779",
    d: "M349.78,29.34,314.91,49.47l-64.42,37.2s-2.59.84-.25-1.09l64.67-37.34,34.62-20A2.72,2.72,0,0,1,349.78,29.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-780",
    d: "M319.53,82.83h0l-3.24,5.69-28.4,16.28-6.31,3.62h0l-3.84,2.2-.45-.17-.26-.11-.31-.12h0l-.22-.09-.44-.18-.37-.14-.29-.12-.31-.13-.36-.14-.31-.12-.2-.08-.14-.06H274l0,0v0h0c0-3.25,0-7.25,0-11.4v-.86c0-4.78-.06-9.69-.1-13.83,0-1.4,0-2.71,0-3.89,0-2.81-.05-4.93-.06-5.9a2.55,2.55,0,0,0-.24-1.09l-4-8.65a2.71,2.71,0,0,0-1.1-1.22l-20-11.57V47l36-20.81,3.3-1.91h6.09L314,36a2.67,2.67,0,0,1,.88.82,1.87,1.87,0,0,1,.22.39l4,8.66a3.13,3.13,0,0,1,.19.54,2.51,2.51,0,0,1,.06.55c0,.55,0,1.47,0,2.67,0,2.08,0,5,.08,8.37C319.49,65.84,319.56,76,319.53,82.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-781",
    d: "M282.93,15.43V30.87L277,29.18l-.47.26V17A3.12,3.12,0,0,1,278,14.33l0,0,.4-.21h0a3.11,3.11,0,0,1,2.88.14,9.38,9.38,0,0,1,1.26.87C282.68,15.21,282.81,15.31,282.93,15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-782",
    d: "M283.73,13.8,280.42,13l-2,1.11h0l-.4.21,0,0A3.12,3.12,0,0,0,276.57,17V29.44l.47-.26V17.34A2.76,2.76,0,0,1,278.3,15h0l.36-.2a2.74,2.74,0,0,1,2.56.12,8,8,0,0,1,1.12.78,3.07,3.07,0,0,1,.34.29l.24.22c.17.17.32.34.48.51a16.51,16.51,0,0,1,1.17-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-783",
    d: "M318.57,82.58l-3,5.24-38.88,22.4h0L274,109.13v0h0v-.91c0-.86,0-1.78,0-2.73h0c0-2.41,0-5.06,0-7.76v-.86c0-4.78-.06-9.69-.1-13.83,0-1.4,0-2.71,0-3.89s0-2,0-2.83v0c0-.85,0-1.58,0-2.16,0-.36,0-.66,0-.89a2.39,2.39,0,0,0-.06-.53,2.81,2.81,0,0,0-.18-.56l-.46-1-1.13-2.46-2.38-5.19a2.61,2.61,0,0,0-.74-1,3,3,0,0,0-.36-.26l-6.55-3.78-.82-.47-2.64-1.52-.27-.16L248.4,50.7V48.15l34.73-20.06L288,25.28h5.57l19.94,11.51a1.68,1.68,0,0,1,.71.78l2.29,5,1.68,3.65a1.79,1.79,0,0,1,.16.71V47c0,.34,0,.73,0,1.16v.77c0,.22,0,.45,0,.69s0,.37,0,.56v.35c0,.26,0,.53,0,.8v.61c0,.43,0,.88,0,1.35,0,.31,0,.62,0,.93,0,.67,0,1.36,0,2.08v.87c0,.31,0,.63,0,1s0,.44,0,.66c0,.63,0,1.28,0,1.93,0,.45,0,.9,0,1.36,0,.21,0,.42,0,.63v6.08C318.57,73.75,318.59,78.68,318.57,82.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-784",
    d: "M284.56,54.82v8.67l-11.5,7.65-1.13-2.46-2.38-5.19a2.61,2.61,0,0,0-.74-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-785",
    d: "M284.56,54.82l-15,8.67a2.71,2.71,0,0,0-1.1-1.22l-6.55-3.78-.82-.47-2.64-1.52-.27-.16,21.1-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-786",
    d: "M274,104.31c0-2.09,0-4.32,0-6.6v-.86c0-4.78-.06-9.69-.1-13.83,0-1.4,0-2.71,0-3.89s0-2,0-2.83v0l17-9.81,0,0,22.14,12.82,5.63,3.26L274,108.2c0-.56,0-1.14,0-1.74v-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-787",
    d: "M318.57,82.58l-27.8-16.11V25.28h2.81l19.94,11.51a1.68,1.68,0,0,1,.71.78l2.29,5,1.68,3.65a1.79,1.79,0,0,1,.16.71V47c0,.46,0,1,0,1.6C318.46,55.66,318.62,72.53,318.57,82.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-788",
    points: "313.87 78.78 313.87 79.85 301.02 87.34 300.49 86.06 313.87 78.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-789",
    d: "M304.32,88v1L274,106.46v-2.15l.34-.25c2.71-1.88,15.36-9,15.36-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-790",
    d: "M312.94,79.32,301.19,86.1,304.32,88,274,105.47h0c0-2.41,0-5.06,0-7.76v-.86c0-4.78-.06-9.69-.1-13.83,0-1.4,0-2.71,0-3.89s0-2,0-2.83l17-9.8.89-.52,22.17,12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-791",
    d: "M307.16,75.71l8.47-4.88h0c1.35-.77,1.95-2.7,1.36-5-.76-3-3.25-5.4-5.55-5.42a2.72,2.72,0,0,0-1.54.42h0L301,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-792",
    d: "M309.52,69v6.65a.58.58,0,0,1-.27.49h0l0,0-1.1.63-.31.18a.6.6,0,0,1-.43-.06l-.75-.43L306.53,75l-5-2.91a.6.6,0,0,1-.29-.51l-1.3-3.45V65a.42.42,0,0,1,.09-.25l.28-.17,1.13-.66a.46.46,0,0,1,.44,0L309,68.1A1.05,1.05,0,0,1,309.52,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-793",
    d: "M308.25,69.75v6.67a.6.6,0,0,1-.15.4.61.61,0,0,1-.31.18.6.6,0,0,1-.43-.06l-.75-.43-6.38-3.71a.62.62,0,0,1-.3-.52V65a.42.42,0,0,1,.09-.25.46.46,0,0,1,.28-.17.42.42,0,0,1,.27,0l7.16,4.16A1.07,1.07,0,0,1,308.25,69.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-794",
    d: "M306.63,72.17c-.83-3.24-3.55-5.89-6.06-5.92a3.08,3.08,0,0,0-1.68.46h0l-1.55.9L297,69.47a8.2,8.2,0,0,0-.16,2.4,13.85,13.85,0,0,0,1.64,3.43l1.41.86a6.26,6.26,0,0,0,2.83,1.7l1,.59,1.48-.85h0C306.62,76.77,307.27,74.66,306.63,72.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-795",
    cx: 300.38,
    cy: 73.11,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(2.15 154.55) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-796",
    cx: 300.38,
    cy: 73.11,
    rx: 2.97,
    ry: 4.39,
    transform: "translate(2.15 154.55) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-797",
    d: "M302.6,74.59c-.83-3.24-3.54-5.88-6.06-5.91a3,3,0,0,0-1.68.45h0l-1.55.91-.38,1.85a8.2,8.2,0,0,0-.16,2.4,14,14,0,0,0,1.64,3.44l1.42.85a6.29,6.29,0,0,0,2.82,1.71l1,.59,1.48-.85h0C302.59,79.19,303.24,77.08,302.6,74.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-798",
    cx: 296.36,
    cy: 75.53,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(0.48 152.9) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-799",
    cx: 296.36,
    cy: 75.53,
    rx: 2.52,
    ry: 3.73,
    transform: "translate(0.48 152.9) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-800",
    points: "278.01 79.81 291.81 71.78 298.02 80.61 283.72 88.87 278.01 79.81"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-801",
    cx: 288.64,
    cy: 80.32,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-802",
    points: "298.02 36.69 298.02 37.59 261.9 58.49 261.08 58.02 258.44 56.49 259.15 55.47 298.02 36.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-803",
    points: "298.02 36.69 280.37 46.88 261.08 58.02 248.4 50.7 248.4 48.15 283.13 28.09 298.02 36.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-804",
    d: "M293.47,56l10.4-6h0c2.56-1.45,3.69-5.1,2.58-9.4C305,35,300.31,30.43,296,30.39a5.18,5.18,0,0,0-2.91.79h0l-2.68,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-805",
    d: "M218.31,60.76,216.1,62a1,1,0,0,0-.48.83v45.55a2.54,2.54,0,0,0,1.28,2.21L248.79,129a1.22,1.22,0,0,0,1.83-1c.23-7.92-.08-36.91-.13-41.35a2.72,2.72,0,0,0-.25-1.09l-4-8.66a2.74,2.74,0,0,0-1.1-1.21l-25.9-14.95A1,1,0,0,0,218.31,60.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-806",
    d: "M218.79,97.08V78.78l4.08,2.35a4.52,4.52,0,0,1,2.26,3.92V97.88a1.66,1.66,0,0,1-2.48,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-807",
    d: "M218.79,64.34V75.05a.11.11,0,0,0,.06.1l.46.27a.12.12,0,0,0,.17-.1V64.6a.1.1,0,0,0-.06-.09l-.46-.27A.11.11,0,0,0,218.79,64.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-808",
    d: "M220.17,65.14V75.85a.11.11,0,0,0,.06.1l.46.27a.12.12,0,0,0,.17-.1V65.4a.11.11,0,0,0-.06-.1l-.46-.26A.11.11,0,0,0,220.17,65.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-809",
    d: "M221.55,65.93V76.65a.11.11,0,0,0,.06.1l.46.26a.11.11,0,0,0,.17-.1V66.2a.11.11,0,0,0-.06-.1l-.46-.27A.11.11,0,0,0,221.55,65.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-810",
    d: "M222.93,66.73V77.44a.11.11,0,0,0,.06.1l.46.27a.12.12,0,0,0,.17-.1V67a.1.1,0,0,0-.06-.09l-.46-.27A.11.11,0,0,0,222.93,66.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-811",
    d: "M244.14,89.87v24.66a.52.52,0,0,1-.78.4l-14.8-8.55a.54.54,0,0,1-.26-.45v-28a.51.51,0,0,1,.77-.45l0,0,12.67,7.24A.51.51,0,0,1,242,85l2.11,4.69A.49.49,0,0,1,244.14,89.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-812",
    d: "M244.14,89.87v24.66L229.36,106a.52.52,0,0,1-.26-.45V77.49l12.67,7.24A.51.51,0,0,1,242,85l2.11,4.69A.49.49,0,0,1,244.14,89.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-813",
    points: "216.9 110.63 218.79 119.04 244.93 134.13 248.79 129.04 216.9 110.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-814",
    points: "244.93 134.13 244.93 137.79 218.79 122.7 218.79 119.04 244.93 134.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-815",
    d: "M225,109.13c-.48-1.9-2.07-3.44-3.54-3.46a1.78,1.78,0,0,0-1,.27h0l-.9.52-.22,1.09a4.71,4.71,0,0,0-.1,1.4,8.57,8.57,0,0,0,1,2l.83.49a3.56,3.56,0,0,0,1.65,1l.57.35.86-.5h0C225,111.81,225.36,110.58,225,109.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-816",
    cx: 221.34,
    cy: 109.67,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-25.43 120.85) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-817",
    d: "M222.17,111a.57.57,0,0,1-.13.08.94.94,0,0,1-.34.07,1.82,1.82,0,0,1-1.47-1.44,1.11,1.11,0,0,1,.4-1.34.74.74,0,0,1,.34-.08,1.83,1.83,0,0,1,1.47,1.45A1.18,1.18,0,0,1,222.17,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-818",
    d: "M211.91,129.8c1.89.51,4-.11,4.75-1.38a1.72,1.72,0,0,0,.25-1h0v-1l-.83-.73a4.57,4.57,0,0,0-1.18-.77,8,8,0,0,0-2.21-.16l-.85.47a3.74,3.74,0,0,0-1.68,1l-.58.33v1h0C209.58,128.46,210.46,129.41,211.91,129.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-819",
    cx: 213.23,
    cy: 126.35,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(84.71 338.29) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-820",
    d: "M222.44,109.69a1.83,1.83,0,0,0-1.47-1.45.74.74,0,0,0-.34.08l-.06,0-5.3,3.05a7.18,7.18,0,0,0-3.56,6.18v6.12a.17.17,0,0,0,0,.07s0,0,0,0v2.44s0,0,0,0a.62.62,0,0,0,.08.4,1.35,1.35,0,0,0,.88.63,1.83,1.83,0,0,0,2-.57l0,0a.74.74,0,0,0,.07-.32h0v-2.48a1.1,1.1,0,0,0,0-.18v-6.12a4.1,4.1,0,0,1,2-3.53l5.24-3,.06,0,.07,0A1.18,1.18,0,0,0,222.44,109.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-821",
    d: "M284.72,88.22a5.12,5.12,0,0,1-2.21,4.62l-6.32,3.59-2.23.42h0c0-4.78-.06-9.69-.1-13.83,0-1.4,0-2.71,0-3.89l.52-.31a3.94,3.94,0,0,1,2.23-.63c3.25,0,6.76,3.46,7.84,7.64A9.87,9.87,0,0,1,284.72,88.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-822",
    points: "298.02 80.61 298.02 81.56 283.52 90.06 283.72 88.87 298.02 80.61"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-823",
    cx: 288.64,
    cy: 79.97,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-824",
    d: "M293,80a3.38,3.38,0,0,1-1,2.35,3.44,3.44,0,0,1-.54.47,4.8,4.8,0,0,1-2.51.88l-.36,0-.35,0a4.8,4.8,0,0,1-2.51-.88,4,4,0,0,1-.54-.47,3.38,3.38,0,0,1-1-2.35c0-.07,0-.13,0-.19a3.4,3.4,0,0,1,.12-.71,3.74,3.74,0,0,1,1.45-2,4.5,4.5,0,0,1,.64-.38,5.12,5.12,0,0,1,4.37,0,4.5,4.5,0,0,1,.64.38,3.74,3.74,0,0,1,1.45,2,3.4,3.4,0,0,1,.12.71C293,79.84,293,79.9,293,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "M289.5,79.78,292,82.32a3.44,3.44,0,0,1-.54.47L289,80.29v3.38l-.36,0-.35,0V80.29l-2.51,2.5a4,4,0,0,1-.54-.47l2.54-2.54h-3.53a3.4,3.4,0,0,1,.12-.71h3.41l-2-2a4.5,4.5,0,0,1,.64-.38l2.18,2.19,2.19-2.19a4.5,4.5,0,0,1,.64.38l-2,2h3.41a3.4,3.4,0,0,1,.12.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-826",
    cx: 288.64,
    cy: 79.43,
    rx: 0.64,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M288.64,79.43a7.67,7.67,0,0,1-.37-.77c0-.26,0-.52,0-.77V74a7.53,7.53,0,0,1,.36-.77A7.39,7.39,0,0,1,289,74v3.86c0,.25,0,.51,0,.77a7.53,7.53,0,0,1-.36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M285.58,66v7.2h0c0,.83.74,1.61,1.94,1.94,1.58.42,3.35-.09,4-1.15a1.4,1.4,0,0,0,.21-.82h0V66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-726",
    cx: 288.64,
    cy: 65.96,
    rx: 2.06,
    ry: 3.06,
    transform: "translate(219.74 353.9) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-827",
    d: "M280.36,24.93V64.81h0c0,2.24,2,4.36,5.27,5.25,4.26,1.15,9.06-.25,10.73-3.11a4.11,4.11,0,0,0,.57-2.23h0l0-40.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-828",
    cx: 288.63,
    cy: 25.28,
    rx: 5.59,
    ry: 8.28,
    transform: "translate(260.41 313.63) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-829",
    points: "318.57 82.58 315.59 87.82 276.71 110.22 273.98 109.13 273.97 108.2 318.57 82.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-830",
    d: "M271.24,29.78V51.71h0c0,1.23,1.09,2.4,2.89,2.88,2.34.64,5-.13,5.9-1.71a2.12,2.12,0,0,0,.31-1.22h0V29.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-831",
    cx: 275.78,
    cy: 29.97,
    rx: 3.08,
    ry: 4.55,
    transform: "translate(243.01 305.44) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-832",
    points: "323.37 46.63 336.05 39.31 336.05 64.93 323.37 72.25 323.37 46.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-833",
    points: "335.27 41.34 335.27 49.89 324.71 55.7 324.71 47.41 334.99 41.49 335.27 41.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-834",
    points: "334.99 41.49 334.99 49.72 324.71 55.37 324.71 47.41 334.99 41.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-835",
    d: "M324.71,57.09v2.27a.19.19,0,0,0,.09.16h0l.44.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.42A.35.35,0,0,0,324.71,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-836",
    d: "M325.14,57.34v2.27a.17.17,0,0,0,.06.14.17.17,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18V55.73a.11.11,0,0,0,0-.08.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0L325.32,57A.35.35,0,0,0,325.14,57.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-837",
    d: "M328.36,55v2.27a.21.21,0,0,0,.08.17h0l.45.26,0,0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.37.37,0,0,0,328.36,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-838",
    d: "M328.79,55.22V57.5a.24.24,0,0,0,0,.14.21.21,0,0,0,.1.06.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17V53.62a.16.16,0,0,0,0-.09.11.11,0,0,0-.09-.05.14.14,0,0,0-.09,0L329,54.91A.36.36,0,0,0,328.79,55.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-839",
    d: "M332,52.86v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,332,52.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "M332.43,53.11v2.28a.19.19,0,0,0,.05.13.24.24,0,0,0,.11.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18V51.5a.11.11,0,0,0,0-.08.21.21,0,0,0-.1-.06.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,332.43,53.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-841",
    d: "M337.85,43.52v2.27a.19.19,0,0,0,.09.16h0l.44.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.16.16,0,0,0-.15,0L338,43.21A.35.35,0,0,0,337.85,43.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-842",
    d: "M338.28,43.77V46a.2.2,0,0,0,.05.14.24.24,0,0,0,.11.06.2.2,0,0,0,.15,0l.25-.15L341,44.81a.22.22,0,0,0,.1-.18V42.16a.11.11,0,0,0,0-.08A.21.21,0,0,0,341,42a.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,338.28,43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-843",
    d: "M337.85,47.78v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.14.14,0,0,0-.15,0L338,47.47A.35.35,0,0,0,337.85,47.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-844",
    d: "M338.28,48v2.28a.19.19,0,0,0,.05.13.24.24,0,0,0,.11.06.2.2,0,0,0,.15,0l.25-.15L341,49.07a.21.21,0,0,0,.1-.18V46.42a.11.11,0,0,0,0-.08.21.21,0,0,0-.1-.06.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,338.28,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-845",
    d: "M324.71,61.44v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.22.22,0,0,0,.1-.18l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,324.71,61.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-846",
    d: "M325.14,61.69V64a.16.16,0,0,0,.06.13.17.17,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.21.21,0,0,0,.1-.18V60.08a.11.11,0,0,0,0-.08.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,325.14,61.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-847",
    d: "M328.36,59.32v2.27a.21.21,0,0,0,.08.17h0l.45.27h0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.17l.44-1.18V58a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0L328.53,59A.37.37,0,0,0,328.36,59.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-848",
    d: "M328.79,59.57v2.28a.22.22,0,0,0,0,.14.21.21,0,0,0,.1.06.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17V58a.16.16,0,0,0,0-.09.11.11,0,0,0-.09-.05.14.14,0,0,0-.09,0L329,59.26A.36.36,0,0,0,328.79,59.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-849",
    d: "M332,57.21v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.16.16,0,0,0,.15,0l.25-.14,0-.53,1.71-1a.22.22,0,0,0,.1-.18l.44-1.17v-1a.12.12,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,332,57.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-850",
    d: "M332.43,57.46v2.28a.19.19,0,0,0,.05.13.17.17,0,0,0,.11.06.16.16,0,0,0,.15,0l.25-.14,2.18-1.27a.21.21,0,0,0,.1-.18V55.86a.12.12,0,0,0,0-.09.21.21,0,0,0-.1-.06.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,332.43,57.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-851",
    d: "M325.06,66a1.76,1.76,0,0,1,1.42-1.38.71.71,0,0,1,.39.11h0l.36.21.09.43a2,2,0,0,1,0,.56,3.58,3.58,0,0,1-.39.81l-.33.2a1.49,1.49,0,0,1-.66.4l-.23.13-.34-.19h0A1.1,1.1,0,0,1,325.06,66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-852",
    cx: 326.52,
    cy: 66.22,
    rx: 1.47,
    ry: 0.99,
    transform: "translate(110.51 319.88) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-853",
    points: "328.93 64.47 332.91 62.17 332.91 61.52 328.93 63.81 328.93 64.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-854",
    points: "328.93 66.1 335.56 62.27 335.56 61.55 328.93 65.44 328.93 66.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-855",
    points: "250.64 105 250.64 103.61 273.92 90.17 273.93 91.55 250.64 105"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-856",
    points: "232.03 68.13 230.83 67.43 254.14 54.02 255.34 54.71 232.03 68.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-857",
    points: "300.92 28.41 299.72 27.72 330.22 10.16 331.42 10.85 300.92 28.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-858",
    points: "263.16 133.68 263.16 130.02 279 139.16 279 142.82 263.16 133.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-859",
    d: "M318.36,46.93V47L290.77,62.88,273.7,72.7a2.81,2.81,0,0,0-.18-.56l-1.59-3.46,18.84-11.07,2.7-1.59,10.4-6,12.65-7.45,1.68,3.65A1.79,1.79,0,0,1,318.36,46.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-860",
    d: "M318.38,48.59,290.77,64.4l-17,9.72c0-.36,0-.66,0-.89a2.39,2.39,0,0,0-.06-.53l17.07-9.82L318.36,47c0,.34,0,.73,0,1.16v.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-861",
    d: "M274.29,96.86H274c0-4.78-.06-9.69-.1-13.83a11.35,11.35,0,0,1,4.34,6.38C279.27,93.56,277.52,96.9,274.29,96.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-862",
    d: "M274.1,93.84h-.18c0-2.69,0-5.46-.06-7.79a6.4,6.4,0,0,1,2.45,3.6C276.91,92,275.92,93.86,274.1,93.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-863",
    points: "294.86 100.73 294.86 98.35 302.35 94.1 302.35 96.4 294.86 100.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M319.26,46.37l-41.53,64.25-.45-.17-.79-.32-.44-.18-2-.8,0,0,40.9-72.35a1.87,1.87,0,0,1,.22.39l4,8.66A3.13,3.13,0,0,1,319.26,46.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M319.43,58,287.89,104.8l-6.31,3.62,37.77-58.83C319.37,51.67,319.4,54.61,319.43,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-864",
    d: "M286.4,16.17l-1.82-1.61a16.51,16.51,0,0,0-1.17,2.16,9.15,9.15,0,0,1,.93,1.31,8.53,8.53,0,0,1,1.14,4.25v5.3l.6.39a37.36,37.36,0,0,0,1.3-5.24C287.68,20.53,286.4,16.17,286.4,16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-865",
    d: "M292.44,19v5.45L286.08,28V22.52a9.58,9.58,0,0,0-3.15-7.09c-.12-.12-.25-.22-.38-.33a9.38,9.38,0,0,0-1.26-.87,3.11,3.11,0,0,0-2.88-.14l2-1.11,3.84-2.12.61-.33h0a3.3,3.3,0,0,1,1.21-.24,3.18,3.18,0,0,1,1.57.43A9.58,9.58,0,0,1,292.44,19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-866",
    points: "284.69 268.67 284.69 272.32 259.34 286.96 259.34 283.3 284.69 268.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-867",
    points: "284.69 268.67 252.98 250.38 148.41 310.75 132.57 319.9 164.26 338.2 192.78 321.73 208.63 330.88 275.19 292.45 259.34 283.3 284.69 268.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-868",
    points: "174.56 325.85 276.76 266.84 278.1 263.89 178.42 319.05 174.56 325.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-869",
    points: "276.76 266.84 276.76 270.49 174.56 329.51 174.56 325.85 276.76 266.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-870",
    points: "132.57 319.9 132.57 323.56 164.26 341.86 192.78 325.39 208.63 334.54 275.18 296.11 275.18 292.45 208.63 330.88 192.78 321.73 164.26 338.2 132.57 319.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-871",
    d: "M279.54,262.41a.34.34,0,0,1,0,.1v.05s0,.07,0,.1a.56.56,0,0,1,0,.12,1.42,1.42,0,0,1-.08.18l0,.06a1.71,1.71,0,0,1-.11.14l-.06.07-.06.06-.07,0a.78.78,0,0,1-.15.1l-.07,0-.08,0h0l-99,57.15a1.22,1.22,0,0,1-1.37.1l-31.9-18.42a2.56,2.56,0,0,1-1.28-2.21V254.58a1,1,0,0,1,.49-.83l2.21-1.28h0L245,196.42l.42-.24.18-.11,1.6-.93a1,1,0,0,1,1,0l25.9,15a2.32,2.32,0,0,1,.5.37l.15.15a2.54,2.54,0,0,1,.36.5,1.74,1.74,0,0,1,.1.19l4,8.65a2.79,2.79,0,0,1,.24,1.1C279.45,225.49,279.76,254.49,279.54,262.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-872",
    d: "M261.7,257.91l-.22-.56-2.28.48-2.69,1.82L255.24,262l2.38,2.72,5.49-3.14h0a1.49,1.49,0,0,0,.8-1.33v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-873",
    d: "M258.34,259.37v4a1.5,1.5,0,0,1-2.26,1.29l-2.57-1.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-874",
    points: "265.67 231.03 255.09 258.54 253 263.96 251.44 263.1 251.44 237.48 264.12 230.16 265.67 231.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-875",
    points: "255.09 258.54 253 263.96 251.44 263.1 251.44 237.48 253 238.34 255.09 258.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-876",
    points: "256.26 253.54 256.26 252.16 279.54 238.72 279.55 240.09 256.26 253.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-877",
    d: "M275.19,211.31,175.9,268.64c-4.21,1.81-1.1-1.21-1.1-1.21l99.28-57.33A2.65,2.65,0,0,1,275.19,211.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-878",
    d: "M279.4,221.06l-34.87,20.13-64.42,37.2s-2.58.83-.24-1.1L244.53,240l34.63-20A2.79,2.79,0,0,1,279.4,221.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-879",
    d: "M249.15,274.55h0l-3.23,5.69-28.4,16.27-6.32,3.62h0l-3.85,2.21-.44-.18-.27-.1a2.22,2.22,0,0,0-.31-.13h0l-.21-.08-.45-.18-.36-.15-.3-.12-.31-.12-.36-.14L204,301l-.2-.08-.14-.05,0,0,0,0s0,0,0,0h0c0-3.24,0-7.24,0-11.4,0-.28,0-.57,0-.86,0-4.77-.06-9.69-.09-13.83,0-1.39,0-2.7,0-3.89,0-2.81,0-4.93-.06-5.89a2.64,2.64,0,0,0-.25-1.1l-4-8.65a2.71,2.71,0,0,0-1.11-1.21l-20-11.57v-3.66l36.05-20.82,3.3-1.9h6.08l20.17,11.64a2.65,2.65,0,0,1,.88.82,2.46,2.46,0,0,1,.22.39l4,8.65a2.72,2.72,0,0,1,.18.55,3.33,3.33,0,0,1,.07.54c0,.55,0,1.47,0,2.68,0,2.08.05,5,.08,8.37C249.12,257.56,249.19,267.74,249.15,274.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-880",
    d: "M212.55,207.14v15.44l-5.88-1.68-.47.26V208.67a3.1,3.1,0,0,1,1.41-2.63h0l.39-.22h0a3.13,3.13,0,0,1,2.88.13,9.27,9.27,0,0,1,1.27.88C212.31,206.92,212.43,207,212.55,207.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-881",
    d: "M213.35,205.52l-3.3-.83-2,1.12h0l-.39.22h0a3.1,3.1,0,0,0-1.41,2.63v12.49l.47-.26V209.05a2.76,2.76,0,0,1,1.25-2.33h0l.36-.2a2.78,2.78,0,0,1,2.56.13,7.93,7.93,0,0,1,1.12.77l.33.29c.08.08.17.15.24.23a5.79,5.79,0,0,1,.48.51,16.64,16.64,0,0,1,1.17-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-882",
    d: "M248.19,274.29l-3,5.24-38.88,22.4h0l-2.72-1.09s0,0,0,0h0v-.9c0-.87,0-1.79,0-2.74h0c0-2.41,0-5.05,0-7.76,0-.28,0-.57,0-.86,0-4.77-.06-9.69-.09-13.83,0-1.39,0-2.7,0-3.89,0-1,0-2,0-2.83h0c0-.86,0-1.59,0-2.16,0-.36,0-.66,0-.89a2.33,2.33,0,0,0-.06-.53,2.39,2.39,0,0,0-.19-.57l-.46-1-1.12-2.45-2.38-5.2a2.78,2.78,0,0,0-.74-1,3,3,0,0,0-.37-.25l-6.54-3.78-.82-.47-2.65-1.53-.27-.15L178,242.42v-2.56l34.73-20.05,4.88-2.82h5.57l19.94,11.52a1.73,1.73,0,0,1,.71.78l2.29,5,1.68,3.66a1.71,1.71,0,0,1,.16.71v.06c0,.34,0,.72,0,1.15a1.55,1.55,0,0,0,0,.22v.55c0,.23,0,.46,0,.69v.57c0,.11,0,.22,0,.34V243c0,.19,0,.4,0,.6,0,.44,0,.89,0,1.36,0,.3,0,.61,0,.93,0,.67,0,1.36,0,2.08,0,.28,0,.57,0,.87s0,.63,0,1v.65c0,.64,0,1.28,0,1.94,0,.45,0,.9,0,1.36v1.44c0,.38,0,.77,0,1.16v4.1C248.2,265.47,248.21,270.4,248.19,274.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-883",
    d: "M214.19,246.53v8.67l-11.51,7.65-1.12-2.45-2.38-5.2a2.78,2.78,0,0,0-.74-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-884",
    d: "M214.19,246.53l-15,8.67a2.71,2.71,0,0,0-1.11-1.21l-6.54-3.78-.82-.47-2.65-1.53-.27-.15,21.11-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-885",
    d: "M203.61,296c0-2.08,0-4.32,0-6.6,0-.28,0-.57,0-.86,0-4.77-.06-9.69-.09-13.83,0-1.39,0-2.7,0-3.89,0-1,0-2,0-2.83h0l17-9.81,0,0L242.56,271l5.63,3.26L203.6,299.92v-1.74c0-.33,0-.66,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-886",
    d: "M248.19,274.29l-27.8-16.1V217h2.82l19.94,11.52a1.73,1.73,0,0,1,.71.78l2.29,5,1.68,3.66a1.71,1.71,0,0,1,.16.71v.06c0,.45,0,1,0,1.6C248.08,247.37,248.24,264.25,248.19,274.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-887",
    points: "243.49 270.49 243.49 271.57 230.65 279.05 230.11 277.78 243.49 270.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-888",
    d: "M234,279.66v1L203.6,298.18c0-.33,0-.66,0-1V296l.33-.24c2.72-1.88,15.36-9,15.36-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-889",
    d: "M242.56,271l-11.75,6.78,3.14,1.85-30.34,17.52h0c0-2.41,0-5.05,0-7.76,0-.28,0-.57,0-.86,0-4.77-.06-9.69-.09-13.83,0-1.39,0-2.7,0-3.89,0-1,0-2,0-2.83l17-9.8.89-.51,22.17,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-890",
    d: "M236.79,267.43l8.46-4.89h0c1.36-.76,2-2.7,1.37-5-.76-3-3.25-5.39-5.55-5.42a2.86,2.86,0,0,0-1.54.42h0l-8.89,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-891",
    d: "M239.14,260.73v6.65a.61.61,0,0,1-.26.49h0l-.05,0-1.1.64-.31.18a.61.61,0,0,1-.43-.07l-.74-.43-.08-1.54-5-2.91a.62.62,0,0,1-.3-.52l-1.29-3.44v-3.05a.45.45,0,0,1,.08-.26l.29-.16,1.13-.66a.39.39,0,0,1,.43,0l7.13,4.14A1.05,1.05,0,0,1,239.14,260.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-892",
    d: "M237.88,261.46v6.68a.56.56,0,0,1-.16.4.59.59,0,0,1-.74.11l-.74-.43-6.38-3.71a.59.59,0,0,1-.3-.52v-7.23a.45.45,0,0,1,.08-.26.43.43,0,0,1,.29-.16.38.38,0,0,1,.27.05l7.15,4.16A1.05,1.05,0,0,1,237.88,261.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-893",
    d: "M236.26,263.88c-.84-3.23-3.55-5.88-6.06-5.91a3,3,0,0,0-1.68.46h0l-1.55.9-.38,1.86a7.75,7.75,0,0,0-.16,2.39,14,14,0,0,0,1.64,3.44l1.41.85a6.32,6.32,0,0,0,2.83,1.71l1,.59,1.47-.85h0C236.24,268.48,236.9,266.37,236.26,263.88Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-894",
    cx: 230.01,
    cy: 264.82,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(-99.45 144.44) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-895",
    cx: 230.01,
    cy: 264.82,
    rx: 2.97,
    ry: 4.39,
    transform: "translate(-99.45 144.44) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-896",
    d: "M232.23,266.31c-.83-3.24-3.55-5.89-6.06-5.92a3.08,3.08,0,0,0-1.68.46h0l-1.55.9-.38,1.86a8.2,8.2,0,0,0-.16,2.4,13.85,13.85,0,0,0,1.64,3.43l1.41.86a6.21,6.21,0,0,0,2.83,1.7l1,.59,1.48-.85h0C232.21,270.91,232.87,268.8,232.23,266.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-897",
    cx: 225.98,
    cy: 267.25,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(-101.13 142.79) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-898",
    cx: 225.98,
    cy: 267.25,
    rx: 2.52,
    ry: 3.73,
    transform: "translate(-101.13 142.79) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-899",
    points: "207.64 271.52 221.44 263.5 227.64 272.32 213.34 280.58 207.64 271.52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-900",
    cx: 218.26,
    cy: 272.04,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-901",
    points: "227.64 228.41 227.64 229.31 191.53 250.21 190.71 249.74 188.06 248.21 188.78 247.19 227.64 228.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-902",
    points: "227.64 228.41 209.99 238.6 190.71 249.74 178.03 242.42 178.03 239.86 212.76 219.81 227.64 228.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-903",
    d: "M223.09,247.73l10.41-6h0c2.55-1.44,3.69-5.09,2.58-9.4-1.44-5.6-6.14-10.18-10.49-10.23a5.23,5.23,0,0,0-2.9.79h0L220,224.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-904",
    d: "M147.93,252.47l-2.2,1.28a1,1,0,0,0-.48.83v45.55a2.55,2.55,0,0,0,1.27,2.21l31.9,18.42a1.22,1.22,0,0,0,1.83-1c.22-7.92-.09-36.92-.14-41.35a2.63,2.63,0,0,0-.24-1.1l-4-8.65a2.69,2.69,0,0,0-1.1-1.21l-25.9-15A1,1,0,0,0,147.93,252.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-905",
    d: "M148.41,288.79v-18.3l4.08,2.36a4.52,4.52,0,0,1,2.26,3.91v12.83a1.65,1.65,0,0,1-2.48,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-906",
    d: "M148.41,256.05v10.72a.13.13,0,0,0,.06.1l.46.26a.11.11,0,0,0,.17-.1V256.32a.12.12,0,0,0,0-.1l-.46-.26A.12.12,0,0,0,148.41,256.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-907",
    d: "M149.79,256.85v10.72a.11.11,0,0,0,.06.09l.46.27a.11.11,0,0,0,.17-.1V257.12a.12.12,0,0,0,0-.1l-.46-.27A.12.12,0,0,0,149.79,256.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "M151.17,257.65v10.71a.13.13,0,0,0,.06.1l.46.27a.11.11,0,0,0,.17-.1V257.91a.12.12,0,0,0-.05-.1l-.46-.26A.12.12,0,0,0,151.17,257.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-909",
    d: "M152.55,258.44v10.72a.13.13,0,0,0,.06.1l.46.26a.11.11,0,0,0,.17-.1V258.71a.12.12,0,0,0-.05-.1l-.46-.26A.12.12,0,0,0,152.55,258.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-910",
    d: "M173.77,281.59v24.65a.52.52,0,0,1-.78.4l-14.81-8.55a.51.51,0,0,1-.26-.45v-28a.52.52,0,0,1,.78-.45h0l12.67,7.25a.51.51,0,0,1,.22.24l2.1,4.68A.54.54,0,0,1,173.77,281.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "M173.77,281.59v24.65L159,297.71a.54.54,0,0,1-.26-.45V269.2l12.67,7.25a.51.51,0,0,1,.22.24l2.1,4.68A.54.54,0,0,1,173.77,281.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-912",
    points: "146.52 302.34 148.41 310.75 174.56 325.85 178.42 320.76 146.52 302.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-913",
    points: "174.56 325.85 174.56 329.51 148.41 314.41 148.41 310.75 174.56 325.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-914",
    d: "M154.61,300.84c-.49-1.89-2.07-3.44-3.54-3.45a1.77,1.77,0,0,0-1,.26h0l-.91.53-.22,1.08a4.55,4.55,0,0,0-.09,1.4,8,8,0,0,0,1,2l.82.5a3.7,3.7,0,0,0,1.65,1l.58.34.86-.5h0C154.6,303.53,155,302.29,154.61,300.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-915",
    cx: 150.96,
    cy: 301.39,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-127.03 110.74) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-916",
    d: "M151.8,302.66l-.14.08a.7.7,0,0,1-.33.07,1.81,1.81,0,0,1-1.48-1.43,1.12,1.12,0,0,1,.41-1.35.7.7,0,0,1,.33-.07,1.83,1.83,0,0,1,1.48,1.44A1.22,1.22,0,0,1,151.8,302.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-917",
    d: "M141.54,321.51c1.88.51,4-.11,4.75-1.38a1.77,1.77,0,0,0,.25-1h0v-1l-.84-.73a5,5,0,0,0-1.17-.77,8.36,8.36,0,0,0-2.22-.15l-.84.47a3.6,3.6,0,0,0-1.68.95l-.58.32v1h0C139.2,320.18,140.09,321.12,141.54,321.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-918",
    cx: 142.86,
    cy: 318.07,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-176.65 457.68) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-919",
    d: "M152.07,301.4a1.83,1.83,0,0,0-1.48-1.44.7.7,0,0,0-.33.07l-.06,0-5.3,3.06a7.17,7.17,0,0,0-3.56,6.18V318a.64.64,0,0,0,.08.4,1.38,1.38,0,0,0,.88.63,1.85,1.85,0,0,0,2-.58s0,0,0-.05a.6.6,0,0,0,.08-.31h0v-2.47h0a1.21,1.21,0,0,0,0-.19V309.3a4.11,4.11,0,0,1,2-3.53l5.23-3,.06,0,.08,0A1.22,1.22,0,0,0,152.07,301.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-920",
    d: "M214.35,279.93a5.09,5.09,0,0,1-2.22,4.62l-6.32,3.59-2.22.42c0-.28,0,0,0,0,0-4.77-.06-9.69-.09-13.83,0-1.39,0-2.7,0-3.89l.52-.3a3.82,3.82,0,0,1,2.23-.63c3.25,0,6.75,3.45,7.83,7.64A9.36,9.36,0,0,1,214.35,279.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-921",
    points: "227.64 272.32 227.64 273.27 213.15 281.77 213.34 280.58 227.64 272.32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-922",
    cx: 218.26,
    cy: 271.68,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-923",
    d: "M222.66,271.68a3.37,3.37,0,0,1-1,2.36,4.13,4.13,0,0,1-.55.47,4.73,4.73,0,0,1-2.5.88h-.72a4.76,4.76,0,0,1-2.5-.88,3.5,3.5,0,0,1-.54-.47,3.34,3.34,0,0,1-1-2.36v-.18a3.39,3.39,0,0,1,.13-.72,3.67,3.67,0,0,1,1.45-1.95,3.72,3.72,0,0,1,.64-.38,5.09,5.09,0,0,1,4.36,0,3.81,3.81,0,0,1,.65.38,3.65,3.65,0,0,1,1.44,1.95,3.39,3.39,0,0,1,.13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-924",
    d: "M219.13,271.5l2.54,2.54a4.13,4.13,0,0,1-.55.47l-2.5-2.5v3.38h-.72V272l-2.5,2.5a3.5,3.5,0,0,1-.54-.47l2.53-2.54h-3.53a3.39,3.39,0,0,1,.13-.72h3.4l-1.95-1.95a3.72,3.72,0,0,1,.64-.38l2.18,2.18,2.18-2.18a3.81,3.81,0,0,1,.65.38l-2,1.95h3.4a3.39,3.39,0,0,1,.13.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-925",
    cx: 218.26,
    cy: 271.14,
    rx: 0.64,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M218.26,271.14a6.65,6.65,0,0,1-.36-.77c0-.26,0-.51,0-.77v-3.85c.11-.26.22-.51.36-.77a6.65,6.65,0,0,1,.36.77v4.62a5.32,5.32,0,0,1-.36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M215.21,257.67v7.21h0c0,.82.73,1.61,1.94,1.93,1.57.43,3.34-.09,4-1.14a1.48,1.48,0,0,0,.21-.82h0V257.7Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-726",
    cx: 218.26,
    cy: 257.67,
    rx: 2.06,
    ry: 3.06,
    transform: "translate(-41.62 473.3) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-926",
    d: "M210,216.65l0,39.88h0c0,2.23,2,4.36,5.27,5.24,4.25,1.15,9.06-.24,10.72-3.11a3.91,3.91,0,0,0,.57-2.22h0l0-40.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-927",
    cx: 218.25,
    cy: 216.99,
    rx: 5.59,
    ry: 8.28,
    transform: "translate(-0.95 433.02) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-928",
    points: "248.19 274.29 245.21 279.54 206.33 301.93 203.61 300.84 203.6 299.92 248.19 274.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "M200.86,221.5v21.92h0c0,1.23,1.1,2.4,2.9,2.89,2.34.63,5-.13,5.9-1.71a2.22,2.22,0,0,0,.31-1.22h0V221.16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-930",
    cx: 205.41,
    cy: 221.69,
    rx: 3.08,
    ry: 4.55,
    transform: "translate(-18.36 424.83) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-931",
    points: "253 238.34 265.67 231.03 265.67 256.64 253 263.96 253 238.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-932",
    points: "264.89 233.05 264.89 241.61 254.34 247.41 254.34 239.12 264.61 233.21 264.89 233.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-933",
    points: "264.61 233.21 264.61 241.44 254.34 247.09 254.34 239.12 264.61 233.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-934",
    d: "M254.34,248.8v2.27a.22.22,0,0,0,.09.17h0l.44.26,0,0a.22.22,0,0,0,.14,0l.26-.15,0-.53,1.7-1a.2.2,0,0,0,.11-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.38.38,0,0,0,254.34,248.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-935",
    d: "M254.77,249.05v2.28a.19.19,0,0,0,.16.2.22.22,0,0,0,.14,0l.26-.15,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.16.16,0,0,0,0-.09.14.14,0,0,0-.1-.05.14.14,0,0,0-.09,0L255,248.74A.38.38,0,0,0,254.77,249.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-936",
    d: "M258,246.69V249a.19.19,0,0,0,.09.16h0l.44.26h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.22.22,0,0,0,.1-.18l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,258,246.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-937",
    d: "M258.41,246.94v2.28a.16.16,0,0,0,.06.13.17.17,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.21.21,0,0,0,.1-.18v-2.47a.11.11,0,0,0,0-.08.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0l-2.44,1.42A.35.35,0,0,0,258.41,246.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-938",
    d: "M261.63,244.57v2.27a.21.21,0,0,0,.08.17h0l.44.27h0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.37.37,0,0,0,261.63,244.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-939",
    d: "M262.06,244.82v2.28a.22.22,0,0,0,.05.14.21.21,0,0,0,.1.06.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.16.16,0,0,0,0-.09.11.11,0,0,0-.09,0,.18.18,0,0,0-.1,0l-2.44,1.42A.37.37,0,0,0,262.06,244.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-940",
    d: "M267.48,235.23v2.27a.21.21,0,0,0,.08.17h0l.45.26,0,0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.37.37,0,0,0,267.48,235.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-941",
    d: "M267.91,235.48v2.28a.22.22,0,0,0,0,.14.21.21,0,0,0,.1.06.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.16.16,0,0,0,0-.09.11.11,0,0,0-.09,0,.14.14,0,0,0-.09,0l-2.44,1.42A.36.36,0,0,0,267.91,235.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-942",
    d: "M267.48,239.49v2.27a.21.21,0,0,0,.08.17h0l.45.27h0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.37.37,0,0,0,267.48,239.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-943",
    d: "M267.91,239.74V242a.22.22,0,0,0,0,.14.21.21,0,0,0,.1.06.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.16.16,0,0,0,0-.09.11.11,0,0,0-.09-.05.14.14,0,0,0-.09,0l-2.44,1.42A.36.36,0,0,0,267.91,239.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-944",
    d: "M254.34,253.15v2.27a.22.22,0,0,0,.09.17h0l.44.27h0a.22.22,0,0,0,.14,0l.26-.15,0-.53,1.7-1a.2.2,0,0,0,.11-.17l.44-1.18v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.38.38,0,0,0,254.34,253.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-945",
    d: "M254.77,253.4v2.28a.22.22,0,0,0,0,.14.24.24,0,0,0,.11.06.22.22,0,0,0,.14,0l.26-.15,2.18-1.27a.19.19,0,0,0,.1-.17V251.8a.16.16,0,0,0,0-.09.14.14,0,0,0-.1-.05.14.14,0,0,0-.09,0L255,253.09A.38.38,0,0,0,254.77,253.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-946",
    d: "M258,251v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.16.16,0,0,0,.15,0l.25-.14,0-.53,1.71-1a.22.22,0,0,0,.1-.18l.44-1.17v-1a.12.12,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,258,251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-947",
    d: "M258.41,251.29v2.28a.16.16,0,0,0,.06.13.13.13,0,0,0,.1.06.16.16,0,0,0,.15,0l.25-.14,2.18-1.27a.21.21,0,0,0,.1-.18v-2.46a.12.12,0,0,0,0-.09.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0L258.59,251A.35.35,0,0,0,258.41,251.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-948",
    d: "M261.63,248.93v2.26a.2.2,0,0,0,.08.17h0l.44.27h0a.2.2,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.17l.44-1.18v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0l-2.43,1.41A.37.37,0,0,0,261.63,248.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-949",
    d: "M262.06,249.18v2.27a.22.22,0,0,0,.05.14.21.21,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18v-2.47a.16.16,0,0,0,0-.09.11.11,0,0,0-.09,0,.13.13,0,0,0-.1,0l-2.44,1.41A.37.37,0,0,0,262.06,249.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-950",
    d: "M254.68,257.72a1.74,1.74,0,0,1,1.42-1.38.63.63,0,0,1,.39.1h0l.37.21.09.44a1.76,1.76,0,0,1,0,.56,3.14,3.14,0,0,1-.38.8l-.33.2a1.49,1.49,0,0,1-.66.4l-.23.14L255,259h0A1.1,1.1,0,0,1,254.68,257.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-951",
    cx: 256.15,
    cy: 257.94,
    rx: 1.47,
    ry: 0.99,
    transform: "translate(-93.55 357.21) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-952",
    points: "258.56 256.19 262.54 253.89 262.54 253.23 258.56 255.52 258.56 256.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-953",
    points: "258.56 257.81 265.18 253.99 265.18 253.27 258.56 257.15 258.56 257.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-954",
    points: "180.27 296.71 180.27 295.33 203.54 281.89 203.55 283.27 180.27 296.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-955",
    points: "161.65 259.84 160.46 259.15 183.77 245.73 184.97 246.42 161.65 259.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-956",
    points: "230.55 220.12 229.35 219.43 259.85 201.88 261.05 202.57 230.55 220.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-957",
    points: "192.78 325.39 192.78 321.73 208.63 330.88 208.63 334.54 192.78 325.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-958",
    d: "M248,238.65v.06l-27.6,15.88-17.06,9.83a2.39,2.39,0,0,0-.19-.57l-1.58-3.45,18.83-11.08,2.7-1.59,10.41-6,12.65-7.45,1.68,3.66A1.71,1.71,0,0,1,248,238.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-959",
    d: "M248,240.31l-27.62,15.8-17,9.73c0-.36,0-.66,0-.89a2.33,2.33,0,0,0-.06-.53l17.06-9.83L248,238.71c0,.34,0,.72,0,1.15,0,.08,0,.15,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-960",
    d: "M203.92,288.58l-.34,0c0-4.77-.06-9.69-.09-13.83a11.38,11.38,0,0,1,4.34,6.38C208.9,285.27,207.15,288.62,203.92,288.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-961",
    d: "M203.73,285.56h-.19c0-2.69,0-5.46,0-7.8a6.45,6.45,0,0,1,2.44,3.6C206.54,283.69,205.55,285.58,203.73,285.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-962",
    points: "224.48 292.45 224.48 290.07 231.98 285.82 231.98 288.11 224.48 292.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M248.88,238.09l-41.53,64.25-.44-.18-.79-.31-.45-.18-2-.81,0,0,40.9-72.34a2.46,2.46,0,0,1,.22.39l4,8.65A2.72,2.72,0,0,1,248.88,238.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M249.05,249.68l-31.53,46.83-6.32,3.62L249,241.31C249,243.39,249,246.32,249.05,249.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-963",
    d: "M216,207.89l-1.82-1.62a16.64,16.64,0,0,0-1.17,2.17,8.21,8.21,0,0,1,.94,1.31A8.52,8.52,0,0,1,215.1,214v5.3l.6.39a35.8,35.8,0,0,0,1.3-5.25C217.3,212.25,216,207.89,216,207.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-964",
    d: "M222.06,210.72v5.45l-6.36,3.52v-5.45a9.54,9.54,0,0,0-1.28-4.79,9.44,9.44,0,0,0-1.87-2.31c-.12-.11-.24-.22-.37-.32a9.27,9.27,0,0,0-1.27-.88,3.13,3.13,0,0,0-2.88-.13l2-1.12,3.84-2.11.6-.34h0a3.13,3.13,0,0,1,2.77.18A9.57,9.57,0,0,1,222.06,210.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-965",
    points: "152.12 191.44 152.12 195.1 126.77 209.74 126.77 206.08 152.12 191.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-966",
    points: "152.12 191.44 120.41 173.16 15.85 233.53 0 242.68 31.69 260.98 60.21 244.51 76.06 253.66 142.62 215.23 126.77 206.08 152.12 191.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-967",
    points: "41.99 248.63 144.19 189.62 145.53 186.67 45.85 241.82 41.99 248.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-968",
    points: "144.19 189.62 144.19 193.27 41.99 252.28 41.99 248.63 144.19 189.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-969",
    points: "0 242.68 0 246.34 31.69 264.64 60.21 248.17 76.06 257.32 142.61 218.89 142.61 215.23 76.06 253.66 60.21 244.51 31.69 260.98 0 242.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-970",
    d: "M147,185.19a.34.34,0,0,1,0,.1v.05s0,.07,0,.1a.56.56,0,0,1,0,.12,1.42,1.42,0,0,1-.08.18l0,.06a.76.76,0,0,1-.11.14l-.06.07-.06.06-.07.05-.14.1-.08,0-.08,0h0l-99,57.15a1.22,1.22,0,0,1-1.37.1L14,225.12a2.55,2.55,0,0,1-1.27-2.21V177.36a1,1,0,0,1,.48-.83l2.21-1.28h0l97.07-56,.42-.24.18-.11,1.61-.93a1,1,0,0,1,1,0l25.9,15a2.59,2.59,0,0,1,.5.37l.14.15a2.59,2.59,0,0,1,.37.5l.09.19,4,8.65a2.63,2.63,0,0,1,.24,1.1C146.88,148.27,147.19,177.27,147,185.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-971",
    d: "M129.13,180.69l-.21-.57-2.29.48-2.69,1.83-1.27,2.32,2.38,2.71,5.49-3.13h0a1.5,1.5,0,0,0,.79-1.33v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-972",
    d: "M125.77,182.15v4a1.49,1.49,0,0,1-2.26,1.28L120.94,186Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-973",
    points: "133.1 153.81 122.52 181.32 120.43 186.74 118.87 185.88 118.87 160.25 131.55 152.94 133.1 153.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-974",
    points: "122.52 181.32 120.43 186.74 118.87 185.88 118.87 160.25 120.43 161.12 122.52 181.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-975",
    points: "123.69 176.32 123.69 174.94 146.97 161.5 146.98 162.87 123.69 176.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-976",
    d: "M142.62,134.09,43.33,191.42c-4.21,1.81-1.1-1.21-1.1-1.21l99.29-57.33A2.69,2.69,0,0,1,142.62,134.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-977",
    d: "M146.83,143.84,112,164l-64.43,37.2s-2.58.83-.24-1.1L112,162.73l34.62-20A2.63,2.63,0,0,1,146.83,143.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-978",
    d: "M116.58,197.33h0L113.35,203,85,219.29l-6.32,3.62h0l-3.85,2.21-.44-.18-.27-.11-.3-.12h0l-.21-.08-.45-.18-.36-.15-.3-.12-.31-.12-.36-.14-.3-.13-.2-.08-.14-.05,0,0,0,0s0,0,0,0h0c0-3.24,0-7.24,0-11.4v-.86c0-4.77-.07-9.69-.1-13.83,0-1.39,0-2.7,0-3.89,0-2.81,0-4.93-.06-5.89a2.64,2.64,0,0,0-.25-1.1l-4-8.65a2.71,2.71,0,0,0-1.11-1.21l-20-11.57v-3.66l36.05-20.82,3.3-1.91H90.9l20.16,11.65a2.65,2.65,0,0,1,.88.82,1.87,1.87,0,0,1,.22.39l4,8.65a2.72,2.72,0,0,1,.18.55,3.33,3.33,0,0,1,.07.54c0,.55,0,1.47,0,2.68,0,2.08.06,5,.08,8.37C116.55,180.33,116.62,190.52,116.58,197.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-979",
    d: "M80,129.92v15.44l-5.89-1.68-.47.26V131.45A3.1,3.1,0,0,1,75,128.82h0l.39-.22h0a3.13,3.13,0,0,1,2.88.13,8.69,8.69,0,0,1,1.27.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-980",
    d: "M80.79,128.3l-3.31-.83-2,1.12h0l-.39.22h0a3.1,3.1,0,0,0-1.41,2.63v12.49l.47-.26V131.83a2.76,2.76,0,0,1,1.25-2.33h0l.36-.2a2.78,2.78,0,0,1,2.56.13,7.93,7.93,0,0,1,1.12.77l.33.29a2.73,2.73,0,0,1,.25.23c.16.16.32.33.47.51a16.64,16.64,0,0,1,1.17-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-981",
    d: "M115.63,197.07l-3,5.24-38.87,22.4h0L71,223.62s0,0,0,0h0v-.9c0-.87,0-1.79,0-2.74h0c0-2.41,0-5.05,0-7.76v-.86c0-4.77-.07-9.69-.1-13.83,0-1.39,0-2.7,0-3.89,0-1,0-2,0-2.83h0c0-.86,0-1.59,0-2.16,0-.36,0-.66,0-.89a2.33,2.33,0,0,0-.06-.53,2.39,2.39,0,0,0-.19-.57l-.45-1L69,183.18,66.61,178a2.78,2.78,0,0,0-.74-1,3,3,0,0,0-.37-.25L59,173l-.82-.47L55.5,171l-.27-.16-9.77-5.63v-2.56l34.73-20,4.88-2.82h5.57l19.94,11.51a1.75,1.75,0,0,1,.71.79l2.29,5,1.68,3.66a1.71,1.71,0,0,1,.16.71v.06c0,.34,0,.72,0,1.15a1.55,1.55,0,0,0,0,.22v.55c0,.23,0,.46,0,.69s0,.37,0,.57v1.15c0,.19,0,.4,0,.6,0,.44,0,.89,0,1.36,0,.3,0,.61,0,.93,0,.66,0,1.36,0,2.07,0,.29,0,.58,0,.88s0,.63,0,1v.65c0,.64,0,1.28,0,1.94,0,.45,0,.9,0,1.36,0,.2,0,.41,0,.62V178c0,.38,0,.77,0,1.16v4.1C115.63,188.25,115.64,193.18,115.63,197.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-982",
    d: "M81.62,169.31V178l-11.5,7.65L69,183.18,66.61,178a2.78,2.78,0,0,0-.74-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-983",
    d: "M81.62,169.31l-15,8.67a2.71,2.71,0,0,0-1.11-1.21L59,173l-.82-.47L55.5,171l-.27-.16,21.1-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-984",
    d: "M71,218.8c0-2.08,0-4.32,0-6.6v-.86c0-4.77-.07-9.69-.1-13.83,0-1.39,0-2.7,0-3.89,0-1,0-2,0-2.83h0l17-9.81,0,0L110,193.81l5.64,3.26L71,222.7V221c0-.33,0-.66,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-985",
    d: "M115.63,197.07,87.82,181v-41.2h2.82l19.94,11.51a1.75,1.75,0,0,1,.71.79l2.29,5,1.68,3.66a1.71,1.71,0,0,1,.16.71v.06c0,.45,0,1,0,1.6C115.51,170.15,115.67,187,115.63,197.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-986",
    points: "110.92 193.27 110.92 194.35 98.08 201.83 97.54 200.56 110.92 193.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-987",
    d: "M101.38,202.44v1.05L71,221c0-.33,0-.66,0-1V218.8l.33-.24c2.72-1.88,15.37-9,15.37-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-988",
    d: "M110,193.81l-11.75,6.78,3.14,1.85L71,220h0c0-2.41,0-5.05,0-7.76v-.86c0-4.77-.07-9.69-.1-13.83,0-1.39,0-2.7,0-3.89,0-1,0-2,0-2.83l17-9.8.89-.51,22.17,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-989",
    d: "M104.22,190.21l8.46-4.89h0c1.36-.76,2-2.7,1.37-5-.76-3-3.25-5.39-5.55-5.42a2.86,2.86,0,0,0-1.54.42h0l-8.88,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-990",
    d: "M106.57,183.51v6.65a.58.58,0,0,1-.26.49h0l0,0-1.1.64-.3.18a.63.63,0,0,1-.44-.07l-.74-.43-.08-1.54-5-2.91a.62.62,0,0,1-.3-.52L97,182.59v-3.05a.39.39,0,0,1,.09-.26l.28-.16,1.13-.66a.39.39,0,0,1,.43,0l7.13,4.14A1.05,1.05,0,0,1,106.57,183.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-991",
    d: "M105.31,184.24v6.68a.56.56,0,0,1-.16.4.62.62,0,0,1-.3.18.63.63,0,0,1-.44-.07l-.74-.43-6.38-3.71a.59.59,0,0,1-.3-.52v-7.23a.39.39,0,0,1,.09-.26.4.4,0,0,1,.28-.16.38.38,0,0,1,.27,0l7.16,4.16A1.07,1.07,0,0,1,105.31,184.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-992",
    d: "M103.69,186.66c-.84-3.24-3.55-5.88-6.06-5.91a2.92,2.92,0,0,0-1.68.46h0l-1.55.9L94,184a7.75,7.75,0,0,0-.16,2.39,14,14,0,0,0,1.64,3.44l1.41.85a6.32,6.32,0,0,0,2.83,1.71l1,.59,1.47-.85h0C103.67,191.26,104.33,189.15,103.69,186.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-993",
    cx: 97.44,
    cy: 187.6,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(-78.64 70.62) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-994",
    cx: 97.44,
    cy: 187.6,
    rx: 2.97,
    ry: 4.39,
    transform: "translate(-78.64 70.62) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-995",
    d: "M99.66,189.09c-.83-3.24-3.55-5.89-6.06-5.92a3.08,3.08,0,0,0-1.68.46h0l-1.55.9L90,186.39a8.2,8.2,0,0,0-.16,2.4,13.85,13.85,0,0,0,1.64,3.43l1.41.86a6.26,6.26,0,0,0,2.83,1.7l1,.59,1.48-.85h0C99.65,193.69,100.3,191.58,99.66,189.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-996",
    cx: 93.41,
    cy: 190.02,
    rx: 4.24,
    ry: 6.28,
    transform: "translate(-80.31 68.97) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-997",
    cx: 93.41,
    cy: 190.02,
    rx: 2.52,
    ry: 3.73,
    transform: "translate(-80.31 68.97) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-998",
    points: "75.07 194.3 88.87 186.28 95.08 195.1 80.77 203.36 75.07 194.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-999",
    cx: 85.69,
    cy: 194.82,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1000",
    points: "95.08 151.19 95.08 152.08 58.96 172.99 58.14 172.51 55.5 170.99 56.21 169.97 95.08 151.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1001",
    points: "95.08 151.19 77.42 161.38 58.14 172.51 45.46 165.2 45.46 162.64 80.19 142.59 95.08 151.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1002",
    d: "M90.53,170.51l10.4-6h0c2.55-1.44,3.69-5.09,2.58-9.4-1.44-5.6-6.14-10.18-10.49-10.23a5.25,5.25,0,0,0-2.9.79h0l-2.68,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1003",
    d: "M15.37,175.25l-2.21,1.28a1,1,0,0,0-.48.83v45.55A2.55,2.55,0,0,0,14,225.12l31.9,18.42a1.22,1.22,0,0,0,1.83-1c.22-7.92-.09-36.92-.14-41.35a2.63,2.63,0,0,0-.24-1.1l-4-8.65a2.69,2.69,0,0,0-1.1-1.21l-25.9-15A1,1,0,0,0,15.37,175.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1004",
    d: "M15.85,211.57v-18.3l4.08,2.36a4.53,4.53,0,0,1,2.25,3.91v12.83a1.65,1.65,0,0,1-2.47,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1005",
    d: "M15.85,178.83v10.72a.12.12,0,0,0,.05.1l.46.26a.12.12,0,0,0,.18-.1V179.1a.13.13,0,0,0-.06-.1l-.46-.27A.12.12,0,0,0,15.85,178.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1006",
    d: "M17.23,179.63v10.72a.11.11,0,0,0,.05.09l.46.27a.12.12,0,0,0,.18-.1V179.9a.13.13,0,0,0-.06-.1l-.46-.27A.11.11,0,0,0,17.23,179.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1007",
    d: "M18.61,180.43v10.71a.12.12,0,0,0,.05.1l.46.27a.12.12,0,0,0,.18-.1V180.69a.13.13,0,0,0-.06-.1l-.46-.26A.11.11,0,0,0,18.61,180.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1008",
    d: "M20,181.22v10.72a.12.12,0,0,0,.05.1l.46.26a.12.12,0,0,0,.18-.1V181.49a.13.13,0,0,0-.06-.1l-.46-.27A.12.12,0,0,0,20,181.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1009",
    d: "M41.2,204.37V229a.52.52,0,0,1-.78.4l-14.81-8.55a.51.51,0,0,1-.26-.45v-28a.52.52,0,0,1,.78-.45h0l12.67,7.25a.51.51,0,0,1,.22.24l2.1,4.68A.54.54,0,0,1,41.2,204.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1010",
    d: "M41.2,204.37V229l-14.78-8.53a.54.54,0,0,1-.26-.45V192l12.67,7.25a.51.51,0,0,1,.22.24l2.1,4.68A.54.54,0,0,1,41.2,204.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1011",
    points: "13.95 225.12 15.85 233.53 41.99 248.63 45.85 243.54 13.95 225.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1012",
    points: "41.99 248.63 41.99 252.28 15.85 237.19 15.85 233.53 41.99 248.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1013",
    d: "M22,223.62c-.49-1.89-2.07-3.44-3.54-3.45a1.77,1.77,0,0,0-1,.26h0l-.9.53L16.39,222a4.92,4.92,0,0,0-.09,1.4,8,8,0,0,0,1,2l.82.5a3.75,3.75,0,0,0,1.65,1l.58.34.86-.5h0C22,226.31,22.42,225.07,22,223.62Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1014",
    cx: 18.39,
    cy: 224.17,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-106.22 36.92) rotate(-28.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1015",
    d: "M19.23,225.44l-.14.08a.7.7,0,0,1-.33.07,1.81,1.81,0,0,1-1.48-1.43,1.13,1.13,0,0,1,.41-1.35.72.72,0,0,1,.33-.07,1.8,1.8,0,0,1,1.48,1.44A1.22,1.22,0,0,1,19.23,225.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1016",
    d: "M9,244.29c1.88.51,4-.11,4.75-1.38a1.69,1.69,0,0,0,.25-1h0v-1.05l-.84-.73a4.72,4.72,0,0,0-1.17-.77,8.36,8.36,0,0,0-2.22-.15l-.84.47a3.6,3.6,0,0,0-1.68,1l-.58.32v1h0C6.63,243,7.52,243.9,9,244.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1017",
    cx: 10.29,
    cy: 240.85,
    rx: 2.48,
    ry: 3.67,
    transform: "translate(-230.65 248.68) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1018",
    d: "M19.5,224.18A1.8,1.8,0,0,0,18,222.74a.72.72,0,0,0-.33.07l-.06,0-5.3,3.06a7.17,7.17,0,0,0-3.56,6.18v8.7a.72.72,0,0,0,.08.4,1.38,1.38,0,0,0,.88.63,1.84,1.84,0,0,0,2-.58s0,0,0,0a.6.6,0,0,0,.08-.31h0v-2.47h0a1.21,1.21,0,0,0,0-.19v-6.11a4.11,4.11,0,0,1,2-3.53l5.23-3,.07,0,.07-.05A1.22,1.22,0,0,0,19.5,224.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1019",
    d: "M81.78,202.71a5.09,5.09,0,0,1-2.22,4.62l-6.31,3.59-2.23.42h0c0-4.77-.07-9.69-.1-13.83,0-1.39,0-2.7,0-3.89l.52-.3a3.84,3.84,0,0,1,2.23-.63c3.25,0,6.76,3.45,7.83,7.64A9.3,9.3,0,0,1,81.78,202.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1020",
    points: "95.08 195.1 95.08 196.05 80.58 204.56 80.77 203.36 95.08 195.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1021",
    cx: 85.69,
    cy: 194.46,
    rx: 5.25,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1022",
    d: "M90.09,194.46a3.37,3.37,0,0,1-1,2.36,4.13,4.13,0,0,1-.55.47,4.73,4.73,0,0,1-2.5.88h-.72a4.76,4.76,0,0,1-2.5-.88,3.5,3.5,0,0,1-.54-.47,3.34,3.34,0,0,1-1-2.36,1.09,1.09,0,0,1,0-.18,2.85,2.85,0,0,1,.12-.72,3.67,3.67,0,0,1,1.45-1.95,3.72,3.72,0,0,1,.64-.38,5.12,5.12,0,0,1,4.37,0,4.15,4.15,0,0,1,.64.38A3.65,3.65,0,0,1,90,193.56a3.39,3.39,0,0,1,.13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1023",
    d: "M86.56,194.28l2.54,2.54a4.13,4.13,0,0,1-.55.47l-2.5-2.5v3.38h-.72v-3.38l-2.5,2.5a3.5,3.5,0,0,1-.54-.47l2.54-2.54H81.3a2.85,2.85,0,0,1,.12-.72h3.41l-2-1.95a3.72,3.72,0,0,1,.64-.38l2.18,2.18,2.19-2.18a4.15,4.15,0,0,1,.64.38l-2,1.95H90a3.39,3.39,0,0,1,.13.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1024",
    cx: 85.69,
    cy: 193.92,
    rx: 0.64,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M85.69,193.92a6.65,6.65,0,0,1-.36-.77c0-.26,0-.51,0-.77v-3.85c.11-.26.22-.51.36-.77a6.65,6.65,0,0,1,.36.77v3.85c0,.26,0,.51,0,.77a6.75,6.75,0,0,1-.37.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M82.64,180.45v7.21h0c0,.82.73,1.61,1.94,1.93,1.57.43,3.35-.09,4-1.14a1.49,1.49,0,0,0,.21-.83h0v-7.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-726",
    cx: 85.69,
    cy: 180.45,
    rx: 2.06,
    ry: 3.06,
    transform: "translate(-95.62 264.3) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1025",
    d: "M77.41,139.43l0,39.88h0c0,2.23,2,4.36,5.27,5.24,4.26,1.15,9.06-.24,10.73-3.11a4,4,0,0,0,.56-2.22h0l0-40.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1026",
    cx: 85.68,
    cy: 139.77,
    rx: 5.59,
    ry: 8.28,
    transform: "translate(-54.96 224.03) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1027",
    points: "115.63 197.07 112.64 202.31 73.76 224.71 71.04 223.62 71.03 222.7 115.63 197.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1028",
    d: "M68.3,144.28V166.2h0c0,1.23,1.09,2.4,2.89,2.89,2.34.63,5-.14,5.9-1.71a2.22,2.22,0,0,0,.31-1.22h0V143.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1029",
    cx: 72.84,
    cy: 144.47,
    rx: 3.08,
    ry: 4.55,
    transform: "translate(-72.36 215.83) rotate(-89.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1030",
    points: "120.43 161.13 133.1 153.81 133.1 179.42 120.43 186.74 120.43 161.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1031",
    points: "132.32 155.83 132.32 164.39 121.77 170.19 121.77 161.9 132.04 155.99 132.32 155.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1032",
    points: "132.04 155.99 132.04 164.21 121.77 169.87 121.77 161.9 132.04 155.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1033",
    d: "M121.77,171.58v2.27a.22.22,0,0,0,.09.17h0l.44.26,0,0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0L122,171.27A.38.38,0,0,0,121.77,171.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1034",
    d: "M122.2,171.83v2.28a.19.19,0,0,0,.16.2.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.16.16,0,0,0,0-.09.12.12,0,0,0-.1,0,.14.14,0,0,0-.09,0l-2.44,1.42A.37.37,0,0,0,122.2,171.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1035",
    d: "M125.41,169.47v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.2.2,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.19.19,0,0,0,.1-.17l.44-1.18v-1a.11.11,0,0,0,0-.08l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,125.41,169.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1036",
    d: "M125.84,169.72V172a.16.16,0,0,0,.06.13.17.17,0,0,0,.1.06.2.2,0,0,0,.15,0l.25-.15,2.18-1.26a.22.22,0,0,0,.1-.18v-2.47a.11.11,0,0,0,0-.08.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0L126,169.41A.35.35,0,0,0,125.84,169.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1037",
    d: "M129.06,167.35v2.27a.2.2,0,0,0,.09.17h0l.45.26,0,0a.23.23,0,0,0,.14,0l.26-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.29.29,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.14,0L129.23,167A.37.37,0,0,0,129.06,167.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1038",
    d: "M129.49,167.6v2.28a.22.22,0,0,0,0,.14.24.24,0,0,0,.11.06.23.23,0,0,0,.14,0l.26-.15,2.17-1.27a.18.18,0,0,0,.1-.17V166a.29.29,0,0,0,0-.09.14.14,0,0,0-.1,0,.14.14,0,0,0-.09,0l-2.44,1.42A.36.36,0,0,0,129.49,167.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1039",
    d: "M134.91,158v2.27a.2.2,0,0,0,.09.17h0l.44.26,0,0a.23.23,0,0,0,.14,0l.26-.15,0-.53,1.71-1a.19.19,0,0,0,.1-.18l.45-1.17v-1a.32.32,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.14,0l-2.43,1.41A.36.36,0,0,0,134.91,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1040",
    d: "M135.34,158.26v2.28a.19.19,0,0,0,.16.2.23.23,0,0,0,.14,0l.26-.15,2.17-1.27a.18.18,0,0,0,.11-.17v-2.47a.32.32,0,0,0,0-.09.14.14,0,0,0-.1,0,.14.14,0,0,0-.09,0L135.52,158A.37.37,0,0,0,135.34,158.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1041",
    d: "M134.91,162.27v2.27a.2.2,0,0,0,.09.17h0l.44.26,0,0a.23.23,0,0,0,.14,0l.26-.15,0-.53,1.71-1a.19.19,0,0,0,.1-.18l.45-1.17v-1a.32.32,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.14,0L135.09,162A.36.36,0,0,0,134.91,162.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1042",
    d: "M135.34,162.52v2.28a.22.22,0,0,0,0,.14.24.24,0,0,0,.11.06.23.23,0,0,0,.14,0l.26-.15,2.17-1.27a.18.18,0,0,0,.11-.17v-2.47a.32.32,0,0,0,0-.09.14.14,0,0,0-.1-.05.14.14,0,0,0-.09,0l-2.44,1.42A.38.38,0,0,0,135.34,162.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1043",
    d: "M121.77,175.93v2.27a.22.22,0,0,0,.09.17h0l.44.27h0a.26.26,0,0,0,.15,0l.25-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.18l.44-1.17v-1a.16.16,0,0,0,0-.09l0,0-.45-.25a.16.16,0,0,0-.15,0L122,175.62A.38.38,0,0,0,121.77,175.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1044",
    d: "M122.2,176.18v2.28a.22.22,0,0,0,0,.14.24.24,0,0,0,.11.06.26.26,0,0,0,.15,0l.25-.15,2.18-1.27a.19.19,0,0,0,.1-.17v-2.47a.16.16,0,0,0,0-.09.12.12,0,0,0-.1-.05.14.14,0,0,0-.09,0l-2.44,1.42A.38.38,0,0,0,122.2,176.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1045",
    d: "M125.41,173.82v2.27a.19.19,0,0,0,.09.16h0l.44.26h0a.16.16,0,0,0,.15,0l.25-.15,0-.52,1.71-1a.22.22,0,0,0,.1-.18l.44-1.17v-1a.12.12,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.15,0l-2.43,1.41A.35.35,0,0,0,125.41,173.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1046",
    d: "M125.84,174.07v2.28a.16.16,0,0,0,.06.13.17.17,0,0,0,.1.06.16.16,0,0,0,.15,0l.25-.15,2.18-1.26a.21.21,0,0,0,.1-.18v-2.46a.12.12,0,0,0,0-.09.17.17,0,0,0-.1-.06.15.15,0,0,0-.09,0L126,173.76A.35.35,0,0,0,125.84,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1047",
    d: "M129.06,171.71V174a.2.2,0,0,0,.09.17h0l.45.27h0a.23.23,0,0,0,.14,0l.26-.15,0-.53,1.71-1a.21.21,0,0,0,.1-.17l.44-1.18v-1a.29.29,0,0,0,0-.09l0,0-.45-.25a.14.14,0,0,0-.14,0l-2.44,1.41A.37.37,0,0,0,129.06,171.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1048",
    d: "M129.49,172v2.28a.22.22,0,0,0,0,.14.24.24,0,0,0,.11.06.23.23,0,0,0,.14,0l.26-.15,2.17-1.27a.18.18,0,0,0,.1-.17v-2.47a.29.29,0,0,0,0-.09.14.14,0,0,0-.1,0,.1.1,0,0,0-.09,0l-2.44,1.41A.36.36,0,0,0,129.49,172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1049",
    d: "M122.12,180.5a1.72,1.72,0,0,1,1.41-1.38.68.68,0,0,1,.4.1h0l.36.21.09.44a1.76,1.76,0,0,1,0,.56,3.14,3.14,0,0,1-.38.8l-.33.2a1.49,1.49,0,0,1-.66.4l-.23.14-.35-.2h0A1.09,1.09,0,0,1,122.12,180.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1050",
    cx: 123.58,
    cy: 180.72,
    rx: 1.47,
    ry: 0.99,
    transform: "translate(-94.38 201.37) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1051",
    points: "125.99 178.97 129.97 176.67 129.97 176.01 125.99 178.3 125.99 178.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1052",
    points: "125.99 180.59 132.62 176.77 132.62 176.05 125.99 179.93 125.99 180.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1053",
    points: "47.7 219.49 47.7 218.11 70.97 204.67 70.98 206.05 47.7 219.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1054",
    points: "29.09 182.62 27.89 181.93 51.2 168.51 52.4 169.2 29.09 182.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1055",
    points: "97.98 142.9 96.78 142.21 127.28 124.66 128.48 125.35 97.98 142.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1056",
    points: "60.21 248.17 60.21 244.51 76.06 253.66 76.06 257.32 60.21 248.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1057",
    d: "M115.42,161.43v.06l-27.6,15.88L70.76,187.2a2.39,2.39,0,0,0-.19-.57L69,183.18,87.82,172.1l2.7-1.59,10.41-6,12.65-7.45,1.68,3.66A1.71,1.71,0,0,1,115.42,161.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1058",
    d: "M115.44,163.09l-27.62,15.8-17,9.73c0-.36,0-.66,0-.89a2.33,2.33,0,0,0-.06-.53l17.06-9.83,27.6-15.88c0,.34,0,.72,0,1.15,0,.08,0,.15,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1059",
    d: "M71.35,211.36l-.33,0c0-4.77-.07-9.69-.1-13.83a11.38,11.38,0,0,1,4.34,6.38C76.33,208.05,74.58,211.4,71.35,211.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1060",
    d: "M71.16,208.34H71c0-2.69,0-5.46,0-7.8a6.4,6.4,0,0,1,2.44,3.6C74,206.47,73,208.36,71.16,208.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1061",
    points: "91.92 215.23 91.92 212.85 99.41 208.6 99.41 210.89 91.92 215.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M116.31,160.87,74.78,225.12l-.44-.18-.79-.31-.45-.18-2-.81,0,0,40.9-72.34a1.87,1.87,0,0,1,.22.39l4,8.65A2.72,2.72,0,0,1,116.31,160.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M116.48,172.46,85,219.29l-6.32,3.62,37.77-58.82C116.43,166.17,116.46,169.1,116.48,172.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1062",
    d: "M83.45,130.67l-1.82-1.62a16.64,16.64,0,0,0-1.17,2.17,8.32,8.32,0,0,1,2.08,5.56v5.3l.59.39a36.68,36.68,0,0,0,1.31-5.25C84.73,135,83.45,130.67,83.45,130.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1063",
    d: "M89.49,133.5V139l-6.36,3.52V137a9.54,9.54,0,0,0-1.28-4.79A9.4,9.4,0,0,0,80,129.92l-.38-.32a8.69,8.69,0,0,0-1.27-.88,3.13,3.13,0,0,0-2.88-.13l2-1.12,3.84-2.11.6-.34h0a3.13,3.13,0,0,1,2.77.18A9.57,9.57,0,0,1,89.49,133.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M315.71,242.77a11.29,11.29,0,0,1,1.33,4.34c-.06,1.73-6.92,12.51-6.92,12.51s1,3.49-.4,3.94-3.39-2.87-3.07-4.78,4.85-12,4.85-12L308,241.38S314.87,240.85,315.71,242.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1064",
    d: "M307.65,232.06s8,9.88,8,10.08c.56,1.29-2.33,3.85-4.78,3.87-.48,0-6.34-6.41-7.16-10.66C303.25,232.77,306.3,232.12,307.65,232.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1065",
    d: "M300.9,315.12c1.49-.11,5.57.72,7.89.07,0,0,.34,3.82.42,4.77a1.77,1.77,0,0,1-2.63,1.55,54.46,54.46,0,0,1-7.81-4.42S297.61,315.36,300.9,315.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1066",
    d: "M287.12,319.63c1.5-.11,5.58.72,7.89.07,0,0,.39,3.82.48,4.77a1.75,1.75,0,0,1-2.61,1.55,55.62,55.62,0,0,1-7.86-4.43S283.84,319.86,287.12,319.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1067",
    d: "M310.33,299.5c-.31,5.91-1.19,16.05-1.19,16.05s-3.28,1.94-5,.42a2.71,2.71,0,0,1-.76-1.27s.12-18.1-3.93-34.94-1.62-14.5-1.62-14.5l5.44-2.54,5.61-2.62s2.8,5,1,16.88S310.63,293.59,310.33,299.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1068",
    d: "M304.17,316a2.71,2.71,0,0,1-.76-1.27s.12-18.1-3.93-34.94-1.62-14.5-1.62-14.5l5.44-2.54a17.72,17.72,0,0,1,.87,3.7s-.8,6.24-1.8,12.27a18.25,18.25,0,0,0-.07,5.57C303.19,290.58,305.14,306.23,304.17,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1069",
    d: "M301.22,277.37l-.15.48c-2.36,7.61-3.5,13.29-2.85,21.65.66,8.54-2.14,20.42-2.14,20.42a4.83,4.83,0,0,1-1.44.95,4.28,4.28,0,0,1-4.42-.95,123.5,123.5,0,0,1,.37-12.52c.55-7.54-.59-13.69-2-26.17s-1.31-16.4-1.27-16.52c1.76-6,14.78-5.37,16.25-1.82S303.83,269,301.22,277.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1070",
    d: "M298.22,299.5c.66,8.54-2.14,20.42-2.14,20.42a4.83,4.83,0,0,1-1.44.95c.11-.36.23-.75.37-1.17,3.45-10,2-28.8,2.13-31s3.93-10.88,3.93-10.88C298.71,285.46,297.57,291.14,298.22,299.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1071",
    d: "M309.6,261.91c-1.32,1.48-12.36,7-17.35,6.48a4,4,0,0,1-.82-.16c-4.48-1.37-4.3-4.48-4.3-4.48.87-5.91.32-7.47-.55-13.13-.05-.3-.08-.6-.11-.9-.56-5.32,1.22-10.15,2.93-11.89s5.59-3.09,5.59-3.09,9.43-5,11.94-3.32c3.23,2.19.69,8.08,1.41,15.69C309.29,257.08,311,260.34,309.6,261.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M300.38,227.65c-.19,1.23.56,3.23.92,4.74s-1.3,2.39-3.17,3.11a2.91,2.91,0,0,1-3.14-.76s1.87-4.8-.67-4.77a3.52,3.52,0,0,1-1.56-.27h0c-1-.5-1.14-1.59-1.26-2.69a2.86,2.86,0,0,0-.82-2.06c-.45-.67.62-.63.48-2.71a6.27,6.27,0,0,1,.61-3.38c4.37-5.63,10.3-1.84,11.1,2.05a5.47,5.47,0,0,1-1,4.52C301.21,226.39,300.46,227.07,300.38,227.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M301.3,232.39c.35,1.51-1.3,2.39-3.17,3.11a2.91,2.91,0,0,1-3.14-.76,8.86,8.86,0,0,0,.62-3.62,1.2,1.2,0,0,0-1.29-1.15,3.52,3.52,0,0,1-1.56-.27,5.32,5.32,0,0,0,4.44-1.15c.57-.42,1.12-.83,1.65-1.19,1.7-1.2,3-2.05,3-2.05v.11c-.67,1-1.42,1.65-1.5,2.23C300.19,228.88,300.94,230.88,301.3,232.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M298.85,227.36l-.2.28s-1.86,2.24-3,3.48a1.2,1.2,0,0,0-1.29-1.15,3.52,3.52,0,0,1-1.56-.27,5.32,5.32,0,0,0,4.44-1.15C297.77,228.13,298.32,227.72,298.85,227.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1072",
    d: "M295.48,224.58s0-1.11,1.53-1.31c1.39-.17,1.4,2,.78,3.51a10.45,10.45,0,0,0-.42,1.15l-.17.62a3.8,3.8,0,0,0,2.9.28c1-.42,1.37-1,2-3.2s2.85-4.9.78-5.52c0,0,1.31-5.35-5.37-5.81s-5.67,3.36-5.67,3.36-2.47,2.49-.06,3.63,3,0,2.89,2.09S295.09,225.85,295.48,224.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M296.53,223.85a.76.76,0,0,1,.74-.09,1,1,0,0,1,.43.74,2.39,2.39,0,0,1-.37,1.7.41.41,0,0,1-.14.15.2.2,0,0,1-.21,0c-.1-.09,0-.26,0-.38a1.67,1.67,0,0,0,.27-.83.84.84,0,0,0-.42-.74.59.59,0,0,0-.77.21C295.84,224.43,296.38,224,296.53,223.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1073",
    d: "M291.16,219.54a11.73,11.73,0,0,1-2.83-1.76c-.9-.9,1-3.93,4.7-3S291.16,219.54,291.16,219.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1074",
    d: "M304.43,221.82s1.28,2.05-1.36,3.08c-2.81,1.09-7.88-2.91-7.88-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1075",
    d: "M291.16,219.54a31.63,31.63,0,0,0,4,2.45h0c2.09,1.06,4.62,2,6.6,1.68a3,3,0,0,0,.61-.15,3.35,3.35,0,0,0,1.15-.61,3.59,3.59,0,0,0,.87-1.1s1.6-6.82-3.73-9.12a7.68,7.68,0,0,0-3.1-.67h0a6.15,6.15,0,0,0-3,.79,4.32,4.32,0,0,0-.73.47A7.56,7.56,0,0,0,291.16,219.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1076",
    d: "M293.83,213.29c3.33-.08,5.05.15,6.65,2.62s.83,7.55.83,7.55l.49.22a3,3,0,0,0,.61-.15c.15-.61.32-1.43.51-2.49a8,8,0,0,0-3.52-7.76c-1.1-.66-3.31-.64-4.84-.46A4.32,4.32,0,0,0,293.83,213.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1077",
    d: "M293.83,213.29c2.58-.64,9.17-1.17,8,10.39a3.5,3.5,0,0,0,1.76-.76s2.09-9.86-6-10.89h0A6.2,6.2,0,0,0,293.83,213.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1078",
    d: "M295.2,222c2.09,1.06,4.62,2,6.6,1.68l-.49-.22A15.28,15.28,0,0,1,295.2,222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1079",
    d: "M294.31,235a9.91,9.91,0,0,1,2.92-1.58c2-.84,4.65-2.07,4.65-2.07l.59,1.26S299.28,237.84,294.31,235Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M286.94,254.06s-4.95,6.46-8,5.46c-2.57-.86-9.65-7.29-12.16-9.42l-.19-.15c-.1-.08-.17-.15-.22-.18l0,0a2.84,2.84,0,0,0-.42-.31c-.75-.38-.81-1.06-1.2-1.44s0-.41-.39-.84a1.61,1.61,0,0,1-.46-1,3.17,3.17,0,0,1-.69-1.45c-.18-.61.26-.91.61.13a2.89,2.89,0,0,0,2.2,1.59c.16-.17-.11-.54-.85-1.18s-.53-1.38,0-1a10.54,10.54,0,0,1,2.29,1.49,16.08,16.08,0,0,1,1.2,2.94l10.24,5.2L281,251l.63-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M286.94,254.06s-4.95,6.46-8,5.46c-2.57-.86-9.65-7.29-12.16-9.42,1.95,1.55,9.86,7.81,11.82,8.89,2.23,1.22,6.59-3.43,6.59-3.43S281,255.24,281,251l.63-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1080",
    d: "M288.22,239.3s-7.35,11.24-7.29,11.43a5.1,5.1,0,0,0,5.43,4.55s2.89-3.77,6.61-7.7C296.86,243.47,291.63,233.48,288.22,239.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1081",
    d: "M549.19,257.69l-5.8-3.34s.39-2.29,1.89-2.69,3.75-.17,4.49,1.51S549.19,257.69,549.19,257.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1082",
    d: "M542,247.41a3.58,3.58,0,0,0-3.66,0l-12.58,7.26a8.91,8.91,0,0,0-4.44,7.7v3.38l7,4,1-5.45a9.23,9.23,0,0,1,4.3-5.2c3.26-1.61,13.42-8.06,14.79-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1083",
    d: "M529.84,268.86l-1.58.92V266.4a8.91,8.91,0,0,1,4.44-7.7l12.58-7.26a3.66,3.66,0,0,1,5.49,3.17v2.16l-1.58.92v-3.08a2.08,2.08,0,0,0-3.12-1.8l-12.58,7.26a7.32,7.32,0,0,0-3.65,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1084",
    d: "M391.3,253.59l-5.8-3.34s.38-2.28,1.89-2.69,3.75-.16,4.49,1.51S391.3,253.59,391.3,253.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1085",
    d: "M384.07,243.31a3.63,3.63,0,0,0-3.66,0l-12.58,7.26a8.91,8.91,0,0,0-4.44,7.7v3.38l7,4,1-5.45a9.19,9.19,0,0,1,4.3-5.2c3.25-1.61,13.41-8.06,14.79-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1086",
    d: "M372,264.76l-1.59.92V262.3a8.92,8.92,0,0,1,4.45-7.7l12.57-7.26a3.67,3.67,0,0,1,5.5,3.17v2.17l-1.58.91v-3.08a2.08,2.08,0,0,0-3.12-1.8L375.6,256A7.34,7.34,0,0,0,372,262.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1087",
    d: "M289.76,386.61l-5.8-3.34s.38-2.28,1.89-2.69,3.75-.16,4.49,1.51S289.76,386.61,289.76,386.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1088",
    d: "M282.53,376.33a3.63,3.63,0,0,0-3.66,0l-12.58,7.26a8.91,8.91,0,0,0-4.44,7.7v3.38l7,4,1-5.45a9.19,9.19,0,0,1,4.3-5.2c3.25-1.61,13.41-8.06,14.79-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1089",
    d: "M270.41,397.78l-1.58.92v-3.38a8.91,8.91,0,0,1,4.44-7.7l12.58-7.26a3.66,3.66,0,0,1,5.49,3.17v2.17l-1.58.91v-3.08a2.07,2.07,0,0,0-1-1.8,2,2,0,0,0-2.08,0L274.06,389a7.34,7.34,0,0,0-3.65,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1090",
    d: "M252.31,413.1l-5.8-3.34s.38-2.29,1.89-2.69,3.75-.16,4.49,1.51S252.31,413.1,252.31,413.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1091",
    d: "M245.08,402.82a3.61,3.61,0,0,0-3.66,0l-12.58,7.26a8.92,8.92,0,0,0-4.45,7.7v3.38l7,4,1-5.45a9.19,9.19,0,0,1,4.3-5.2c3.25-1.61,13.41-8.06,14.79-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1092",
    d: "M233,424.27l-1.59.92v-3.38a8.92,8.92,0,0,1,4.45-7.7l12.57-7.26a3.67,3.67,0,0,1,5.5,3.17v2.16l-1.58.92V410a2.08,2.08,0,0,0-3.12-1.8l-12.58,7.26a7.34,7.34,0,0,0-3.65,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1093",
    d: "M106.34,328.55l-5.8-3.34s.38-2.29,1.89-2.69,3.75-.17,4.49,1.51S106.34,328.55,106.34,328.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1094",
    d: "M99.11,318.27a3.6,3.6,0,0,0-3.67,0l-12.57,7.26a8.92,8.92,0,0,0-4.45,7.7v3.38l7,4,1-5.45a9.22,9.22,0,0,1,4.31-5.2c3.25-1.61,13.41-8.06,14.79-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1095",
    d: "M87,339.72l-1.58.92v-3.38a8.92,8.92,0,0,1,4.45-7.7l12.57-7.26a3.67,3.67,0,0,1,5.5,3.17v2.16l-1.58.92v-3.08a2.09,2.09,0,0,0-3.13-1.8l-12.57,7.26A7.31,7.31,0,0,0,87,337.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1096",
    d: "M640.16,473.35l-5.8-3.34s.38-2.29,1.89-2.69,3.75-.17,4.49,1.51S640.16,473.35,640.16,473.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1097",
    d: "M632.93,463.06a3.61,3.61,0,0,0-3.66,0l-12.58,7.26a8.9,8.9,0,0,0-4.44,7.69v3.39l7,4,1-5.45a9.19,9.19,0,0,1,4.3-5.2c3.25-1.61,13.41-8.07,14.79-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1098",
    d: "M620.81,484.52l-1.59.92v-3.38a8.92,8.92,0,0,1,4.45-7.7l12.58-7.26a3.66,3.66,0,0,1,5.49,3.17v2.16l-1.58.92v-3.08a2.08,2.08,0,0,0-3.12-1.8l-12.58,7.26a7.32,7.32,0,0,0-3.65,6.33Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/LoginImg.0b493fc6dd47d6a80bd2f3f8ee79eba0.svg";
export { ForwardRef as ReactComponent };